
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2cigx", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $eec8e8449eafd9c1$export$90dcee7ddb8a0c0c);
const $eec8e8449eafd9c1$var$globalObj = window || $parcel$global;
const $eec8e8449eafd9c1$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
const $eec8e8449eafd9c1$export$90dcee7ddb8a0c0c = (healthcheck = $eec8e8449eafd9c1$var$defaultHealthcheck)=>{
    $eec8e8449eafd9c1$var$globalObj.performHealthcheck = healthcheck;
};

});

parcelRegister("8aaWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $450787a793d5ee43$export$2e2bcd8739ae039);

var $2ChuC = parcelRequire("2ChuC");

var $8Xjsv = parcelRequire("8Xjsv");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$450787a793d5ee43$export$2e2bcd8739ae039 = {
    install: (args)=>{
        // @ts-expect-error - TS2322 - Type '{ flags?: boolean | undefined; navigation?: boolean | undefined; renderNavigation: (() => any) | (() => void); upflow?: boolean | undefined; heartbeat?: boolean | undefined; profileCardNextLegacy?: boolean | undefined; ... 4 more ...; searchDwellTimeComponent?: boolean | undefined; }' is not assignable to type 'GlobalArgs'.
        const argsWithDefaults = {
            renderNavigation: $8Xjsv.default,
            ...args
        };
        (0, $2ChuC.default).install(argsWithDefaults);
    }
};

});
parcelRegister("2ChuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe3490a17e762431$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $6YRTH = parcelRequire("6YRTH");

var $j8DrX = parcelRequire("j8DrX");

var $7AZuS = parcelRequire("7AZuS");

var $7o9iL = parcelRequire("7o9iL");

const $fe3490a17e762431$var$renderEngagementMessages = ()=>{
    (parcelRequire("dZTqe"));
};

const $fe3490a17e762431$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("dxZMM"));
};

const $fe3490a17e762431$var$renderHeartbeat = ()=>{
    (parcelRequire("jzW9D"));
};

const $fe3490a17e762431$var$loadUpFlowAPI = ()=>(parcelRequire("h7Vx2"));

const $fe3490a17e762431$var$installConnectModules = ()=>(parcelRequire("feIhl"));
const $fe3490a17e762431$var$markSafeForAnalytics = (str)=>str || null;
const $fe3490a17e762431$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $j8DrX.default)('ajs-search-session-id');
    const containerId = (0, $j8DrX.default)('ajs-search-container-id');
    const objectId = (0, $j8DrX.default)('ajs-search-object-id');
    const objectType = (0, $j8DrX.default)('ajs-search-content-type');
    (0, $6YRTH.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $7o9iL.default)('search-dwell-time', $fe3490a17e762431$var$markSafeForAnalytics(searchSessionId), {
        containerId: $fe3490a17e762431$var$markSafeForAnalytics(containerId),
        objectId: $fe3490a17e762431$var$markSafeForAnalytics(objectId),
        objectType: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
        actionSubject: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
        source: $fe3490a17e762431$var$markSafeForAnalytics(objectType)
    });
};
const $fe3490a17e762431$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $7AZuS.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $fe3490a17e762431$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $fe3490a17e762431$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $fe3490a17e762431$var$renderProfileCardNextLegacy();
    if (args.connectModules) $fe3490a17e762431$var$installConnectModules();
    if (args.engagementMessages) $fe3490a17e762431$var$renderEngagementMessages();
    if (args.heartbeat) $fe3490a17e762431$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $fe3490a17e762431$var$renderSearchDwellTimeComponent();
};
const $fe3490a17e762431$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($fe3490a17e762431$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $fe3490a17e762431$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $fe3490a17e762431$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: true,
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe3490a17e762431$export$2e2bcd8739ae039 = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $fe3490a17e762431$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        };
        $fe3490a17e762431$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))({
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $fe3490a17e762431$var$installLowPriorityApps(installArgs);
    }
};

});
parcelRegister("fr1K2", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $7MmCC = parcelRequire("7MmCC");

var $ftdKz = parcelRequire("ftdKz");

var $etAYC = parcelRequire("etAYC");

var $4NkAS = parcelRequire("4NkAS");

var $b2dLE = parcelRequire("b2dLE");

var $9SRAA = parcelRequire("9SRAA");

var $7GWAt = parcelRequire("7GWAt");
/** Used to compose bitmasks for cloning. */ var $b3caba7e25e0a917$var$CLONE_DEEP_FLAG = 1, $b3caba7e25e0a917$var$CLONE_FLAT_FLAG = 2, $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $b3caba7e25e0a917$var$omit = $9SRAA(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $1nIHN(paths, function(path) {
        path = $etAYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $4NkAS(object, $7GWAt(object), result);
    if (isDeep) result = $7MmCC(result, $b3caba7e25e0a917$var$CLONE_DEEP_FLAG | $b3caba7e25e0a917$var$CLONE_FLAT_FLAG | $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG, $b2dLE);
    var length = paths.length;
    while(length--)$ftdKz(result, paths[length]);
    return result;
});
module.exports = $b3caba7e25e0a917$var$omit;

});
parcelRegister("ftdKz", function(module, exports) {

var $etAYC = parcelRequire("etAYC");

var $hYfgW = parcelRequire("hYfgW");

var $8lSJl = parcelRequire("8lSJl");

var $gzebZ = parcelRequire("gzebZ");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $b4343aeaece186b7$var$baseUnset(object, path) {
    path = $etAYC(path, object);
    object = $8lSJl(object, path);
    return object == null || delete object[$gzebZ($hYfgW(path))];
}
module.exports = $b4343aeaece186b7$var$baseUnset;

});
parcelRegister("8lSJl", function(module, exports) {

var $fTwLR = parcelRequire("fTwLR");

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $614abd39878e1d90$var$parent(object, path) {
    return path.length < 2 ? object : $fTwLR(object, $dM3Z8(path, 0, -1));
}
module.exports = $614abd39878e1d90$var$parent;

});


parcelRegister("b2dLE", function(module, exports) {

var $1QOns = parcelRequire("1QOns");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $808a8f8fca7f9ff7$var$customOmitClone(value) {
    return $1QOns(value) ? undefined : value;
}
module.exports = $808a8f8fca7f9ff7$var$customOmitClone;

});


parcelRegister("6YRTH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bd6eeaf3add142$export$2e2bcd8739ae039);

var $6vAaw = parcelRequire("6vAaw");

var $fr1K2 = parcelRequire("fr1K2");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e3bd6eeaf3add142$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});

parcelRegister("7AZuS", function(module, exports) {

$parcel$export(module.exports, "renderFlags", () => $271711a34feab2aa$export$b6228dc14c5adf51);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $2YZCu = parcelRequire("2YZCu");

var $jsLXn = parcelRequire("jsLXn");

var $iNWLk = parcelRequire("iNWLk");

var $9F6Ii = parcelRequire("9F6Ii");

var $kxZPA = parcelRequire("kxZPA");
const $271711a34feab2aa$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $2YZCu.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $271711a34feab2aa$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $271711a34feab2aa$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $271711a34feab2aa$var$Flags = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("amLL8")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $271711a34feab2aa$var$AfterPaintFlags = (0, $kxZPA.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("amLL8")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});
const $271711a34feab2aa$export$b6228dc14c5adf51 = ()=>(0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsLXn.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$Flags, null)))), $271711a34feab2aa$var$getContainer());

});
parcelRegister("jsLXn", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $88b19a22a09480ac$export$6f7845cc5e693f16);

var $5uXOq = parcelRequire("5uXOq");

var $irJ4w = parcelRequire("irJ4w");

var $lzeFL = parcelRequire("lzeFL");

var $5tsrJ = parcelRequire("5tsrJ");

var $1OjhZ = parcelRequire("1OjhZ");

var $j8DrX = parcelRequire("j8DrX");

var $1nUas = parcelRequire("1nUas");

var $2HbP2 = parcelRequire("2HbP2");

var $8ApFP = parcelRequire("8ApFP");

var $iXVV6 = parcelRequire("iXVV6");

var $fiv1r = parcelRequire("fiv1r");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $a83ud = parcelRequire("a83ud");
const $88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, children);

const $88b19a22a09480ac$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("hWnRN"))
    };
    const { data: orgId } = (0, $14XJw.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nUas.IntlProvider), {
            messages: state.messages,
            locale: (0, $lzeFL.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irJ4w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tsrJ.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OjhZ.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a83ud.LoadingPhaseManager), null));
};

});
parcelRegister("1OjhZ", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $5cef917adb45d092$export$6f49c95a810d59fa);

var $5uXOq = parcelRequire("5uXOq");

var $ha42n = parcelRequire("ha42n");
var $bSOOm = parcelRequire("bSOOm");

var $9sAyK = parcelRequire("9sAyK");
const $5cef917adb45d092$var$useUnmount = (callback)=>(0, $5uXOq.useEffect)(()=>callback, [
        callback
    ]);
const $5cef917adb45d092$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $5uXOq.useState)(new (0, $ha42n.ExperienceTracker)());
    const [cleanupSliSub] = (0, $5uXOq.useState)(()=>experienceTracker.subscribe((0, $9sAyK.sliSubscriber)));
    const cleanup = (0, $5uXOq.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $5cef917adb45d092$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSOOm.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("ha42n", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $19380a56c83c3ed5$export$12b6b072930fd68f);

var $82vfp = parcelRequire("82vfp");
class $19380a56c83c3ed5$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $82vfp.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("82vfp", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $abf5733617623630$export$c90b54e658fc4d7c);

var $j0xjM = parcelRequire("j0xjM");
function $abf5733617623630$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $abf5733617623630$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $j0xjM.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $abf5733617623630$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("j0xjM", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $f8ffb4638fa466dd$export$d27a2b6293f7631c);
class $f8ffb4638fa466dd$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("9sAyK", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $6b2f2360dd11edee$export$db0b99fe17114899);

var $fjcgS = parcelRequire("fjcgS");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

const $6b2f2360dd11edee$var$transformApplication = (application)=>{
    switch(application){
        case 0, $efvDm.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $efvDm.JIRA_CORE:
            return 'jira-core';
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $efvDm.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return 'jedi';
        case 0, $ldyPw.STANDARD_EDITION:
            return 'standard';
        case 0, $ldyPw.PREMIUM_EDITION:
            return 'premium';
        case 0, $ldyPw.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $6b2f2360dd11edee$var$transformApplication(application),
            edition: $6b2f2360dd11edee$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $6b2f2360dd11edee$var$reportSli = (experienceDescription)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $6b2f2360dd11edee$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $6b2f2360dd11edee$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$b48b3d1872522384:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});
const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("1nUas", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $0264700d4de7e638$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $0264700d4de7e638$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});

parcelRegister("2HbP2", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $d012230882eb31a4$export$7c9538f5f3c365e9);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $4R6GH = parcelRequire("4R6GH");

var $gJdig = parcelRequire("gJdig");
const $d012230882eb31a4$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $5uXOq.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $5uXOq.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $d012230882eb31a4$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $5uXOq.useRef)(1);
    const [modals, setModals] = (0, $5uXOq.useState)([]);
    const modalContext = (0, $5uXOq.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJdig.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, modals.map((modal)=>{
        return (0, $4R6GH.fg)('jpo-31059_modal_close_behaviour_controls') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d012230882eb31a4$var$RenderModal, {
            key: modal.key,
            modal: modal
        }) : // @ts-expect-error - TS2739 - Complaining about lack of the new props, will be deleted on jpo-31059_modal_close_behaviour_controls cleanup
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(modal.component, {
            key: modal.key,
            onClose: modal.close
        });
    })));
}

});
parcelRegister("gJdig", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $308ba6e6ba886f08$export$ab57792b9b6974a6);

var $5uXOq = parcelRequire("5uXOq");
const $308ba6e6ba886f08$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});


parcelRegister("8ApFP", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $a83c9e8eeb3d40c2$export$c71778b3a4356b04);

var $cfDZ3 = parcelRequire("cfDZ3");

var $hVf1M = parcelRequire("hVf1M");
const $a83c9e8eeb3d40c2$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $cfDZ3.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $cfDZ3.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $cfDZ3.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $hVf1M.getIsProjectAdmin)
    }
});

});
parcelRegister("hVf1M", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $d8c128d9b214e073$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $d8c128d9b214e073$export$d53e6d79d3fa5f31);
let $d8c128d9b214e073$var$projectAdmin = null;
const $d8c128d9b214e073$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($d8c128d9b214e073$var$projectAdmin == null || !$d8c128d9b214e073$var$projectAdmin.loading && $d8c128d9b214e073$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($d8c128d9b214e073$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($d8c128d9b214e073$var$projectAdmin.isProjectAdmin);
};
const $d8c128d9b214e073$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $d8c128d9b214e073$var$projectAdmin = projectAdminState;
};

});


parcelRegister("fiv1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dee5a929ec50c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $41dee5a929ec50c3$export$83fb48644dee72f0);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");
function $41dee5a929ec50c3$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.RelayEnvironmentProvider), {
        environment: (0, $5yJb9.default)()
    }, children);
}
function $41dee5a929ec50c3$export$83fb48644dee72f0() {
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("5yJb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfb67cb8d2ba29a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $eiowN = parcelRequire("eiowN");

var $aWXMn = parcelRequire("aWXMn");
let $0dfb67cb8d2ba29a$var$relayEnvironment;
function $0dfb67cb8d2ba29a$export$2e2bcd8739ae039() {
    if (!$0dfb67cb8d2ba29a$var$relayEnvironment) {
        const environmentConfig = (0, $aWXMn.getRelayEnvironmentConfig)();
        $0dfb67cb8d2ba29a$var$relayEnvironment = new (0, $eiowN.Environment)(environmentConfig);
    }
    return $0dfb67cb8d2ba29a$var$relayEnvironment;
}

});
parcelRegister("aWXMn", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $eb7981c11bea2531$export$a451c85db2d1cda3);

var $4XQuR = parcelRequire("4XQuR");

var $d89yU = parcelRequire("d89yU");

var $6LmWt = parcelRequire("6LmWt");
const $eb7981c11bea2531$export$a451c85db2d1cda3 = ()=>(0, $6LmWt.getDefaultRelayEnvironmentConfig)({
        network: (0, $d89yU.getNetwork)(),
        log: (0, $4XQuR.default),
        requiredFieldLogger: $4XQuR.requiredFieldLogger
    });

});
parcelRegister("4XQuR", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $50b0aa0805b37d6d$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $50b0aa0805b37d6d$export$2e2bcd8739ae039);

var $bFU4G = parcelRequire("bFU4G");

var $2YZCu = parcelRequire("2YZCu");

var $jp5kW = parcelRequire("jp5kW");
const $50b0aa0805b37d6d$var$RELAY_CLIENT_ID = 'AGG';
const $50b0aa0805b37d6d$var$LOG_NAMESPACE = `relay.${$50b0aa0805b37d6d$var$RELAY_CLIENT_ID}.error.graphql`;
const $50b0aa0805b37d6d$var$requests = {};
const $50b0aa0805b37d6d$var$queries = {};
const $50b0aa0805b37d6d$var$resources = {};
const $50b0aa0805b37d6d$var$executes = {};
const $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $50b0aa0805b37d6d$export$1ab8b98d209afe85 = (event)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData($50b0aa0805b37d6d$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $50b0aa0805b37d6d$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $50b0aa0805b37d6d$export$2e2bcd8739ae039(event) {
    if ((0, $jp5kW.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $50b0aa0805b37d6d$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                    $50b0aa0805b37d6d$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$requests[networkRequestId];
                        delete $50b0aa0805b37d6d$var$queries[name];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $50b0aa0805b37d6d$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $bFU4G.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $50b0aa0805b37d6d$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $50b0aa0805b37d6d$var$queries[node.name];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$resources[event.resourceID];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $50b0aa0805b37d6d$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $50b0aa0805b37d6d$var$executes[event.executeId] = {
                name: event.params.name,
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"query" | "mutation" | "subscription"'.
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next':
            $50b0aa0805b37d6d$var$executes[event.executeId].duration += event.duration;
            break;
        case 'execute.async.module':
            break;
        case 'execute.flight.payload_deserialize':
            break;
        case 'execute.error':
            delete $50b0aa0805b37d6d$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $50b0aa0805b37d6d$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $50b0aa0805b37d6d$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("d89yU", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $7997274d03790a98$export$7de4970ebfd8206d);

var $eiowN = parcelRequire("eiowN");

var $gIJXH = parcelRequire("gIJXH");

var $k1TrK = parcelRequire("k1TrK");

var $fwvto = parcelRequire("fwvto");
const $7997274d03790a98$export$7de4970ebfd8206d = ()=>{
    if ((0, $fwvto.isSSR)()) (0, $eiowN.Network).create((0, $gIJXH.fetch));
    return (0, $eiowN.Network).create((0, $gIJXH.fetch), (0, $k1TrK.subscribe));
};

});
parcelRegister("gIJXH", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3);

var $4R6GH = parcelRequire("4R6GH");

var $9XhfI = parcelRequire("9XhfI");

var $dMryf = parcelRequire("dMryf");
const $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    return (0, $4R6GH.fg)('jfp-magma-support-defer') ? (0, $9XhfI.fetch)(request, variables, cacheConfig) : (0, $dMryf.fetch)(request, variables, cacheConfig);
};

});
parcelRegister("9XhfI", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $1ea431952d5687e8$export$e7aa7bc5c1b3cfb3);

var $hGgHi = parcelRequire("hGgHi");

var $eiowN = parcelRequire("eiowN");

var $4R6GH = parcelRequire("4R6GH");

var $6b2ko = parcelRequire("6b2ko");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $7pVV3 = parcelRequire("7pVV3");

var $ajjqZ = parcelRequire("ajjqZ");

var $4pgHP = parcelRequire("4pgHP");

var $eCZ6m = parcelRequire("eCZ6m");

var $5Wobd = parcelRequire("5Wobd");

var $jlPGx = parcelRequire("jlPGx");

var $ifOJ4 = parcelRequire("ifOJ4");

var $jCRE8 = parcelRequire("jCRE8");

var $lKFKm = parcelRequire("lKFKm");

var $7isEg = parcelRequire("7isEg");

var $aLyyN = parcelRequire("aLyyN");
const $1ea431952d5687e8$var$getQueryResponseCache = ()=>(0, $4R6GH.fg)('jfp_magma_fix_relay_query_cache_loading_from_ssr') ? (0, $7pVV3.getQueryResponseCache)() : (0, $7pVV3.QueryResponseCache);
// @ts-expect-error the global is placed there by bifrost SSR. See src/entry-fs/util/render.tsx
const $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $1ea431952d5687e8$var$moduleID = 'relay-fetch';
const $1ea431952d5687e8$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    const redirecting = (0, $aLyyN.checkAuthentication)();
    if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (0, $eiowN.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $7isEg.getLoggingAndMetricsHelper)(loggingMetadata);
    function augmentResponse(response) {
        if ((0, $4R6GH.fg)('obsrve-2487-gql-use-traceid-extensions-field')) (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getTraceIdFromExtensions)(response));
        else (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getRequestIdFromExtensions)(response));
        (0, $4pgHP.putExtensions)(queryName, response.extensions);
    }
    function validateResponse(response) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
        const errors = response.errors || undefined;
        if (errors != null) {
            const requestId = response?.extensions?.gateway?.request_id;
            if (!(0, $aLyyN.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
            (0, $5a0Nh.captureErrors)(errors, {
                operationName: queryName,
                requestId: requestId
            });
            if ((0, $5a0Nh.isUnauthenticated)(errors)) return false;
        }
        return true;
    }
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    const earlyScriptPromise = !false && (0, $ajjqZ.claimEarlyScriptPromise)((0, $ajjqZ.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    return (0, $eiowN.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$1ea431952d5687e8$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                if ('incremental' in response && response.incremental?.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                // the pending versus completed values, so we can just return the array without the extra account keeping.
                // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                // TypeScript can't handle the polymorphism.
                sink.next(response.incremental);
                else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                sink.next(response);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // On client...
            if (!false && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = $1ea431952d5687e8$var$getQueryResponseCache().get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(ssrCache)) {
                    $1ea431952d5687e8$var$getQueryResponseCache().delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) // TODO MAGMA-3017: force close if server timeout or DomContentLoaded
                    // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                    // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                    // Receive response events as they are streamed from the server.
                    (0, $ifOJ4.getClientDispatcher)().register(sinkID, handleResponse);
                    else finalise();
                    return;
                }
            }
            const endpoint = (0, $eCZ6m.getAggEndpoint)(request, cacheConfig);
            const body = (0, $eCZ6m.getRequestBody)(request, variables);
            const fetchOverNetwork = (0, $jCRE8.buildGraphqlFetch)(endpoint, (0, $aLyyN.generateOptions)({
                body: body
            }, endpoint));
            const initialSource = ()=>!false && earlyScriptPromise ? (0, $jCRE8.withErrorHandling)(earlyScriptPromise) : (0, $jCRE8.withErrorHandling)(fetchOverNetwork());
            const responses = (0, $jCRE8.processMultipartPromise)(()=>(0, $6b2ko.retryOnError)(initialSource, {
                    retryFunc: ()=>(0, $jCRE8.withErrorHandling)(fetchOverNetwork()),
                    retryPredicate: (0, $aLyyN.shouldRetry),
                    retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                }));
            // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
            // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
            let responseShouldHang = false;
            let firstResponseUsed = false;
            let resolveFirstResponse;
            const firstResponse = new Promise((resolve)=>{
                resolveFirstResponse = resolve;
            });
            responses.subscribe({
                start: ()=>{
                    if (requestID != null) {
                        (0, $kipqU.QueryPromisesMap).set(requestID, firstResponse);
                        (0, $kipqU.CompletedQueryPromisesMap).set(requestID, completedResponse);
                    }
                },
                next: (response)=>{
                    if (false && $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                        // Send the response payload to a side-channel.
                        // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                        (0, $jlPGx.registerEvent)({
                            id: sinkID,
                            name: 'default',
                            args: [
                                response
                            ]
                        });
                        // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                        return;
                    }
                    if (!firstResponseUsed) {
                        firstResponseUsed = true;
                        // according to spec, we can assume the first response is a GraphQLSingularResponse.
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const singularResponse = response;
                        augmentResponse(singularResponse);
                        if (!validateResponse(singularResponse)) {
                            //  Short circuit operation and handle the unauthorized errors.
                            (0, $lKFKm.showUnauthenticatedFlag)(queryName);
                            responseShouldHang = true;
                            return;
                        }
                        enforceNonNullability(singularResponse);
                        // write cache query response on SSR
                        if (false && requestID != null) $1ea431952d5687e8$var$getQueryResponseCache().setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                    }
                    handleResponse(response);
                    // signal that the initial response has been received
                    // so that SSR SPA knows it is safe to render
                    resolveFirstResponse();
                    // After the initial response, further responses are sent through a side-channel.
                    if (false && $1ea431952d5687e8$var$isSsrHandoverIncrementsEnabled()) finalise();
                },
                error: (error)=>{
                    if (!firstResponseUsed) firstResponseUsed = true;
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                },
                complete: ()=>{
                    if (responseShouldHang) return;
                    finalise();
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("6b2ko", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $6910b563ec955346$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $6910b563ec955346$export$f859c88bfac2cf2c);
const $6910b563ec955346$export$81189edc9b923717 = 1;
const $6910b563ec955346$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6910b563ec955346$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $6910b563ec955346$export$81189edc9b923717 ? $6910b563ec955346$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("5a0Nh", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $cf86a52470c84b66$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $cf86a52470c84b66$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $cf86a52470c84b66$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $cf86a52470c84b66$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $7Jxgt = parcelRequire("7Jxgt");
const $cf86a52470c84b66$var$errorCollector = new Map();
const $cf86a52470c84b66$export$da396ad2a542b095 = 120000; // 2min
const $cf86a52470c84b66$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $cf86a52470c84b66$var$errorCollector.delete(key);
    }, $cf86a52470c84b66$export$da396ad2a542b095);
};
const $cf86a52470c84b66$export$c211170518c6d0f6 = (key = (0, $7Jxgt.v4)())=>{
    $cf86a52470c84b66$var$errorCollector.set(key, []);
    $cf86a52470c84b66$var$scheduleCleanup(key);
    return key;
};
const $cf86a52470c84b66$export$e0491a0d974dadfa = (key)=>{
    const errors = $cf86a52470c84b66$var$errorCollector.get(key);
    $cf86a52470c84b66$var$errorCollector.delete(key);
    return errors || [];
};
const $cf86a52470c84b66$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $cf86a52470c84b66$var$errorCollector.forEach((value, key)=>{
        $cf86a52470c84b66$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $cf86a52470c84b66$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("kipqU", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $f428f7f15822f637$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $f428f7f15822f637$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $f428f7f15822f637$export$607b80f5bc6e396d = new Map();
const $f428f7f15822f637$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("7pVV3", function(module, exports) {

$parcel$export(module.exports, "QueryResponseCache", () => $675c7f0a9d659efe$export$688bd21be71b9e5d);
$parcel$export(module.exports, "getQueryResponseCache", () => $675c7f0a9d659efe$export$3233e692a93c0cfd);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $eiowN = parcelRequire("eiowN");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $4R6GH = parcelRequire("4R6GH");

var $kizcd = parcelRequire("kizcd");
function $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $eiowN.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $675c7f0a9d659efe$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
const $675c7f0a9d659efe$export$da2711d74cd28aed = [
    'fetchModulesV2Query'
];
class $675c7f0a9d659efe$export$be21c283b097d175 extends (0, $eiowN.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $675c7f0a9d659efe$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName) && !$675c7f0a9d659efe$export$da2711d74cd28aed.includes(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $kizcd.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $2YZCu.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $675c7f0a9d659efe$export$688bd21be71b9e5d = new $675c7f0a9d659efe$export$be21c283b097d175({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $675c7f0a9d659efe$export$3233e692a93c0cfd = (0, $8QpSo.default)(()=>new $675c7f0a9d659efe$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    }));
const $675c7f0a9d659efe$export$94e535e06b7ade61 = ()=>((0, $4R6GH.fg)('jfp_magma_fix_relay_query_cache_loading_from_ssr') ? $675c7f0a9d659efe$export$3233e692a93c0cfd() : $675c7f0a9d659efe$export$688bd21be71b9e5d).serialize();

});
parcelRegister("kizcd", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $f174935352f053b0$export$8431e42d062de453);
class $f174935352f053b0$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("ajjqZ", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $383b599fde987e1e$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $383b599fde987e1e$export$828ac0325bce4536);
$parcel$export(module.exports, "putEarlyScriptPromise", () => $383b599fde987e1e$export$e1336d32be02faf4);
$parcel$export(module.exports, "earlyFetch", () => $383b599fde987e1e$export$5b55058781674413);

var $tcn7E = parcelRequire("tcn7E");

var $l83Uu = parcelRequire("l83Uu");

var $eKonk = parcelRequire("eKonk");

var $eCZ6m = parcelRequire("eCZ6m");
const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
    const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
    if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
    return result;
};
const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
};
const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
    (0, $l83Uu.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $eCZ6m.getAggEndpoint)(compiledQuery.params);
    const body = (0, $eCZ6m.getRequestBody)(compiledQuery.params, variables);
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)(capability ?? null);
    $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'Content-Type': 'application/json',
            Accept: 'application/json,text/javascript,*/*',
            'X-ExperimentalApi': experimentalApis.join(','),
            ...(0, $tcn7E.getActiveTraceHttpRequestHeaders)(endpoint),
            ...capabilityHeader ? {
                [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
            } : {}
        },
        method: 'POST',
        body: body
    }).then((response)=>{
        (0, $l83Uu.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("l83Uu", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $ef655a7b07a35675$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $ef655a7b07a35675$export$e88cb5bfb57ce9c4);

var $dO0aE = parcelRequire("dO0aE");
const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);

});
parcelRegister("dO0aE", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $7345e390d0c3a088$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7345e390d0c3a088$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $7345e390d0c3a088$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $7345e390d0c3a088$export$26e841bcf1aeb894 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $7345e390d0c3a088$export$895e385291c3b753 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});



parcelRegister("jlPGx", function(module, exports) {

$parcel$export(module.exports, "registerEvent", () => $8c8d2c511a52b5a9$export$bd50bc4cd3c601ee);
const $8c8d2c511a52b5a9$var$events = [];
const $8c8d2c511a52b5a9$export$bd50bc4cd3c601ee = (event)=>{
    $8c8d2c511a52b5a9$var$events.push(event);
};
/**
 * Take all events registered so far, return them, and clear the list.
 */ const $8c8d2c511a52b5a9$export$3c7145db84d4587c = ()=>{
    return $8c8d2c511a52b5a9$var$events.splice(0, $8c8d2c511a52b5a9$var$events.length);
};

});

parcelRegister("ifOJ4", function(module, exports) {

$parcel$export(module.exports, "getClientDispatcher", () => $c402b43f217e880b$export$5bb012cf9b3a5452);
let $c402b43f217e880b$var$dispatcher;
/**
 * The glue between a {@link ServerToClientEvent} and a client-side component.
 *
 * This class is responsible for ingesting events from the server and dispatching them to the correct component.
 *
 * Components hoping to be called from the server must be registered. Today, that's a manual call a developer
 * needs to make. Tomorrow, that may be automatically generated by the compiler reading a code annotation.
 */ class $c402b43f217e880b$var$ClientDispatcher {
    #handlers;
    #queuedPayloads;
    constructor(){
        this.#handlers = new Map();
        this.#queuedPayloads = new Map();
    }
    /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ ingest(payload) {
        const handler = this.#handlers.get(payload.id);
        if (handler) this.#exec(handler, payload);
        else {
            const queue = this.#queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.#queuedPayloads.set(payload.id, queue);
        }
    }
    /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ register(id, callback) {
        this.#handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.#queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.#exec(callback, payload));
            this.#queuedPayloads.delete(id);
        }
    }
    /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ #exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}
const $c402b43f217e880b$export$5bb012cf9b3a5452 = ()=>{
    if (!$c402b43f217e880b$var$dispatcher) $c402b43f217e880b$var$dispatcher = new $c402b43f217e880b$var$ClientDispatcher();
    return $c402b43f217e880b$var$dispatcher;
};

});

parcelRegister("jCRE8", function(module, exports) {

$parcel$export(module.exports, "processMultipartPromise", () => $263b59cc260a85be$export$f76505a7f2969e4e);
$parcel$export(module.exports, "withErrorHandling", () => $263b59cc260a85be$export$c874c20f7c9f97c);
$parcel$export(module.exports, "buildGraphqlFetch", () => $263b59cc260a85be$export$744180da2870332e);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $eiowN = parcelRequire("eiowN");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $5HnTq = parcelRequire("5HnTq");


var $eusud = parcelRequire("eusud");
function $263b59cc260a85be$var$getBoundary(contentType) {
    const boundaryMatch = contentType.match(/boundary=['"]([^;]+)['"]/);
    return boundaryMatch ? boundaryMatch[1] : null;
}
/**
 * Processes a chunk of multipart data and emits parsed JSON payloads to the observer
 * Uses a more memory-efficient approach by processing chunks directly
 */ function $263b59cc260a85be$var$processChunk(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [, body] = part.split(/\r?\n\r?\n/);
            if (body) try {
                const jsonData = JSON.parse(body.trim());
                observer.next(jsonData);
            } catch (error) {
                observer.error(new Error(`Invalid JSON: ${error instanceof Error ? error.message : String(error)}`));
            }
        }
    }
    // Return the last part which might be incomplete
    return parts[parts.length - 1];
}
/**
 * Processes a ReadableStream of multipart data with improved memory efficiency
 */ async function $263b59cc260a85be$var$processStream(reader, boundary, observer) {
    const decoder = new TextDecoder('utf-8');
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    const processNextChunk = async ()=>{
        const result = await reader.read();
        if (result.done) {
            // Process any remaining data
            if (incompleteChunk.length > 0) $263b59cc260a85be$var$processChunk(incompleteChunk, boundaryString, observer);
            observer.complete();
            return;
        }
        // Decode the new chunk and combine with any incomplete data from previous chunk
        const newText = decoder.decode(result.value, {
            stream: true
        });
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $263b59cc260a85be$var$processChunk(combinedChunk, boundaryString, observer);
        return processNextChunk();
    };
    await processNextChunk();
}
function $263b59cc260a85be$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $263b59cc260a85be$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const reader = response.body?.getReader();
    if (!reader) {
        observer.error(new Error('Failed to get reader from response body'));
        return;
    }
    $263b59cc260a85be$var$processStream(reader, boundary, observer).catch((error)=>observer.error(error));
}
function $263b59cc260a85be$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>observer.next(data)).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $263b59cc260a85be$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>observer.error(error));
}
function $263b59cc260a85be$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $eiowN.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $263b59cc260a85be$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $263b59cc260a85be$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $263b59cc260a85be$var$handleMultipartResponse(response, observer);
            else observer.error(new Error(`Unsupported content type: ${contentType}`));
        }).catch((error)=>observer.error(error));
    });
}
function $263b59cc260a85be$export$c874c20f7c9f97c(source) {
    return source.then((0, $eusud.handleErrors)).catch((0, $eusud.handleNetworkErrors));
}
function $263b59cc260a85be$export$744180da2870332e(url, options) {
    const acceptableFormats = [
        'application/graphql-response+json',
        'application/json'
    ];
    // Accept multipart responses on the client, or only on servers that explicitly support receiving and then handing over incremental responses.
    // @ts-expect-error the global is placed there by bifrost SSR. See src/entry-fs/util/render.tsx
    if (!(false && !globalThis.__SSR_HANDOVER_INCREMENTS)) acceptableFormats.push('multipart/mixed');
    const postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: acceptableFormats.join(', ')
        }
    };
    return ()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            ...options,
            ...postOptions
        }));
}
function $263b59cc260a85be$export$2586da7b5f4b5763(url, options) {
    const fetchFn = $263b59cc260a85be$export$744180da2870332e(url, options);
    return $263b59cc260a85be$export$f76505a7f2969e4e(()=>$263b59cc260a85be$export$c874c20f7c9f97c(fetchFn()));
}

});
parcelRegister("8KpGl", function(module, exports) {

$parcel$export(module.exports, "getReroutableURL", () => $e8054b634989671a$export$23769875e8eebaf6);

var $g96Vw = parcelRequire("g96Vw");
// FIXME: Pillar to define entire URL, not just hostname.
const $e8054b634989671a$var$LOCAL_URL = new URL(`${'http'}://${(0, $g96Vw.getDevHostname)()}:${(0, $g96Vw.getProxyServerPort)()}`);
function $e8054b634989671a$export$23769875e8eebaf6(pathOrURL) {
    var e;
    return pathOrURL;
}

});
parcelRegister("g96Vw", function(module, exports) {

$parcel$export(module.exports, "getDevHostname", () => $e257580e5f260c28$export$a6aba27c4797e08b);
$parcel$export(module.exports, "getProxyServerPort", () => $e257580e5f260c28$export$6819122a922c6aaf);
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */ const $e257580e5f260c28$export$a6aba27c4797e08b = ()=>{
    const envDns = undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
function $e257580e5f260c28$export$6819122a922c6aaf() {
    return 9000;
}

});


const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("eusud", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $3637c0f7edbd2bb4$export$8e9baed7697e4959);
$parcel$export(module.exports, "handleNetworkErrors", () => $3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
$parcel$export(module.exports, "handleErrors", () => $3637c0f7edbd2bb4$export$1e36de371b2e3d5a);
$parcel$export(module.exports, "applyErrorHandling", () => $3637c0f7edbd2bb4$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $3637c0f7edbd2bb4$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $3637c0f7edbd2bb4$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $3637c0f7edbd2bb4$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $3637c0f7edbd2bb4$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $3637c0f7edbd2bb4$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $3637c0f7edbd2bb4$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $3637c0f7edbd2bb4$export$a5717cbee13f28b7);


var $jp5kW = parcelRequire("jp5kW");

var $5HnTq = parcelRequire("5HnTq");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $6b2ko = parcelRequire("6b2ko");

var $iwPwz = parcelRequire("iwPwz");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $3637c0f7edbd2bb4$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $jJZqs.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $3637c0f7edbd2bb4$var$putOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PUT'
};
const $3637c0f7edbd2bb4$var$postOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'POST'
};
const $3637c0f7edbd2bb4$var$deleteOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'DELETE'
};
const $3637c0f7edbd2bb4$var$patchOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PATCH'
};
const $3637c0f7edbd2bb4$export$b47ad9bdf9122b88 = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $3637c0f7edbd2bb4$export$1e36de371b2e3d5a = (response)=>{
    const traceId = (0, $iwPwz.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status || (0, $3cd8a0ece36fbae5$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $3637c0f7edbd2bb4$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $3637c0f7edbd2bb4$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff(fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $jp5kW.default)('platform_fetch_retries')) return executeRequest();
    return (0, $6b2ko.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$692a4d9808143175 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    })).then($3637c0f7edbd2bb4$export$1e36de371b2e3d5a).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$export$b47ad9bdf9122b88);
const $3637c0f7edbd2bb4$export$659b5ee69e6eb976 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    });
const $3637c0f7edbd2bb4$export$d7b48b2904a5d812 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$a5717cbee13f28b7 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$6d01bf1146815b9b = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$560989ee94ad2a20 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    });

});
parcelRegister("iwPwz", function(module, exports) {

$parcel$export(module.exports, "getTraceId", () => $19a21974d2ff6598$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $19a21974d2ff6598$export$b569b31eebca952d);

var $fnyT4 = parcelRequire("fnyT4");
const $19a21974d2ff6598$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $fnyT4.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $19a21974d2ff6598$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $fnyT4.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("fnyT4", function(module, exports) {

$parcel$export(module.exports, "TRACE_ID_HEADER", () => $5d3410503b671c4b$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $5d3410503b671c4b$export$830a89e935012abe);
const $5d3410503b671c4b$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $5d3410503b671c4b$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $5d3410503b671c4b$export$830a89e935012abe = [
    $5d3410503b671c4b$export$4b69438fb7c7b9b2,
    $5d3410503b671c4b$var$TRACE_ID_HEADER_MICROS
];

});




parcelRegister("lKFKm", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $42cb6e1c2fdc593e$export$758fcc357484571e);

var $pa9q9 = parcelRequire("pa9q9");

var $fjcgS = parcelRequire("fjcgS");

var $8iiwm = parcelRequire("8iiwm");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $42cb6e1c2fdc593e$var$reloadPage = ()=>window.location.reload();
const $42cb6e1c2fdc593e$var$sendAnalyticEvent = (operationName)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $42cb6e1c2fdc593e$export$758fcc357484571e = (operationName)=>{
    (0, $pa9q9.showFlag)({
        type: 'error',
        title: (0, $8iiwm.default).title,
        description: (0, $8iiwm.default).description,
        messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $8iiwm.default).login,
                onClick: $42cb6e1c2fdc593e$var$reloadPage
            }
        ]
    });
    $42cb6e1c2fdc593e$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("pa9q9", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $00ff685527f9e8c1$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $00ff685527f9e8c1$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $00ff685527f9e8c1$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $00ff685527f9e8c1$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $00ff685527f9e8c1$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $00ff685527f9e8c1$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $00ff685527f9e8c1$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $00ff685527f9e8c1$export$c126d8b307b8ab86);

var $fHfPB = parcelRequire("fHfPB");

var $gEdnQ = parcelRequire("gEdnQ");

var $01A9Z = parcelRequire("01A9Z");

var $7HGHK = parcelRequire("7HGHK");
const $00ff685527f9e8c1$export$e12b2cc6b75b006b = (0, $gEdnQ.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$export$900a08a292ad23cd = (0, $fHfPB.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$var$dismissFlagById = (id)=>{
    $00ff685527f9e8c1$export$900a08a292ad23cd((0, $fHfPB.dismissFlag)(id));
};
const $00ff685527f9e8c1$var$hasFlag = (id)=>Boolean((0, $01A9Z.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $00ff685527f9e8c1$export$dbb055af53fd81a0 = {
    showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
    dismissFlag: $00ff685527f9e8c1$export$900a08a292ad23cd
};
const $00ff685527f9e8c1$export$eee61a1aafe3884 = ()=>({
        showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
        dismissFlag: $00ff685527f9e8c1$var$dismissFlagById,
        hasFlag: $00ff685527f9e8c1$var$hasFlag
    });
const $00ff685527f9e8c1$export$dc4f8132c3090b32 = ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0;
const $00ff685527f9e8c1$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $7HGHK.DISMISS_COMMAND);
const $00ff685527f9e8c1$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $00ff685527f9e8c1$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $00ff685527f9e8c1$export$63ffd7d99470afd4 = (flag)=>!$00ff685527f9e8c1$export$14b1864d9cf0809f(flag) && !$00ff685527f9e8c1$export$d84ce5adcee46025(flag) && !$00ff685527f9e8c1$export$cd5f9f2b991b82d9(flag);
const $00ff685527f9e8c1$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("fHfPB", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $8eb241d1a1f5d9b7$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $8eb241d1a1f5d9b7$export$2e2bcd8739ae039);

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
const $8eb241d1a1f5d9b7$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $7HGHK.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8eb241d1a1f5d9b7$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $d6YjM.dismissFlagAction)(action.id));
    };

});
parcelRegister("d6YjM", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $07f19e2fef34903b$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $07f19e2fef34903b$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $07f19e2fef34903b$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $07f19e2fef34903b$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $07f19e2fef34903b$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $07f19e2fef34903b$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $07f19e2fef34903b$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $07f19e2fef34903b$export$aad8462122ac592b);
const $07f19e2fef34903b$export$9d04158a25ce4cd = 'state.SHOW';
const $07f19e2fef34903b$export$57bf213be019eeb0 = (payload)=>({
        type: $07f19e2fef34903b$export$9d04158a25ce4cd,
        payload: payload
    });
const $07f19e2fef34903b$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $07f19e2fef34903b$export$abf286bbe7073aba = (payload)=>({
        type: $07f19e2fef34903b$export$b31a07d2e6382678,
        payload: payload
    });
const $07f19e2fef34903b$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $07f19e2fef34903b$export$4818b3c52448050d = (payload)=>({
        type: $07f19e2fef34903b$export$1eb56620df104bf,
        payload: payload
    });
const $07f19e2fef34903b$export$4a991c87e640ef77 = 'state.RESET';
const $07f19e2fef34903b$export$aad8462122ac592b = ()=>({
        type: $07f19e2fef34903b$export$4a991c87e640ef77
    });

});

parcelRegister("7HGHK", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $9deb2cdefe93babb$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $9deb2cdefe93babb$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $9deb2cdefe93babb$export$188cdb77b72629d7);
const $9deb2cdefe93babb$export$e705274c5e156b93 = 'DISMISS';
const $9deb2cdefe93babb$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $9deb2cdefe93babb$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("gEdnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c019df33694ffbe1$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c019df33694ffbe1$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $d6YjM.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $d6YjM.show)(newFlag));
        return flagId;
    };

});

parcelRegister("01A9Z", function(module, exports) {

$parcel$export(module.exports, "store", () => $5787309a6ab0ba9c$export$6f57813fe9f31bf9);

var $imvpl = parcelRequire("imvpl");
const $5787309a6ab0ba9c$export$6f57813fe9f31bf9 = (0, $imvpl.createStore)();

});
parcelRegister("imvpl", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6bbcd4b408b9a94e$export$f51a9068ac82ea43);

var $F2Mxm = parcelRequire("F2Mxm");

var $gG398 = parcelRequire("gG398");
const $6bbcd4b408b9a94e$export$f51a9068ac82ea43 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'flags',
        rootReducer: $gG398.default,
        rootEpic: rootEpic
    });

});
parcelRegister("F2Mxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca77440264e922e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $iGv2H = parcelRequire("iGv2H");

var $hkadP = parcelRequire("hkadP");

var $i9gPl = parcelRequire("i9gPl");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$fca77440264e922e$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $i9gPl.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $iGv2H.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("korqb"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $e1AU2.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)(rootReducer), initialState, (0, $hkadP.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $5uXOq.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $3f2cs.compose)(...enhancers, (0, $3f2cs.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("iGv2H", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $a4079cece44c0fab$export$342c99cc1e9bc5c6);
const $a4079cece44c0fab$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("hkadP", function(module, exports) {

$parcel$export(module.exports, "default", () => $607c98afd3082218$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$607c98afd3082218$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $3f2cs.compose;
};

});

parcelRegister("i9gPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $330df53c22ed8aaf$export$2e2bcd8739ae039);
class $330df53c22ed8aaf$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("gG398", function(module, exports) {

$parcel$export(module.exports, "default", () => $1feeabef4760da78$export$2e2bcd8739ae039);

var $ifg6x = parcelRequire("ifg6x");

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");
const $1feeabef4760da78$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$1feeabef4760da78$export$2e2bcd8739ae039 = (state = $1feeabef4760da78$var$defaultState, action)=>{
    switch(action.type){
        case 0, $d6YjM.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))([
                    {
                        id: (0, $7Jxgt.v4)(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $d6YjM.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $d6YjM.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $d6YjM.RESET:
            return $1feeabef4760da78$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("8iiwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7ec0f26423b786$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c7ec0f26423b786$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("7isEg", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $6c554999a424d172$export$726e1df8186bb981);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");
const $6c554999a424d172$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $6c554999a424d172$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $2YZCu.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: (error)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $2YZCu.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'name'
                ], null)
            });
        },
        logErrorRetry: (error, retryAttempt)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $2YZCu.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'name'
                ], null),
                retryAttempt: retryAttempt
            });
        }
    };
};

});

parcelRegister("aLyyN", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $00bea5ba58fba29b$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "blocklist", () => $00bea5ba58fba29b$export$c5c28c9e707bcda1);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $00bea5ba58fba29b$export$9dec0f42cc67f6ab);
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $00bea5ba58fba29b$export$eefb7f54c3b07211);
$parcel$export(module.exports, "getRequestIdFromExtensions", () => $00bea5ba58fba29b$export$751e3e5dc81a08d0);
$parcel$export(module.exports, "generateOptions", () => $00bea5ba58fba29b$export$c21133b4499f5374);
$parcel$export(module.exports, "shouldRetry", () => $00bea5ba58fba29b$export$7bfea3c3d460ecd8);

var $hGgHi = parcelRequire("hGgHi");

var $1UikQ = parcelRequire("1UikQ");

var $kTK0a = parcelRequire("kTK0a");

var $2I8bw = parcelRequire("2I8bw");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $6b2ko = parcelRequire("6b2ko");

var $4tcSU = parcelRequire("4tcSU");

var $gwtGO = parcelRequire("gwtGO");
let $00bea5ba58fba29b$var$redirecting = false;
const $00bea5ba58fba29b$var$redirect = ()=>{
    const identity = (0, $kTK0a.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
const $00bea5ba58fba29b$export$b8dbb7d6029c5413 = ()=>{
    if (!false && !$00bea5ba58fba29b$var$redirecting) {
        const heartbeatService = (0, $2I8bw.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            $00bea5ba58fba29b$var$redirect();
            // Set flag to prevent multiple redirects
            $00bea5ba58fba29b$var$redirecting = true;
        }
    }
    return $00bea5ba58fba29b$var$redirecting;
};
const $00bea5ba58fba29b$export$c5c28c9e707bcda1 = [
    'issueAggQuery'
];
const $00bea5ba58fba29b$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $6b2ko.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $00bea5ba58fba29b$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
const $00bea5ba58fba29b$export$751e3e5dc81a08d0 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.request_id;
    return undefined;
};
const $00bea5ba58fba29b$export$c21133b4499f5374 = (options = {}, url = null)=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $4tcSU.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $5HnTq.getDefaultOptions)((0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? url : null),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(','),
            ...csrfTokenHeader
        }
    });
};
const $00bea5ba58fba29b$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $jJZqs.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});
parcelRegister("gwtGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1019e315ad42f34a$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $1019e315ad42f34a$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});



parcelRegister("dMryf", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $cad88c39422b51e7$export$e7aa7bc5c1b3cfb3);

var $hGgHi = parcelRequire("hGgHi");

var $eiowN = parcelRequire("eiowN");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $6b2ko = parcelRequire("6b2ko");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $7pVV3 = parcelRequire("7pVV3");

var $ajjqZ = parcelRequire("ajjqZ");

var $4pgHP = parcelRequire("4pgHP");

var $eCZ6m = parcelRequire("eCZ6m");

var $5Wobd = parcelRequire("5Wobd");

var $lKFKm = parcelRequire("lKFKm");

var $7isEg = parcelRequire("7isEg");

var $aLyyN = parcelRequire("aLyyN");
const $cad88c39422b51e7$var$getQueryResponseCache = ()=>(0, $4R6GH.fg)('jfp_magma_fix_relay_query_cache_loading_from_ssr') ? (0, $7pVV3.getQueryResponseCache)() : (0, $7pVV3.QueryResponseCache);
const $cad88c39422b51e7$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    const redirecting = (0, $aLyyN.checkAuthentication)();
    if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (0, $eiowN.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $ajjqZ.claimEarlyScriptPromise)((0, $ajjqZ.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $7isEg.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $eiowN.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $eCZ6m.getAggEndpoint)(request, cacheConfig);
            const body = (0, $eCZ6m.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = $cad88c39422b51e7$var$getQueryResponseCache().get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) $cad88c39422b51e7$var$getQueryResponseCache().delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $6b2ko.retryOnError)(()=>(0, $eusud.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $eusud.performPostRequest)(endpoint, (0, $aLyyN.generateOptions)({
                        body: body
                    }, endpoint)),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $eusud.performPostRequestWithRetry)(endpoint, {
                ...(0, $aLyyN.generateOptions)({
                    body: body
                }, endpoint),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                if ((0, $4R6GH.fg)('obsrve-2487-gql-use-traceid-extensions-field')) (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getTraceIdFromExtensions)(response));
                else (0, $5Wobd.addTraceId)(queryName, (0, $aLyyN.getRequestIdFromExtensions)(response));
                (0, $4pgHP.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!(0, $aLyyN.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $5a0Nh.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $5a0Nh.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $lKFKm.showUnauthenticatedFlag)(queryName);
                        // Surprise behaviour: the observable should hang indefinitely here!
                        // At least, that is the expectation of existing code; see src/packages/issue/issue-view/src/integration-tests/experience-tracking/view.cy-integration.tsx
                        // Which assumes that the operation never completes, so relay never receives a (null) response, so it never complains about the data.
                        // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) $cad88c39422b51e7$var$getQueryResponseCache().setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) // todo: stop sending the value of the promise to QueryPromisesMap. Might happen as part of cleaning up the feature gate for defer support writ large.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $kipqU.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});


parcelRegister("k1TrK", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $4ced6779db298dc0$export$ec068583843480e7);

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $lWhTC = parcelRequire("lWhTC");

var $1Uhm6 = parcelRequire("1Uhm6");

var $cfDZ3 = parcelRequire("cfDZ3");
const $4ced6779db298dc0$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $eiowN.Observable).create((sink)=>{
        const client = (0, $lWhTC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.gateway?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $1Uhm6.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $cfDZ3.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("lWhTC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $2a46eca1e9133707$export$6bb76d6eba7e258c);

var $4U1PW = parcelRequire("4U1PW");

var $jp5kW = parcelRequire("jp5kW");

var $gwtGO = parcelRequire("gwtGO");


var $hoQbP = parcelRequire("hoQbP");
let $2a46eca1e9133707$var$client;
const $2a46eca1e9133707$export$6bb76d6eba7e258c = ()=>{
    if ((0, $hoQbP.isSSR)() || (0, $jp5kW.default)('graphql_subscriptions')) return null;
    if (!$2a46eca1e9133707$var$client) $2a46eca1e9133707$var$client = (0, $4U1PW.createClient)({
        url: (0, $hoQbP.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $37d1b046897e548f$export$8b012b965402e06a),
        retryAttempts: (0, $37d1b046897e548f$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(',')
        }
    });
    return $2a46eca1e9133707$var$client;
};
const $2a46eca1e9133707$export$2f0afd443356d36f = ()=>{
    $2a46eca1e9133707$var$client = null;
};

});
const $37d1b046897e548f$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("hoQbP", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $9e6d9986231c3fe5$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $9e6d9986231c3fe5$export$29a72e89601dfc59);
const $9e6d9986231c3fe5$export$48d7c418edadb60c = ()=>false ?? false;
const $9e6d9986231c3fe5$export$29a72e89601dfc59 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("1Uhm6", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $db2d4e9951ebaa0f$export$ece4736473c28965);
const $db2d4e9951ebaa0f$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`ErrorEvent: "${error.error}"`);
    else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});


parcelRegister("fwvto", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $c5bf640417859136$export$48d7c418edadb60c);
const $c5bf640417859136$export$48d7c418edadb60c = ()=>false ?? false;

});





parcelRegister("a83ud", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0);

var $5uXOq = parcelRequire("5uXOq");

var $j7rCb = parcelRequire("j7rCb");
const $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $j7rCb.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("hWnRN", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("iNWLk", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $6377b132f88aa82c$export$8b4a0fffcddd96f4);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");
const $6377b132f88aa82c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, children));

});

parcelRegister("9F6Ii", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $02febe252cc7980c$export$5f8d39834fd61797);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $02febe252cc7980c$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = !(0, $4R6GH.fg)('jira-enable-strict-mode');
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled by default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).StrictMode, null, children);
};

});

parcelRegister("amLL8", function(module, exports) {

let $78c101733f7c73a9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $78c101733f7c73a9$var$load("hPzOn"),
    $78c101733f7c73a9$var$load("cM9em"),
    $78c101733f7c73a9$var$load("fr9NE"),
    $78c101733f7c73a9$var$load("h46oV")
]).then(()=>parcelRequire('3jTq3'));

});


parcelRegister("7o9iL", function(module, exports) {

$parcel$export(module.exports, "default", () => $87698987077682aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $9F6Ii = parcelRequire("9F6Ii");

var $TtQEC = parcelRequire("TtQEC");
const $87698987077682aa$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $87698987077682aa$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TtQEC.default), {
        sessionId: sessionId,
        data: data
    })), $87698987077682aa$var$getPlaceholder(placeholder));
};
var $87698987077682aa$export$2e2bcd8739ae039 = $87698987077682aa$var$renderDwellTimeComponent;

});
parcelRegister("TtQEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ee37fd26b4ccf1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");


var $l7nSX = parcelRequire("l7nSX");
const $c8ee37fd26b4ccf1$var$defaultSource = 'dwellComponent';
const $c8ee37fd26b4ccf1$var$defaultActionSubject = 'dwellComponent';
const $c8ee37fd26b4ccf1$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSubject)(actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject), (0, $jzjy1.AnalyticsSource)(source || $c8ee37fd26b4ccf1$var$defaultSource, (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))((0, $l7nSX.default));
class $c8ee37fd26b4ccf1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $c8ee37fd26b4ccf1$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $c8ee37fd26b4ccf1$var$defaultSource,
            actionSubject: data && data.actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("jzjy1", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $578c443a5ba38dde$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $578c443a5ba38dde$export$ec9f54bd4341ceb);

var $994MI = parcelRequire("994MI");
const $578c443a5ba38dde$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $994MI.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $578c443a5ba38dde$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $994MI.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("l7nSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5cee06f4a100e3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9E7Uh = parcelRequire("9E7Uh");

var $8oe80 = parcelRequire("8oe80");

var $hhweD = parcelRequire("hhweD");
class $8c5cee06f4a100e3$export$1c7ccff61c195c75 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $9E7Uh.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args), this.sendDwellEvent = (payload)=>(0, $hhweD.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $8c5cee06f4a100e3$export$2e2bcd8739ae039 = (0, $8oe80.default)('dwellTime', {
    onDwell: 'dwelled'
})($8c5cee06f4a100e3$export$1c7ccff61c195c75);

});
parcelRegister("8oe80", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd6b229cbb45328e$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");
const $cd6b229cbb45328e$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cd6b229cbb45328e$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $994MI.default)({
            componentName: componentName
        })((0, $cb25w.default)($cd6b229cbb45328e$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $cd6b229cbb45328e$export$2e2bcd8739ae039 = $cd6b229cbb45328e$var$componentWithAnalytics;

});

parcelRegister("hhweD", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $a4297ed46523d116$export$13990ad4625571ed);

var $4f8Oj = parcelRequire("4f8Oj");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
const $a4297ed46523d116$var$isNotUndefined = (a)=>a !== undefined;
const $a4297ed46523d116$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $a4297ed46523d116$var$isNotUndefined);
};
const $a4297ed46523d116$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$a4297ed46523d116$var$mapPayload(payload),
        analyticsType: (0, $gvRPW.TRACK_EVENT_TYPE)
    }).fire();
};

});
parcelRegister("i4iBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a364fe632bf506b$export$2e2bcd8739ae039);

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");
var // AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
// eslint-disable-next-line jira/import/no-anonymous-default-export
$8a364fe632bf506b$export$2e2bcd8739ae039 = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};

});





parcelRegister("dZTqe", function(module, exports) {

let $a30bf69036916119$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a30bf69036916119$var$load("cM9em"),
    $a30bf69036916119$var$load("fr9NE"),
    $a30bf69036916119$var$load("h2MrD"),
    $a30bf69036916119$var$load("bYT2S"),
    $a30bf69036916119$var$load("2ZtG1")
]).then(()=>parcelRequire('2Q8el'));

});

parcelRegister("dxZMM", function(module, exports) {

let $9dce48cd330800c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9dce48cd330800c0$var$load("cM9em"),
    $9dce48cd330800c0$var$load("fr9NE"),
    $9dce48cd330800c0$var$load("eNmuD"),
    $9dce48cd330800c0$var$load("hPzOn"),
    $9dce48cd330800c0$var$load("h2MrD"),
    $9dce48cd330800c0$var$load("bYT2S"),
    $9dce48cd330800c0$var$load("54DPr")
]).then(()=>parcelRequire('forzB'));

});

parcelRegister("jzW9D", function(module, exports) {

let $e40e6574e3580374$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e40e6574e3580374$var$load("bERdS").then(()=>parcelRequire('8ymsB'));

});

parcelRegister("h7Vx2", function(module, exports) {

let $c77fb7b878cc8e70$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c77fb7b878cc8e70$var$load("3PrnJ"),
    $c77fb7b878cc8e70$var$load("h2MrD"),
    $c77fb7b878cc8e70$var$load("bYT2S"),
    $c77fb7b878cc8e70$var$load("cM9em"),
    $c77fb7b878cc8e70$var$load("fr9NE"),
    $c77fb7b878cc8e70$var$load("kWrFZ"),
    $c77fb7b878cc8e70$var$load("92sUi"),
    $c77fb7b878cc8e70$var$load("i5RRW"),
    $c77fb7b878cc8e70$var$load("9vNc4"),
    $c77fb7b878cc8e70$var$load("4ogRW"),
    $c77fb7b878cc8e70$var$load("kfXhT"),
    $c77fb7b878cc8e70$var$load("2Lfdl"),
    $c77fb7b878cc8e70$var$load("hPzOn"),
    $c77fb7b878cc8e70$var$load("dsiAd"),
    $c77fb7b878cc8e70$var$load("eNmuD"),
    $c77fb7b878cc8e70$var$load("dzRix")
]).then(()=>parcelRequire('faPQm'));

});

parcelRegister("feIhl", function(module, exports) {

let $b17a82a97a323842$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b17a82a97a323842$var$load("Nlduf").then(()=>parcelRequire('jEc6C'));

});


parcelRegister("8Xjsv", function(module, exports) {

$parcel$export(module.exports, "renderPageContainer", () => $17cccc58f3ff23f2$export$53746a9158b8b9c8);
$parcel$export(module.exports, "default", () => $17cccc58f3ff23f2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4Pf62 = parcelRequire("4Pf62");

var $frBVt = parcelRequire("frBVt");

var $i2Rm5 = parcelRequire("i2Rm5");

var $7bkFJ = parcelRequire("7bkFJ");

var $j8DrX = parcelRequire("j8DrX");
parcelRequire("2YzDH");

var $cfDZ3 = parcelRequire("cfDZ3");

var $9F6Ii = parcelRequire("9F6Ii");

var $81ezV = parcelRequire("81ezV");

var $b7awD = parcelRequire("b7awD");

var $hbs21 = parcelRequire("hbs21");

var $5HG6S = parcelRequire("5HG6S");

var $3qHVS = parcelRequire("3qHVS");

var $lGgkA = parcelRequire("lGgkA");

var $hnPK7 = parcelRequire("hnPK7");
var $2Gs5h = parcelRequire("2Gs5h");

// Trigger async import asap, no need for RLL as SSR renders without too
const $17cccc58f3ff23f2$var$pageContainerImport = (parcelRequire("g9ZQ1"));

var $hWnRN = parcelRequire("hWnRN");
const $17cccc58f3ff23f2$export$53746a9158b8b9c8 = async ({ App: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'ComponentType<any>'.
App = null, containerId: containerId = 'navigation-app', onLoad: onLoad, pageType: pageType = 'legacy-page' } = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById(containerId);
    if (container) {
        const { default: PageContainerV2 } = await $17cccc58f3ff23f2$var$pageContainerImport;
        (0, $lGgkA.LooselyLazy).init({
            mode: 'RENDER',
            crossOrigin: 'anonymous'
        });
        const tenantContext = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        $parcel$global.__NAV_VERSION__ = '3.0.0';
        (0, $7bkFJ.initPlatformFeatureFlags)((0, $3qHVS.visualRefreshResolverOverride));
        const history = (0, $hnPK7.createLegacyHistory)();
        const routes = (0, $hbs21.getLegacyRoutes)();
        const matchedRoute = (0, $2Gs5h.default)(routes, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.pathname, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search, '');
        (0, $cfDZ3.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        const resourceContext = (0, $5HG6S.getSpaRouterContext)({
            tenantContext: tenantContext
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resourceData = window.SKELETON_NAVIGATION;
        const LegacyRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), {
                history: history,
                routes: routes,
                resourceContext: resourceContext,
                resourceData: resourceData
            }, children);
        const placeholders = (0, $frBVt.getPlaceholdersFromHTML)();
        (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PageContainerV2, {
            id: "jira.entry.legacy",
            locale: tenantContext.locale,
            baseUrl: "",
            messages: $hWnRN,
            onLoad: onLoad,
            Router: LegacyRouter,
            routerLinkComponent: (0, $81ezV.JiraRouterLinkConfiguration),
            pageType: pageType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
            id: "jira.route-app.legacy-bootstrap"
        }, App ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, null) : null)))), container);
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$17cccc58f3ff23f2$export$2e2bcd8739ae039 = ()=>{
    const isGlobalSidebarEnabled = (0, $j8DrX.default)('ajs-global-sidebar-enabled') === 'true';
    if (!isGlobalSidebarEnabled) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.getElementById('navigation-app')) $17cccc58f3ff23f2$export$53746a9158b8b9c8();
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener('DOMContentLoaded', ()=>$17cccc58f3ff23f2$export$53746a9158b8b9c8());
};

});
parcelRegister("frBVt", function(module, exports) {

$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $126443352ff757de$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $126443352ff757de$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointReferencePlaceholder", () => $126443352ff757de$export$35247b69e0cfe74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");
const $126443352ff757de$var$styles = {
    root: "_1e0c1bgi"
};
function $126443352ff757de$export$9e9f35acc3af3a9a() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $126443352ff757de$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $5uXOq.createContext)(new Map());
function $126443352ff757de$export$35247b69e0cfe74({ children: children, entryPointReference: entryPointReference, fallback: originalFallback, name: name, ...placeholderProps }) {
    const hasMounted = (0, $5uXOq.useRef)(false);
    // using useState to ensure the entryPointReference is loaded synchronously
    // for the initial render (enabling SSR)
    const [component] = (0, $5uXOq.useState)(()=>{
        if (entryPointReference) try {
            return entryPointReference.getComponent();
        } catch (thrown) {
            return undefined;
        }
    });
    const placeholders = (0, $5uXOq.useContext)($126443352ff757de$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $5uXOq.useState)(!ssrFallback || component ? originalFallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name,
        className: (0, $bwpsq.default)([
            $126443352ff757de$var$styles.root
        ])
    }));
    const lastOriginalFallback = (0, $5uXOq.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    const resetFallback = (0, $5uXOq.useCallback)(()=>{
        if (placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        name,
        placeholders,
        setFallback
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // reset the fallback when the entrypoint reference changes
        if (hasMounted.current) resetFallback();
    }, [
        entryPointReference,
        resetFallback
    ]);
    (0, $5uXOq.useEffect)(()=>{
        hasMounted.current = true;
        // reset fallback on unmount
        return resetFallback;
    }, [
        resetFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-ep-placeholder-id": name,
        className: (0, $bwpsq.default)([
            $126443352ff757de$var$styles.root
        ])
    }, children));
}

});

parcelRegister("7bkFJ", function(module, exports) {

$parcel$export(module.exports, "initPlatformFeatureFlags", () => $fef4d3d4b4c51b47$export$2d291317456ada16);

var $VSDnB = parcelRequire("VSDnB");

var $4R6GH = parcelRequire("4R6GH");

var $co1wz = parcelRequire("co1wz");
const $fef4d3d4b4c51b47$export$2d291317456ada16 = ([isOverride, resolver])=>{
    (0, $VSDnB.setBooleanFeatureFlagResolver)((flagKey)=>// disable existence check as platform feature >flags< might not be gates
        (0, $4R6GH.withoutFeatureExistenceCheck)(()=>isOverride(flagKey) ? resolver(flagKey) : (0, $4R6GH.fg)(flagKey) || (0, $co1wz.ff)(flagKey)));
};

});

parcelRegister("2YzDH", function(module, exports) {
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $jOqMN = parcelRequire("jOqMN");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("2Geeh"));
    const isDevMode = false;
    (0, $jOqMN.default).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $jOqMN.default).batchUpdates = !false;
    Object.freeze((0, $jOqMN.default));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("2Geeh", function(module, exports) {
const $1f3a8aadd86b4cc5$var$style = document.createElement('style');
$1f3a8aadd86b4cc5$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ul style:first-child~*+ul,ol ul:not(:first-child),ol style:first-child~*+ul,ul ol:not(:first-child),ul style:first-child~*+ol,ol ol:not(:first-child),ol style:first-child~*+ol{margin-top:var(--ds-space-050,4px)}p:first-child,style:first-child+p,ul:first-child,style:first-child+ul,ol:first-child,style:first-child+ol,dl:first-child,style:first-child+dl,h1:first-child,style:first-child+h1,h2:first-child,style:first-child+h2,h3:first-child,style:first-child+h3,h4:first-child,style:first-child+h4,h5:first-child,style:first-child+h5,h6:first-child,style:first-child+h6,blockquote:first-child,style:first-child+blockquote,pre:first-child,style:first-child+pre,form:first-child,style:first-child+form,table:first-child,style:first-child+table{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,ui-monospace,Menlo,"Segoe UI Mono","Ubuntu Mono",monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{color-scheme:light}[data-color-mode=dark]{color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,style:first-child+td,th:first-child,style:first-child+th{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($1f3a8aadd86b4cc5$var$style);

});


parcelRegister("81ezV", function(module, exports) {

$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $33ea5bfeb747665b$export$a580704a2f3cfca);

var $5uXOq = parcelRequire("5uXOq");

var $hjSul = parcelRequire("hjSul");
const $33ea5bfeb747665b$export$a580704a2f3cfca = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ref: ref,
        href: href || '#',
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest
    }, children);
});

});

parcelRegister("b7awD", function(module, exports) {

$parcel$export(module.exports, "Router", () => $87aa2fd82c8be71a$export$55185c17a0fcbe46);

var $5uXOq = parcelRequire("5uXOq");

var $15Xx4 = parcelRequire("15Xx4");

var $d8orV = parcelRequire("d8orV");
const $87aa2fd82c8be71a$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $d8orV.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15Xx4.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("d8orV", function(module, exports) {

$parcel$export(module.exports, "usePlugins", () => $0614c9d3afc2dd7f$export$c41e96fd89bc6106);

var $5uXOq = parcelRequire("5uXOq");

var $a2g00 = parcelRequire("a2g00");

var $5yJb9 = parcelRequire("5yJb9");

var $9OXo1 = parcelRequire("9OXo1");

var $8Y8sk = parcelRequire("8Y8sk");
const $0614c9d3afc2dd7f$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $5uXOq.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $8Y8sk.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $a2g00.createEntryPointsPlugin)({
            environment: (0, $5yJb9.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("a2g00", function(module, exports) {

$parcel$export(module.exports, "createEntryPointsPlugin", () => $e3cbf02360bc6f96$export$33586718f82f356f);

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $3gC8D = parcelRequire("3gC8D");

var $3I4nj = parcelRequire("3I4nj");

var $ktB2C = parcelRequire("ktB2C");

var $9dbn9 = parcelRequire("9dbn9");

var $gH2st = parcelRequire("gH2st");
const $e3cbf02360bc6f96$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $3I4nj.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefethed right before being loaded
                if (prefetchingRoute && (0, $3gC8D.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $3gC8D.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else {
                    const entryPointParamsWithContext = {
                        context: context,
                        ...entryPointParams
                    };
                    const loadEntryPointsWithContext = ()=>(0, $8Uumt.loadEntryPoint)({
                            getEnvironment: ()=>environment
                        }, entryPoint, entryPointParamsWithContext);
                    entryPointReference = false && (0, $4R6GH.fg)('jira-ssr-prevent-prewarming-entrypoint-in-prefetch') ? (0, $gH2st.default)(entryPoint, entryPointParamsWithContext, loadEntryPointsWithContext) : loadEntryPointsWithContext();
                }
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $3I4nj.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $3I4nj.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $3gC8D.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $3gC8D.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $8Uumt.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $3I4nj.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $3gC8D.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $3I4nj.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $3I4nj.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $ktB2C.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        },
        getStats: async ()=>{
            const lastLoadedRoute = (0, $3I4nj.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $9dbn9.getEntryPointStats)(entryPointReference);
            return [];
        }
    });

});
parcelRegister("3gC8D", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $f48ce76f20803aec$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $f48ce76f20803aec$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $f48ce76f20803aec$export$5997e70fc4543270);
const $f48ce76f20803aec$export$37d3126be6549b13 = 10000;
const $f48ce76f20803aec$export$b65d7ba7fbf150f1 = ()=>$f48ce76f20803aec$export$37d3126be6549b13 + Date.now();
const $f48ce76f20803aec$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $f48ce76f20803aec$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $f48ce76f20803aec$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("3I4nj", function(module, exports) {

$parcel$export(module.exports, "useLastLoadedRoute", () => $f09634e8d32626d1$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $f09634e8d32626d1$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $f09634e8d32626d1$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $f09634e8d32626d1$export$7e18f3e3cbd04326);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $bKpgX = parcelRequire("bKpgX");
const $f09634e8d32626d1$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $f09634e8d32626d1$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $f09634e8d32626d1$var$actions = {
    setLastLoadedRoute: $f09634e8d32626d1$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $f09634e8d32626d1$export$bb3dc9c55f78173e
};
const $f09634e8d32626d1$var$EntryPointsStore = (0, $iXqE5.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $f09634e8d32626d1$var$actions,
    name: 'react-resource-router/entry-points'
});
const $f09634e8d32626d1$export$895238443fc3eae4 = (0, $3sQ5x.createHook)($f09634e8d32626d1$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $f09634e8d32626d1$export$fe654a734624d17f = ()=>(0, $bKpgX.defaultRegistry).getStore($f09634e8d32626d1$var$EntryPointsStore);
const $f09634e8d32626d1$export$b28ecd0e4705f6b7 = ()=>$f09634e8d32626d1$export$fe654a734624d17f().storeState.getState();
const $f09634e8d32626d1$export$5763b2305b3056df = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $f09634e8d32626d1$export$7e18f3e3cbd04326 = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().prefetchingRoute;

});

parcelRegister("ktB2C", function(module, exports) {

$parcel$export(module.exports, "waitForEntryPoint", () => $67d2b262678828c6$export$944f853f194e5dd5);

var $kipqU = parcelRequire("kipqU");
const $67d2b262678828c6$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $kipqU.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $67d2b262678828c6$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});

parcelRegister("9dbn9", function(module, exports) {

$parcel$export(module.exports, "getEntryPointStats", () => $61c2db9f130d2efd$export$ee016802bdebb378);

var $kipqU = parcelRequire("kipqU");
const $61c2db9f130d2efd$export$14ba46fa7bd4c0a9 = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
const $61c2db9f130d2efd$export$982a0a12103fb99f = async (promise)=>{
    if (!promise) return 'resolved';
    try {
        if (await Promise.race([
            promise,
            Promise.resolve('timeout')
        ]) === 'timeout') return 'pending';
        return 'resolved';
    } catch (e) {
        return 'rejected';
    }
};
const $61c2db9f130d2efd$var$getEntrypointQueryState = async (queryId)=>{
    const queryPromise = (0, $kipqU.QueryPromisesMap).get(queryId);
    return {
        queryId: queryId,
        status: await $61c2db9f130d2efd$export$982a0a12103fb99f(queryPromise)
    };
};
const $61c2db9f130d2efd$export$ee016802bdebb378 = (entryPointConfig)=>{
    const result = [];
    const analyseEntrypoint = ({ queries: queries, entryPoints: entryPoints })=>{
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) result.push($61c2db9f130d2efd$var$getEntrypointQueryState(String(queries[key].id)));
        });
        if (entryPoints) Object.entries(entryPoints).forEach(([, entryPoint])=>{
            analyseEntrypoint(entryPoint);
        });
    };
    analyseEntrypoint(entryPointConfig);
    return Promise.all(result);
};

});

parcelRegister("gH2st", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d282350af6c97c4$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $2OZhN = parcelRequire("2OZhN");

var $6jQmc = parcelRequire("6jQmc");

var $klZ80 = parcelRequire("klZ80");

const $7d282350af6c97c4$var$DummyAsyncModule = (0, $2OZhN.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("klZ80"))), {
    moduleId: "7d80bb6f",
    moduleName: "ReactFragment"
} // using a real async import to make the js-resource transformers/babel-plugins happy
);
$7d282350af6c97c4$var$DummyAsyncModule.getModuleIfRequired = ()=>(0, $klZ80.default); // prevent attempts to fetch the module async at all

/**
 * Run a given loadEntryPoint function without loading the entrypoint modules, then load them right afterwards.
 *
 * This is to prevent triggering the loading of entrypoints modules inline with the data fetching.
 * When JS modules are inline-required (such as in SSR when async modules are converted to inline-requires)
 * this leads to inline-evaluating all dependencies for large component modules before kicking off the data for them.
 * This causes a measurable performance hit (~20-80ms in many cases) before we even kick off critical data fetches.
 *
 * Deferring the module loading until after the data fetching allows the module execution to occur in the less critical
 * idle time while waiting for data fetches to return.
 */ function $7d282350af6c97c4$var$loadEntryPointDataThenModules(entryPoint, entryPointParams, loadEntryPointCallback) {
    const originalModulesByEntrypointRef = new Map();
    (0, $6jQmc.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
        originalModulesByEntrypointRef.set(loopingEntryPoint, loopingEntryPoint.root);
        // eslint-disable-next-line no-param-reassign
        loopingEntryPoint.root = $7d282350af6c97c4$var$DummyAsyncModule;
    });
    try {
        return loadEntryPointCallback();
    } finally{
        (0, $6jQmc.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
            const originalModule = originalModulesByEntrypointRef.get(loopingEntryPoint);
            if (!originalModule) throw new Error('Original module not found for entrypoint');
            // eslint-disable-next-line no-param-reassign
            loopingEntryPoint.root = originalModule;
        });
        // Kicks off the loading of the original modules as they would have, but after the data fetches have been started
        // Without this, entrypoints may have trouble rendering
        // Wrap it in a promise to prevent it from affecting timers that start synchronously after this function
        Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("klZ80")));
        }).then((res)=>originalModulesByEntrypointRef.forEach((entryPointModule)=>{
                const jsModule = entryPointModule.getModuleIfRequired();
                if (jsModule != null) return;
                entryPointModule.load();
            }));
    }
}
var $7d282350af6c97c4$export$2e2bcd8739ae039 = $7d282350af6c97c4$var$loadEntryPointDataThenModules;

});
parcelRegister("2OZhN", function(module, exports) {

$parcel$export(module.exports, "JSResourceForUserVisible", () => $ca4f44207dc12143$export$58f934f3d33a84b6);

var $eIMrK = parcelRequire("eIMrK");

var $ce6VA = parcelRequire("ce6VA");

var $iyWSs = parcelRequire("iyWSs");
const $ca4f44207dc12143$var$cache = (0, $eIMrK.createCache)(new Map());
function $ca4f44207dc12143$export$58f934f3d33a84b6(loader, opts) {
    return $ca4f44207dc12143$var$cache.get(opts.moduleId, ()=>(0, $ce6VA.PreloadableJSResource)(()=>(0, $iyWSs.postTask)(loader, {
                priority: 'user-blocking'
            }), opts));
}

});

parcelRegister("6jQmc", function(module, exports) {

$parcel$export(module.exports, "default", () => $692ea781fc4c525f$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Recursively run through all nested entrypoints with a given callback
 */ function $692ea781fc4c525f$var$forAllEntryPoints(entryPoint, entryPointParams, callback) {
    callback(entryPoint);
    const preloadProps = entryPoint.getPreloadProps(entryPointParams);
    const entryPoints = preloadProps.entryPoints;
    if (!entryPoints) return;
    Object.values(entryPoints).forEach(({ entryPoint: nestedEntryPoint, entryPointParams: nestedParams })=>{
        if (nestedEntryPoint) $692ea781fc4c525f$var$forAllEntryPoints(nestedEntryPoint, nestedParams, callback);
    });
}
var $692ea781fc4c525f$export$2e2bcd8739ae039 = $692ea781fc4c525f$var$forAllEntryPoints;

});

parcelRegister("klZ80", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $73d7313e0b755887$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $73d7313e0b755887$var$ReactFragment = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
var $73d7313e0b755887$export$2e2bcd8739ae039 = $73d7313e0b755887$var$ReactFragment;

});



parcelRegister("8Y8sk", function(module, exports) {

$parcel$export(module.exports, "createResourcesPlugin", () => $d3b2f44f58ee61bb$export$23ed892c481a96fe);

var $8fYaK = parcelRequire("8fYaK");

var $4CEu1 = parcelRequire("4CEu1");
const $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $d3b2f44f58ee61bb$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
    const nextResources = (0, $4CEu1.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $d3b2f44f58ee61bb$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
    const nextResources = (0, $4CEu1.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $d3b2f44f58ee61bb$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $8fYaK.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $d3b2f44f58ee61bb$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $d3b2f44f58ee61bb$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $8fYaK.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
            const nextResources = (0, $4CEu1.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $8fYaK.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("4CEu1", function(module, exports) {

$parcel$export(module.exports, "getResourcesForNextLocation", () => $448a0fea894dd469$export$7cbbc763e2f3d65d);

var $9KbzN = parcelRequire("9KbzN");

var $dj41J = parcelRequire("dj41J");
const $448a0fea894dd469$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $dj41J.routeHasResources)(nextRoute)) return [];
    if ((0, $dj41J.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $9KbzN.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $9KbzN.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("9KbzN", function(module, exports) {

$parcel$export(module.exports, "getResourceIdentifier", () => $82cfa1d66d41fab5$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $82cfa1d66d41fab5$export$cd7fbe7e979df558);
const $82cfa1d66d41fab5$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $82cfa1d66d41fab5$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$82cfa1d66d41fab5$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("dj41J", function(module, exports) {

$parcel$export(module.exports, "routeHasResources", () => $9c8422e0259b24f6$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $9c8422e0259b24f6$export$221027ff1aa38f82);
const $9c8422e0259b24f6$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $9c8422e0259b24f6$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});





parcelRegister("hbs21", function(module, exports) {

$parcel$export(module.exports, "getLegacyRoutes", () => $2254658c9ab99d90$export$26f94fc240f0d1ea);

var $3RJkv = parcelRequire("3RJkv");

var $6QKrH = parcelRequire("6QKrH");

var $427L2 = parcelRequire("427L2");

var $4kR3A = parcelRequire("4kR3A");

var $44po0 = parcelRequire("44po0");

var $9lEpL = parcelRequire("9lEpL");

var $BHTa6 = parcelRequire("BHTa6");

var $lOa5w = parcelRequire("lOa5w");

var $V8lCn = parcelRequire("V8lCn");

var $dG4Nb = parcelRequire("dG4Nb");

var $eHVIE = parcelRequire("eHVIE");

var $a3M7u = parcelRequire("a3M7u");

var $av6XZ = parcelRequire("av6XZ");

var $dWjmB = parcelRequire("dWjmB");

var $46ldp = parcelRequire("46ldp");

var $7j0wg = parcelRequire("7j0wg");

var $3sDS0 = parcelRequire("3sDS0");

var $9qiL2 = parcelRequire("9qiL2");

var $1piRd = parcelRequire("1piRd");

var $5j7oE = parcelRequire("5j7oE");

var $02Sse = parcelRequire("02Sse");

var $eEYQp = parcelRequire("eEYQp");

var $5l2vg = parcelRequire("5l2vg");

var $627SN = parcelRequire("627SN");

var $e0Qo3 = parcelRequire("e0Qo3");

var $3PPM5 = parcelRequire("3PPM5");

var $2gA3M = parcelRequire("2gA3M");

var $1Sanm = parcelRequire("1Sanm");

var $2WPhO = parcelRequire("2WPhO");

var $3zYiE = parcelRequire("3zYiE");

var $6304k = parcelRequire("6304k");

var $3Gl8S = parcelRequire("3Gl8S");

var $hTDEk = parcelRequire("hTDEk");

var $adtuy = parcelRequire("adtuy");

var $iKdOk = parcelRequire("iKdOk");

var $jSUYz = parcelRequire("jSUYz");

var $4G8Hg = parcelRequire("4G8Hg");

var $atx0K = parcelRequire("atx0K");

var $3JFtk = parcelRequire("3JFtk");

var $ji0AJ = parcelRequire("ji0AJ");

var $eH0Vd = parcelRequire("eH0Vd");

var $GeoVa = parcelRequire("GeoVa");

var $dRasN = parcelRequire("dRasN");

var $5sKph = parcelRequire("5sKph");

var $giS9p = parcelRequire("giS9p");

var $gCRNR = parcelRequire("gCRNR");

var $8dktk = parcelRequire("8dktk");

var $bf7on = parcelRequire("bf7on");

var $14GxZ = parcelRequire("14GxZ");

var $hJtWy = parcelRequire("hJtWy");

var $hJf2R = parcelRequire("hJf2R");

var $2oYAN = parcelRequire("2oYAN");

var $gh1kZ = parcelRequire("gh1kZ");

var $isGPI = parcelRequire("isGPI");

var $fPw7u = parcelRequire("fPw7u");

var $cxEqO = parcelRequire("cxEqO");

var $7RDxI = parcelRequire("7RDxI");

var $heNmF = parcelRequire("heNmF");

var $1YKIi = parcelRequire("1YKIi");

var $e5Z3j = parcelRequire("e5Z3j");

var $bXosp = parcelRequire("bXosp");

var $k5iyb = parcelRequire("k5iyb");

var $d20Tk = parcelRequire("d20Tk");

var $53AfD = parcelRequire("53AfD");

var $emSra = parcelRequire("emSra");

var $kzk0Z = parcelRequire("kzk0Z");

var $b6Js4 = parcelRequire("b6Js4");

var $1yPEz = parcelRequire("1yPEz");

var $7l2eC = parcelRequire("7l2eC");

var $nXJme = parcelRequire("nXJme");

var $cn2JB = parcelRequire("cn2JB");

var $cTxQ0 = parcelRequire("cTxQ0");

var $6yYh1 = parcelRequire("6yYh1");

var $gmU6D = parcelRequire("gmU6D");

var $fBKKy = parcelRequire("fBKKy");

var $6flsA = parcelRequire("6flsA");

var $6G6iV = parcelRequire("6G6iV");

var $fkydJ = parcelRequire("fkydJ");

var $h2Jra = parcelRequire("h2Jra");

var $2MUGS = parcelRequire("2MUGS");

var $7HMEh = parcelRequire("7HMEh");

var $dWO0i = parcelRequire("dWO0i");

var $hLsgj = parcelRequire("hLsgj");

var $j87Pk = parcelRequire("j87Pk");

var $h83U2 = parcelRequire("h83U2");

var $koRHn = parcelRequire("koRHn");

var $fFHok = parcelRequire("fFHok");

var $b6nn0 = parcelRequire("b6nn0");

var $ldD1A = parcelRequire("ldD1A");

var $bLPvl = parcelRequire("bLPvl");

var $1E84W = parcelRequire("1E84W");

var $38hbb = parcelRequire("38hbb");

var $kF9VY = parcelRequire("kF9VY");

var $c0M7D = parcelRequire("c0M7D");

var $f2ROg = parcelRequire("f2ROg");

var $9XTKv = parcelRequire("9XTKv");

var $2RECB = parcelRequire("2RECB");

var $kirc0 = parcelRequire("kirc0");

var $dZTGv = parcelRequire("dZTGv");

var $kevOU = parcelRequire("kevOU");

var $h2wuj = parcelRequire("h2wuj");

var $8Q961 = parcelRequire("8Q961");

var $brK7m = parcelRequire("brK7m");

var $3s8fE = parcelRequire("3s8fE");

var $3740v = parcelRequire("3740v");

var $e4xQQ = parcelRequire("e4xQQ");

var $8ytbz = parcelRequire("8ytbz");

var $gcILV = parcelRequire("gcILV");

var $5ga67 = parcelRequire("5ga67");

var $1W2Gl = parcelRequire("1W2Gl");

var $Ty8f6 = parcelRequire("Ty8f6");

var $4NQSs = parcelRequire("4NQSs");

var $gVtbv = parcelRequire("gVtbv");

var $fdER9 = parcelRequire("fdER9");

var $3LHeo = parcelRequire("3LHeo");

var $coMZk = parcelRequire("coMZk");

var $7LrwN = parcelRequire("7LrwN");

var $26OFn = parcelRequire("26OFn");

var $jbXVA = parcelRequire("jbXVA");

var $94XVt = parcelRequire("94XVt");

var $aayfE = parcelRequire("aayfE");

var $cxoJv = parcelRequire("cxoJv");

var $2Y1h4 = parcelRequire("2Y1h4");

var $jxBgp = parcelRequire("jxBgp");

var $iG5yV = parcelRequire("iG5yV");

var $8yO2T = parcelRequire("8yO2T");

var $6nlgB = parcelRequire("6nlgB");

var $iViDO = parcelRequire("iViDO");

var $7aXIN = parcelRequire("7aXIN");

var $43xSO = parcelRequire("43xSO");

var $6qiOQ = parcelRequire("6qiOQ");

var $7gf5D = parcelRequire("7gf5D");

var $kVX9A = parcelRequire("kVX9A");

var $eFO8D = parcelRequire("eFO8D");

var $cm20p = parcelRequire("cm20p");

var $JOjYa = parcelRequire("JOjYa");

var $5guhB = parcelRequire("5guhB");

var $1Va65 = parcelRequire("1Va65");

var $4hYtG = parcelRequire("4hYtG");

var $lSmMA = parcelRequire("lSmMA");

var $82PdT = parcelRequire("82PdT");

var $jIr9s = parcelRequire("jIr9s");

var $5cpbg = parcelRequire("5cpbg");

var $29xMF = parcelRequire("29xMF");

var $fLmiZ = parcelRequire("fLmiZ");

var $g2P0y = parcelRequire("g2P0y");

var $1KhKT = parcelRequire("1KhKT");

var $lz4Nv = parcelRequire("lz4Nv");

var $iIXYD = parcelRequire("iIXYD");

var $fxYAK = parcelRequire("fxYAK");

var $dPq7r = parcelRequire("dPq7r");

var $dHtcq = parcelRequire("dHtcq");

var $imHTN = parcelRequire("imHTN");

var $76Qj6 = parcelRequire("76Qj6");

var $1WWKh = parcelRequire("1WWKh");

var $9yaGy = parcelRequire("9yaGy");

var $eWZIp = parcelRequire("eWZIp");

var $88PgZ = parcelRequire("88PgZ");

var $dlgy2 = parcelRequire("dlgy2");

var $38qLO = parcelRequire("38qLO");

var $ipHzu = parcelRequire("ipHzu");

var $f3jZ3 = parcelRequire("f3jZ3");

var $7xiPB = parcelRequire("7xiPB");

var $lRq3t = parcelRequire("lRq3t");

var $gZe42 = parcelRequire("gZe42");

var $4DWPZ = parcelRequire("4DWPZ");

var $4DO1F = parcelRequire("4DO1F");

var $aCW6m = parcelRequire("aCW6m");

var $7781P = parcelRequire("7781P");

var $eAMh2 = parcelRequire("eAMh2");

var $lS7PF = parcelRequire("lS7PF");

var $5QGoI = parcelRequire("5QGoI");

var $dOEiY = parcelRequire("dOEiY");

var $4k7ly = parcelRequire("4k7ly");

var $8Y3IU = parcelRequire("8Y3IU");

var $486WL = parcelRequire("486WL");

var $kQECV = parcelRequire("kQECV");

var $kk5yP = parcelRequire("kk5yP");

var $5nUrq = parcelRequire("5nUrq");

var $kPUF4 = parcelRequire("kPUF4");

var $jXCBD = parcelRequire("jXCBD");

var $9uymn = parcelRequire("9uymn");

var $llWtm = parcelRequire("llWtm");

var $2esMz = parcelRequire("2esMz");

var $eey6O = parcelRequire("eey6O");

var $av0Fi = parcelRequire("av0Fi");

var $5JGis = parcelRequire("5JGis");

var $kbANj = parcelRequire("kbANj");

var $b0VF1 = parcelRequire("b0VF1");

var $1Q4PR = parcelRequire("1Q4PR");

var $li7Ec = parcelRequire("li7Ec");

var $4u3md = parcelRequire("4u3md");

var $kRES4 = parcelRequire("kRES4");

var $3vVvx = parcelRequire("3vVvx");

var $2RsFl = parcelRequire("2RsFl");

var $jagxj = parcelRequire("jagxj");

var $9QqjO = parcelRequire("9QqjO");

var $9U4Np = parcelRequire("9U4Np");

var $kaVHd = parcelRequire("kaVHd");

var $kLemY = parcelRequire("kLemY");

var $9WV4g = parcelRequire("9WV4g");

var $grES6 = parcelRequire("grES6");

var $bF5bS = parcelRequire("bF5bS");

var $36pks = parcelRequire("36pks");

var $DGgtd = parcelRequire("DGgtd");

var $eEyXO = parcelRequire("eEyXO");

var $tvLh3 = parcelRequire("tvLh3");

var $4iAyz = parcelRequire("4iAyz");

var $kFwno = parcelRequire("kFwno");

var $argbs = parcelRequire("argbs");

var $cJhQw = parcelRequire("cJhQw");

var $loZyq = parcelRequire("loZyq");

var $et6S9 = parcelRequire("et6S9");

var $ez710 = parcelRequire("ez710");

var $3Ig4M = parcelRequire("3Ig4M");

var $64onD = parcelRequire("64onD");

var $kL5a2 = parcelRequire("kL5a2");

var $lhxTN = parcelRequire("lhxTN");

var $1vxGF = parcelRequire("1vxGF");

var $kDz1I = parcelRequire("kDz1I");

var $49VqI = parcelRequire("49VqI");

var $hD3MI = parcelRequire("hD3MI");

var $afhYz = parcelRequire("afhYz");

var $4h7pu = parcelRequire("4h7pu");

var $6FSmK = parcelRequire("6FSmK");

var $laBkp = parcelRequire("laBkp");

var $37pp9 = parcelRequire("37pp9");

var $gflji = parcelRequire("gflji");

var $6jDzT = parcelRequire("6jDzT");

var $jmaPx = parcelRequire("jmaPx");

var $8wzgb = parcelRequire("8wzgb");

var $4YpQx = parcelRequire("4YpQx");

var $3HICX = parcelRequire("3HICX");

var $hEiRG = parcelRequire("hEiRG");

var $adWCc = parcelRequire("adWCc");

var $8hgsj = parcelRequire("8hgsj");

var $1YU78 = parcelRequire("1YU78");

var $bJ1QL = parcelRequire("bJ1QL");

var $3vlci = parcelRequire("3vlci");

var $7z8HU = parcelRequire("7z8HU");

var $8DSg9 = parcelRequire("8DSg9");

var $eRLno = parcelRequire("eRLno");

var $4ufmY = parcelRequire("4ufmY");

var $6reNT = parcelRequire("6reNT");

var $jD4ED = parcelRequire("jD4ED");

var $eYfVu = parcelRequire("eYfVu");

var $9D2fh = parcelRequire("9D2fh");

var $7wJID = parcelRequire("7wJID");

var $04xzx = parcelRequire("04xzx");

var $c6Si3 = parcelRequire("c6Si3");

var $8k7EA = parcelRequire("8k7EA");

var $6pjPD = parcelRequire("6pjPD");

var $gaHy8 = parcelRequire("gaHy8");

var $anXSE = parcelRequire("anXSE");
const $2254658c9ab99d90$export$d47aca795954578 = ()=>[
        (0, $9QqjO.legacyJsdGettingStartedRouteEntry),
        (0, $jagxj.legacyJsdCustomersRouteEntry),
        (0, $kaVHd.legacyJsdKnowledgeRouteEntry),
        (0, $9WV4g.legacyJsdQueuesManageRouteEntry),
        (0, $kLemY.legacyJsdQueuesRouteEntry),
        (0, $grES6.legacyJsdReportsCustomRouteEntry),
        (0, $bF5bS.legacyJsdReportsRouteEntry),
        (0, $DGgtd.legacyJsdSettingsLanguageRouteEntry),
        (0, $eEyXO.legacyJsdSettingsLanguagePagesRouteEntry),
        (0, $9U4Np.legacyJsdJiraAutomationRouteEntry),
        (0, $tvLh3.legacyJsdWidgetsRouteEntry),
        (0, $36pks.legacyJsdSettingsFallbackRouteEntry),
        (0, $eHVIE.legacyCustomReportRouteEntry),
        (0, $9lEpL.legacyBacklogRouteEntry),
        (0, $BHTa6.legacyBoardRapidViewRouteEntry),
        (0, $lOa5w.legacyBoardRouteEntry),
        (0, $44po0.legacyAllReportsRouteEntry),
        (0, $jSUYz.globalIssueNavigatorRouteEntry),
        (0, $adtuy.globalIssueNavigatorBrowseRouteEntry),
        (0, $iKdOk.globalIssueNavigatorRedirectRouteEntry),
        (0, $2RsFl.legacyIssueRouteEntry),
        (0, $kFwno.legacyPinRouteEntry),
        (0, $et6S9.legacyProjectReleasesRouteEntry),
        (0, $3Ig4M.legacyProjectReleasesNoteRouteEntry),
        (0, $ez710.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $loZyq.legacyProjectReleasesBambooRouteEntry),
        (0, $8DSg9.legacyReportsAverageAgeRouteEntry),
        (0, $4ufmY.legacyReportsCreatedVsResolvedRouteEntry),
        (0, $jD4ED.legacyReportsPieRouteEntry),
        (0, $eYfVu.legacyReportsRecentlyCreatedRouteEntry),
        (0, $9D2fh.legacyReportsResolutionTimeRouteEntry),
        (0, $7wJID.legacyReportsSingleLevelGroupByRouteEntry),
        (0, $04xzx.legacyReportsTimeSinceRouteEntry),
        (0, $c6Si3.legacyReportsTimeTrackingReportRouteEntry),
        (0, $6reNT.legacyReportsDeveloperWorkloadRouteEntry),
        (0, $8k7EA.legacyReportsVersionWorkloadRouteEntry),
        (0, $6pjPD.legacyReportsWorkloadPieRouteEntry),
        (0, $eRLno.legacyReportsConfigRouteEntry),
        (0, $dG4Nb.legacyConnectProjectRouteEntry),
        (0, $hEiRG.legacyProjectSettingsPeopleRouteEntry),
        (0, $bJ1QL.legacyProjectSettingsSummaryRouteEntry),
        (0, $jmaPx.legacyProjectSettingsIssueTypesRouteEntry),
        (0, $6jDzT.legacyProjectSettingsIssueTypesAssociateRouteEntry),
        (0, $laBkp.legacyProjectSettingsIssueLayoutRouteEntry),
        (0, $7z8HU.legacyProjectSettingsWorkflowsRouteEntry),
        (0, $3vlci.legacyProjectSettingsWorkflowsAssociateRouteEntry),
        (0, $1YU78.legacyProjectSettingsScreensRouteEntry),
        (0, $8hgsj.legacyProjectSettingsScreensAssociateRouteEntry),
        (0, $6FSmK.legacyProjectSettingsFieldsRouteEntry),
        (0, $4h7pu.legacyProjectSettingsFieldsAssociateRouteEntry),
        (0, $3HICX.legacyProjectSettingsOpsgenieRouteEntry),
        (0, $adWCc.legacyProjectSettingsPermissionsRouteEntry),
        (0, $gflji.legacyProjectSettingsIssueSecurityRouteEntry),
        (0, $37pp9.legacyProjectSettingsIssueSecurityAssociateRouteEntry),
        (0, $4YpQx.legacyProjectSettingsNotificationsRouteEntry),
        (0, $8wzgb.legacyProjectSettingsNotificationsAssociateRouteEntry),
        (0, $kDz1I.legacyProjectSettingsConfigRouteEntry),
        (0, $afhYz.legacyProjectSettingsEditRouteEntry),
        (0, $49VqI.legacyProjectSettingsDeleteRouteEntry),
        (0, $kL5a2.legacyProjectSettingsCollectorsRouteEntry),
        (0, $64onD.legacyProjectSettingsCollectorsAddRouteEntry),
        (0, $lhxTN.legacyProjectSettingsCollectorsHelpRouteEntry),
        (0, $1vxGF.legacyProjectSettingsCollectorsViewRouteEntry),
        (0, $hD3MI.legacyProjectSettingsDevRouteEntry),
        (0, $av6XZ.legacyDashboardsConfigureRouteEntry),
        (0, $46ldp.dashboardsDirectoryRouteEntry),
        (0, $a3M7u.legacyDashboardsAddRouteEntry),
        (0, $7j0wg.legacyDashboardsEditRouteEntry),
        (0, $dWjmB.legacyDashboardsDeleteRouteEntry),
        (0, $3sDS0.legacyDashboardsRestoreRouteEntry),
        (0, $1Sanm.legacyGinManageRouteEntry),
        (0, $02Sse.legacyGinBulkeditRouteEntry),
        (0, $5j7oE.legacyGinBulkRouteEntry),
        (0, $2gA3M.legacyGinIssueMoveRouteEntry),
        (0, $6304k.legacyGinSubtaskActionRouteEntry),
        (0, $5l2vg.legacyGinIssueCloneRouteEntry),
        (0, $eEYQp.legacyGinIssueAssignRouteEntry),
        (0, $e0Qo3.legacyGinIssueCreateRouteEntry),
        (0, $627SN.legacyGinIssueConvertRouteEntry),
        (0, $3PPM5.legacyGinIssueEditRouteEntry),
        (0, $3Gl8S.legacyGinWatchersIssueRouteEntry),
        (0, $1piRd.legacyGinActionRouteEntry),
        (0, $3zYiE.legacyGinSubscriptionsRouteEntry),
        (0, $2WPhO.legacyGinSubscriptionEditRouteEntry),
        (0, $argbs.legacyPortfolioPagesRouteEntry),
        (0, $cJhQw.legacyPortfolioTeamRouteEntry),
        (0, $iIXYD.globalSettingsSystemApplicationViewRouteEntry),
        (0, $1KhKT.globalSettingsSystemApplicationAdvancedRouteEntry),
        (0, $lz4Nv.globalSettingsSystemApplicationEditRouteEntry),
        (0, $dPq7r.globalSettingsSystemAuditingRouteEntry),
        (0, $kbANj.globalSettingsSystemRolesViewRouteEntry),
        (0, $5JGis.globalSettingsSystemRolesUsageRouteEntry),
        (0, $9uymn.globalSettingsSystemRolesActorsRouteEntry),
        (0, $llWtm.globalSettingsSystemRolesActorsGroupsRouteEntry),
        (0, $2esMz.globalSettingsSystemRolesActorsUsersRouteEntry),
        (0, $av0Fi.globalSettingsSystemRolesEditRouteEntry),
        (0, $eey6O.globalSettingsSystemRolesDeleteRouteEntry),
        (0, $kPUF4.globalSettingsSystemProjectDeleteRouteEntry),
        (0, $5nUrq.globalSettingsSystemProjectAssignSecurityRouteEntry),
        (0, $kk5yP.globalSettingsSystemPermissionsRouteEntry),
        (0, $dHtcq.globalSettingsSystemCollectorsRouteEntry),
        (0, $imHTN.globalSettingsSystemDefaultSettingsRouteEntry),
        (0, $eAMh2.globalSettingsSystemLookRouteEntry),
        (0, $88PgZ.globalSettingsSystemExportRouteEntry),
        (0, $dlgy2.globalSettingsSystemGlobalPermissionsRouteEntry),
        (0, $gZe42.globalSettingsSystemImportExternalRouteEntry),
        (0, $4DWPZ.globalSettingsSystemImportExternalPagesRouteEntry),
        (0, $lRq3t.globalSettingsSystemImportCsvRouteEntry),
        (0, $4DO1F.globalSettingsSystemImportJsonRouteEntry),
        (0, $aCW6m.globalSettingsSystemImportTrelloRouteEntry),
        (0, $7xiPB.globalSettingsSystemImportCloudRouteEntry),
        (0, $f3jZ3.globalSettingsSystemImportBulkRouteEntry),
        (0, $hTDEk.globalAutomationRouteEntry),
        (0, $486WL.globalSettingsSystemMailSettingsRouteEntry),
        (0, $4k7ly.globalSettingsSystemMailOutgoingRouteEntry),
        (0, $5QGoI.globalSettingsSystemMailDeleteMailHandlerRouteEntry),
        (0, $dOEiY.globalSettingsSystemMailIncomingRouteEntry),
        (0, $lS7PF.globalSettingsSystemMailAddRouteEntry),
        (0, $kQECV.globalSettingsSystemMailVerifyRouteEntry),
        (0, $8Y3IU.globalSettingsSystemMailSendRouteEntry),
        (0, $ipHzu.globalSettingsSystemHelperPermissionRouteEntry),
        (0, $38qLO.globalSettingsSystemHelperNotificationRouteEntry),
        (0, $li7Ec.globalSettingsSystemSharedFiltersRouteEntry),
        (0, $1Q4PR.globalSettingsSystemSharedDashboardsRouteEntry),
        (0, $fxYAK.globalSettingsSystemAttachmentsRouteEntry),
        (0, $eWZIp.globalSettingsSystemEventsRouteEntry),
        (0, $76Qj6.globalSettingsSystemEventsAddRouteEntry),
        (0, $1WWKh.globalSettingsSystemEventsDeleteRouteEntry),
        (0, $9yaGy.globalSettingsSystemEventsEditRouteEntry),
        (0, $4u3md.globalSettingsSystemUserInterfaceDashboardEditRouteEntry),
        (0, $kRES4.globalSettingsSystemUserInterfacePreferencesRouteEntry),
        (0, $3vVvx.globalSettingsSystemWebhooksRouteEntry),
        (0, $b0VF1.globalSettingsSystemServicesRouteEntry),
        (0, $7781P.globalSettingsSystemLexorankRouteEntry),
        (0, $cm20p.globalSettingsProductsAccessRouteEntry),
        (0, $5cpbg.globalSettingsProductsSoftwareConfigRouteEntry),
        (0, $JOjYa.globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry),
        (0, $82PdT.globalSettingsProductsSdconfigRouteEntry),
        (0, $jIr9s.globalSettingsProductsSdmailRouteEntry),
        (0, $5guhB.globalSettingsProductsApplinksRouteEntry),
        (0, $4hYtG.globalSettingsProductsDvcsRouteEntry),
        (0, $1Va65.globalSettingsProductsDvcsBitbucketRouteEntry),
        (0, $lSmMA.globalSettingsProductsJsdStatusRouteEntry),
        (0, $g2P0y.globalSettingsProjectsCategoriesViewRouteEntry),
        (0, $fLmiZ.globalSettingsProjectsCategoriesEditRouteEntry),
        (0, $29xMF.globalSettingsProjectsCategoriesDeleteRouteEntry),
        (0, $jbXVA.globalSettingsIssuesTypesEditRouteEntry),
        (0, $26OFn.globalSettingsIssuesTypesDeleteRouteEntry),
        (0, $94XVt.globalSettingsIssuesTypesMigrateRouteEntry),
        (0, $43xSO.globalSettingsIssuesTypesTranslationsRouteEntry),
        (0, $jxBgp.globalSettingsIssuesTypesSchemesOptionRouteEntry),
        (0, $aayfE.globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry),
        (0, $cxoJv.globalSettingsIssuesTypesSchemesAssociateRouteEntry),
        (0, $2Y1h4.globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry),
        (0, $dRasN.globalSettingsIssueSubtasksRouteEntry),
        (0, $3LHeo.globalSettingsIssuesSubtasksDisableRouteEntry),
        (0, $coMZk.globalSettingsIssuesSubtasksEditRouteEntry),
        (0, $7LrwN.globalSettingsIssuesSubtasksTranlationsRouteEntry),
        (0, $gaHy8.workflowDesignerRouteEntry),
        (0, $giS9p.globalSettingsIssueWorkflowRouteEntry),
        (0, $7gf5D.globalSettingsIssuesWorkflowTransitionRouteEntry),
        (0, $6qiOQ.globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry),
        (0, $kVX9A.globalSettingsIssuesWorkflowsImportRouteEntry),
        (0, $gCRNR.globalSettingsIssueWorkflowSchemesRouteEntry),
        (0, $eFO8D.globalSettingsIssuesWorkflowsSchemesEditRouteEntry),
        (0, $emSra.globalSettingsIssuesFieldViewRouteEntry),
        (0, $gh1kZ.globalSettingsIssuesFieldAddRouteEntry),
        (0, $fPw7u.globalSettingsIssuesFieldConfigureRouteEntry),
        (0, $isGPI.globalSettingsIssuesFieldConfigureEditRouteEntry),
        (0, $heNmF.globalSettingsIssuesFieldEditRouteEntry),
        (0, $cxEqO.globalSettingsIssuesFieldCopyRouteEntry),
        (0, $7RDxI.globalSettingsIssuesFieldDeleteRouteEntry),
        (0, $1YKIi.globalSettingsIssuesFieldSchemesAddRouteEntry),
        (0, $e5Z3j.globalSettingsIssuesFieldSchemesConfigureRouteEntry),
        (0, $d20Tk.globalSettingsIssuesFieldSchemesEditRouteEntry),
        (0, $53AfD.globalSettingsIssuesFieldSchemesEditItemRouteEntry),
        (0, $bXosp.globalSettingsIssuesFieldSchemesCopyRouteEntry),
        (0, $k5iyb.globalSettingsIssuesFieldSchemesDeleteRouteEntry),
        (0, $iG5yV.globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry),
        (0, $7aXIN.globalSettingsIssuesTypesScreenSchemesEntityRouteEntry),
        (0, $iViDO.globalSettingsIssuesTypesScreenSchemesEditRouteEntry),
        (0, $8yO2T.globalSettingsIssuesTypesScreenSchemesCopyRouteEntry),
        (0, $6nlgB.globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry),
        (0, $ji0AJ.globalSettingsCustomFieldsRouteEntry),
        (0, $bf7on.globalSettingsIssuesCustomFieldsConfigRouteEntry),
        (0, $hJtWy.globalSettingsIssuesCustomFieldsEditRouteEntry),
        (0, $2oYAN.globalSettingsIssuesCustomFieldsTranslateRouteEntry),
        (0, $14GxZ.globalSettingsIssuesCustomFieldsDeleteRouteEntry),
        (0, $hJf2R.globalSettingsIssuesCustomFieldsManageRouteEntry),
        (0, $8dktk.globalSettingsIssuesCustomFieldsAssociateRouteEntry),
        (0, $427L2.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $GeoVa.globalSettingsFieldLayoutsRouteEntry),
        (0, $kzk0Z.globalSettingsIssuesFieldlayoutsConfigRouteEntry),
        (0, $fBKKy.globalSettingsIssuesFieldviewRouteEntry),
        (0, $b6Js4.globalSettingsIssuesFieldlayoutsCopyRouteEntry),
        (0, $7l2eC.globalSettingsIssuesFieldlayoutsEditRouteEntry),
        (0, $1yPEz.globalSettingsIssuesFieldlayoutsDeleteRouteEntry),
        (0, $eH0Vd.globalSettingsFieldLayoutSchemesRouteEntry),
        (0, $nXJme.globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry),
        (0, $gmU6D.globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry),
        (0, $cn2JB.globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry),
        (0, $6yYh1.globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry),
        (0, $cTxQ0.globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry),
        (0, $5sKph.globalSettingsIssueTimeTrackingRouteEntry),
        (0, $h2Jra.globalSettingsIssuesLinkTypesRouteEntry),
        (0, $6G6iV.globalSettingsIssuesLinkTypesActivateRouteEntry),
        (0, $fkydJ.globalSettingsIssuesLinkTypesDeactivateRouteEntry),
        (0, $7HMEh.globalSettingsIssuesLinktypesEditRouteEntry),
        (0, $2MUGS.globalSettingsIssuesLinktypesDeleteRouteEntry),
        (0, $gVtbv.globalSettingsIssuesStatusesRouteEntry),
        (0, $fdER9.globalSettingsIssuesStatusesTranslationsRouteEntry),
        (0, $brK7m.globalSettingsIssuesResolutionsRouteEntry),
        (0, $3s8fE.globalSettingsIssuesResolutionsTranslationsRouteEntry),
        (0, $kevOU.globalSettingsIssuesResolutionsDefaultRouteEntry),
        (0, $8Q961.globalSettingsIssuesResolutionsEditRouteEntry),
        (0, $h2wuj.globalSettingsIssuesResolutionsDeleteRouteEntry),
        (0, $kirc0.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $dZTGv.globalSettingsIssuesPrioritiesTranslationsRouteEntry),
        (0, $6flsA.globalSettingsIssuesGeneralTranslationsRouteEntry),
        (0, $2RECB.globalSettingsIssuesPrioritiesEditRouteEntry),
        (0, $9XTKv.globalSettingsIssuesPrioritiesDeleteRouteEntry),
        (0, $f2ROg.globalSettingsIssuesPrioritiesDefaultRouteEntry),
        (0, $4NQSs.globalSettingsIssuesSecuritySchemesRouteEntry),
        (0, $3740v.globalSettingsIssuesSecurityEditRouteEntry),
        (0, $e4xQQ.globalSettingsIssuesSecurityLevelAddRouteEntry),
        (0, $gcILV.globalSettingsIssuesSecurityLevelEditRouteEntry),
        (0, $8ytbz.globalSettingsIssuesSecurityLevelDeleteRouteEntry),
        (0, $5ga67.globalSettingsIssuesSecuritySchemesAddRouteEntry),
        (0, $Ty8f6.globalSettingsIssuesSecuritySchemesEditRouteEntry),
        (0, $1W2Gl.globalSettingsIssuesSecuritySchemesDeleteRouteEntry),
        (0, $b6nn0.globalSettingsIssuesNotificationViewRouteEntry),
        (0, $h83U2.globalSettingsIssuesNotificationSchemeAddRouteEntry),
        (0, $fFHok.globalSettingsIssuesNotificationSchemeEditRouteEntry),
        (0, $koRHn.globalSettingsIssuesNotificationSchemeDeleteRouteEntry),
        (0, $dWO0i.globalSettingsIssuesNotificationAddRouteEntry),
        (0, $j87Pk.globalSettingsIssuesNotificationEditRouteEntry),
        (0, $hLsgj.globalSettingsIssuesNotificationDeleteRouteEntry),
        (0, $kF9VY.globalSettingsIssuesPermissionsSchemesRouteEntry),
        (0, $bLPvl.globalSettingsIssuesPermissionsSchemesAddRouteEntry),
        (0, $ldD1A.globalSettingsIssuesPermissionsEditRouteEntry),
        (0, $38hbb.globalSettingsIssuesPermissionsSchemesEditRouteEntry),
        (0, $c0M7D.globalSettingsIssuesPermissionsSchemesProjectRouteEntry),
        (0, $1E84W.globalSettingsIssuesPermissionsSchemesDeleteRouteEntry),
        (0, $4kR3A.addonsEmceePublicRouteEntry),
        (0, $atx0K.emceeAppRouteEntry),
        (0, $3JFtk.manageAppsRouteEntry),
        (0, $4G8Hg.globalSettingsAddonsOauthRouteEntry),
        (0, $jXCBD.globalSettingsSystemProjectSelectRouteEntry),
        (0, $4iAyz.legacyPersonalSettingsAccessTokensRouteEntry),
        (0, $V8lCn.legacyConnectGeneralRouteEntry),
        (0, $9qiL2.legacyFallbackRouteEntry)
    ];
const $2254658c9ab99d90$export$26f94fc240f0d1ea = ()=>$2254658c9ab99d90$export$d47aca795954578().map((0, $anXSE.default)).map((route)=>({
            ...route,
            group: 'legacy',
            component: route.component || (0, $6QKrH.LegacyPage),
            resources: [
                ...new Set([
                    ...(0, $3RJkv.getNavigationResources)(),
                    ...route.resources ? route.resources : []
                ])
            ]
        }));

});
parcelRegister("3RJkv", function(module, exports) {

$parcel$export(module.exports, "getModernIssueTransitionResources", () => $4f455891fb36bf50$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $4f455891fb36bf50$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $4f455891fb36bf50$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $4f455891fb36bf50$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $4f455891fb36bf50$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $4f455891fb36bf50$export$808691f5a412afa3);
// eslint-disable-next-line jira/import-whitelist

var $5kYzp = parcelRequire("5kYzp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $7xTO3 = parcelRequire("7xTO3");

var $c1N9v = parcelRequire("c1N9v");

var $loy04 = parcelRequire("loy04");

var $2fwuR = parcelRequire("2fwuR");

var $fwzEJ = parcelRequire("fwzEJ");

var $3HwlS = parcelRequire("3HwlS");

var $h9iZl = parcelRequire("h9iZl");

var $2eyDn = parcelRequire("2eyDn");

var $drGWM = parcelRequire("drGWM");

var $kMiZJ = parcelRequire("kMiZJ");

var $bHhiy = parcelRequire("bHhiy");


var $aA974 = parcelRequire("aA974");

var $f5nIZ = parcelRequire("f5nIZ");

var $hZhhj = parcelRequire("hZhhj");

var $9MiT2 = parcelRequire("9MiT2");

var $fNOVA = parcelRequire("fNOVA");

var $kJQXA = parcelRequire("kJQXA");

var $atU1t = parcelRequire("atU1t");

var $c34Wf = parcelRequire("c34Wf");

var $eOlBz = parcelRequire("eOlBz");

var $3X1Xr = parcelRequire("3X1Xr");

var $dxCvy = parcelRequire("dxCvy");

var $4dc0x = parcelRequire("4dc0x");

var $51Yl2 = parcelRequire("51Yl2");

var $lXNZG = parcelRequire("lXNZG");

var $kkNtb = parcelRequire("kkNtb");

var $2Ql51 = parcelRequire("2Ql51");

var $9vlEn = parcelRequire("9vlEn");

var $gNStA = parcelRequire("gNStA");

var $5pSYQ = parcelRequire("5pSYQ");

var $2M1hQ = parcelRequire("2M1hQ");
const $4f455891fb36bf50$var$inExperimentCohortJiraSideNavMSRExperiment = ()=>{
    // We need to use UNSAFE_noExposureExp to check if jira-side-nav experiment is enabled without firing exposure events
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [sideNavExpConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('post_office_jira_side_nav_exp_msr_vs_no_rec');
    return sideNavExpConfig.get('isEnabled', false);
};
const $4f455891fb36bf50$var$conditionalPostOfficeJiraSideNavResource = (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('post_office_ssr_jira_side_nav_enabled') && $4f455891fb36bf50$var$inExperimentCohortJiraSideNavMSRExperiment(), (0, $5pSYQ.postOfficeJiraSideNavResource));
const $4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled = ()=>{
    return (0, $6s1PB.expVal)('jira_issue_transition_screen_modernisation_toggle', 'value', 'OFF') !== 'OFF';
};
const $4f455891fb36bf50$var$conditionalGicOptInStatusResource = (0, $gNStA.resourceWithCondition)(()=>(0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience'), (0, $f5nIZ.gicOptInStatusResources));
const $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource = (0, $gNStA.resourceWithCondition)($4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled, (0, $fNOVA.issueTransitionOptInStatusResource));
const $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs'), (0, $aA974.gicSmartFieldsFeatureResource));
const $4f455891fb36bf50$export$e1afa08027b1e44b = ()=>[
        $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource,
        (0, $9MiT2.issueTransitionChangeboardingPreferencesResource)
    ];
const $4f455891fb36bf50$var$conditionalOperationsJiraSideNavResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_ssr_jira_side_nav_enabled'), (0, $bHhiy.getConsolidationStateResource)(), (0, $2M1hQ.createResource)({
    type: `${(0, $5a94e356f9d5e220$export$25ee35b01de9d734)}_NOOP`,
    getKey: ()=>`${0, $5a94e356f9d5e220$export$25ee35b01de9d734}_NOOP`,
    getData: async ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: false
}));
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition2
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $4f455891fb36bf50$var$dedupableConditionalResources = [
    (0, $gNStA.resourceWithCondition2)((0, $3HwlS.getWillShowNav4), (0, $2fwuR.sidebarNav4Resource)),
    (0, $gNStA.resourceWithCondition2)((0, $3HwlS.getWillShowNav4), (0, $2fwuR.sidebarNav4UiStateResource)),
    (0, $gNStA.resourceWithCondition2)((0, $3HwlS.getWillShowNav4), (0, $fwzEJ.topNav4UIStateResource)),
    $4f455891fb36bf50$var$conditionalOperationsJiraSideNavResource
];
const $4f455891fb36bf50$export$75cffd1aaecf4a2c = ()=>[
        (0, $c34Wf.navigationUiStateResource),
        (0, $h9iZl.navigationPlansVisibilityResource),
        (0, $9vlEn.userHomepageResource),
        $4f455891fb36bf50$var$conditionalGicOptInStatusResource,
        (0, $5kYzp.announcementBannerSettingsV4Resource),
        (0, $2eyDn.consentBannerUserPreferencesResource),
        (0, $kMiZJ.consolidationUserStateResource),
        ...$4f455891fb36bf50$var$dedupableConditionalResources,
        (0, $2Ql51.themePreferenceResource),
        ...$4f455891fb36bf50$export$e1afa08027b1e44b(),
        (0, $3X1Xr.persistentIssueCreateModalViewResource),
        $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource,
        (0, $hZhhj.incomingMailServerExpiryStatusResource),
        (0, $kkNtb.rovoEntitlementResource),
        (0, $lXNZG.jpdRecommendationDismissedResource),
        (0, $51Yl2.fetchUserTraitsResource),
        (0, $4dc0x.fetchSiteTraitsResource),
        $4f455891fb36bf50$var$conditionalPostOfficeJiraSideNavResource
    ];
const $4f455891fb36bf50$export$c57dc1ea7f76f91f = ()=>[
        (0, $7xTO3.staticJSWUserBoardSidebarNavigationResource)
    ];
const $4f455891fb36bf50$export$af2259a87f79645d = ()=>[
        (0, $c1N9v.staticPlanSidebarNavigationResource)
    ];
const $4f455891fb36bf50$export$a103e99ad51f7bc3 = ()=>[
        (0, $atU1t.navigationSidebarGlobalResource),
        (0, $bHhiy.getConsolidationStateResource)(),
        (0, $drGWM.checkApiKeyManagementKeysResource)()
    ];
const $4f455891fb36bf50$export$808691f5a412afa3 = ()=>[
        (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
        (0, $kJQXA.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $5bkvv.forgeProjectSettingsModuleResource),
        (0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});
parcelRegister("5kYzp", function(module, exports) {

$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $76a68e4d8702ab58$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $76a68e4d8702ab58$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4AdUG = parcelRequire("4AdUG");

var $2EmJy = parcelRequire("2EmJy");

var $9UEf0 = parcelRequire("9UEf0");
const $76a68e4d8702ab58$export$2a421cd16fa9a95a = (0, $2M1hQ.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $2EmJy.get)(),
            (0, $9UEf0.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $76a68e4d8702ab58$export$8fbe7f8de07afffd = (0, $2M1hQ.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $4AdUG.get)(),
            (0, $9UEf0.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $76a68e4d8702ab58$export$43d4950a3e443fd3 = ()=>(0, $2YP9W.useResource)($76a68e4d8702ab58$export$2a421cd16fa9a95a);
const $76a68e4d8702ab58$export$6fb72f4a0c177494 = ()=>(0, $2YP9W.useResource)($76a68e4d8702ab58$export$8fbe7f8de07afffd);

});
parcelRegister("4AdUG", function(module, exports) {

$parcel$export(module.exports, "get", () => $90a9ae99ea774144$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $90a9ae99ea774144$export$adaa4cf7ef1b65be);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $90a9ae99ea774144$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $eusud.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $90a9ae99ea774144$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $eusud.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};

});

parcelRegister("2EmJy", function(module, exports) {

$parcel$export(module.exports, "get", () => $02ac2f2e29fd92e6$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $02ac2f2e29fd92e6$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $eusud.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $eusud.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $981adbf91eeefd26$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $981adbf91eeefd26$export$5e0c0e8c940630f8 = 'private';
const $981adbf91eeefd26$export$1d5a5b6462188eb3 = 'public';


parcelRegister("9UEf0", function(module, exports) {

$parcel$export(module.exports, "get", () => $0fff4d2d98ff5692$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $0fff4d2d98ff5692$export$adaa4cf7ef1b65be);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $0fff4d2d98ff5692$var$key = 'announcementBannerDismissedLast';
const $0fff4d2d98ff5692$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $89SaW.getUserProperty)(accoundId, $0fff4d2d98ff5692$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $0fff4d2d98ff5692$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $89SaW.setUserProperties)(accoundId, $0fff4d2d98ff5692$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
parcelRegister("89SaW", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $646571db30c23ce6$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $646571db30c23ce6$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $646571db30c23ce6$export$b3126db2ef6e34ed);

var $jJZqs = parcelRequire("jJZqs");

var $6no39 = parcelRequire("6no39");
const $646571db30c23ce6$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $646571db30c23ce6$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>{
    const url = $646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey);
    return fetch(url, {
        ...(0, $6no39.getDefaultOptions)(url),
        method: 'PUT',
        body: data
    });
};
const $646571db30c23ce6$export$b3126db2ef6e34ed = (accountId, propertyKey)=>{
    const url = $646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey);
    return fetch(url, (0, $6no39.getDefaultOptions)(url)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $jJZqs.default)(res.status, errResp);
        });
    }).then((data)=>data.value);
};

});
parcelRegister("6no39", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $b41761551f5f2353$export$430a3269e24b912e);

var $51xpa = parcelRequire("51xpa");
function $b41761551f5f2353$export$430a3269e24b912e(url) {
    const options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    return url ? (0, $51xpa.applyObservabilityHeaders)(url, options) : options;
}
const $b41761551f5f2353$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};

});




parcelRegister("5bkvv", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleResource", () => $3d515a0fe8e87c81$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $3d515a0fe8e87c81$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $3d515a0fe8e87c81$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectModuleResourceOnNav3Only", () => $3d515a0fe8e87c81$export$9f19b684a7493211);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $3d515a0fe8e87c81$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $3d515a0fe8e87c81$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $3d515a0fe8e87c81$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $3d515a0fe8e87c81$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $3d515a0fe8e87c81$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $3d515a0fe8e87c81$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $3d515a0fe8e87c81$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $3d515a0fe8e87c81$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $3d515a0fe8e87c81$export$e6be2f0ca0849869);

var $8O7FC = parcelRequire("8O7FC");

var $4R6GH = parcelRequire("4R6GH");

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $dK8AG = parcelRequire("dK8AG");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $1yLrr = parcelRequire("1yLrr");
const $3d515a0fe8e87c81$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $dK8AG.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $3d515a0fe8e87c81$export$b9489d8c5c5e3626 = (0, $2M1hQ.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.ADMIN_PAGE_MODULE], (0, $1yLrr.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$dcc98f4b36ce9223 = ()=>[
        $3d515a0fe8e87c81$export$b9489d8c5c5e3626
    ];
const $3d515a0fe8e87c81$export$72db683c2914a65e = (0, $2M1hQ.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$9f19b684a7493211 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources')), $3d515a0fe8e87c81$export$72db683c2914a65e);
const $3d515a0fe8e87c81$export$7523db37432ba090 = (0, $2M1hQ.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.BACKLOG_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$cfd99f451b423d3a = (0, $2M1hQ.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.BOARD_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$7b639f33f086f9f1 = (0, $2M1hQ.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.SPRINT_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$8a5aed164e925eb6 = (0, $2M1hQ.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$ec3265610584f9ce = ()=>[
        $3d515a0fe8e87c81$export$8a5aed164e925eb6
    ];
const $3d515a0fe8e87c81$export$7a928d209faf75f = (0, $2M1hQ.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$e81e11bbc3239153 = ()=>(0, $2YP9W.useResource)($3d515a0fe8e87c81$export$7a928d209faf75f);
const $3d515a0fe8e87c81$export$97b0827022fdafe3 = (0, $2M1hQ.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.GLOBAL_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$80b2f91dabb3dd65 = ()=>[
        $3d515a0fe8e87c81$export$97b0827022fdafe3
    ];
const $3d515a0fe8e87c81$export$ebf5369e4dcfad00 = (0, $2M1hQ.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$e6be2f0ca0849869 = (0, $2M1hQ.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_NAVIGATION)
        }).then(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (modules)=>modules[0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $3d515a0fe8e87c81$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("8O7FC", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $7c4745a46edf6307$export$89a1f01f2a7cb2a1);

var $2YZCu = parcelRequire("2YZCu");
const $7c4745a46edf6307$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $2YZCu.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("k2DRb", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "BACKLOG_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e);
$parcel$export(module.exports, "BOARD_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11);
$parcel$export(module.exports, "SPRINT_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$cfb15d127f20a01f);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "COMMAND_PALETTE_MODULE", () => $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $e80aa4d4aac5b0dc$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $e80aa4d4aac5b0dc$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$7e2136b4285d29f5);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $e80aa4d4aac5b0dc$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $e80aa4d4aac5b0dc$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $e80aa4d4aac5b0dc$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $e80aa4d4aac5b0dc$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $e80aa4d4aac5b0dc$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $e80aa4d4aac5b0dc$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $e80aa4d4aac5b0dc$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $e80aa4d4aac5b0dc$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $e80aa4d4aac5b0dc$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $e80aa4d4aac5b0dc$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $e80aa4d4aac5b0dc$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $e80aa4d4aac5b0dc$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $e80aa4d4aac5b0dc$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $e80aa4d4aac5b0dc$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $e80aa4d4aac5b0dc$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $e80aa4d4aac5b0dc$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $e80aa4d4aac5b0dc$export$d719bb340dc354e4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $e80aa4d4aac5b0dc$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $e80aa4d4aac5b0dc$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $e80aa4d4aac5b0dc$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$51ab2784839ce348);
const $e80aa4d4aac5b0dc$export$9af0088c49bdedb = 'PRODUCTION';
const $e80aa4d4aac5b0dc$export$71acbd662c478c42 = 'STAGING';
const $e80aa4d4aac5b0dc$export$978072fd3fd149 = 'DEVELOPMENT';
const $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063 = 'default';
const $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e = 'jira:backlogAction';
const $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11 = 'jira:boardAction';
const $e80aa4d4aac5b0dc$export$cfb15d127f20a01f = 'jira:sprintAction';
const $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992 = 'jira:command';
const $e80aa4d4aac5b0dc$export$259bab989b0129d0 = 'jira:issueGlance';
const $e80aa4d4aac5b0dc$export$75f224942f595e13 = 'jira:issueContext';
const $e80aa4d4aac5b0dc$export$ba0968f9752844 = 'jira:issuePanel';
const $e80aa4d4aac5b0dc$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
const $e80aa4d4aac5b0dc$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $e80aa4d4aac5b0dc$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $e80aa4d4aac5b0dc$export$811b7f067a43b422 = 'jira:uiModifications';
const $e80aa4d4aac5b0dc$export$e3887d6bafe8a17 = 'jira:customField';
const $e80aa4d4aac5b0dc$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
const $e80aa4d4aac5b0dc$export$151b03356f566603 = 'jira:projectPage';
const $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $e80aa4d4aac5b0dc$export$31ac745ab2add7cc = 'jira:globalPage';
const $e80aa4d4aac5b0dc$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $e80aa4d4aac5b0dc$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $e80aa4d4aac5b0dc$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $e80aa4d4aac5b0dc$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $e80aa4d4aac5b0dc$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $e80aa4d4aac5b0dc$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $e80aa4d4aac5b0dc$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7 = [
    $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e,
    $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992,
    $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11,
    $e80aa4d4aac5b0dc$export$cfb15d127f20a01f,
    $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16,
    $e80aa4d4aac5b0dc$export$259bab989b0129d0,
    $e80aa4d4aac5b0dc$export$75f224942f595e13,
    $e80aa4d4aac5b0dc$export$7e2136b4285d29f5,
    $e80aa4d4aac5b0dc$export$ba0968f9752844,
    $e80aa4d4aac5b0dc$export$cc20a5638825fbb0,
    $e80aa4d4aac5b0dc$export$9069d4b945c3d532,
    $e80aa4d4aac5b0dc$export$811b7f067a43b422,
    $e80aa4d4aac5b0dc$export$e3887d6bafe8a17,
    $e80aa4d4aac5b0dc$export$7b7866c04a2ad947,
    $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0,
    $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58,
    $e80aa4d4aac5b0dc$export$151b03356f566603,
    $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636,
    $e80aa4d4aac5b0dc$export$31ac745ab2add7cc,
    $e80aa4d4aac5b0dc$export$353acf28daa75c79,
    $e80aa4d4aac5b0dc$export$25627f012b21b0b9,
    $e80aa4d4aac5b0dc$export$8af4cb794979f60d,
    $e80aa4d4aac5b0dc$export$5592ab836d562168,
    $e80aa4d4aac5b0dc$export$842eb4236828ac9,
    $e80aa4d4aac5b0dc$export$42d6a8740fd42e58,
    $e80aa4d4aac5b0dc$export$a7186e5a73395db4,
    $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17
];
const $e80aa4d4aac5b0dc$export$2b8aeda236486576 = 'edit';
const $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d = 'view';
const $e80aa4d4aac5b0dc$export$b37d58c3ed77c139 = 'create';
const $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251 = 'contextConfig';
const $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d = 'none';
const $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe = 5;
const $e80aa4d4aac5b0dc$export$8e96118a698216cb = 'native';
const $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb = 'basic';
const $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7 = 'blank';
const $e80aa4d4aac5b0dc$export$ecbd7135d66cb322 = 'unknownSource';
const $e80aa4d4aac5b0dc$export$61d882aa7aba51c = 'global-issue-create';
const $e80aa4d4aac5b0dc$export$46cb92762d68a048 = 'issue-view';
const $e80aa4d4aac5b0dc$export$fe90e46aea58e30b = 'navigation';
const $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a = 'full-page-app';
const $e80aa4d4aac5b0dc$export$eae46a3c13473a8d = 'router';
const $e80aa4d4aac5b0dc$export$ac11ee191d09688f = 'legacy';
const $e80aa4d4aac5b0dc$export$4346e4e240c84319 = 'organization-panel';
const $e80aa4d4aac5b0dc$export$d719bb340dc354e4 = 'assets-import-type';
const $e80aa4d4aac5b0dc$export$4b6228758e800433 = 'jira';
const $e80aa4d4aac5b0dc$export$70495c8cc141a7a4 = 'jsm';
const $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2 = 'cmdb';
const $e80aa4d4aac5b0dc$export$a48dade1864725a = {
    jiraBacklogAction: [],
    jiraBoardAction: [],
    jiraSprintAction: [],
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueNavigatorAction: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraPersonalSettingsPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: [],
    jiraCommand: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$e80aa4d4aac5b0dc$export$a48dade1864725a
};
const $e80aa4d4aac5b0dc$export$218a328f66b86f7d = ()=>({
        ...$e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $e80aa4d4aac5b0dc$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $e80aa4d4aac5b0dc$export$df7774a415710cce = 'com.atlassian.forge:';
const $e80aa4d4aac5b0dc$export$51ab2784839ce348 = `${$e80aa4d4aac5b0dc$export$df7774a415710cce}${$e80aa4d4aac5b0dc$export$3193d714ab54ee26}`;

});

parcelRegister("iVaKa", function(module, exports) {

$parcel$export(module.exports, "fetchModules", () => $1b1a9656c7bb4ee4$export$24d8e11b15325c53);

var $gPjkL = parcelRequire("gPjkL");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $bPtOr = parcelRequire("bPtOr");

var $dYScp = parcelRequire("dYScp");

var $hBuqR = parcelRequire("hBuqR");

var $bOLUk = parcelRequire("bOLUk");

var $k2DRb = parcelRequire("k2DRb");

var $5yJb9 = parcelRequire("5yJb9");

var $gPjkL = parcelRequire("gPjkL");

var $d5W4H = parcelRequire("d5W4H");

var $h8M2b = parcelRequire("h8M2b");

var $ioGTN = parcelRequire("ioGTN");
const $1b1a9656c7bb4ee4$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, $k2DRb.SOURCE_UNKNOWN) } = params;
    if (!(0, $d5W4H.canFetchForgeModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous
    })) return (0, $h8M2b.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $dYScp.measureExecutionTimeMetrics)(()=>$1b1a9656c7bb4ee4$export$9f9fdbce0829073d(params));
        if (Math.random() * 100 < (0, $hBuqR.FORGE_SAMPLING_RATE)) (0, $bOLUk.fireInitializationFetchFinishedEvent)(source);
        return (0, $h8M2b.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $bPtOr.getErrorType)(error);
        (0, $bOLUk.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($1b1a9656c7bb4ee4$export$458cbcb6374269d2.includes(errorType)) return (0, $h8M2b.toMappedExtensions)(types, []);
        throw error;
    }
};
function $1b1a9656c7bb4ee4$export$9f9fdbce0829073d(props) {
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    const operationName = (0, $gPjkL.default).params.name;
    const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, $ioGTN.trackGraphQLErrors)(operationName);
    let extensions;
    return new Promise((resolve, reject)=>{
        const subscription = (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $gPjkL.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes,
            includeUserAccess: (0, $4R6GH.fg)('forge_query_include_user_access'),
            includeEgressOverridesForge: (0, $4R6GH.fg)('forge-ui-overrides-property-in-extension-list'),
            includeUserAccessEnabledForge: (0, $4R6GH.fg)('forge_query_include_user_access_enabled')
        }).subscribe({
            next: (response)=>{
                stopGraphQLErrorTracking();
                extensions = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                response.jira?.forge?.extensions?.concat() || null;
            },
            error: (error)=>{
                stopGraphQLErrorTracking();
                reject(error);
                subscription.unsubscribe();
            },
            complete: ()=>{
                // If there is a GraphQL error and extensions are `null`, it means a critical error has happened, and we have to reject the promise.
                // However, if the list of extensions is present in the response, it shouldn't be considered an error.
                const graphQLError = getGraphQLError();
                if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                else resolve(extensions || []);
                subscription.unsubscribe();
            }
        });
    });
}
const $1b1a9656c7bb4ee4$export$458cbcb6374269d2 = [
    (0, $bPtOr.FAILED_TO_FETCH),
    (0, $bPtOr.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $bPtOr.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("gPjkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $13cd104237d48c31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdaeaebceedcd9b9c4eac7cf2b8c4be4>>
 * @relayHash 7c54c041f1e395e1a5fa87d0faceebe3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccfec1376b5c860c1ea954efb06d46f6463017fd1311a44948aad2f095269a97
const $13cd104237d48c31$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeEgressOverridesForge"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUserAccess"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUserAccessEnabledForge"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "condition": "includeHidden",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeScopes",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "condition": "includeUserAccess",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                },
                                                {
                                                    "condition": "includeUserAccessEnabledForge",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "enabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "condition": "includeEgressOverridesForge",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inScopeEUD"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeEgressOverridesForge",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "overrides"
                                        },
                                        {
                                            "concreteType": "JiraForgeInstallationConfigExtension",
                                            "kind": "LinkedField",
                                            "name": "installationConfig",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchModulesV2Query",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchModulesV2Query",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "id": "ccfec1376b5c860c1ea954efb06d46f6463017fd1311a44948aad2f095269a97",
            "metadata": {},
            "name": "fetchModulesV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$13cd104237d48c31$var$node.hash = "34a7d1880eed110367d785564deed185";
var $13cd104237d48c31$export$2e2bcd8739ae039 = $13cd104237d48c31$var$node;

});

parcelRegister("bPtOr", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $e4bddb38a31390d9$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $e4bddb38a31390d9$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $e4bddb38a31390d9$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $e4bddb38a31390d9$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $e4bddb38a31390d9$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $e4bddb38a31390d9$export$e19f9f08a6d79fd2);


var $fZneA = parcelRequire("fZneA");

var $bvblX = parcelRequire("bvblX");

var $bCf8q = parcelRequire("bCf8q");
const $e4bddb38a31390d9$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $e4bddb38a31390d9$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $e4bddb38a31390d9$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $e4bddb38a31390d9$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $e4bddb38a31390d9$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $e4bddb38a31390d9$export$89a175d4190df42e = 'Invoke value functions failed:';
const $e4bddb38a31390d9$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $e4bddb38a31390d9$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $bCf8q.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $e4bddb38a31390d9$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    // Tracked GraphQL errors contain useful info about internal errors like status codes
    // We want to categorize them more precisely, because some error types aren't SLO critical.
    if (error instanceof (0, $bvblX.TrackedGraphQLError)) {
        if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $e4bddb38a31390d9$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
        return 'TRACKED_GRAPHQL_ERROR';
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $e4bddb38a31390d9$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($e4bddb38a31390d9$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($e4bddb38a31390d9$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($e4bddb38a31390d9$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($e4bddb38a31390d9$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $fZneA.isClientFetchError)(error)) return $e4bddb38a31390d9$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("bvblX", function(module, exports) {

$parcel$export(module.exports, "TrackedGraphQLError", () => $b1b2278e9c04b70b$export$f2062ad173e74c75);
class $b1b2278e9c04b70b$export$f2062ad173e74c75 extends Error {
    constructor(errorMessage, errors, traceIds){
        super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
        this.errors = errors;
        // Get first trace id
        this.traceId = traceIds?.[0];
        // Get first status code
        this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
        // Combine error messages
        this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
    }
}

});


parcelRegister("dYScp", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $d79aabebae5ffeb3$export$a859f6866f4653e0);

var $7Jxgt = parcelRequire("7Jxgt");

var $hBuqR = parcelRequire("hBuqR");

var $8kVg1 = parcelRequire("8kVg1");
const $d79aabebae5ffeb3$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, $7Jxgt.v4)();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $hBuqR.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
};

});
parcelRegister("hBuqR", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $bbc089ab376d4a7b$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $bbc089ab376d4a7b$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $bbc089ab376d4a7b$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $bbc089ab376d4a7b$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $bbc089ab376d4a7b$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $bbc089ab376d4a7b$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $bbc089ab376d4a7b$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $bbc089ab376d4a7b$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $bbc089ab376d4a7b$export$f892f621fb508154 = 'jiraForgeUi';
const $bbc089ab376d4a7b$export$273f5980517336e2 = 'jiraforgeui';
const $bbc089ab376d4a7b$export$ed63b053e04e26df = 'trigger';
const $bbc089ab376d4a7b$export$725bacc669333eef = 'extension';
const $bbc089ab376d4a7b$export$d920cee73ec094d0 = 10;
const $bbc089ab376d4a7b$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $bbc089ab376d4a7b$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $bbc089ab376d4a7b$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $bbc089ab376d4a7b$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("8kVg1", function(module, exports) {

$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $f1fed22795d0c676$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $f1fed22795d0c676$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $f1fed22795d0c676$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $f1fed22795d0c676$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $f1fed22795d0c676$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $f1fed22795d0c676$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $f1fed22795d0c676$export$a318f99472db73c8);

var $dGrdR = parcelRequire("dGrdR");

var $6RCeq = parcelRequire("6RCeq");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $hBuqR = parcelRequire("hBuqR");
const $f1fed22795d0c676$export$c3d8833fbea3e976 = (0, $dGrdR.metrics).concurrent.custom({
    key: (0, $hBuqR.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $f1fed22795d0c676$export$292f3b557281044f = (0, $dGrdR.metrics).concurrent.custom({
    key: (0, $hBuqR.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $f1fed22795d0c676$export$89ace7e2bb7d7685 = new (0, $duUGa.UFOExperience)((0, $hBuqR.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});
async function $f1fed22795d0c676$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $6RCeq.default).getEntriesByName(startMark).length > 0 || (0, $6RCeq.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $6RCeq.default).mark(startMark);
    const result = await fn();
    (0, $6RCeq.default).mark(endMark);
    return result;
}
const $f1fed22795d0c676$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $6RCeq.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $6RCeq.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $6RCeq.default).clearMarks(name);
    });
};
const $f1fed22795d0c676$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $dGrdR.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $hBuqR.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $hBuqR.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $f1fed22795d0c676$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $dGrdR.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("bOLUk", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $2f4555f4bd0f0eef$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0);
$parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", () => $2f4555f4bd0f0eef$export$e914f7df1e4ad79b);
$parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", () => $2f4555f4bd0f0eef$export$b274c658390b491b);

var $6yg2S = parcelRequire("6yg2S");

var $8uOa6 = parcelRequire("8uOa6");
const $2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $2f4555f4bd0f0eef$export$917d0643b0111a02 = (0, $6yg2S.toEventId)('issueViewInitialization');
const $2f4555f4bd0f0eef$export$43e875fd63e64525 = (0, $6yg2S.toEventId)('fetchModulesInitialization');
const $2f4555f4bd0f0eef$export$132ca822850e455f = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$e914f7df1e4ad79b = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$b274c658390b491b = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("6yg2S", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $cb46d7d052e3d68d$export$75e84ef5a3771f9a);
const $cb46d7d052e3d68d$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("8uOa6", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $73635d33815c9f98$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $73635d33815c9f98$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $73635d33815c9f98$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $73635d33815c9f98$export$390a62413962e4f0);

var $fjcgS = parcelRequire("fjcgS");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $7yD9b = parcelRequire("7yD9b");

var $eGXs2 = parcelRequire("eGXs2");
const $73635d33815c9f98$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $hBuqR.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $6MtPV.createAttributes)(attributes),
        source: source,
        action: action
    });
const $73635d33815c9f98$var$getAnalyticsClient = async ()=>(await (0, $fjcgS.getAnalyticsWebClientPromise)()).getInstance();
const $73635d33815c9f98$var$sendOperationalEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendOperationalEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$var$sendUiEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendUIEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$var$sendTrackEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendTrackEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendUiEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendTrackEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $73635d33815c9f98$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $7yD9b.logError)((0, $7yD9b.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $eGXs2.isSynthetic)().toString()}, id=${id}, source=${(0, $6MtPV.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("6MtPV", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $31dca5b0e1651a2f$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $31dca5b0e1651a2f$export$c7c9603a6b1fd815);

var $84Tib = parcelRequire("84Tib");

var $j8DrX = parcelRequire("j8DrX");

var $4R6GH = parcelRequire("4R6GH");

var $9uiWt = parcelRequire("9uiWt");

var $bPtOr = parcelRequire("bPtOr");

var $eGXs2 = parcelRequire("eGXs2");
const $31dca5b0e1651a2f$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $31dca5b0e1651a2f$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $31dca5b0e1651a2f$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $eGXs2.isSynthetic)(),
        isOverridingFragments: (0, $9uiWt.isOverridingFragments)(),
        isSSR: false,
        ...(0, $4R6GH.fg)('ditto-add-region-and-shard-to-op-analytics') ? {
            shard: (0, $j8DrX.default)('ajs-shard') || '',
            region: (0, $j8DrX.default)('ajs-region') || ''
        } : {}
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $31dca5b0e1651a2f$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $31dca5b0e1651a2f$export$78c6267359db7e73(error);
            attributes.errorType = (0, $bPtOr.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($84Tib)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("9uiWt", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $c677f4c9cc5e982f$export$1d1321d2b374d697);
const $c677f4c9cc5e982f$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("eGXs2", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $58ae13ec31f88266$export$947749d756ccb0a);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");
const $58ae13ec31f88266$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('forge_ui_synthetic_check');

});


parcelRegister("7yD9b", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $187fc325525eefe3$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $187fc325525eefe3$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $187fc325525eefe3$export$58da9968c3170cb1);

var $2YZCu = parcelRequire("2YZCu");

var $hBuqR = parcelRequire("hBuqR");
const $187fc325525eefe3$export$e31edcd35abe3bb1 = 'environment-mapping';
const $187fc325525eefe3$export$d1e4f308040bb0d5 = 'analytics';
const $187fc325525eefe3$export$36f315a5c6daf40b = 'custom-field-object-type';
const $187fc325525eefe3$export$6ee8198f29fffdb4 = {
    [$187fc325525eefe3$export$d1e4f308040bb0d5]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$187fc325525eefe3$export$e31edcd35abe3bb1]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$187fc325525eefe3$export$36f315a5c6daf40b]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $187fc325525eefe3$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData($187fc325525eefe3$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("d5W4H", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08);
const $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08 = ({ isAnonymous: isAnonymous, cloudId: cloudId })=>{
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    /**
	 * Similarly to the `bob` tenant situation above, we don't want to fetch Forge modules on monolith webdriver tests,
	 * that are also started with `./jmake run ci`, but this time with a valid `cloudId`.
	 * The reason for that is the heartbeat service that is not available in there, which leads to the login page redirects.
	 */ if (!false && $f4d6ea2b45e6b20f$export$489a82a1efc4cd04().endsWith('.atl-test.space')) return false;
    // There is no anonymous access for now
    return !isAnonymous;
};
const $f4d6ea2b45e6b20f$export$489a82a1efc4cd04 = ()=>window.location.hostname;

});

parcelRegister("h8M2b", function(module, exports) {

$parcel$export(module.exports, "toMappedExtensions", () => $cb129cf486f6f6f7$export$e073e0c0d1c23345);
function $cb129cf486f6f6f7$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    returnedExtensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return result;
}

});

parcelRegister("ioGTN", function(module, exports) {

$parcel$export(module.exports, "trackGraphQLErrors", () => $03e8a2344fd340fa$export$a5c00ff206a4c88b);

var $5a0Nh = parcelRequire("5a0Nh");

var $bvblX = parcelRequire("bvblX");

var $5Wobd = parcelRequire("5Wobd");
function $03e8a2344fd340fa$export$a5c00ff206a4c88b(operationName) {
    const queryId = (0, $5a0Nh.startCaptureGraphQlErrors)();
    (0, $5Wobd.startCapturingTraceIds)(operationName);
    return {
        stopGraphQLErrorTracking: ()=>(0, $5Wobd.stopCapturingTraceIds)(operationName),
        getGraphQLError: ()=>$03e8a2344fd340fa$var$getGraphQLError(queryId, operationName)
    };
}
function $03e8a2344fd340fa$var$getGraphQLError(key, operationName) {
    const errors = (0, $5a0Nh.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
    if (errors.length) return new (0, $bvblX.TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, $5Wobd.getTraceIds)(operationName));
    return undefined;
}

});


parcelRegister("dK8AG", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $9ffe1ab8f180b628$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $9ffe1ab8f180b628$export$b87af5b274141bd6);

var $1nb22 = parcelRequire("1nb22");
const $9ffe1ab8f180b628$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $9ffe1ab8f180b628$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});
parcelRegister("1nb22", function(module, exports) {

$parcel$export(module.exports, "getProjectKey", () => $061afadfbcc74f44$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectIdOrKey", () => $061afadfbcc74f44$export$c072f183553fb7ea);
$parcel$export(module.exports, "getProjectKeyId", () => $061afadfbcc74f44$export$1f7213d0f9054f06);
const $061afadfbcc74f44$export$89040d072f281f85 = (query)=>query?.selectedProjectId || query?.pid || query?.projectId || query?.['project.id'];
const $061afadfbcc74f44$export$667f2a0f99c75faa = (match, query)=>match?.params.projectKey || query?.projectKey || query?.['project.key'] || (match.params?.issueKey || '').split('-')[0];
const $061afadfbcc74f44$export$c072f183553fb7ea = (match, query)=>$061afadfbcc74f44$export$89040d072f281f85(query) || $061afadfbcc74f44$export$667f2a0f99c75faa(match, query);
const $061afadfbcc74f44$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = $061afadfbcc74f44$export$89040d072f281f85(query);
    const projectKey = $061afadfbcc74f44$export$667f2a0f99c75faa(match, query);
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});


parcelRegister("gNStA", function(module, exports) {

$parcel$export(module.exports, "resourceWithCondition", () => $4fbc57fe7e788209$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $4fbc57fe7e788209$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $4fbc57fe7e788209$export$5284559c6d2f1a7b);

var $kbVA4 = parcelRequire("kbVA4");
const $4fbc57fe7e788209$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $kbVA4.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        },
        get skipBrowser () {
            return resourceTrue.skipBrowser;
        }
    };
const $4fbc57fe7e788209$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $4fbc57fe7e788209$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $4fbc57fe7e788209$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $4fbc57fe7e788209$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("kbVA4", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $513d12eeb22c04a1$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $513d12eeb22c04a1$export$5664a170ac5a9781);
const $513d12eeb22c04a1$export$eb37f5d331ea4de4 = 'NOOP';
const $513d12eeb22c04a1$export$5664a170ac5a9781 = 5000;

});


parcelRegister("1yLrr", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $8bb90f56b7c2b78a$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5);

var $3JOCw = parcelRequire("3JOCw");

var $e0AC8 = parcelRequire("e0AC8");
const $8bb90f56b7c2b78a$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});
parcelRegister("3JOCw", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $7CoLY = parcelRequire("7CoLY");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $2b8cd72f1d3e4fca$var$uniqBy(array, iteratee) {
    return array && array.length ? $7CoLY(array, $bxDef(iteratee, 2)) : [];
}
module.exports = $2b8cd72f1d3e4fca$var$uniqBy;

});

parcelRegister("e0AC8", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $d4c89d40e0b3eaac$export$a92b17288693d366);
const $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $d4c89d40e0b3eaac$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});



parcelRegister("7xTO3", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $7371ef5d04dd1248$export$5839dd8142de842e);

var $2YZCu = parcelRequire("2YZCu");

var $8YTna = parcelRequire("8YTna");

var $2M1hQ = parcelRequire("2M1hQ");

var $55UpE = parcelRequire("55UpE");
const $7371ef5d04dd1248$export$5839dd8142de842e = (0, $2M1hQ.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $55UpE.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000
});

});
parcelRegister("8YTna", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $f7f12dfb24bc320d$export$557c2f222778cea6);
const $f7f12dfb24bc320d$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("55UpE", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $e577b36e40c022cb$export$306fb49fca60b34);

var $eusud = parcelRequire("eusud");
const $e577b36e40c022cb$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("c1N9v", function(module, exports) {

$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $2M1hQ = parcelRequire("2M1hQ");

var $ijN6s = parcelRequire("ijN6s");
const $4a8a43738dc54d5c$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$4a8a43738dc54d5c$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $ijN6s.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000
});

});
parcelRegister("ijN6s", function(module, exports) {

$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $b2d0559c1bc2bb35$export$a49729698cfc5310);

var $eusud = parcelRequire("eusud");
const $b2d0559c1bc2bb35$var$requestSideBarInfo = (planId, scenarioId)=>(0, $eusud.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $b2d0559c1bc2bb35$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $b2d0559c1bc2bb35$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("loy04", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $c5a0b9808c0c3182$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $c5a0b9808c0c3182$export$2d5a704ae6f6b050);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $jAGOQ = parcelRequire("jAGOQ");
const $c5a0b9808c0c3182$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $c5a0b9808c0c3182$export$e4bf33528101348c = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$c5a0b9808c0c3182$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $c5a0b9808c0c3182$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});
const $c5a0b9808c0c3182$export$2d5a704ae6f6b050 = ()=>(0, $2YP9W.useResource)($c5a0b9808c0c3182$export$e4bf33528101348c);

});
parcelRegister("jAGOQ", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $45e9310ad65e3e88$export$b15f9f5cf6db359e);

var $eusud = parcelRequire("eusud");
const $45e9310ad65e3e88$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("2fwuR", function(module, exports) {

$parcel$export(module.exports, "sidebarNav4Resource", () => $692dbcae1edae2a1$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarNav4UiStateResource", () => $692dbcae1edae2a1$export$a46129bd512544d7);

var $jhS4y = parcelRequire("jhS4y");

var $3Jbkp = parcelRequire("3Jbkp");

var $fMcVX = parcelRequire("fMcVX");

var $ao2h1 = parcelRequire("ao2h1");

var $2OeZv = parcelRequire("2OeZv");

var $fZBia = parcelRequire("fZBia");

var $kYHsT = parcelRequire("kYHsT");

var $k9L5z = parcelRequire("k9L5z");
const $692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $692dbcae1edae2a1$export$7648dc6f76f4f83d = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${$692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId } })=>{
        const initialSelectedPath = (0, $3Jbkp.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $2OeZv.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_APPS)),
                isFiltersExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $kYHsT.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $k9L5z.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $692dbcae1edae2a1$export$a46129bd512544d7 = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $fZBia.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("jhS4y", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_APP_MENU_ID", () => $d66e3a3484b422c6$export$1bb3d16bc95080e3);
$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $d66e3a3484b422c6$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $d66e3a3484b422c6$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $d66e3a3484b422c6$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $d66e3a3484b422c6$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $d66e3a3484b422c6$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $d66e3a3484b422c6$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $d66e3a3484b422c6$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $d66e3a3484b422c6$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $d66e3a3484b422c6$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $d66e3a3484b422c6$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $d66e3a3484b422c6$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $d66e3a3484b422c6$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $d66e3a3484b422c6$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $d66e3a3484b422c6$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $d66e3a3484b422c6$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $d66e3a3484b422c6$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $d66e3a3484b422c6$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $d66e3a3484b422c6$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $d66e3a3484b422c6$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $d66e3a3484b422c6$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $d66e3a3484b422c6$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $d66e3a3484b422c6$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $d66e3a3484b422c6$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $d66e3a3484b422c6$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $d66e3a3484b422c6$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $d66e3a3484b422c6$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $d66e3a3484b422c6$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $d66e3a3484b422c6$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $d66e3a3484b422c6$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $d66e3a3484b422c6$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", () => $d66e3a3484b422c6$export$11fcdf33179ef88e);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_HUBS", () => $d66e3a3484b422c6$export$d69bec513af84431);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE_ANALYTICS", () => $d66e3a3484b422c6$export$1d260f51eeaab73d);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $d66e3a3484b422c6$export$80dc576e446bdb6b);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_ASSETS", () => $d66e3a3484b422c6$export$5aa3e4dd37f372d5);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_GOALS", () => $d66e3a3484b422c6$export$7986b535c183c592);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $d66e3a3484b422c6$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $d66e3a3484b422c6$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $d66e3a3484b422c6$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $d66e3a3484b422c6$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $d66e3a3484b422c6$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $d66e3a3484b422c6$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $d66e3a3484b422c6$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $d66e3a3484b422c6$export$100a1a639a0db980);
const $d66e3a3484b422c6$export$1bb3d16bc95080e3 = {
    GLOBAL_APP_GOALS: 'jira.sidebar.globalApp.goals',
    GLOBAL_APP_ASSETS: 'jira.sidebar.globalApp.assets'
};
const $d66e3a3484b422c6$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps',
    CUSTOMER_SERVICE: 'jira.sidebar.customerService',
    CUSTOMER_HUBS: 'jira.sidebar.customerHubs',
    CUSTOMER_SERVICE_ANALYTICS: 'jira.sidebar.customerServiceAnalytics',
    ...$d66e3a3484b422c6$export$1bb3d16bc95080e3
};
const $d66e3a3484b422c6$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_OPERATIONS: (projectKey)=>`proj-${projectKey}-ops`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    ISSUE: (id)=>`issue_${id}`,
    /** @deprecated delete when cleaning up slv-3_migrate_archived_issues_routes */ ARCHIVED_ISSUES: (id)=>`archived_issues_${id}`,
    ARCHIVED_WORK_ITEMS: (id)=>`archived_work_items_${id}`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $d66e3a3484b422c6$export$441cd608ea3204f4 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.APPS;
const $d66e3a3484b422c6$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $d66e3a3484b422c6$export$75c65bfc98b3a6e1 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ASSETS;
const $d66e3a3484b422c6$export$8a0af92d49f1d13d = 'asst_schm';
const $d66e3a3484b422c6$export$a09300d15acc958a = 'asst_rprt';
const $d66e3a3484b422c6$export$4d718fbd418eef5c = 'board-view-all';
const $d66e3a3484b422c6$export$dd009509c2dabb5e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.DASHBOARDS;
const $d66e3a3484b422c6$export$d3da0455b4200fb2 = 'dash-view';
const $d66e3a3484b422c6$export$b9dd2b5309d19763 = 'dash-view-starred';
const $d66e3a3484b422c6$export$3d81af172a8e3c57 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.FILTERS;
const $d66e3a3484b422c6$export$1e2599eaf0039a97 = 'filt-search';
const $d66e3a3484b422c6$export$53d274d993c9d5b5 = 'filt-view-all';
const $d66e3a3484b422c6$export$7661ea763be69cfa = 'filt-view-starred';
const $d66e3a3484b422c6$export$47c6ce6a83a59eab = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GOALS;
const $d66e3a3484b422c6$export$ef89639b7d9c162a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OPERATIONS;
const $d66e3a3484b422c6$export$af4ab6d4e920522a = 'ops-alrt';
const $d66e3a3484b422c6$export$25c40acb2c53a294 = 'ops-over';
const $d66e3a3484b422c6$export$c7d8892f1628b844 = 'ops-rprt';
const $d66e3a3484b422c6$export$bb19a52e3df99541 = 'ops-oncl';
const $d66e3a3484b422c6$export$3bd12c092f8db11b = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OVERVIEWS;
const $d66e3a3484b422c6$export$f2533da33c749933 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PLANS;
const $d66e3a3484b422c6$export$8468c5b6648f4f1f = 'plan-view-all';
const $d66e3a3484b422c6$export$fed17b4c0866b97d = 'proj-app';
const $d66e3a3484b422c6$export$9c5278bd360a285 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PROJECTS;
const $d66e3a3484b422c6$export$85389c606bb641dd = 'proj-view-all';
const $d66e3a3484b422c6$export$4a1974b63c858e9c = 'proj-view-starred';
const $d66e3a3484b422c6$export$692b796030a796f3 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.RECENT;
const $d66e3a3484b422c6$export$cdc80d4b5ce0c6a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ROADMAPS;
const $d66e3a3484b422c6$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $d66e3a3484b422c6$export$5637ca42a4d77f32 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.STARRED;
const $d66e3a3484b422c6$export$d4f6fcf571f9c50 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.TEAMS;
const $d66e3a3484b422c6$export$11fcdf33179ef88e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
const $d66e3a3484b422c6$export$d69bec513af84431 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_HUBS;
const $d66e3a3484b422c6$export$1d260f51eeaab73d = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_SERVICE_ANALYTICS;
const $d66e3a3484b422c6$export$80dc576e446bdb6b = 'yrwk';
const $d66e3a3484b422c6$export$5aa3e4dd37f372d5 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_ASSETS;
const $d66e3a3484b422c6$export$7986b535c183c592 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_GOALS;
const $d66e3a3484b422c6$export$79c15668ed799a1b = 'sd-sett-acc';
const $d66e3a3484b422c6$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $d66e3a3484b422c6$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $d66e3a3484b422c6$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $d66e3a3484b422c6$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $d66e3a3484b422c6$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $d66e3a3484b422c6$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $d66e3a3484b422c6$export$100a1a639a0db980 = 'sd-sett-ops';

});

parcelRegister("3Jbkp", function(module, exports) {

$parcel$export(module.exports, "getInitialSelectedPath", () => $e52131b0b61339d3$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $bxYf9 = parcelRequire("bxYf9");

var $7Ckoi = parcelRequire("7Ckoi");
const $e52131b0b61339d3$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))((0, $7Ckoi.routeToSelectedPath));

});
parcelRegister("7Ckoi", function(module, exports) {

$parcel$export(module.exports, "routeToSelectedPath", () => $551cdf5d088747a1$export$a92474c098a1fd13);
$parcel$export(module.exports, "useRouteToSelectedPath", () => $551cdf5d088747a1$export$a086f1986cac3253);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $4R6GH = parcelRequire("4R6GH");

var $lODMY = parcelRequire("lODMY");

var $fBDpl = parcelRequire("fBDpl");

var $ezq2z = parcelRequire("ezq2z");

var $j3mSh = parcelRequire("j3mSh");

var $1RoZ2 = parcelRequire("1RoZ2");

var $hdJn1 = parcelRequire("hdJn1");

var $2m3Yb = parcelRequire("2m3Yb");

var $3weqe = parcelRequire("3weqe");

var $c6hlO = parcelRequire("c6hlO");

var $3lNyZ = parcelRequire("3lNyZ");

var $8bXrC = parcelRequire("8bXrC");

var $eReVn = parcelRequire("eReVn");

var $djX45 = parcelRequire("djX45");
function $551cdf5d088747a1$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $2m3Yb.topLevelConverter).routes.has(routeName)) return (0, $2m3Yb.topLevelConverter).convert(routeContext);
    if ((0, $fBDpl.appsConverter).routes.has(routeName)) return (0, $fBDpl.appsConverter).convert(routeContext);
    if ((0, $ezq2z.assetsConverter).routes.has(routeName)) return (0, $ezq2z.assetsConverter).convert(routeContext);
    if ((0, $j3mSh.dashboardsConverter).routes.has(routeName)) return (0, $j3mSh.dashboardsConverter).convert(routeContext);
    if ((0, $1RoZ2.filtersConverter).routes.has(routeName)) return (0, $1RoZ2.filtersConverter).convert(routeContext);
    if ((0, $hdJn1.operationsConverter).routes.has(routeName)) return (0, $hdJn1.operationsConverter).convert(routeContext);
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convert(routeContext);
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convert(routeContext);
    if ((0, $c6hlO.plansConverter).routes.has(routeName)) return (0, $c6hlO.plansConverter).convert(routeContext);
    if ((0, $3lNyZ.projectsConverter).routes.has(routeName)) return (0, $3lNyZ.projectsConverter).convert(routeContext);
    if ((0, $8bXrC.roadmapsConverter).routes.has(routeName)) return (0, $8bXrC.roadmapsConverter).convert(routeContext);
    if ((0, $eReVn.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $eReVn.serviceManagementProjectSettingsConverter).convert(routeContext);
    if ((0, $4R6GH.fg)('jcs_master_flag')) {
        if ((0, $djX45.customerServiceConverter).routes.has(routeName)) return (0, $djX45.customerServiceConverter).convert(routeContext);
    }
    return [];
}
function $551cdf5d088747a1$export$216c13b87ae41e0b(state) {
    const routeName = state.route.name;
    const match = state.match;
    const query = state.query;
    if ((0, $2m3Yb.topLevelConverter).routes.has(routeName)) return (0, $2m3Yb.topLevelConverter).convertNew({
        routeName: routeName
    });
    if ((0, $fBDpl.appsConverter).routes.has(routeName)) return (0, $fBDpl.appsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $ezq2z.assetsConverter).routes.has(routeName)) return (0, $ezq2z.assetsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $j3mSh.dashboardsConverter).routes.has(routeName)) return (0, $j3mSh.dashboardsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $1RoZ2.filtersConverter).routes.has(routeName)) return (0, $1RoZ2.filtersConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $hdJn1.operationsConverter).routes.has(routeName)) return (0, $hdJn1.operationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $c6hlO.plansConverter).routes.has(routeName)) return (0, $c6hlO.plansConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $3lNyZ.projectsConverter).routes.has(routeName)) return (0, $3lNyZ.projectsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $8bXrC.roadmapsConverter).routes.has(routeName)) return (0, $8bXrC.roadmapsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $eReVn.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $eReVn.serviceManagementProjectSettingsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $4R6GH.fg)('jcs_master_flag')) {
        if ((0, $djX45.customerServiceConverter).routes.has(routeName)) return (0, $djX45.customerServiceConverter).convertNew({
            routeName: routeName
        });
    }
    return [];
}
function $551cdf5d088747a1$export$8eb45058a3aef67f() {
    return (0, $5uXOq.useState)(()=>{
        const selectedPath = $551cdf5d088747a1$export$216c13b87ae41e0b((0, $lODMY.getRouterState)());
        return {
            initialSelectedPath: selectedPath,
            selectedPath: selectedPath
        };
    });
}
function $551cdf5d088747a1$export$a086f1986cac3253() {
    const [selectedPathData, setSelectedPathData] = $551cdf5d088747a1$export$8eb45058a3aef67f();
    (0, $5uXOq.useEffect)(()=>(0, $lODMY.addRouteListener)((state)=>{
            const nextSelectedPath = $551cdf5d088747a1$export$216c13b87ae41e0b(state);
            const pathIsDifferent = (0, $4R6GH.fg)('jira-concurrent-nav4-fix-selected-path') ? !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(nextSelectedPath, selectedPathData.selectedPath) // Since this is an array and not a primitive, we need to do an isEqual check
             : nextSelectedPath !== selectedPathData.selectedPath;
            if (pathIsDifferent) setSelectedPathData({
                initialSelectedPath: selectedPathData.initialSelectedPath,
                selectedPath: nextSelectedPath
            });
        }), [
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath,
        setSelectedPathData
    ]);
    return selectedPathData;
}

});
parcelRegister("fBDpl", function(module, exports) {

$parcel$export(module.exports, "appsConverter", () => $55a8ac7f9c56fb94$export$d017a63045c88c47);

var $jhS4y = parcelRequire("jhS4y");
// TODO: verify these routes
const $55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'legacy-connect-project',
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ 'connect-general-service-desk-project',
    'connect-project'
];
const $55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES = [
    'forge-spa-global',
    'marketplace-index',
    'forge-spa-personal-settings'
];
const $55a8ac7f9c56fb94$export$66b32f6f30eb4b4 = new Set([
    ...$55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $55a8ac7f9c56fb94$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_APPS)
    ];
    return $55a8ac7f9c56fb94$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $55a8ac7f9c56fb94$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_APPS)
    ];
    return $55a8ac7f9c56fb94$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $55a8ac7f9c56fb94$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'marketplace-index':
            path.push((0, $jhS4y.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 'connect-general':
        case 'connect-general-invalid':
        case 'forge-spa-global':
        case 'forge-spa-personal-settings':
        case 'legacy-connect-general':
            path.push((0, $jhS4y.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 'connect-project':
        case 'legacy-connect-project':
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $jhS4y.MENU_ID_PROJECTS),
                    (0, $jhS4y.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 'connect-general-service-desk-project':
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $jhS4y.MENU_ID_PROJECTS),
                    (0, $jhS4y.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $55a8ac7f9c56fb94$export$d017a63045c88c47 = {
    routes: $55a8ac7f9c56fb94$export$66b32f6f30eb4b4,
    convert: $55a8ac7f9c56fb94$var$convert,
    convertNew: $55a8ac7f9c56fb94$var$convertNew
};

});

parcelRegister("ezq2z", function(module, exports) {

$parcel$export(module.exports, "assetsConverter", () => $bdd6509d07f3cefb$export$6cfeba0849032a84);

var $jhS4y = parcelRequire("jhS4y");
const $bdd6509d07f3cefb$var$routes = new Set([
    'assets',
    'assets-configure',
    'assets-data-manager-getting-started',
    'assets-object',
    'assets-schema',
    'assets-schema-configuration',
    'assets-object-type-configuration',
    'assets-reports',
    'assets-reports-default-redirect',
    'assets-reports-unsubscribe',
    'servicedesk-cmdb-assets',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-reports',
    'servicedesk-cmdb-assets-reports-default-redirect',
    'servicedesk-cmdb-assets-reports-unsubscribe',
    'servicedesk-cmdb-insight',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration'
]);
function $bdd6509d07f3cefb$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $jhS4y.MENU_ID_ASSETS)
    ];
    return $bdd6509d07f3cefb$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $bdd6509d07f3cefb$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [
        (0, $jhS4y.MENU_ID_ASSETS)
    ];
    return $bdd6509d07f3cefb$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $bdd6509d07f3cefb$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'servicedesk-cmdb-assets':
        case 'servicedesk-cmdb-object':
        case 'servicedesk-cmdb-object-schema':
        case 'servicedesk-cmdb-object-schema-configuration':
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $jhS4y.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        // eslint-disable-next-line no-duplicate-case
        case 'servicedesk-cmdb-object':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema-configuration':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $jhS4y.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 'servicedesk-cmdb-assets-reports':
        case 'servicedesk-cmdb-assets-reports-default-redirect':
        case 'servicedesk-cmdb-assets-reports-unsubscribe':
            path.push((0, $jhS4y.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $bdd6509d07f3cefb$export$6cfeba0849032a84 = {
    routes: $bdd6509d07f3cefb$var$routes,
    convert: $bdd6509d07f3cefb$var$convert,
    convertNew: $bdd6509d07f3cefb$var$convertNew
};

});

parcelRegister("j3mSh", function(module, exports) {

$parcel$export(module.exports, "dashboardsConverter", () => $257dabfdf8711aa2$export$6468819b4be328b1);

var $jhS4y = parcelRequire("jhS4y");
const $257dabfdf8711aa2$var$routes = new Set([
    'dashboards-directory',
    'dashboard-edit',
    'dashboard-view',
    'dashboard-wallboard'
]);
function $257dabfdf8711aa2$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_DASHBOARDS)
    ];
    return $257dabfdf8711aa2$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $257dabfdf8711aa2$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_DASHBOARDS)
    ];
    return $257dabfdf8711aa2$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $257dabfdf8711aa2$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'dashboards-directory':
            path.push((0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 'dashboard-wallboard':
            query.dashboardId && path.push((0, $jhS4y.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $jhS4y.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $257dabfdf8711aa2$export$6468819b4be328b1 = {
    routes: $257dabfdf8711aa2$var$routes,
    convert: $257dabfdf8711aa2$var$convert,
    convertNew: $257dabfdf8711aa2$var$convertNew
};

});

parcelRegister("1RoZ2", function(module, exports) {

$parcel$export(module.exports, "filtersConverter", () => $c2ae3b230f933dc6$export$6e91331b5debb7c8);

var $jhS4y = parcelRequire("jhS4y");
const $c2ae3b230f933dc6$var$routes = new Set([
    'filters-directory',
    'global-issue-navigator',
    'global-issue-navigator-browse-issue-redirect',
    'issue',
    'legacy-gin',
    'legacy-gin-issue',
    'legacy-gin-subscriptions'
]);
function $c2ae3b230f933dc6$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_FILTERS)
    ];
    return $c2ae3b230f933dc6$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $c2ae3b230f933dc6$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_FILTERS)
    ];
    return $c2ae3b230f933dc6$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $c2ae3b230f933dc6$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'filters-directory':
            path.push((0, $jhS4y.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 'issue':
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $jhS4y.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $jhS4y.MENU_ID_PROJECTS),
                        (0, $jhS4y.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $jhS4y.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $jhS4y.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $c2ae3b230f933dc6$export$6e91331b5debb7c8 = {
    routes: $c2ae3b230f933dc6$var$routes,
    convert: $c2ae3b230f933dc6$var$convert,
    convertNew: $c2ae3b230f933dc6$var$convertNew
};

});

parcelRegister("hdJn1", function(module, exports) {

$parcel$export(module.exports, "operationsConverter", () => $9b181cf5d70a46b3$export$7fc92455d5020e1);

var $4R6GH = parcelRequire("4R6GH");

var $jhS4y = parcelRequire("jhS4y");
const $9b181cf5d70a46b3$var$routes = new Set([
    'eoc-automations',
    'eoc-custom-roles',
    'eoc-global-alerts',
    'eoc-global-alert-detail',
    'eoc-global-group-detail',
    'eoc-global-reports',
    'eoc-global-report-dashboard',
    'eoc-heartbeats',
    'eoc-global-heartbeats',
    'eoc-maintenance',
    'eoc-on-call',
    'eoc-on-call-redirect',
    'eoc-overview',
    'eoc-overview-all-teams',
    'eoc-permissions',
    'eoc-reports',
    'eoc-reports-team',
    'eoc-reports-unsubscribe',
    'eoc-schedules',
    'eoc-team-alerts',
    'eoc-team-alert-detail',
    'eoc-team-alert-issue-syncing',
    'eoc-team-alert-issue-syncing-create',
    'eoc-team-alert-issue-syncing-detail',
    'eoc-team-group-detail',
    'eoc-team-integrations',
    'eoc-team-integration-create',
    'eoc-team-integration-detail',
    'eoc-team-integration-list',
    'eoc-team-integration-log',
    'eoc-team-policies',
    'eoc-who-is-on-call',
    'eoc-global-escalations'
]);
function $9b181cf5d70a46b3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_OPERATIONS)
    ];
    return $9b181cf5d70a46b3$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $9b181cf5d70a46b3$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_OPERATIONS)
    ];
    return $9b181cf5d70a46b3$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $9b181cf5d70a46b3$var$convertRouteToPath(args) {
    const { routeName: routeName, query: query, path: path } = args;
    switch(routeName){
        case 'eoc-who-is-on-call':
            path.push((0, $jhS4y.MENU_ID_OPS_ON_CALL));
            break;
        case 'eoc-global-alerts':
        case 'eoc-global-alert-detail':
            {
                path.push((0, $jhS4y.MENU_ID_OPS_ALERTS));
                if ((0, $4R6GH.fg)('operations_nav4_remaining_items_multi_highlight')) {
                    const { query: alarmQueue = '', view: view, filter: savedSearchId } = query;
                    view && path.push((0, $jhS4y.ENTITY_ID).ALARM_QUEUE(savedSearchId || alarmQueue));
                    break;
                }
                const { query: alarmQueue = '', view: view } = query;
                view && path.push((0, $jhS4y.ENTITY_ID).ALARM_QUEUE(alarmQueue));
                break;
            }
        case 'eoc-global-reports':
        case 'eoc-global-report-dashboard':
        case 'eoc-reports-unsubscribe':
            path.push((0, $jhS4y.MENU_ID_OPS_REPORTS));
            break;
        case 'eoc-automations':
        case 'eoc-global-group-detail':
        case 'eoc-heartbeats':
        case 'eoc-maintenance':
        case 'eoc-permissions':
        case 'eoc-on-call':
        case 'eoc-on-call-redirect':
        case 'eoc-overview':
        case 'eoc-overview-all-teams':
        case 'eoc-reports':
        case 'eoc-reports-team':
        case 'eoc-schedules':
        case 'eoc-team-group-detail':
        case 'eoc-team-alerts':
        case 'eoc-team-alert-detail':
        case 'eoc-team-policies':
        case 'eoc-team-alert-issue-syncing':
        case 'eoc-team-alert-issue-syncing-create':
        case 'eoc-team-alert-issue-syncing-detail':
        case 'eoc-team-integrations':
        case 'eoc-team-integration-create':
        case 'eoc-team-integration-detail':
        case 'eoc-team-integration-list':
        case 'eoc-team-integration-log':
            path.push((0, $jhS4y.MENU_ID_OPS_OVERVIEW));
            break;
        default:
            break;
    }
    return path;
}
const $9b181cf5d70a46b3$export$7fc92455d5020e1 = {
    routes: $9b181cf5d70a46b3$var$routes,
    convert: $9b181cf5d70a46b3$var$convert,
    convertNew: $9b181cf5d70a46b3$var$convertNew
};

});

parcelRegister("2m3Yb", function(module, exports) {

$parcel$export(module.exports, "topLevelConverter", () => $c60c27b55fbcd9c5$export$a33f2d74a674bf8a);

var $jhS4y = parcelRequire("jhS4y");
const $c60c27b55fbcd9c5$var$routes = new Set([
    'your-work',
    'people-index'
]);
function $c60c27b55fbcd9c5$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $c60c27b55fbcd9c5$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $c60c27b55fbcd9c5$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $c60c27b55fbcd9c5$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $c60c27b55fbcd9c5$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'your-work':
            path.push((0, $jhS4y.MENU_ID_YOUR_WORK));
            break;
        case 'people-index':
            path.push((0, $jhS4y.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $c60c27b55fbcd9c5$export$a33f2d74a674bf8a = {
    routes: $c60c27b55fbcd9c5$var$routes,
    convert: $c60c27b55fbcd9c5$var$convert,
    convertNew: $c60c27b55fbcd9c5$var$convertNew
};

});

parcelRegister("3weqe", function(module, exports) {

$parcel$export(module.exports, "overviewsConverter", () => $b8a10fc0a37e731b$export$5469f6c6536ca9c5);

var $jhS4y = parcelRequire("jhS4y");
const $b8a10fc0a37e731b$var$routes = new Set([
    'classic-business-overview-calendar',
    'classic-business-overview-redirect',
    'classic-business-overview-summary',
    'classic-business-overview-timeline'
]);
function $b8a10fc0a37e731b$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_OVERVIEWS)
    ];
    return $b8a10fc0a37e731b$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $b8a10fc0a37e731b$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $jhS4y.MENU_ID_OVERVIEWS)
    ];
    return $b8a10fc0a37e731b$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $b8a10fc0a37e731b$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    routeName;
    {
        const { overviewId: overviewId } = match.params;
        overviewId && path.push((0, $jhS4y.ENTITY_ID).OVERVIEW(overviewId));
    }
    return path;
}
const $b8a10fc0a37e731b$export$5469f6c6536ca9c5 = {
    routes: $b8a10fc0a37e731b$var$routes,
    convert: $b8a10fc0a37e731b$var$convert,
    convertNew: $b8a10fc0a37e731b$var$convertNew
};

});

parcelRegister("c6hlO", function(module, exports) {

$parcel$export(module.exports, "plansConverter", () => $a783e1b6f52291a3$export$3bde637b58016d1);

var $jhS4y = parcelRequire("jhS4y");
const $a783e1b6f52291a3$var$routes = new Set([
    'plans-directory',
    'software-advanced-roadmaps',
    'software-advanced-roadmaps-getting-started-redirect',
    'software-advanced-roadmaps-setup',
    'software-plan-calendar',
    'software-plan-dependencies',
    'software-plan-increment',
    'software-plan-increments',
    'software-plan-releases',
    'software-plan-summary',
    'software-plan-teams',
    'software-plan-timeline',
    'trashed-plan-direct-link',
    'software-plan-upsell'
]);
function $a783e1b6f52291a3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_PLANS)
    ];
    return $a783e1b6f52291a3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $a783e1b6f52291a3$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $jhS4y.MENU_ID_PLANS)
    ];
    return $a783e1b6f52291a3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $a783e1b6f52291a3$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'plans-directory':
        case 'software-advanced-roadmaps-getting-started-redirect':
            path.push((0, $jhS4y.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 'trashed-plan-direct-link':
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $jhS4y.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $a783e1b6f52291a3$export$3bde637b58016d1 = {
    routes: $a783e1b6f52291a3$var$routes,
    convert: $a783e1b6f52291a3$var$convert,
    convertNew: $a783e1b6f52291a3$var$convertNew
};

});

parcelRegister("3lNyZ", function(module, exports) {

$parcel$export(module.exports, "projectsConverter", () => $6eaade1a69d23d1d$export$c41b724886e5872b);

var $4R6GH = parcelRequire("4R6GH");

var $jhS4y = parcelRequire("jhS4y");
const $6eaade1a69d23d1d$var$routes = new Set([
    'browse-project-redirect',
    'legacy-all-reports',
    'projects-directory',
    'issue-navigator',
    'issue-navigator-core',
    'project-components',
    'project-not-found',
    'project-versions',
    'software-version-detail',
    'software-version-detail-no-tab-path',
    'forge-spa-project',
    'forge-spa-project-servicedesk',
    'forge-spa-servicedesk-queue',
    'polaris-ideas',
    'polaris-onboarding',
    'opsgenie-schedule',
    'issue-navigator-classic',
    'project-pages',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'software-backlog',
    'software-boards',
    'software-calendar',
    'software-calendar-classic',
    'classic-software-proforma-issue-forms-direct',
    'software-code',
    'software-code-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-form',
    'software-form-classic',
    'software-form-builder',
    'software-form-builder-classic',
    'software-form-submit',
    'software-form-submit-classic',
    'software-form-submit-embed',
    'software-form-submit-public',
    'software-form-submit-classic-embed',
    'software-form-submit-classic-public',
    'software-goals',
    'software-goals-classic',
    'software-incidents',
    'software-incidents-classic',
    'software-issue-navigator',
    'software-list',
    'software-list-classic',
    'software-periscope',
    'software-periscope-classic',
    'software-reports',
    'software-reports-boardless',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-cycle-time',
    'software-reports-cycle-time-classic',
    'software-reports-deployment-frequency',
    'software-reports-deployment-frequency-classic',
    'software-reports-velocity',
    'software-reports-velocity-cmp',
    'software-security',
    'software-security-classic',
    'software-summary',
    'software-summary-embed',
    'software-summary-classic',
    'software-summary-classic-embed',
    'software-timeline',
    'software-timeline-classic',
    'software-view-not-found',
    'software-view-not-found-classic',
    'software-board-view-not-found',
    'software-board-view-not-found-classic',
    'knowledge-hub-all-articles',
    'kb-article-embed-editor',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-all-categories',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-suggested-topics',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'notification-logs',
    'servicedesk-atlassian-analytics',
    'servicedesk-boards',
    'servicedesk-calendar',
    'servicedesk-project-summary',
    'servicedesk-change-calendar',
    'servicedesk-connect-project',
    'servicedesk-customers-v2',
    'servicedesk-customer-details',
    'servicedesk-customer-service-escalations',
    'servicedesk-customer-service-products',
    'servicedesk-getting-started-page',
    'servicedesk-issue',
    'servicedesk-issues',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-organizations',
    'servicedesk-organization-details',
    'servicedesk-organization_v2',
    'servicedesk-queues-practice-custom-board',
    'servicedesk-queues-practice-custom-calendar',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-manage-view',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-board',
    'servicedesk-queues-custom-calendar',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-custom-issue-detail',
    'servicedesk-queues-edit',
    'servicedesk-practice-views-config',
    'servicedesk-queues-views-config',
    'servicedesk-queues-issue',
    'servicedesk-queues-manage-view',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-services',
    'servicedesk-service-details',
    'classic-business-approvals',
    'classic-business-attachments',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-form',
    'classic-business-form-builder',
    'classic-business-form-submit',
    'classic-business-form-submit-public',
    'classic-business-list',
    'classic-business-shortcut',
    'classic-business-summary',
    'classic-business-timeline',
    'classic-business-view-not-found',
    'classic-business-redirect',
    'inbox',
    'inbox-classic'
]);
const $6eaade1a69d23d1d$var$routesWithArchivedWorkItemsRoute = new Set($6eaade1a69d23d1d$var$routes);
// Remove 'archived-issues-directory' when cleaning up slv-3_migrate_archived_issues_routes
$6eaade1a69d23d1d$var$routesWithArchivedWorkItemsRoute.add('archived-issues-directory').add('classic-business-archived-work-items').add('servicedesk-archived-work-items').add('software-archived-work-items-classic').add('software-archived-work-items');
function $6eaade1a69d23d1d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_PROJECTS)
    ];
    return $6eaade1a69d23d1d$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6eaade1a69d23d1d$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_PROJECTS)
    ];
    return $6eaade1a69d23d1d$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6eaade1a69d23d1d$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'polaris-onboarding':
            break;
        case 'projects-directory':
            path.push((0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 'forge-spa-project':
        case 'forge-spa-project-servicedesk':
        case 'forge-spa-servicedesk-queue':
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $jhS4y.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $jhS4y.ENTITY_ID).APP(appId));
                break;
            }
        case 'knowledge-hub-all-articles':
        case 'kb-article-embed-editor':
        case 'knowledge-hub-article-in-category':
        case 'knowledge-hub-browse-all-articles':
        case 'knowledge-hub-browse-all-categories':
        case 'knowledge-hub-browse-view-article':
        case 'knowledge-hub-category':
        case 'knowledge-hub-category-page':
        case 'knowledge-hub-drafts':
        case 'knowledge-hub-suggested-topics':
        case 'knowledge-hub-landing':
        case 'knowledge-hub-search':
        case 'knowledge-hub-setup':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 'servicedesk-getting-started-page':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 'notification-logs':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 'servicedesk-project-summary':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 'servicedesk-boards':
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $jhS4y.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 'servicedesk-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-change-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-organizations':
        case 'servicedesk-organization-details':
        case 'servicedesk-organization_v2':
        case 'servicedesk-customers-v2':
        case 'servicedesk-customer-details':
        case 'servicedesk-customer-service-products':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 'servicedesk-customer-service-escalations':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 'servicedesk-kb-requests-reports':
        case 'servicedesk-kb-requests-reports-time-scale-issue':
        case 'servicedesk-kb-requests-reports-time-scale':
        case 'servicedesk-reports':
        case 'servicedesk-reports-custom':
        case 'servicedesk-reports-custom-create':
        case 'servicedesk-reports-custom-edit':
        case 'servicedesk-reports-custom-time-scale-issue':
        case 'servicedesk-reports-custom-time-scale':
        case 'servicedesk-reports-satisfaction':
        case 'servicedesk-reports-satisfaction-time-scale-issue':
        case 'servicedesk-reports-satisfaction-time-scale':
        case 'servicedesk-reports-type':
        case 'servicedesk-reports-workload':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 'servicedesk-oncall-schedule':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 'servicedesk-issues':
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $jhS4y.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $jhS4y.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 'servicedesk-queues-practice-custom-board':
        case 'servicedesk-queues-practice-custom-calendar':
        case 'servicedesk-practice-custom-and-issue':
        case 'servicedesk-practice-edit':
        case 'servicedesk-practice-issue':
        case 'servicedesk-practice-landing':
        case 'servicedesk-practice-manage-view':
        case 'servicedesk-practice-views-config':
        case 'servicedesk-practice-new':
            {
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $jhS4y.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-addon':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-custom-calendar':
        case 'servicedesk-queues-custom-view':
        case 'servicedesk-queues-edit':
        case 'servicedesk-queues-issue':
        case 'servicedesk-queues-manage-view':
        case 'servicedesk-queues-views-config':
        case 'servicedesk-queues-new':
            {
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-custom-issue-detail':
            {
                const { projectKey: projectKey, queueId: queueId, issueKey: issueKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                issueKey && path.push((0, $jhS4y.ENTITY_ID).ISSUE(issueKey));
                break;
            }
        case 'servicedesk-services':
        case 'servicedesk-service-details':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                boardId && path.push((0, $jhS4y.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $jhS4y.ENTITY_ID).FORM(formId));
            }
    }
    if ((0, $4R6GH.fg)('fix-operations-menu-item-deselected-bug')) {
        const { projectKey: projectKey } = match.params;
        if ((routeName === 'servicedesk-change-calendar' || routeName === 'servicedesk-services' || routeName === 'servicedesk-service-details') && projectKey) path.push((0, $jhS4y.ENTITY_ID).PROJECT_OPERATIONS(projectKey));
    }
    return path;
}
const $6eaade1a69d23d1d$export$c41b724886e5872b = {
    get routes () {
        return (0, $4R6GH.fg)('ken_1984_archive_route_support_sidebar') ? $6eaade1a69d23d1d$var$routesWithArchivedWorkItemsRoute : $6eaade1a69d23d1d$var$routes;
    },
    convert: $6eaade1a69d23d1d$var$convert,
    convertNew: $6eaade1a69d23d1d$var$convertNew
};

});

parcelRegister("8bXrC", function(module, exports) {

$parcel$export(module.exports, "roadmapsConverter", () => $8c39d6aa787bb969$export$5761942b1e0c2dd0);

var $jhS4y = parcelRequire("jhS4y");
const $8c39d6aa787bb969$var$routes = new Set([
    'polaris-collections'
]);
function $8c39d6aa787bb969$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_ROADMAPS)
    ];
    return $8c39d6aa787bb969$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $8c39d6aa787bb969$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $jhS4y.MENU_ID_ROADMAPS)
    ];
    return $8c39d6aa787bb969$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $8c39d6aa787bb969$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'polaris-collections':
            {
                const collectionId = match.params.collectionUUID;
                if (collectionId) path.push((0, $jhS4y.ENTITY_ID).ROADMAP(collectionId));
                else path.push((0, $jhS4y.MENU_ID_ROADMAPS_VIEW_ALL));
                break;
            }
        default:
    }
    return path;
}
const $8c39d6aa787bb969$export$5761942b1e0c2dd0 = {
    routes: $8c39d6aa787bb969$var$routes,
    convert: $8c39d6aa787bb969$var$convert,
    convertNew: $8c39d6aa787bb969$var$convertNew
};

});

parcelRegister("eReVn", function(module, exports) {

$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $59806d8088c642c3$export$dd307ede503fe0e);

var $7HDop = parcelRequire("7HDop");

var $9ujoJ = parcelRequire("9ujoJ");

var $buwAo = parcelRequire("buwAo");

var $ji59e = parcelRequire("ji59e");

var $cAtSX = parcelRequire("cAtSX");

var $g49yz = parcelRequire("g49yz");

var $aBfqj = parcelRequire("aBfqj");

var $9wUes = parcelRequire("9wUes");

var $8pE1n = parcelRequire("8pE1n");

var $cfj3a = parcelRequire("cfj3a");

var $d9ukL = parcelRequire("d9ukL");

var $2I1zE = parcelRequire("2I1zE");

var $4P4Lq = parcelRequire("4P4Lq");

var $fdCkK = parcelRequire("fdCkK");

var $i62iX = parcelRequire("i62iX");

var $eObGp = parcelRequire("eObGp");

var $6z8e6 = parcelRequire("6z8e6");

var $coidL = parcelRequire("coidL");

var $jHXos = parcelRequire("jHXos");

var $h6YNW = parcelRequire("h6YNW");

var $6EgCy = parcelRequire("6EgCy");

var $2CYtL = parcelRequire("2CYtL");

var $bveQD = parcelRequire("bveQD");

var $59iBR = parcelRequire("59iBR");

var $b7dWt = parcelRequire("b7dWt");

var $8qmAq = parcelRequire("8qmAq");

var $fQ161 = parcelRequire("fQ161");

var $9sAYT = parcelRequire("9sAYT");

var $jJkuR = parcelRequire("jJkuR");

var $kuaoc = parcelRequire("kuaoc");

var $ieCBx = parcelRequire("ieCBx");

var $1XuFh = parcelRequire("1XuFh");

var $3BQ4q = parcelRequire("3BQ4q");

var $2m3cT = parcelRequire("2m3cT");

var $hewRX = parcelRequire("hewRX");

var $cmEH1 = parcelRequire("cmEH1");

var $9xhY2 = parcelRequire("9xhY2");

var $043ka = parcelRequire("043ka");

var $jhS4y = parcelRequire("jhS4y");
const $59806d8088c642c3$var$routes = new Set([
    'legacy-project-settings-fields',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-notifications',
    'legacy-project-settings-people',
    'legacy-project-settings-permissions',
    'legacy-project-settings-screens',
    'legacy-project-settings-workflows',
    'legacy-project-settings-workflows-associate',
    'project-settings-automation',
    'servicedesk-sla-settings',
    (0, $ji59e.projectSettingsLegacyAutomationRoute).name,
    (0, $cAtSX.projectSettingsServicedeskAccessRoute).name,
    (0, $8pE1n.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $fdCkK.projectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $6z8e6.projectSettingsServicedeskFeedbackRoute).name,
    (0, $coidL.projectSettingsServicedeskFieldsRoute).name,
    (0, $59iBR.projectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $b7dWt.projectSettingsServicedeskRequestTypesWorkCategoryRoute).name,
    (0, $2I1zE.projectSettingsServicedeskChatRoute).name,
    (0, $i62iX.projectSettingsServicedeskEmailRoute).name,
    (0, $eObGp.projectSettingsServicedeskExternalLinksRoute).name,
    (0, $bveQD.projectSettingsServicedeskPortalSettingsRoute).name,
    (0, $8qmAq.projectSettingsServicedeskWidgetRoute).name,
    (0, $aBfqj.projectSettingsServicedeskChangeManagementRoute).name,
    (0, $jHXos.projectSettingsServicedeskIncidentManagementRoute).name,
    (0, $4P4Lq.projectSettingsServicedeskClassicAppsRoute).name,
    (0, $fQ161.projectSettingsVirtualAgentSettingsRoute).name,
    (0, $9wUes.projectSettingsServicedeskChannelsChatRoute).name,
    (0, $d9ukL.projectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $9sAYT.virtualAgentConversationsRoute).name,
    (0, $jJkuR.virtualAgentIntentsRoute).name,
    (0, $kuaoc.virtualAgentSettingsRoute).name,
    (0, $ieCBx.virtualAgentStandardFlowsRoute).name,
    (0, $9ujoJ.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $buwAo.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $2CYtL.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $g49yz.projectSettingsServicedeskAppsFieldsRoute).name,
    (0, $1XuFh.projectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $3BQ4q.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $2m3cT.projectSettingsServicedeskKbRoute).name,
    (0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $9xhY2.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $043ka.servicedeskWorkflowConfigRoute).name,
    (0, $6EgCy.projectSettingsServicedeskIssuetypesRoute).name,
    (0, $cfj3a.projectSettingsServicedeskChannelsPortalRoute).name,
    (0, $7HDop.projectSettingsServicedeskAutomationRoute).name,
    (0, $hewRX.servicedeskSlaSettingsRoute).name,
    (0, $h6YNW.projectSettingsServicedeskInternalNotificationsNextGenRoute).name
]);
function $59806d8088c642c3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $59806d8088c642c3$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $59806d8088c642c3$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $59806d8088c642c3$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $59806d8088c642c3$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        // Access Menu
        case 'legacy-project-settings-people':
        case (0, $cAtSX.projectSettingsServicedeskAccessRoute).name:
        case (0, $fdCkK.projectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $8pE1n.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 'legacy-project-settings-permissions':
        case 'legacy-project-settings-issue-security':
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $b7dWt.projectSettingsServicedeskRequestTypesWorkCategoryRoute).name:
        case (0, $9xhY2.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management
        case (0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $59iBR.projectSettingsServicedeskProformaProjectFormsRoute).name:
        case 'legacy-project-settings-workflows':
        case (0, $043ka.servicedeskWorkflowConfigRoute).name:
        case 'legacy-project-settings-workflows-associate':
        case 'servicedesk-sla-settings':
        case (0, $hewRX.servicedeskSlaSettingsRoute).name:
        case (0, $6z8e6.projectSettingsServicedeskFeedbackRoute).name:
        case 'legacy-project-settings-issue-types':
        case (0, $6EgCy.projectSettingsServicedeskIssuetypesRoute).name:
        case 'legacy-project-settings-fields':
        case (0, $coidL.projectSettingsServicedeskFieldsRoute).name:
        case 'legacy-project-settings-screens':
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Automation
        case 'project-settings-automation':
        case (0, $ji59e.projectSettingsLegacyAutomationRoute).name:
        case (0, $7HDop.projectSettingsServicedeskAutomationRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $bveQD.projectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $cfj3a.projectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $i62iX.projectSettingsServicedeskEmailRoute).name:
        case (0, $2I1zE.projectSettingsServicedeskChatRoute).name:
        case (0, $8qmAq.projectSettingsServicedeskWidgetRoute).name:
        case (0, $2m3cT.projectSettingsServicedeskKbRoute).name:
        case (0, $eObGp.projectSettingsServicedeskExternalLinksRoute).name:
        case (0, $9wUes.projectSettingsServicedeskChannelsChatRoute).name:
        case (0, $d9ukL.projectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $fQ161.projectSettingsVirtualAgentSettingsRoute).name:
        case (0, $jJkuR.virtualAgentIntentsRoute).name:
        case (0, $ieCBx.virtualAgentStandardFlowsRoute).name:
        case (0, $9sAYT.virtualAgentConversationsRoute).name:
        case (0, $kuaoc.virtualAgentSettingsRoute).name:
            // case issueCollectors.name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $aBfqj.projectSettingsServicedeskChangeManagementRoute).name:
        case (0, $jHXos.projectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 'legacy-project-settings-notifications':
        case (0, $1XuFh.projectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $2CYtL.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $3BQ4q.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $9ujoJ.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $buwAo.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $h6YNW.projectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $4P4Lq.projectSettingsServicedeskClassicAppsRoute).name:
        case (0, $g49yz.projectSettingsServicedeskAppsFieldsRoute).name:
            // ADD rest of the apps here
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $59806d8088c642c3$export$dd307ede503fe0e = {
    routes: $59806d8088c642c3$var$routes,
    convert: $59806d8088c642c3$var$convert,
    convertNew: $59806d8088c642c3$var$convertNew
};

});
parcelRegister("7HDop", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $a850596cfe5a4de7$export$1a2228d5e07202a0);
const $a850596cfe5a4de7$export$1a2228d5e07202a0 = {
    name: 'project-settings-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automate'
};

});

parcelRegister("9ujoJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $0bae5d3040b6efcd$export$1f37a1aff4f594af);
const $0bae5d3040b6efcd$export$1f37a1aff4f594af = {
    name: 'project-settings-servicedesk-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
    exact: true
};

});

parcelRegister("buwAo", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $a41537dc6d61dc3d$export$40539cb16771014e);
const $a41537dc6d61dc3d$export$40539cb16771014e = {
    name: 'project-settings-servicedesk-notifications-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("ji59e", function(module, exports) {

$parcel$export(module.exports, "projectSettingsLegacyAutomationRoute", () => $8a393a176348cc6a$export$5f0797185fc4e6fe);
const $8a393a176348cc6a$export$5f0797185fc4e6fe = {
    name: 'project-settings-servicedesk-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation',
    exact: true
};

});

parcelRegister("cAtSX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRoute", () => $6b0529072d4abe8e$export$6473a81f1ee460ef);
const $6b0529072d4abe8e$export$6473a81f1ee460ef = {
    name: 'project-settings-servicedesk-access',
    path: '/jira/servicedesk/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("g49yz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRoute", () => $3fe31df45b0dec62$export$bb46672b3fb14eec);
const $3fe31df45b0dec62$export$bb46672b3fb14eec = {
    name: 'project-settings-servicedesk-apps-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("aBfqj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRoute", () => $f0657cd63f2eea62$export$1444ee3eb63a2ffc);
const $f0657cd63f2eea62$export$1444ee3eb63a2ffc = {
    name: 'project-settings-servicedesk-change-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/change-management',
    exact: true
};

});

parcelRegister("9wUes", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRoute", () => $6368b0346b5f497d$export$be5ad475040cd044);
const $6368b0346b5f497d$export$be5ad475040cd044 = {
    name: 'project-settings-servicedesk-channels-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/chat',
    exact: true
};

});

parcelRegister("8pE1n", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $7daacba204902bb9$export$5fb39a9d3820886c);
const $7daacba204902bb9$export$5fb39a9d3820886c = {
    name: 'project-settings-servicedesk-channels-permissions-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/customer-permissions',
    exact: true
};

});

parcelRegister("cfj3a", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRoute", () => $6736aa15bea6eefc$export$8f4234e4e79e03);
const $6736aa15bea6eefc$export$8f4234e4e79e03 = {
    name: 'project-settings-servicedesk-channels-portal',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
    exact: true
};

});

parcelRegister("d9ukL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRoute", () => $1c3cc396f5e3294d$export$c66db54872d3b51c);
const $1c3cc396f5e3294d$export$c66db54872d3b51c = {
    name: 'project-settings-servicedesk-channels-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/widget',
    exact: true
};

});

parcelRegister("2I1zE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChatRoute", () => $2f07a87a169fe062$export$b22ac188582d1dbd);
const $2f07a87a169fe062$export$b22ac188582d1dbd = {
    name: 'project-settings-servicedesk-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/chat',
    exact: true
};

});

parcelRegister("4P4Lq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRoute", () => $e517d51ddd605d2d$export$2b65324bb87228c5);
const $e517d51ddd605d2d$export$2b65324bb87228c5 = {
    name: 'project-settings-servicedesk-classic-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps',
    exact: true
};

});

parcelRegister("fdCkK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRoute", () => $b0729515e1c8c770$export$d8ed4a1eb0c01b5a);
const $b0729515e1c8c770$export$d8ed4a1eb0c01b5a = {
    name: 'project-settings-servicedesk-customer-permissions',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-permissions',
    exact: true
};

});

parcelRegister("i62iX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskEmailRoute", () => $6c48c7782385d153$export$d7d111417bfcd900);
const $6c48c7782385d153$export$d7d111417bfcd900 = {
    name: 'project-settings-servicedesk-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/email',
    exact: true
};

});

parcelRegister("eObGp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRoute", () => $9ab5fd15e07cb29b$export$2ec1a0d49a1f6ac2);
const $9ab5fd15e07cb29b$export$2ec1a0d49a1f6ac2 = {
    name: 'project-settings-servicedesk-external-links',
    path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
    exact: true
};

});

parcelRegister("6z8e6", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRoute", () => $a459da1dd0fd4437$export$f21485e31d7839aa);
const $a459da1dd0fd4437$export$f21485e31d7839aa = {
    name: 'project-settings-servicedesk-feedback',
    path: '/jira/servicedesk/projects/:projectKey/settings/feedback-settings'
};

});

parcelRegister("coidL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFieldsRoute", () => $60fa813ddf92723e$export$44f665a50373c681);
const $60fa813ddf92723e$export$44f665a50373c681 = {
    name: 'project-settings-servicedesk-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("jHXos", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRoute", () => $5158d983285fb183$export$f91bd0bb0d4783ff);
const $5158d983285fb183$export$f91bd0bb0d4783ff = {
    name: 'project-settings-servicedesk-incident-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/incident-management',
    exact: true
};

});

parcelRegister("h6YNW", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRoute", () => $35c040ff370a690c$export$5db62792327950b4);
const $35c040ff370a690c$export$5db62792327950b4 = {
    name: 'project-settings-servicedesk-internal-notifications-nextGen',
    path: '/jira/servicedesk/projects/:projectKey/settings/internal-notifications'
};

});

parcelRegister("6EgCy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRoute", () => $62f1cfaa37e848ed$export$2ffcb2e92bb4950b);
const $62f1cfaa37e848ed$export$2ffcb2e92bb4950b = {
    name: 'project-settings-servicedesk-issuetypes',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("2CYtL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $944b1aaf3a971594$export$5108e41f558ecf03);
const $944b1aaf3a971594$export$5108e41f558ecf03 = {
    name: 'project-settings-servicedesk-notifications-internal-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications'
};

});

parcelRegister("bveQD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRoute", () => $110f0f2897157711$export$7593a7e4a6fc0aaf);
const $110f0f2897157711$export$7593a7e4a6fc0aaf = {
    name: 'project-settings-servicedesk-portal-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/portal-settings/:subPath(portal-groups)?',
    exact: true
};

});

parcelRegister("59iBR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRoute", () => $7ab6606893b01740$export$ee87e5f9754e3600);
const $7ab6606893b01740$export$ee87e5f9754e3600 = {
    name: 'project-settings-servicedesk-proforma-project-forms',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("b7dWt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRequestTypesWorkCategoryRoute", () => $5256905c61d3ff71$export$a0d1982e8b6c6462);
const $5256905c61d3ff71$export$a0d1982e8b6c6462 = {
    name: 'project-settings-servicedesk-request-types-work-category',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice',
    exact: true
};

});

parcelRegister("8qmAq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskWidgetRoute", () => $bf2d8be8b98d574c$export$ac674ffd39608325);
const $bf2d8be8b98d574c$export$ac674ffd39608325 = {
    name: 'project-settings-servicedesk-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/widget',
    exact: true
};

});

parcelRegister("fQ161", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVirtualAgentSettingsRoute", () => $6114f059a1e6649c$export$22dd8d5d0c04aa51);
const $6114f059a1e6649c$export$22dd8d5d0c04aa51 = {
    name: 'project-settings-servicedesk-virtual-agent',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent',
    exact: true
};

});

parcelRegister("9sAYT", function(module, exports) {

$parcel$export(module.exports, "virtualAgentConversationsRoute", () => $411142b46ae04f14$export$837f003bb6f40f9);
const $411142b46ae04f14$export$837f003bb6f40f9 = {
    name: 'project-settings-servicedesk-virtual-agent-conversations',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations',
    exact: true
};

});

parcelRegister("jJkuR", function(module, exports) {

$parcel$export(module.exports, "virtualAgentIntentsRoute", () => $0338de7d8107d11d$export$1e70273fc2a407f5);
const $0338de7d8107d11d$export$1e70273fc2a407f5 = {
    name: 'project-settings-servicedesk-virtual-agent-intents',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents',
    exact: true
};

});

parcelRegister("kuaoc", function(module, exports) {

$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $bc551cda135ca5dc$export$80422a49e17dfd6b);
const $bc551cda135ca5dc$export$80422a49e17dfd6b = {
    name: 'project-settings-servicedesk-virtual-agent-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
    exact: true
};

});

parcelRegister("ieCBx", function(module, exports) {

$parcel$export(module.exports, "virtualAgentStandardFlowsRoute", () => $b2e651b968a46995$export$f45c942ecfcc5682);
const $b2e651b968a46995$export$f45c942ecfcc5682 = {
    name: 'project-settings-servicedesk-virtual-agent-standard-flows',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows',
    exact: true
};

});

parcelRegister("1XuFh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRoute", () => $312a1d56c159c7b3$export$176d388c5b23978e);
const $312a1d56c159c7b3$export$176d388c5b23978e = {
    name: 'project-settings-servicedesk-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-notifications'
};

});

parcelRegister("3BQ4q", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $767b3fa8d0e3f22f$export$6ce57d409e1934f2);
const $767b3fa8d0e3f22f$export$6ce57d409e1934f2 = {
    name: 'project-settings-servicedesk-notifications-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/customer-notifications'
};

});

parcelRegister("2m3cT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskKbRoute", () => $4098af05e7cf1529$export$725fadff9ae82302);
const $4098af05e7cf1529$export$725fadff9ae82302 = {
    name: 'project-settings-servicedesk-kb',
    path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
    exact: true
};

});

parcelRegister("hewRX", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $e50829694a27cbc2$export$bfbf66468910573e);
const $e50829694a27cbc2$export$bfbf66468910573e = {
    name: 'servicedesk-sla-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("cmEH1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRoute", () => $f379cc48bbcca18e$export$31f95ad4356ce017);
const $f379cc48bbcca18e$export$31f95ad4356ce017 = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types'
};

});

parcelRegister("9xhY2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $5bf710cc844476bb$export$8c897f53ff36fa6b);
const $5bf710cc844476bb$export$8c897f53ff36fa6b = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned'
};

});

parcelRegister("043ka", function(module, exports) {

$parcel$export(module.exports, "servicedeskWorkflowConfigRoute", () => $e90f1285b1062fcf$export$ecc771c0ee86ccb8);
const $e90f1285b1062fcf$export$ecc771c0ee86ccb8 = {
    name: 'project-settings-servicedesk-workflow-scheme-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});


parcelRegister("djX45", function(module, exports) {

$parcel$export(module.exports, "customerServiceConverter", () => $5d3cd05ec71a5c6d$export$8e632ccd3e33c9f1);

var $jhS4y = parcelRequire("jhS4y");
const $5d3cd05ec71a5c6d$var$routes = new Set([
    'customer-service-helpcenter'
]);
function $5d3cd05ec71a5c6d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $5d3cd05ec71a5c6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $5d3cd05ec71a5c6d$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $5d3cd05ec71a5c6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $5d3cd05ec71a5c6d$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'customer-service-helpcenter':
            path.push((0, $jhS4y.MENU_ID_CUSTOMER_SERVICE));
            break;
        default:
    }
    return path;
}
const $5d3cd05ec71a5c6d$export$8e632ccd3e33c9f1 = {
    routes: $5d3cd05ec71a5c6d$var$routes,
    convert: $5d3cd05ec71a5c6d$var$convert,
    convertNew: $5d3cd05ec71a5c6d$var$convertNew
};

});



parcelRegister("fMcVX", function(module, exports) {

$parcel$export(module.exports, "isSelectedPath", () => $ad785f9726254880$export$cdcd6885320eec31);

var $lhMtU = parcelRequire("lhMtU");
function $ad785f9726254880$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $lhMtU.isMenuIdList)(menuId) ? (0, $lhMtU.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("lhMtU", function(module, exports) {

$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $dc9d941dfadd4b5a$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $dc9d941dfadd4b5a$export$d8e017f58178e379);
const $dc9d941dfadd4b5a$var$MENU_ID_DELIM = '   '; // Three spaces
function $dc9d941dfadd4b5a$export$253323efd0c41e72(menuIds) {
    return menuIds.join($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
}
function $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($dc9d941dfadd4b5a$var$MENU_ID_DELIM) !== -1;
}
function $dc9d941dfadd4b5a$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
}

});


parcelRegister("ao2h1", function(module, exports) {

$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $5f6ac21695ec30bb$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $5f6ac21695ec30bb$export$42ca7b248c7aaee);

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $x9xyg = parcelRequire("x9xyg");

var $5yJb9 = parcelRequire("5yJb9");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $5Wobd = parcelRequire("5Wobd");
const $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $5f6ac21695ec30bb$var$getData = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $x9xyg.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $x9xyg.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, $5yJb9.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $x9xyg.setMark)(endMark);
            (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $5Wobd.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $kipqU.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $x9xyg.setMark)(endMark);
        (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $5Wobd.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $5f6ac21695ec30bb$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $2M1hQ.createResource)({
        type: `${$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            return $5f6ac21695ec30bb$var$getData({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $5f6ac21695ec30bb$export$1cc887c62079ea32 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
const $5f6ac21695ec30bb$export$bbe949b85c06f763 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
const $5f6ac21695ec30bb$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $2YP9W.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("2OeZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $70949048397986dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4a706eb3e25051d1a38768ce66865631>>
 * @relayHash 14a273bd1693a859ee5b1e3f8d05c214
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a51c35e86cc3c000895b8dca6af5a742aaac2b0cc379a27aa0590e4cb411173b

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");

var $cN96Q = parcelRequire("cN96Q");

var $95Z36 = parcelRequire("95Z36");
const $70949048397986dd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "label"
    }, v14 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v15 = {
        "kind": "ScalarField",
        "name": "url"
    }, v16 = {
        "order": "DESC"
    }, v17 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v18 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v21 = [
        v15 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v24 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v25 = [
        v9 /*: any*/ ,
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        v20 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": v21 /*: any*/ ,
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                },
                v22 /*: any*/ 
            ]
        },
        {
            "alias": "editProjectConfig",
            "args": v23 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v24 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "args": v23 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v24 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "alias": "editPermission",
            "args": v23 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v24 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        }
    ], v26 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v27 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v28 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v25 /*: any*/ 
            }
        ]
    }, v29 = [
        v28 /*: any*/ ,
        v26 /*: any*/ 
    ], v30 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v31 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v9 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v33 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v21 /*: any*/ ,
                                            "type": "JiraSoftwareBuiltInNavigationItem"
                                        },
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v22 /*: any*/ 
            ]
        }
    ], v34 = [
        v9 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConfigurableMenuItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudID",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "navKey",
                                    "value": "NAV_SIDEBAR"
                                }
                            ],
                            "concreteType": "JiraUserNavigationConfiguration",
                            "kind": "LinkedField",
                            "name": "userNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraConfigurableNavigationItem",
                                    "kind": "LinkedField",
                                    "name": "navItems",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isVisible"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v14 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v15 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteProjects",
                                            "args": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v16 /*: any*/ ,
                                                        "type": "PROJECT"
                                                    }
                                                },
                                                v17 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v25 /*: any*/ ,
                                                                    "type": "JiraProject"
                                                                },
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v26 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v10 /*: any*/ ,
                                                v27 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recentProjects",
                                            "plural": false,
                                            "selections": v29 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "GrowthRecQuery",
                                    "kind": "LinkedField",
                                    "name": "growthRecommendations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "product",
                                                            "value": "jira"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "tenantId",
                                                            "variableName": "cloudId"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "useCase",
                                                            "value": "jiraProjectMenuRecommendations"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "context"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 2
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "recommendations",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": true,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "entityId"
                                                                        }
                                                                    ],
                                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GrowthRecRecommendations"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "entityAri",
                                                    "variableName": "entityAriProjects"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "ownerAri",
                                                    "variableName": "ownerAri"
                                                }
                                            ],
                                            "concreteType": "SettingsNavigationCustomisation",
                                            "kind": "LinkedField",
                                            "name": "settings_navigationCustomisation",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayPropertyConnection",
                                                    "kind": "LinkedField",
                                                    "name": "properties",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "SettingsDisplayProperty",
                                                            "kind": "LinkedField",
                                                            "name": "nodes",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraProjectsSidebarMenu",
                                    "kind": "LinkedField",
                                    "name": "jira_projectsSidebarMenu",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "current",
                                            "plural": false,
                                            "selections": v25 /*: any*/ 
                                        },
                                        {
                                            "args": [
                                                v17 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ],
                                            "storageKey": "favourites(first:15)"
                                        },
                                        {
                                            "args": [
                                                v27 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recents",
                                            "plural": false,
                                            "selections": v29 /*: any*/ ,
                                            "storageKey": "recents(first:20)"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v16 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v17 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v26 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v10 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v19 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v32 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v26 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v30 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v16 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v17 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v33 /*: any*/ 
                                        },
                                        v26 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v10 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v33 /*: any*/ 
                                        },
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOverviewsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverview",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a51c35e86cc3c000895b8dca6af5a742aaac2b0cc379a27aa0590e4cb411173b",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $cN96Q.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": (0, $95Z36.default)
            }
        }
    };
}();
$70949048397986dd$var$node.hash = "2c0d42ef2bd0d870f4c048210d79296f";
var $70949048397986dd$export$2e2bcd8739ae039 = $70949048397986dd$var$node;

});
parcelRegister("apPdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3cb5e5a280f36f0$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $e3cb5e5a280f36f0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false);
    }
};

});

parcelRegister("bozkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ae0acd0b32b8d9$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $45ae0acd0b32b8d9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false);
    }
};

});

parcelRegister("57dih", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89b8ac04e69345$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $fd89b8ac04e69345$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended');
    }
};

});

parcelRegister("kXP4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c7049d0eb61e95$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $78c7049d0eb61e95$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jcs_project_type_m3');
    }
};

});

parcelRegister("cN96Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $832303d9c03ac1c0$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $832303d9c03ac1c0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar');
    }
};

});

parcelRegister("95Z36", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0e06dd4ba5c9950$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f0e06dd4ba5c9950$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('migrate_plans_navigation_to_relay');
    }
};

});


parcelRegister("fZBia", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c8513a288fea00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee236c9dde5df6d7726d1decdbb50446>>
 * @relayHash 2166d8d37d2e3ef4bf77f06d60ad7574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3
const $79c8513a288fea00$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v2 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v3 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.leftSidebarWidth"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3",
            "metadata": {},
            "name": "sidebarSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$79c8513a288fea00$var$node.hash = "59f81414b49d936016b55cafd8c7ed95";
var $79c8513a288fea00$export$2e2bcd8739ae039 = $79c8513a288fea00$var$node;

});

parcelRegister("kYHsT", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAri", () => $f45b2077be41ed7f$export$d53f27b41a9a02bb);

var $jkf7e = parcelRequire("jkf7e");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/navigation-settings/manifest.ts
var $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $jkf7e.JiraNavigationSettingsAriResourceOwner),
    resourceType: (0, $jkf7e.JiraNavigationSettingsAriResourceType),
    resourceIdSlug: "activation/{activationId}/{navigationSettingScope}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        navigationSettingScope: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/navigation-settings/index.ts
var $f45b2077be41ed7f$export$d53f27b41a9a02bb = class _JiraNavigationSettingsAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._navigationSettingScope = opts.resourceIdSegmentValues.navigationSettingScope;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get navigationSettingScope() {
        return this._navigationSettingScope;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts.qualifier,
            platformQualifier: $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts.resourceOwner,
            resourceType: $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.navigationSettingScope}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                navigationSettingScope: opts.navigationSettingScope
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            navigationSettingScope: this.navigationSettingScope
        };
    }
};

});
parcelRegister("jkf7e", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAriResourceOwner", () => $e11b9c3acd7c102a$export$a71eb7f052c3a8f1);
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceType", () => $e11b9c3acd7c102a$export$8c9eb6c30d1db6dc);
// src/jira/navigation-settings/types.ts
var $e11b9c3acd7c102a$export$a71eb7f052c3a8f1 = "jira", $e11b9c3acd7c102a$export$8c9eb6c30d1db6dc = "navigation-settings";

});


parcelRegister("k9L5z", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAri", () => $eac92cc2828d3532$export$1e9d09c2be53e55e);

var $agYNt = parcelRequire("agYNt");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/identity/user/manifest.ts
var $eac92cc2828d3532$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $agYNt.IdentityUserAriResourceOwner),
    resourceType: (0, $agYNt.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $eac92cc2828d3532$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._userId = opts.resourceIdSegmentValues.userId;
    }
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $eac92cc2828d3532$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $eac92cc2828d3532$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $eac92cc2828d3532$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $eac92cc2828d3532$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $eac92cc2828d3532$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $eac92cc2828d3532$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
};

});
parcelRegister("agYNt", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAriResourceOwner", () => $77aa8f07d2cc15ee$export$b4c14c54282a779d);
$parcel$export(module.exports, "IdentityUserAriResourceType", () => $77aa8f07d2cc15ee$export$e9b50e20f4fbfb71);
// src/identity/user/types.ts
var $77aa8f07d2cc15ee$export$b4c14c54282a779d = "identity", $77aa8f07d2cc15ee$export$e9b50e20f4fbfb71 = "user";

});



parcelRegister("fwzEJ", function(module, exports) {

$parcel$export(module.exports, "topNav4UIStateResource", () => $92bcd9e21d74460f$export$2d81c2e40eea9fba);

var $6s1PB = parcelRequire("6s1PB");

var $ao2h1 = parcelRequire("ao2h1");

var $9ZLcT = parcelRequire("9ZLcT");
const $92bcd9e21d74460f$export$2d81c2e40eea9fba = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>({
            parameters: (0, $9ZLcT.default),
            variables: {
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                includeExtraMenuItems: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("9ZLcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b5c5aa00eda199b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a461a3c25b918939e9d8a0a41a0a36a>>
 * @relayHash 5063dabd883604b31f448c60ea62e531
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b1908e692a7aa5fc47c8b8f0d71d31204d850b421d061ad77e7cbb8ed5eccc4
const $3b5c5aa00eda199b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeExtraMenuItems"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AtlaskitAtlassianNavigationNav4UIQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v2 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Profile"
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4NotificationsData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AtlaskitAtlassianNavigationNav4UIQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "condition": "includeExtraMenuItems",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "email"
                                                }
                                            ],
                                            "type": "AtlassianAccountUser"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "InfluentsNotificationQuery",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "unseenNotificationCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0b1908e692a7aa5fc47c8b8f0d71d31204d850b421d061ad77e7cbb8ed5eccc4",
            "metadata": {},
            "name": "AtlaskitAtlassianNavigationNav4UIQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3b5c5aa00eda199b$var$node.hash = "6fefcd1fdd1316e2af1f4f9d895a7580";
var $3b5c5aa00eda199b$export$2e2bcd8739ae039 = $3b5c5aa00eda199b$var$node;

});


parcelRegister("h9iZl", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $66eb980ebca35ddf$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $66eb980ebca35ddf$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $66eb980ebca35ddf$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $66eb980ebca35ddf$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $66eb980ebca35ddf$export$54805a2120a31ad0);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $66eb980ebca35ddf$export$fa475a9581133779 = (0, $2M1hQ.createResource)({
    type: (0, $94526093207618a3$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $7f4tk.default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $94526093207618a3$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity
});
const $66eb980ebca35ddf$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $66eb980ebca35ddf$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $66eb980ebca35ddf$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $66eb980ebca35ddf$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
parcelRegister("7f4tk", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a56387884fedf0$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $5HnTq = parcelRequire("5HnTq");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $iwPwz = parcelRequire("iwPwz");
var /**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param {string} url - to fetch the JSON from
 * @param {object} options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$00a56387884fedf0$export$2e2bcd8739ae039 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, (0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $iwPwz.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $jJZqs.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $jJZqs.default)(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });

});

const $94526093207618a3$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $94526093207618a3$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("2eyDn", function(module, exports) {

$parcel$export(module.exports, "consentBannerUserPreferencesResource", () => $7912ae5bd04d670f$export$785c22104b6f2285);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $7912ae5bd04d670f$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $21KEY = parcelRequire("21KEY");

var $3TzYp = parcelRequire("3TzYp");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $7912ae5bd04d670f$export$785c22104b6f2285 = (0, $2M1hQ.createResource)({
    type: (0, $f92ba51f7e46c4ce$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $f92ba51f7e46c4ce$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $3TzYp.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_COOKIE_KEY));
        const fallbackConsentToken = (0, $3TzYp.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if ((0, $4R6GH.fg)('jfp-magma-browser-storage-bump-3')) {
            if (consentToken) return {
                consentToken: consentToken,
                fallbackConsentToken: fallbackConsentToken
            };
        } else {
            const currentLocale = (0, $3TzYp.getCookie)((0, $21KEY.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
            if (consentToken && currentLocale) return {
                consentToken: consentToken,
                currentLocale: currentLocale,
                fallbackConsentToken: fallbackConsentToken
            };
        }
        const data = await (0, $eusud.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $7912ae5bd04d670f$export$5bc7e83e85567fb4 = ()=>(0, $2YP9W.useResource)($7912ae5bd04d670f$export$785c22104b6f2285);

});
parcelRegister("3TzYp", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $7ade243d7fa91fea$export$4be65e66cfa2648a);

var $4uHy1 = parcelRequire("4uHy1");
function $7ade243d7fa91fea$export$4be65e66cfa2648a(key) {
    return key ? (0, $4uHy1.getCookie)(key) : (0, $4uHy1.getCookie)();
}

});

const $f92ba51f7e46c4ce$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $f92ba51f7e46c4ce$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("drGWM", function(module, exports) {

$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $ea67ffb8a72e0299$export$b16eaa5246afc9b6);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $j74qU = parcelRequire("j74qU");

var $3H5ry = parcelRequire("3H5ry");


var $2M1hQ = parcelRequire("2M1hQ");

const $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
    if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $j74qU.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
const $ea67ffb8a72e0299$export$b16eaa5246afc9b6 = ()=>(0, $2M1hQ.createResource)({
        type: (0, $9b8f6422d397a375$export$5879151f0d972f18),
        getKey: ()=>'check-api-key-management-keys',
        getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
            const isTransitioning = (0, $3H5ry.checkIsTransitioning)(tenantInfo);
            return $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
        },
        maxAge: Infinity,
        isBrowserOnly: true,
        depends: [
            (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
        ]
    });

});
parcelRegister("3H5ry", function(module, exports) {

$parcel$export(module.exports, "checkShouldUseJSM", () => $bc03080c674ccba2$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $bc03080c674ccba2$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $bc03080c674ccba2$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $bc03080c674ccba2$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $bc03080c674ccba2$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $bc03080c674ccba2$export$cd227238525e8d57);
$parcel$export(module.exports, "checkIsOpsAdmin", () => $bc03080c674ccba2$export$66a96ac2f07f6730);

var $bgC2H = parcelRequire("bgC2H");

const $bc03080c674ccba2$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED;
};
const $bc03080c674ccba2$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).TRANSITIONING;
};
const $bc03080c674ccba2$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $bgC2H.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).CONSOLIDATED;
};
const $bc03080c674ccba2$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).TRANSITIONED;
};
const $bc03080c674ccba2$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1);
};
const $bc03080c674ccba2$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $bgC2H.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$a101f3562b5f0742));
};
const $bc03080c674ccba2$export$66a96ac2f07f6730 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
};

});
parcelRegister("bgC2H", function(module, exports) {

$parcel$export(module.exports, "ConsolidationState", () => $927cd31b0e0ee4e8$export$9ef498b0a11fd37d);
const $927cd31b0e0ee4e8$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $47a35bf911de1c9b$export$650f6934db1290c1 = 'cohort3';
const $47a35bf911de1c9b$export$a101f3562b5f0742 = 'cohort3.5';


const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';

const $9b8f6422d397a375$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';


parcelRegister("kMiZJ", function(module, exports) {

$parcel$export(module.exports, "consolidationUserStateResource", () => $1e0457dbe68ab17d$export$4b870505c49999ef);

var $jcw0u = parcelRequire("jcw0u");

var $2M1hQ = parcelRequire("2M1hQ");

var $9QTNT = parcelRequire("9QTNT");

const $1e0457dbe68ab17d$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $1e0457dbe68ab17d$export$4b870505c49999ef = (0, $2M1hQ.createResource)({
    type: $1e0457dbe68ab17d$var$RESOURCE_KEY,
    getKey: ()=>$1e0457dbe68ab17d$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $9QTNT.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity
});

});
parcelRegister("9QTNT", function(module, exports) {

$parcel$export(module.exports, "getOgConsolidationUserState", () => $1a9945d1ee35f024$export$df7594d56c9ebe57);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $iXaZ3 = parcelRequire("iXaZ3");
const $1a9945d1ee35f024$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $iXaZ3.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $89SaW.getUserProperty)(accountId, (0, $iXaZ3.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $jcw0u.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $jJZqs.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return 0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("iXaZ3", function(module, exports) {

$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $58f10b27bad0d860$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $58f10b27bad0d860$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $58f10b27bad0d860$export$23da4710c3a29eae);
const $58f10b27bad0d860$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $58f10b27bad0d860$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $58f10b27bad0d860$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("bHhiy", function(module, exports) {

$parcel$export(module.exports, "getConsolidationStateResource", () => $cd33a435a46904ef$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $j74qU = parcelRequire("j74qU");

var $4R6GH = parcelRequire("4R6GH");

var $2M1hQ = parcelRequire("2M1hQ");

var $bgC2H = parcelRequire("bgC2H");

const $cd33a435a46904ef$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, isAnonymous, appPermissions)=>{
    let url = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? '/internal/v1/users/ops-user-info' : '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false || isAnonymous) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED,
                ...(0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? {
                    isAdmin: false
                } : {}
            });
        });
        return promise;
    }
    if ((0, $4R6GH.fg)('operations-tenant-info-endpoint-update')) url = `${url}/${atlassianAccountId}`;
    if (false) promise = (0, $j74qU.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? 'og-apps-user-int-api' : 'og-customer-int-api'
        }
    });
    else {
        const clientUrl = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? '/v1/users/ops-user-info' : '/v1/customers/tenant-info';
        promise = (0, $j74qU.eocFetch)(clientUrl).then(({ data: data })=>data);
    }
    return promise;
};
const $cd33a435a46904ef$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, $2M1hQ.createResource)({
        type: (0, $5a94e356f9d5e220$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>$cd33a435a46904ef$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, isAnonymous, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser
    });

});

parcelRegister("aA974", function(module, exports) {

$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $d18db694553f5610$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $d18db694553f5610$export$3870b1ff1b155c73);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $aHuqL = parcelRequire("aHuqL");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $d18db694553f5610$export$ee94bb1f59b07e35 = (0, $2M1hQ.createResource)({
    type: (0, $814b0a0376a60368$export$6f0555de4f60e84e),
    getKey: ()=>(0, $814b0a0376a60368$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $aHuqL.userPreferenceAPI).get((0, $814b0a0376a60368$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? false : undefined
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? false : undefined
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $814b0a0376a60368$export$b8b9d90f9e5bd72b),
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false,
            hasUserDismissedGicOnboarding: (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? false : undefined
        };
    },
    maxAge: Number.MAX_VALUE
});
const $d18db694553f5610$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $2YP9W.useResource)($d18db694553f5610$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    // eslint-disable-next-line no-nested-ternary
    const currentDismissedGicOnboarding = (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false : undefined;
    const dismissReadMore = (0, $5uXOq.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true,
                // eslint-disable-next-line no-nested-ternary
                ...(0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? previousData?.hasUserDismissedGicOnboarding ? {
                    hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                } : {
                    hasUserDismissedGicOnboarding: false
                } : {}
            }));
    }, [
        update
    ]);
    const dismissGicOnboarding = (0, $5uXOq.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                ...previousData?.hasUserDismissedReadMore ? {
                    hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                } : {
                    hasUserDismissedReadMore: false
                },
                hasUserDismissedGicOnboarding: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
        dismissReadMore: dismissReadMore,
        dismissGicOnboarding: dismissGicOnboarding,
        loading: loading
    };
};

});
parcelRegister("aHuqL", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $0f87ed1c6d708024$export$4f7929ca6b50a436);


var $eusud = parcelRequire("eusud");
const $0f87ed1c6d708024$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $0f87ed1c6d708024$var$get = async (key)=>{
    try {
        const result = await (0, $eusud.performGetRequest)($0f87ed1c6d708024$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $0f87ed1c6d708024$var$set = (key, value)=>(0, $eusud.performPutRequest)($0f87ed1c6d708024$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $0f87ed1c6d708024$var$remove = (key)=>(0, $eusud.performDeleteRequest)($0f87ed1c6d708024$var$url(key));
const $0f87ed1c6d708024$export$4f7929ca6b50a436 = {
    get: $0f87ed1c6d708024$var$get,
    set: $0f87ed1c6d708024$var$set,
    remove: $0f87ed1c6d708024$var$remove
};

});

const $814b0a0376a60368$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $814b0a0376a60368$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $814b0a0376a60368$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $814b0a0376a60368$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("f5nIZ", function(module, exports) {

$parcel$export(module.exports, "gicOptInStatusResources", () => $1dd3138bca6cac05$export$14c89b6b6a261524);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");


const $1dd3138bca6cac05$export$14c89b6b6a261524 = (0, $2M1hQ.createResource)({
    type: (0, $8e5bc4e5db4905c7$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            gicOptInStatus = await (0, $eusud.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $8e5bc4e5db4905c7$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("hZhhj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $0f1ada479bbc578a$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $0f1ada479bbc578a$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $0f1ada479bbc578a$export$283aa034b7d4e2a0);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $eusud.performGetRequest)((0, $b9c933d7a799fa71$export$5bf8eb915287f5f4));
const $0f1ada479bbc578a$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $0f1ada479bbc578a$export$369caf52ed1ad2b1 = (0, $2M1hQ.createResource)({
    type: (0, $b9c933d7a799fa71$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $b9c933d7a799fa71$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'maverick'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0f1ada479bbc578a$export$32d9db53927095d3
        };
    },
    maxAge: 3600000
});
const $0f1ada479bbc578a$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $2YP9W.useResource)($0f1ada479bbc578a$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $5uXOq.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $0f1ada479bbc578a$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $b9c933d7a799fa71$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $b9c933d7a799fa71$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $b9c933d7a799fa71$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("9MiT2", function(module, exports) {

$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $2d6f7831c4394a60$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $2d6f7831c4394a60$export$e21c345b2538e96e);

var $5uXOq = parcelRequire("5uXOq");

var $561FV = parcelRequire("561FV");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $erLlC = parcelRequire("erLlC");
const $2d6f7831c4394a60$export$1b6468a6eb7d9b09 = (0, $2M1hQ.createResource)({
    type: (0, $erLlC.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $erLlC.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = 0;
        try {
            const apiResult = await (0, $eusud.performGetRequest)((0, $erLlC.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'value') || !(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'benefitsModalValue')) {
                    const error = new Error('Invalid preference value');
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
                return {
                    numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                    benefitsModal: {
                        isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                    }
                };
            }
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $jcw0u.default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) {
                if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) return {
                    numberOfTimesUserHasSeenChangeboarding: 0,
                    benefitsModal: {
                        isDisabled: false,
                        nextDateToShowBenefitsModal: null
                    }
                };
                return {
                    numberOfTimesUserHasSeenChangeboarding: 0
                };
            }
            (0, $jcw0u.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount,
            benefitsModal: {
                isDisabled: true,
                nextDateToShowBenefitsModal: null
            }
        };
    }
});
const $2d6f7831c4394a60$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $2YP9W.useResource)($2d6f7831c4394a60$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $5uXOq.useState)(()=>{
        if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) return {
            numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
            benefitsModal: {
                isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
            }
        };
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $erLlC.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $5uXOq.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        const body = typeof updates !== 'number' && (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal') ? {
            value: updates?.numberOfTimesUserHasSeenChangeboarding,
            benefitsModal: {
                isDisabled: updates?.benefitsModal?.isDisabled,
                nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
            }
        } : {
            value: updates
        };
        try {
            await (0, $eusud.performPutRequest)((0, $erLlC.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify(body)
            });
            setResponseStatusPut('success');
            let updateData;
            if (typeof updates !== 'number' && (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof updates === 'number') updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates
            };
            update(()=>updateData);
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference({
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: data?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            });
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding,
        data?.benefitsModal?.isDisabled,
        data?.benefitsModal?.nextDateToShowBenefitsModal
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("erLlC", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $ca7314633d486db1$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $ca7314633d486db1$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $ca7314633d486db1$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $ca7314633d486db1$export$91880069e7e73b18);
$parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", () => $ca7314633d486db1$export$9ccdfd91f2512a27);
const $ca7314633d486db1$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $ca7314633d486db1$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $ca7314633d486db1$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $ca7314633d486db1$export$91880069e7e73b18 = -1;
const $ca7314633d486db1$export$9ccdfd91f2512a27 = 14;

});


parcelRegister("fNOVA", function(module, exports) {

$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $cf959888902c771b$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $cf959888902c771b$export$bc11d4816053db5c);

var $5uXOq = parcelRequire("5uXOq");

var $aIZdc = parcelRequire("aIZdc");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $dO2g2 = parcelRequire("dO2g2");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $cf959888902c771b$var$fetchGetIssueTransitionOptInState = async ()=>(0, $eusud.performGetRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca));
const $cf959888902c771b$export$5fbcf4d7a6d9c477 = (0, $2M1hQ.createResource)({
    type: (0, $267ed65766cf1bd0$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $267ed65766cf1bd0$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $4R6GH.fg)('issue-transition-customisation-for-srb') || (0, $aIZdc.isFedRamp)();
        const isModernITSRenderEnabled = (0, $4R6GH.fg)('render-modern-issue-transition') || (0, $aIZdc.isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $cf959888902c771b$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $dO2g2.default)()
        };
    },
    maxAge: Number.MAX_VALUE
});
const $cf959888902c771b$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $eusud.performPutRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $cf959888902c771b$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $2YP9W.useResource)($cf959888902c771b$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $5uXOq.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $dO2g2.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $5uXOq.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $cf959888902c771b$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $267ed65766cf1bd0$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $267ed65766cf1bd0$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $267ed65766cf1bd0$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $267ed65766cf1bd0$export$880a78695d76498e = 8;

parcelRegister("dO2g2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa107364a5021d3$export$2e2bcd8739ae039);

var $aIZdc = parcelRequire("aIZdc");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $4R6GH.fg)('render-modern-issue-transition') || (0, $aIZdc.isFedRamp)();
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $4R6GH.fg)('issue-transition-customisation-for-srb') || (0, $aIZdc.isFedRamp)();
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    return (0, $6s1PB.expValEquals)('jira_issue_transition_screen_modernisation_toggle', 'value', 'BY_DEFAULT_USER_OPT_OUT') ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $8fa107364a5021d3$export$2e2bcd8739ae039 = $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState;

});


parcelRegister("kJQXA", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $273ba0463e1e3cac$export$fa191d7d71460a98);

var $4Pf62 = parcelRequire("4Pf62");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $273ba0463e1e3cac$export$fa191d7d71460a98 = (0, $2M1hQ.createResource)({
    type: (0, $b830026e722fc8e6$export$fd4fc70ec71927d1),
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $eusud.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity
});

});
const $b830026e722fc8e6$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';


parcelRegister("atU1t", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $587727b78e9bd173$export$44e7ad3c66a3f25f);

var $02g8e = parcelRequire("02g8e");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

const $587727b78e9bd173$export$44e7ad3c66a3f25f = (0, $2M1hQ.createResource)({
    type: (0, $f9d36ddc532997a4$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $02g8e.fetchSidebarConfig)(baseUrl, scope, false);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000
});

});
parcelRegister("02g8e", function(module, exports) {

$parcel$export(module.exports, "fetchSidebarConfig", () => $5da99daaa007f26b$export$d1d13c4b972a22f1);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
const $5da99daaa007f26b$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';

const $5da99daaa007f26b$var$fetchUsingProtobuf = async (url)=>{
    try {
        const fetchProtobuf = await (parcelRequire("laEEP"));
        if (!fetchProtobuf) (0, $2YZCu.default).safeErrorWithoutCustomerData($5da99daaa007f26b$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
        return fetchProtobuf.default(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData($5da99daaa007f26b$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
        throw err;
    }
};
const $5da99daaa007f26b$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
};
const $5da99daaa007f26b$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
    if (isServer) {
        const protoUrl = $5da99daaa007f26b$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
        return $5da99daaa007f26b$var$fetchUsingProtobuf(protoUrl);
    }
    const sidebarUrl = $5da99daaa007f26b$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
    return (0, $7f4tk.default)(sidebarUrl);
};

});
parcelRegister("laEEP", function(module, exports) {

let $03fa3a1847f5c79c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03fa3a1847f5c79c$var$load("7erVk").then(()=>parcelRequire('g4I8Z'));

});


const $f9d36ddc532997a4$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';


parcelRegister("c34Wf", function(module, exports) {

$parcel$export(module.exports, "navigationUiStateResource", () => $976a0f933d5d0ba8$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $8QpSo = parcelRequire("8QpSo");

var $2M1hQ = parcelRequire("2M1hQ");

var $kJPyG = parcelRequire("kJPyG");

const $976a0f933d5d0ba8$var$getNavigationUiStateMemoized = (0, $8QpSo.default)((atlassianAccountId)=>(0, $kJPyG.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $976a0f933d5d0ba8$export$14c178691841b423 = (0, $2M1hQ.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$976a0f933d5d0ba8$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity
});

});
parcelRegister("kJPyG", function(module, exports) {

$parcel$export(module.exports, "getNavigationUiState", () => $a5efaf793a61ef5e$export$29999268b070c9bd);

var $89SaW = parcelRequire("89SaW");


var $1yqku = parcelRequire("1yqku");
const $a5efaf793a61ef5e$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $1yqku.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $89SaW.getUserProperty)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $1yqku.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
const $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $2ed2f0cf8ecb933e$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("1yqku", function(module, exports) {

$parcel$export(module.exports, "queryLocalStorage", () => $fa4273588466a1c1$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $fa4273588466a1c1$export$ec13c725e067146a);

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $bSSG7 = parcelRequire("bSSG7");

// TODO - JFP-2294 add prefix for webstorage
const $fa4273588466a1c1$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('');
const $fa4273588466a1c1$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
};
const $fa4273588466a1c1$var$queryLocalStorageSync = ()=>{
    const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
    const item = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $fa4273588466a1c1$var$localStorageProvider.get((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8)) : localStorage.getItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? item : JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $2ed2f0cf8ecb933e$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $fa4273588466a1c1$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $fa4273588466a1c1$var$queryLocalStorageSync();
        resolve(item);
    });
const $fa4273588466a1c1$export$ec13c725e067146a = (data)=>{
    const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
    (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $fa4273588466a1c1$var$localStorageProvider.set((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), data) : localStorage.setItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});
parcelRegister("bSSG7", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $63804f80e89e547d$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $63804f80e89e547d$export$59acef2b3ab1df90);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $dEJQ9 = parcelRequire("dEJQ9");
const $63804f80e89e547d$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, shouldSerialize = true)=>(0, $fNVZf.createStorageProvider)((0, $fNVZf.WebStorageType).LocalStorage, appPrefix, (0, $dEJQ9.makeLocalStore)(), shouldSerialize));
const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    return (0, $fNVZf.createExpirableStorageProvider)((0, $fNVZf.WebStorageType).LocalStorage, appPrefix, (0, $dEJQ9.makeLocalExpirableStore)());
});

});
parcelRegister("fNVZf", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $04caddce42518619$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "WebStorageType", () => $04caddce42518619$export$259e3a861f28589b);
$parcel$export(module.exports, "createStorageProvider", () => $04caddce42518619$export$8441605555fbd60c);
$parcel$export(module.exports, "createExpirableStorageProvider", () => $04caddce42518619$export$b793a81cf479272a);

var $fKgem = parcelRequire("fKgem");

var $bHibm = parcelRequire("bHibm");

var $4R6GH = parcelRequire("4R6GH");

var $c7J1U = parcelRequire("c7J1U");
const $04caddce42518619$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
    (0, $c7J1U.default)
];
const $04caddce42518619$export$259e3a861f28589b = {
    LocalStorage: 'LocalStorage',
    SessionStorage: 'SessionStorage'
};
const $04caddce42518619$export$8441605555fbd60c = (storageType, appPrefix = '', // eslint-disable-next-line @typescript-eslint/no-explicit-any
store, shouldSerialize = true)=>{
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>appPrefix?.trim().length ? `${appPrefix}.${key}` : key;
    const storageAPI = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? (0, $bHibm.AtlBrowserStorageLocal) : (0, $bHibm.AtlBrowserStorageSession);
    const browserStorage = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setItem(prefixedKey, storageValue);
                } else namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setStrictlyNecessaryItem(prefixedKey, storageValue);
                } else throw Error('Method setStrictlyNecessaryItem is not supported.');
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let item;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    // When the feature flag is enabled
                    if (appPrefix?.trim().length) {
                        // Case 1: App prefix exists (all the existing usages of jira-browser-storage-providers had app prefix)
                        item = storageAPI.getItem(prefixedKey);
                        if (typeof item === 'undefined' || item === null) {
                            // Check old store when data not found in new storage
                            const itemFromOldStore = namespacedStore.get(key);
                            if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                                // Migrate data from old store to new storage
                                const stringValue = JSON.stringify(itemFromOldStore);
                                storageAPI.setItem(prefixedKey, stringValue);
                                return itemFromOldStore;
                            }
                        }
                        if (typeof item === 'string') // If data found in new storage, return it
                        return shouldSerialize ? JSON.parse(item) : item;
                    }
                    // Case 2: No app prefix
                    item = storageAPI.getItem(prefixedKey);
                    if (typeof item === 'undefined' || item === null) {
                        // Check browser's localStorage for the key
                        const itemFromNativeBrowserStorage = browserStorage?.getItem(key);
                        if (typeof itemFromNativeBrowserStorage !== 'undefined' && itemFromNativeBrowserStorage !== null) {
                            // Migrate data to new storage
                            storageAPI.setItem(prefixedKey, itemFromNativeBrowserStorage);
                            return itemFromNativeBrowserStorage;
                        }
                    }
                    if (typeof item === 'string') // If data found in new storage, return it
                    return shouldSerialize ? JSON.parse(item) : item;
                } else return namespacedStore.get(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting item from storage:', err);
            }
        },
        remove: (key)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey); // remove data from new store
                    namespacedStore.remove(key); // remove data from old store as well
                } else namespacedStore.remove(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error removing item from storage:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access clearStorageValues method.');
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access getNamespaceKeysLength method.');
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};
const $04caddce42518619$export$b793a81cf479272a = (storageType, appPrefix, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>`${appPrefix}.${key}`;
    const storageAPI = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? (0, $bHibm.AtlBrowserStorageLocal) : (0, $bHibm.AtlBrowserStorageSession);
    const browserStorage = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value, expiration)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const item = {
                        value: value,
                        expiration: expiration
                    };
                    const serializedValue = JSON.stringify(item);
                    storageAPI.setItem(prefixedKey, serializedValue);
                } else namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value, expiration)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const item = {
                    value: value,
                    expiration: expiration
                };
                const serializedValue = JSON.stringify(item);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.setStrictlyNecessaryItem(prefixedKey, serializedValue);
                else throw Error('Method setStrictlyNecessaryItem is not supported.');
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let itemStr;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const item = {
                                value: itemFromOldStore,
                                expiration: namespacedStore.getExpiration(key)
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return itemFromOldStore;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return;
                        }
                        return item.value;
                    }
                } else {
                    itemStr = namespacedStore.get(key);
                    return itemStr;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting item with key=${key}:`, error);
            }
        },
        getExpiration: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                let itemStr;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const expiration = namespacedStore.getExpiration(key);
                            const item = {
                                value: itemFromOldStore,
                                expiration: expiration
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return expiration;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return undefined;
                        }
                        return item.expiration;
                    }
                } else return namespacedStore.getExpiration(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting expiration for item with key=${key}:`, error);
                return undefined;
            }
        },
        remove: (key)=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey);
                    namespacedStore.remove(key);
                } else namespacedStore.remove(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error removing item with key=${key}:`, error);
            }
        },
        removeExpiredKeys: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    for(let i = 0; i < storageAPI.length(); i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) {
                            const itemStr = storageAPI.getItem(key);
                            if (itemStr) {
                                const item = JSON.parse(itemStr);
                                if (item.expiration && item.expiration < Date.now()) {
                                    storageAPI.removeItem(key);
                                    i--;
                                }
                            }
                        }
                    }
                    namespacedStore.removeExpiredKeys(); // clean up old keys too
                } else namespacedStore.removeExpiredKeys();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error removing expired keys:', error);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage values:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};

});
parcelRegister("c7J1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $99d922a6a243a194$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $cuNKJ = parcelRequire("cuNKJ");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $99d922a6a243a194$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $cuNKJ.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $jcw0u.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $cuNKJ.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $cuNKJ.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $cuNKJ.ONE_WEEK) >= (0, $cuNKJ.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $cuNKJ.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;

});
parcelRegister("cuNKJ", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $d21613ddd27d5bbf$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $d21613ddd27d5bbf$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $d21613ddd27d5bbf$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $d21613ddd27d5bbf$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $d21613ddd27d5bbf$export$ea28dfd9333cda2d);
const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("dEJQ9", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $dcae70c06981fc99$export$b2631085fe8db7af);
$parcel$export(module.exports, "isLocalStorageAvailable", () => $dcae70c06981fc99$export$117a30df0da2af20);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $dcae70c06981fc99$export$cf816b43e73de947);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $4Zgux = parcelRequire("4Zgux");

var $2NjNT = parcelRequire("2NjNT");

var $fNVZf = parcelRequire("fNVZf");
const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $dcae70c06981fc99$export$117a30df0da2af20 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});





parcelRegister("eOlBz", function(module, exports) {

$parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", () => $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
$parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", () => $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2);
$parcel$export(module.exports, "useNewIssueViewLockedInStatus", () => $4e2e5fcdbf62dfaf$export$3b09097f2a423abd);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c = (0, $2M1hQ.createResource)({
    type: (0, $103a13dfd187b85c$export$fdb92aeacda42553),
    getKey: ()=>'newIssueViewTransitionLockingStatus',
    getDataLoader: ()=>(parcelRequire("4zEYO")),
    maxAge: Number.MAX_VALUE
});
const $4e2e5fcdbf62dfaf$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $4e2e5fcdbf62dfaf$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
const $4e2e5fcdbf62dfaf$export$3b09097f2a423abd = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $2YP9W.useResource)($4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);

});
const $103a13dfd187b85c$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';

parcelRegister("4zEYO", function(module, exports) {

let $354a380b35f18deb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $354a380b35f18deb$var$load("bDo1N").then(()=>parcelRequire('2RVA3'));

});


parcelRegister("3X1Xr", function(module, exports) {

$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $950f2f2a5a65ba3f$export$266a039a005e8314);

var $2M1hQ = parcelRequire("2M1hQ");


const $950f2f2a5a65ba3f$export$266a039a005e8314 = (0, $2M1hQ.createResource)({
    type: (0, $fa76c7a777da2375$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("imuoK")),
    maxAge: Number.MAX_VALUE
});

});
const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("imuoK", function(module, exports) {

let $d5e1dc84b8193e61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5e1dc84b8193e61$var$load("1Kt13").then(()=>parcelRequire('8FYIq'));

});


parcelRegister("dxCvy", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $fb0493b5a465ed74$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $fb0493b5a465ed74$export$d75816e37af81473);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $fb0493b5a465ed74$var$getDataLoader = ()=>(parcelRequire("d9Fd3"));
const $fb0493b5a465ed74$export$27ad0d75c619be68 = (0, $2M1hQ.createResource)({
    type: (0, $0f463a88567f1621$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>(0, $1nb22.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getDataLoader: $fb0493b5a465ed74$var$getDataLoader,
    maxAge: 1800000
});
const $fb0493b5a465ed74$export$d75816e37af81473 = $fb0493b5a465ed74$export$27ad0d75c619be68;

});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("d9Fd3", function(module, exports) {

let $993c150105f6ec4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $993c150105f6ec4c$var$load("7UkBG").then(()=>parcelRequire('fsLhR'));

});


parcelRegister("4dc0x", function(module, exports) {

$parcel$export(module.exports, "fetchSiteTraitsResource", () => $6bcb8e2c3d1b4192$export$379923e7c903a55d);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $e5wyW = parcelRequire("e5wyW");

var $jX0pr = parcelRequire("jX0pr");


const $6bcb8e2c3d1b4192$var$getDataOld = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const clientUrl = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
        const response = false ? await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }) : await (0, $eusud.performGetRequest)(clientUrl);
        if (response?.attributes) return response.attributes;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $ecc0251f1d9f8566$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $6bcb8e2c3d1b4192$var$getDataNew = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const response = false ? (await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $jX0pr.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $ecc0251f1d9f8566$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $6bcb8e2c3d1b4192$export$379923e7c903a55d = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended'), (0, $2M1hQ.createResource)({
    type: (0, $ecc0251f1d9f8566$export$6f0555de4f60e84e),
    getKey: ()=>(0, $ecc0251f1d9f8566$export$7e7d7930e22ba39f),
    getData: (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api'), $6bcb8e2c3d1b4192$var$getDataNew, $6bcb8e2c3d1b4192$var$getDataOld),
    maxAge: Number.MAX_VALUE
}));

});
parcelRegister("e5wyW", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $12199147dc0ae1fa$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $12199147dc0ae1fa$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("jX0pr", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $7b32fa3ce5d65e32$export$671fb03be30194c3);
$parcel$export(module.exports, "useSitePersonalization", () => $7b32fa3ce5d65e32$export$58982988039b926f);

var $8QpSo = parcelRequire("8QpSo");

var $ld2hZ = parcelRequire("ld2hZ");

var $7f4tk = parcelRequire("7f4tk");
const $7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $7b32fa3ce5d65e32$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $7f4tk.default)($7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $7b32fa3ce5d65e32$export$671fb03be30194c3 = (0, $8QpSo.default)($7b32fa3ce5d65e32$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $7b32fa3ce5d65e32$export$58982988039b926f = ()=>(0, $ld2hZ.useService)($7b32fa3ce5d65e32$export$671fb03be30194c3);

});
parcelRegister("ld2hZ", function(module, exports) {

$parcel$export(module.exports, "useService", () => $b3ad55f76ff82cb6$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $b3ad55f76ff82cb6$export$c963713a27525aaf);

var $5uXOq = parcelRequire("5uXOq");
const $b3ad55f76ff82cb6$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $5uXOq.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $b3ad55f76ff82cb6$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $5uXOq.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $b3ad55f76ff82cb6$export$6de4685a6c88b4e9(request, initialState);
    (0, $5uXOq.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


const $2ffc5f2215c16253$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';

const $ecc0251f1d9f8566$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
const $ecc0251f1d9f8566$export$7e7d7930e22ba39f = 'recommendations-fetch-site-traits-resource-key';
const $ecc0251f1d9f8566$export$7f111648ca05f056 = 'useResource.fetchRecommendationsSiteTraits';


parcelRegister("51Yl2", function(module, exports) {

$parcel$export(module.exports, "fetchUserTraitsResource", () => $7ddcc0e078ed27cf$export$d5198d02e9089545);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $8ilPk = parcelRequire("8ilPk");

var $e5wyW = parcelRequire("e5wyW");


const $7ddcc0e078ed27cf$var$getDataOld = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const clientUrl = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }) : await (0, $eusud.performGetRequest)(clientUrl);
        if (response?.attributes) return response.attributes;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $e07bc74223fe458d$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $7ddcc0e078ed27cf$var$getDataNew = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId ?? '';
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? (await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $8ilPk.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: accountId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $e07bc74223fe458d$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $7ddcc0e078ed27cf$export$d5198d02e9089545 = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended'), (0, $2M1hQ.createResource)({
    type: (0, $e07bc74223fe458d$export$6f0555de4f60e84e),
    getKey: ()=>(0, $e07bc74223fe458d$export$7e7d7930e22ba39f),
    getData: (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api'), $7ddcc0e078ed27cf$var$getDataNew, $7ddcc0e078ed27cf$var$getDataOld),
    maxAge: Number.MAX_VALUE
}));

});
parcelRegister("8ilPk", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $4ab23cf8c5a935d6$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $4ab23cf8c5a935d6$export$8dc79ff315095801);

var $8QpSo = parcelRequire("8QpSo");

var $ld2hZ = parcelRequire("ld2hZ");

var $7f4tk = parcelRequire("7f4tk");
const $4ab23cf8c5a935d6$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $4ab23cf8c5a935d6$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $7f4tk.default)($4ab23cf8c5a935d6$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $4ab23cf8c5a935d6$export$de93ec54b11be450 = (0, $8QpSo.default)($4ab23cf8c5a935d6$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $4ab23cf8c5a935d6$export$8dc79ff315095801 = ()=>(0, $ld2hZ.useService)($4ab23cf8c5a935d6$export$de93ec54b11be450);

});

const $e07bc74223fe458d$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $e07bc74223fe458d$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $e07bc74223fe458d$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';


parcelRegister("lXNZG", function(module, exports) {

$parcel$export(module.exports, "jpdRecommendationDismissedResource", () => $5630a429b63403f9$export$5db7c4562b672f52);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $5630a429b63403f9$export$5db7c4562b672f52 = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended'), (0, $2M1hQ.createResource)({
    type: (0, $2a8d22514dc25dbd$export$6f0555de4f60e84e),
    getKey: ()=>(0, $2a8d22514dc25dbd$export$7e7d7930e22ba39f),
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return {
                hasDismissed: true
            };
            const accountId = tenantContext.atlassianAccountId;
            const response = await (0, $eusud.performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
            return {
                hasDismissed: response?.value ?? false
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, they have never dismissed.
					 */ return {
                hasDismissed: false
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: (0, $2a8d22514dc25dbd$export$7f111648ca05f056),
                    packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return true - this ensures we don't show the recommendation if we don't know if they have dismissed */ return {
            hasDismissed: true
        };
    },
    maxAge: Number.MAX_VALUE
}));

});
const $2a8d22514dc25dbd$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $2a8d22514dc25dbd$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $2a8d22514dc25dbd$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';


parcelRegister("kkNtb", function(module, exports) {

$parcel$export(module.exports, "rovoEntitlementResource", () => $10274390833bf523$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $10274390833bf523$export$b9cee3799212b85a);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

const $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $10274390833bf523$var$getRovoEnabledBasedOnExperiment = ({ isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled })=>{
    // if Rovo is not enabled, we don't need to check the experiment
    if (!isRovoEnabled) return {
        isRovoEnabled: isRovoEnabled,
        isRovoLLMEnabled: isRovoLLMEnabled
    };
    // Killswitch gate to disable the experiment
    if (!(0, $4R6GH.fg)('rovo_team25_rollout_performance_exp_enabled')) return {
        isRovoEnabled: isRovoEnabled,
        isRovoLLMEnabled: isRovoLLMEnabled
    };
    // If a user is in the Control cohort we're overriding the entitlement check with false to NOT serve Rovo experience.
    // Test cohort: users who get the new Rovo experience -> do NOT override the TCS entitlement.
    // Control cohort: users who get the legacy experience (the baseline) -> override the TCS entitlement with false.
    if ((0, $6s1PB.expValEquals)('rovo_team25_rollout_performance_exp', 'cohort', 'control', 'test')) return {
        isRovoEnabled: false,
        isRovoLLMEnabled: false
    };
    // A repeat of the above as a second expeirmenet
    // Tenants should only be in one or the other, controlled by the targetting gate
    if ((0, $6s1PB.expValEquals)('rovo_team25_rollout_perf_b3a_exp', 'cohort', 'control', 'test')) return {
        isRovoEnabled: false,
        isRovoLLMEnabled: false
    };
    return {
        isRovoEnabled: isRovoEnabled,
        isRovoLLMEnabled: isRovoLLMEnabled
    };
};
const $10274390833bf523$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $34f68d752b7fdd6c$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    shouldShowRovoLLMEnabled: (0, $4R6GH.fg)('rovo_use_rovo_llm_enabled_check')
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        const isRovoEnabled = response.data?.jira?.isRovoEnabled ?? null;
        // defaulting to isRovoEnabled if the feature flag is not enabled
        const isRovoLLMEnabled = (0, $4R6GH.fg)('rovo_use_rovo_llm_enabled_check') ? response.data?.jira_isRovoLLMEnabled ?? null : isRovoEnabled;
        return $10274390833bf523$var$getRovoEnabledBasedOnExperiment({
            isRovoEnabled: isRovoEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null,
        isRovoLLMEnabled: undefined
    };
};
const $10274390833bf523$export$a0974cf24d16bc5d = (0, $2M1hQ.createResource)({
    type: $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$10274390833bf523$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity
});
const $10274390833bf523$export$b9cee3799212b85a = ()=>(0, $2YP9W.useResource)($10274390833bf523$export$a0974cf24d16bc5d);

});
const $34f68d752b7fdd6c$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;


parcelRegister("2Ql51", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $14feb59df5995657$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $14feb59df5995657$export$3416635c8aeb5bab);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $Y0b1l = parcelRequire("Y0b1l");

const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("7iqTB"));
const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, $2M1hQ.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $14feb59df5995657$var$getDataLoader,
    maxAge: 300000
});
const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $2YP9W.useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
            actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $Y0b1l.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("Y0b1l", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $fb319b2ef1da4e47$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $fb319b2ef1da4e47$export$2f7a12048d96237);

var $b9op4 = parcelRequire("b9op4");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $aHuqL.userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $aHuqL.userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $b9op4.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $b9op4.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("b9op4", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $a1d11c8212b90b3e$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $a1d11c8212b90b3e$export$2faeed762aac6741);
// This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $a1d11c8212b90b3e$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';

});


parcelRegister("7iqTB", function(module, exports) {

let $54ff13cf77e1512b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $54ff13cf77e1512b$var$load("h2MrD"),
    $54ff13cf77e1512b$var$load("bYT2S"),
    $54ff13cf77e1512b$var$load("5DvFw")
]).then(()=>parcelRequire('jyeNt'));

});


parcelRegister("9vlEn", function(module, exports) {

$parcel$export(module.exports, "userHomepageResource", () => $ea929e6a42e03883$export$16320dd0d1e6c145);

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $ea929e6a42e03883$export$16320dd0d1e6c145 = (0, $2M1hQ.createResource)({
    type: (0, $a4d0f361741078de$export$2026a6db44b15de7),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
        const { homepagePreference: homepagePreference } = await (0, $eusud.performGetRequest)(`${baseUrl}/rest/internal/3/homepage/`);
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity
});

});
const $a4d0f361741078de$export$2026a6db44b15de7 = 'USER_HOMEPAGE';


parcelRegister("5pSYQ", function(module, exports) {

$parcel$export(module.exports, "postOfficeJiraSideNavResource", () => $e6f7d661dd665dbf$export$5fd5ab86e70497f7);
$parcel$export(module.exports, "postOfficeJiraYourWorkResource", () => $e6f7d661dd665dbf$export$5969dfe9b3b29cd3);
$parcel$export(module.exports, "postOfficeJiraTopBannerResource", () => $e6f7d661dd665dbf$export$af242b8c8ffaab42);
$parcel$export(module.exports, "conditionalPostOfficeJiraTopBannerResource", () => $e6f7d661dd665dbf$export$d1df0b3b482d298d);
// eslint-disable-next-line jira/import-whitelist

var $fyLzM = parcelRequire("fyLzM");

var $2M1hQ = parcelRequire("2M1hQ");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");
const $e6f7d661dd665dbf$export$fd097948b42db8d3 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__SCREEN_SPACE_FLAGS',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('screen-space-flags', tenantContext);
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$5fd5ab86e70497f7 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_SIDE_NAV',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('jira-side-nav', tenantContext);
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$5969dfe9b3b29cd3 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_YOUR_WORK',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('jira-your-work', tenantContext);
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$af242b8c8ffaab42 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_TOP_BANNER',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isSiteAdmin) return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('jira-top-banner', tenantContext);
        return null;
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$d1df0b3b482d298d = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-issue-term-refresh-banner'), $e6f7d661dd665dbf$export$af242b8c8ffaab42);

});
parcelRegister("fyLzM", function(module, exports) {

$parcel$export(module.exports, "usePlacementSSRFetch", () => $121a6aea82ff4ae0$export$420f2f91a928b3b6);
$parcel$export(module.exports, "preloadPostOfficePlacementWithTenantContext", () => $121a6aea82ff4ae0$export$65b5eab182e1ca6f);

var $5uXOq = parcelRequire("5uXOq");

var $87o4H = parcelRequire("87o4H");

var $i3PqM = parcelRequire("i3PqM");

var $2YP9W = parcelRequire("2YP9W");

var $adncp = parcelRequire("adncp");
const $121a6aea82ff4ae0$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $121a6aea82ff4ae0$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($121a6aea82ff4ae0$export$18a0019e5439b209(res));
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $121a6aea82ff4ae0$var$preloadPostOfficePlacement = async (placementId, contextOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const jiraFetcherWithS2SHeaders = async (url)=>{
        let hostEnv = 'prod';
        if (environment.currentEnv !== 'production') hostEnv = 'staging';
        const fetchHeaders = {
            'x-ssr-service-name': 'post-office',
            'x-ssr-service-env': hostEnv
        };
        return (0, $i3PqM.defaultFetcher)(url.replace('gateway/api/post-office/', ''), fetchHeaders);
    };
    return (0, $i3PqM.requestInitialData)(placementId, postOfficeContext, false ? jiraFetcherWithS2SHeaders : undefined, (0, $87o4H.buildBasePath)(environment.currentEnv, environment.envConfigs)).then($121a6aea82ff4ae0$export$b3732c8ff6f9c463).then((res)=>res.json());
};
const $121a6aea82ff4ae0$export$420f2f91a928b3b6 = (resource)=>{
    const { data: data } = (0, $2YP9W.useResource)(resource);
    return (0, $5uXOq.useCallback)(()=>{
        if (data) {
            /**
			 * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
			 * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
			 */ const init = {
                status: 200,
                statusText: 'ok!'
            };
            return Promise.resolve(new Response(JSON.stringify(data), init));
        }
    }, [
        data
    ]);
};
const $121a6aea82ff4ae0$export$65b5eab182e1ca6f = async (placementId, preloadedTenantContext)=>{
    return $121a6aea82ff4ae0$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $adncp.tenantToPostOfficeContext)(preloadedTenantContext),
        environment: {
            currentEnv: (0, $adncp.transformJiraEnvToPostOfficeEnvironment)(preloadedTenantContext.environment)
        }
    });
};

});
parcelRegister("87o4H", function(module, exports) {

$parcel$export(module.exports, "buildBasePath", () => $e673525439adf1a3$export$e8b30f9c4a80230f);


var $5MYiV = parcelRequire("5MYiV");
const $e673525439adf1a3$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $5MYiV.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});
var $154d3acab0ca1f4d$exports = {};

$parcel$export($154d3acab0ca1f4d$exports, "API_ORIGIN_LOCAL", () => $154d3acab0ca1f4d$export$1e9fed4c0197724c);
$parcel$export($154d3acab0ca1f4d$exports, "API_PATHNAME_LOCAL", () => $154d3acab0ca1f4d$export$919a9569bce66f17);
$parcel$export($154d3acab0ca1f4d$exports, "API_PATHNAME_STG_PROD", () => $154d3acab0ca1f4d$export$d4fe3482c88e73a8);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_LOCAL", () => $154d3acab0ca1f4d$export$67be2569ef5d7666);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_STG", () => $154d3acab0ca1f4d$export$b49738b89db261cd);
$parcel$export($154d3acab0ca1f4d$exports, "REMOTE_MODULE_URI_PROD", () => $154d3acab0ca1f4d$export$bbd96cd490b0df63);
const $154d3acab0ca1f4d$export$1e9fed4c0197724c = 'http://localhost:8081';
const $154d3acab0ca1f4d$export$919a9569bce66f17 = '/api/v1/placements/';
const $154d3acab0ca1f4d$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $154d3acab0ca1f4d$export$67be2569ef5d7666 = 'http://localhost:9009';
const $154d3acab0ca1f4d$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $154d3acab0ca1f4d$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';

parcelRegister("5MYiV", function(module, exports) {

$parcel$export(module.exports, "defaultEnvironmentValues", () => $d283dbd21f6fbc74$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $d283dbd21f6fbc74$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $d283dbd21f6fbc74$export$877b97169cc75e8b);

var $5uXOq = parcelRequire("5uXOq");

const $d283dbd21f6fbc74$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        test: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $154d3acab0ca1f4d$export$1e9fed4c0197724c),
                pathname: (0, $154d3acab0ca1f4d$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $154d3acab0ca1f4d$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $154d3acab0ca1f4d$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        }
    }
};
const $d283dbd21f6fbc74$export$fceca2c399b32565 = (0, $5uXOq.createContext)($d283dbd21f6fbc74$export$b4ede87479bfcf09);
const $d283dbd21f6fbc74$export$604607f913ef367c = $d283dbd21f6fbc74$export$fceca2c399b32565.Provider;
const $d283dbd21f6fbc74$export$877b97169cc75e8b = ()=>(0, $5uXOq.useContext)($d283dbd21f6fbc74$export$fceca2c399b32565);

});


parcelRegister("i3PqM", function(module, exports) {

$parcel$export(module.exports, "defaultFetcher", () => $897b9e921cef5759$export$77754e0ac9f8aba3);
$parcel$export(module.exports, "requestInitialData", () => $897b9e921cef5759$export$c4c39037cc4b06ab);
const $897b9e921cef5759$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $897b9e921cef5759$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $897b9e921cef5759$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("adncp", function(module, exports) {

$parcel$export(module.exports, "tenantToPostOfficeContext", () => $8d0bdd2f51e19696$export$d8f2c334a0924146);
$parcel$export(module.exports, "subproductToEdition", () => $8d0bdd2f51e19696$export$2d690d13b91ea44f);
$parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", () => $8d0bdd2f51e19696$export$cfacfecb20987ff1);

var $8dYib = parcelRequire("8dYib");
const $8d0bdd2f51e19696$var$JIRA_PRODUCT = 'jira';
const $8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $8d0bdd2f51e19696$var$JIRA_PRODUCT,
    locale: 'en'
};
const $8d0bdd2f51e19696$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return (0, $8dYib.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
};
const $8d0bdd2f51e19696$export$d8f2c334a0924146 = (tenantData)=>{
    const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale } = tenantData;
    const workspaceAri = $8d0bdd2f51e19696$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        isSiteAdmin: isSiteAdmin,
        tenantId: cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        orgId: undefined,
        subproduct: undefined,
        productEdition: undefined
    };
};
const $8d0bdd2f51e19696$export$2d690d13b91ea44f = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $8d0bdd2f51e19696$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};

});
parcelRegister("8dYib", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAri", () => $5fce4e6fa5e3542e$export$d4d0794234e3fd53);

var $b1EkX = parcelRequire("b1EkX");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/workspace/manifest.ts
var $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $b1EkX.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $b1EkX.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $5fce4e6fa5e3542e$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("b1EkX", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $806f13cc47cff352$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $806f13cc47cff352$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $806f13cc47cff352$export$e52ccdf6abac8896 = "jira", $806f13cc47cff352$export$669cd5f7b3746bb = "workspace";

});






parcelRegister("6QKrH", function(module, exports) {

$parcel$export(module.exports, "LegacyPage", () => $fbde0cafbe117684$export$273311ee2c946a58);

var $5uXOq = parcelRequire("5uXOq");

var $gdB0k = parcelRequire("gdB0k");
const $fbde0cafbe117684$export$273311ee2c946a58 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdB0k.default), {
        match: props.match,
        action: props.action,
        route: props.route,
        isSpa: false
    }));
var $fbde0cafbe117684$export$2e2bcd8739ae039 = $fbde0cafbe117684$export$273311ee2c946a58;

});
parcelRegister("gdB0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bb8150642d26f84$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $4oDnX = parcelRequire("4oDnX");

var $vrkiK = parcelRequire("vrkiK");

var $fJ1Pn = parcelRequire("fJ1Pn");
// eslint-disable-next-line jira/react/no-class-components
class $3bb8150642d26f84$var$SpaStateResetPage extends (0, $5uXOq.Component) {
    shouldComponentUpdate(nextProps) {
        const cleanMatch = (0, $vrkiK.getApdexMatchObject)(this.props.match, this.props.route);
        const cleanNextMatch = (0, $vrkiK.getApdexMatchObject)(nextProps.match, nextProps.route);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(cleanMatch, cleanNextMatch);
    }
    render() {
        const { action: action, match: match, route: route, isSpa: isSpa } = this.props;
        const shouldNotUpdate = action === 'REPLACE' && (!isSpa || route.name === 'issue-navigator');
        return /* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { resetCurrentPage: resetCurrentPage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJ1Pn.default), {
                // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type '() => Action<State, void, void | Promise<void>>'.
                resetCurrentPage: shouldNotUpdate ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : resetCurrentPage,
                match: (0, $vrkiK.getApdexMatchObject)(match, route),
                route: route
            }));
    }
}
var $3bb8150642d26f84$export$2e2bcd8739ae039 = $3bb8150642d26f84$var$SpaStateResetPage;

});
parcelRegister("4oDnX", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $363cd3235a9267e4$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "SpaStateActionsSubscriber", () => $363cd3235a9267e4$export$3dfa91988c213fbc);
$parcel$export(module.exports, "useSpaState", () => $363cd3235a9267e4$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $363cd3235a9267e4$export$b134752525935b78);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $7w9eZ = parcelRequire("7w9eZ");
const $363cd3235a9267e4$export$fd52daf2a3c1ec68 = (0, $51nlc.createSubscriber)((0, $7w9eZ.default));
const $363cd3235a9267e4$export$3dfa91988c213fbc = (0, $51nlc.createSubscriber)((0, $7w9eZ.default), {
    selector: null
});
const $363cd3235a9267e4$export$a57865516f6345d1 = (0, $3sQ5x.createHook)((0, $7w9eZ.default));
const $363cd3235a9267e4$export$b134752525935b78 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: null
});

});
parcelRegister("7w9eZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85db42238a8acf29$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $iXqE5 = parcelRequire("iXqE5");

var $6Bj8c = parcelRequire("6Bj8c");
const $85db42238a8acf29$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, $7Jxgt.v4)(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $85db42238a8acf29$var$store = (0, $iXqE5.createStore)({
    name: 'spa-state',
    initialState: $85db42238a8acf29$export$d4c72bab9d6cc13a,
    actions: $6Bj8c
});
var $85db42238a8acf29$export$2e2bcd8739ae039 = $85db42238a8acf29$var$store;

});
parcelRegister("6Bj8c", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("fI6Pg")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("fI6Pg")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("fI6Pg")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("fI6Pg")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("fI6Pg")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("fI6Pg")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("fI6Pg")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("fI6Pg")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("fI6Pg")).setResourceMetrics);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $fI6Pg = parcelRequire("fI6Pg");

});
parcelRegister("fI6Pg", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $4a986cd3487bf863$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $4a986cd3487bf863$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $4a986cd3487bf863$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $4a986cd3487bf863$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $4a986cd3487bf863$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $4a986cd3487bf863$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $4a986cd3487bf863$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $4a986cd3487bf863$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $4a986cd3487bf863$export$8ad155d489dcf34d);

var $7Jxgt = parcelRequire("7Jxgt");

var $1ciso = parcelRequire("1ciso");

var $21pfT = parcelRequire("21pfT");

var $cfDZ3 = parcelRequire("cfDZ3");

var $1AZST = parcelRequire("1AZST");
const $4a986cd3487bf863$export$7bd623b29ec8e1eb = 10000;
const $4a986cd3487bf863$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $21pfT.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $1ciso.default)(nextRouteUfoName, nextRouteName);
        (0, $1AZST.GlobalPageLoadExperience).abort({
            force: true
        });
        (0, $1AZST.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, $7Jxgt.v4)(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $4a986cd3487bf863$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $4a986cd3487bf863$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $4a986cd3487bf863$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId));
            }, $4a986cd3487bf863$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $cfDZ3.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$9d528722f2ff2999(appId, startTime));
    };
const $4a986cd3487bf863$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$6a25429a42d30f9a(appId, endTime));
    };
const $4a986cd3487bf863$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});




parcelRegister("vrkiK", function(module, exports) {

$parcel$export(module.exports, "calcRapidBoardResetState", () => $fd0af9cf1691807e$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $fd0af9cf1691807e$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $fd0af9cf1691807e$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $fd0af9cf1691807e$export$9f3e656a7f6a3adc);
const $fd0af9cf1691807e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [
                'browse-project-redirect'
            ];
            resetDone = true;
            break;
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-backlog':
        case 'rapidboard-report':
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf('browse-project-redirect') > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $fd0af9cf1691807e$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $fd0af9cf1691807e$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-board':
        case 'rapidboard-report':
            // use search to navigate to board
            if (rapidBoardPaths.includes('browse-project-redirect') || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes('browse-project-redirect')) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $fd0af9cf1691807e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $fd0af9cf1691807e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 'issue':
        case 'issue-embed':
        case 'issue-navigator':
        case 'issue-navigator-classic':
        case 'issue-navigator-core':
        case 'servicedesk-issues':
            return true;
        default:
            return false;
    }
};

});

parcelRegister("fJ1Pn", function(module, exports) {

$parcel$export(module.exports, "default", () => $df3649b3ebec92f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $vrkiK = parcelRequire("vrkiK");
class $df3649b3ebec92f5$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.resetDone = true, this.rapidBoardPaths = [];
        const [paths] = (0, $vrkiK.calcRapidBoardResetState)(this.rapidBoardPaths, this.props.route.name, !!this.props.match.query.useStoredSettings);
        this.rapidBoardPaths = paths;
    }
    shouldComponentUpdate(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.props.match, nextProps.match)) {
            // RapidboardPaths is being persisted here.
            // resetDone boolean is calculated in the util function.
            const [paths, resetBoolean] = (0, $vrkiK.calcRapidBoardResetState)(this.rapidBoardPaths, nextProps.route.name, !!nextProps.match.query.useStoredSettings);
            this.rapidBoardPaths = paths;
            this.resetDone = resetBoolean;
        }
        return true;
    }
    componentDidUpdate() {
        if (!this.resetDone) {
            if (!__SPA__) {
                this.resetDone = true;
                return;
            }
            this.props.resetCurrentPage();
            this.resetDone = true;
        }
    }
    render() {
        return null;
    }
}

});



parcelRegister("427L2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $654498d18bc8ccd3$export$5519b86c9ea602e1);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gB79g = parcelRequire("gB79g");

var $aYyVm = parcelRequire("aYyVm");
const $654498d18bc8ccd3$export$5519b86c9ea602e1 = (0, $7NszV.createEntry)((0, $gB79g.globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        component: (0, $aYyVm.LazyExplicitFieldsProjectListPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aYyVm.LazyExplicitFieldsProjectListPromise)
        ]
    }));

});
parcelRegister("ffza4", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianNavigation", () => $772c987a24839dcf$export$4caed23aa0274abb);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");

var $kxZPA = parcelRequire("kxZPA");

const $772c987a24839dcf$export$4caed23aa0274abb = (0, $kxZPA.lazyForPaint)(()=>{
    const bundleReady = (parcelRequire("3V1dy"));
    if (!false) bundleReady.then(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/index.tsx"
});

});
parcelRegister("2SVPM", function(module, exports) {

$parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", () => $b3ae4dfcfbbe07cd$export$15ca6669ae356831);
$parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", () => $b3ae4dfcfbbe07cd$export$ab75d59423c060f4);
$parcel$export(module.exports, "measureInitialPageLoadTiming", () => $b3ae4dfcfbbe07cd$export$e18462760bac553c);
$parcel$export(module.exports, "setProductBundleReadyForInitialRender", () => $b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65);

var $jI6pi = parcelRequire("jI6pi");

var $21pfT = parcelRequire("21pfT");
/**
 * `performance.measure` will throw if start/stop aren't set.
 *
 * This call sets a user-timing on the profiler timelines so we can see sections of the load.
 */ const $b3ae4dfcfbbe07cd$var$safeMeasure = (name, start, stop)=>{
    try {
        performance.measure(name, start, stop);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (_err) {}
};
const $b3ae4dfcfbbe07cd$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
    if (false) return;
    $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stop);
    (0, $21pfT.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
    (0, $jI6pi.addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
};
const $b3ae4dfcfbbe07cd$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
    if (false) return;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(stopMark);
    $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stopMark);
    (0, $21pfT.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
    (0, $jI6pi.addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
};
const $b3ae4dfcfbbe07cd$export$e18462760bac553c = (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = fn();
    performance.mark(stopMark);
    $b3ae4dfcfbbe07cd$var$safeMeasure(name, startMark, stopMark);
    (0, $21pfT.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $jI6pi.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b3ae4dfcfbbe07cd$export$53038a2e9d597818 = async (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = await fn();
    performance.mark(stopMark);
    (0, $21pfT.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $jI6pi.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65 = ()=>{
    if (false) return;
    $b3ae4dfcfbbe07cd$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
};

});

parcelRegister("3V1dy", function(module, exports) {

let $2da7a3c0ff94457b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2da7a3c0ff94457b$var$load("kfXhT"),
    $2da7a3c0ff94457b$var$load("2Lfdl"),
    $2da7a3c0ff94457b$var$load("hPzOn"),
    $2da7a3c0ff94457b$var$load("eNmuD"),
    $2da7a3c0ff94457b$var$load("h2MrD"),
    $2da7a3c0ff94457b$var$load("bYT2S"),
    $2da7a3c0ff94457b$var$load("cM9em"),
    $2da7a3c0ff94457b$var$load("fr9NE"),
    $2da7a3c0ff94457b$var$load("1eG9i")
]).then(()=>parcelRequire('9DfkH'));

});


parcelRegister("ibkIl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLayout", () => $3eb51436f6201a33$export$e6aef6083548e882);

var $2BrOV = parcelRequire("2BrOV");

var $aPfsS = parcelRequire("aPfsS");
const $3eb51436f6201a33$export$e6aef6083548e882 = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout));

});
parcelRegister("2BrOV", function(module, exports) {

$parcel$export(module.exports, "globalLayout", () => $6d4ecb0834e594e8$export$929cb72e7acb7fd9);

var $aPfsS = parcelRequire("aPfsS");
const $6d4ecb0834e594e8$var$rightSidebars = ()=>[];
const $6d4ecb0834e594e8$export$929cb72e7acb7fd9 = (0, $aPfsS.createLayout)({
    rightSidebars: $6d4ecb0834e594e8$var$rightSidebars()
});

});
parcelRegister("aPfsS", function(module, exports) {

$parcel$export(module.exports, "coalesce", () => $ba604ddd48a07730$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $ba604ddd48a07730$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $ba604ddd48a07730$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $ba604ddd48a07730$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $ba604ddd48a07730$export$e97a7da67a5b8ce4);

var $5uXOq = parcelRequire("5uXOq");

var $lpwtK = parcelRequire("lpwtK");

var $lfTZh = parcelRequire("lfTZh");

const $ba604ddd48a07730$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $ba604ddd48a07730$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const key = $ba604ddd48a07730$export$6e5538615c060df7(displayName) ?? $ba604ddd48a07730$export$6e5538615c060df7(name) ?? i;
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: key?.toString(),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null)));
    });
const $ba604ddd48a07730$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $ba604ddd48a07730$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $ba604ddd48a07730$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $ba604ddd48a07730$export$3dd437ade36ede40(layout);
};
const $ba604ddd48a07730$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $ba604ddd48a07730$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $ba604ddd48a07730$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $ba604ddd48a07730$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $ba604ddd48a07730$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $lpwtK.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null);
    };
    const name = $ba604ddd48a07730$export$6e5538615c060df7(Component.displayName) ?? $ba604ddd48a07730$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $ba604ddd48a07730$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("lpwtK", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $f3d7644b5666677d$export$51b1383ef8844a7);

var $5uXOq = parcelRequire("5uXOq");

var $bsuuc = parcelRequire("bsuuc");

var $1J3t1 = parcelRequire("1J3t1");
const $f3d7644b5666677d$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarNavigation)(customContext);
    const project = (0, $5uXOq.useMemo)(()=>data && (0, $bsuuc.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("bsuuc", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $36c780ae7e3dc8c8$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $36c780ae7e3dc8c8$export$9df5fa0a366163d2);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");
const $36c780ae7e3dc8c8$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC;
const $36c780ae7e3dc8c8$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $36c780ae7e3dc8c8$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey,
        ...typeof project.isLiveTemplate === 'boolean' && (0, $4R6GH.fg)('jira_custom_templates_ux') && {
            isLiveTemplate: project.isLiveTemplate
        }
    });
const $36c780ae7e3dc8c8$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});

parcelRegister("1J3t1", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $bb292f58b8ec7804$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $bb292f58b8ec7804$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $bb292f58b8ec7804$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $bb292f58b8ec7804$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $bb292f58b8ec7804$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $bb292f58b8ec7804$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $bb292f58b8ec7804$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $bb292f58b8ec7804$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $bb292f58b8ec7804$export$d63d92edebe543d9);

var $5uXOq = parcelRequire("5uXOq");

var $b2pl3 = parcelRequire("b2pl3");

var $6zFAI = parcelRequire("6zFAI");

var $gcI3W = parcelRequire("gcI3W");

var $loy04 = parcelRequire("loy04");

var $ggg5j = parcelRequire("ggg5j");

var $324W5 = parcelRequire("324W5");

var $2YP9W = parcelRequire("2YP9W");

var $727Q1 = parcelRequire("727Q1");
const $bb292f58b8ec7804$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $324W5.useResourceWithCustomRouterContext)((0, $ggg5j.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $5uXOq.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $727Q1.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $bb292f58b8ec7804$export$2bed15cd7d167db5 = ()=>(0, $2YP9W.useResource)((0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$a9d05fc2c1d94895 = ()=>(0, $2YP9W.useResource)((0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$d48e3c3556894533 = ()=>(0, $2YP9W.useResource)((0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$24a781cd863077aa = ()=>(0, $2YP9W.useResource)((0, $b2pl3.staticJSMProjectConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("b2pl3", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $565682b770797f58$export$fab84295e18e9246);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $jAGOQ = parcelRequire("jAGOQ");
const $565682b770797f58$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $565682b770797f58$export$fab84295e18e9246 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$565682b770797f58$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $565682b770797f58$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("6zFAI", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $ee61b377cbb3343f$export$b8c6e2666f12f4bb);
$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only", () => $ee61b377cbb3343f$export$a799c58e7bee6de4);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $1nb22 = parcelRequire("1nb22");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $jAGOQ = parcelRequire("jAGOQ");
const $ee61b377cbb3343f$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $ee61b377cbb3343f$export$b8c6e2666f12f4bb = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$ee61b377cbb3343f$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $ee61b377cbb3343f$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});
const $ee61b377cbb3343f$export$a799c58e7bee6de4 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources')), $ee61b377cbb3343f$export$b8c6e2666f12f4bb);

});

parcelRegister("gcI3W", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $e60f9280597d4f0e$export$b662f3f877add30d);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $jAGOQ = parcelRequire("jAGOQ");
const $e60f9280597d4f0e$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e60f9280597d4f0e$export$b662f3f877add30d = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$e60f9280597d4f0e$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e60f9280597d4f0e$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("ggg5j", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $3ec7290d9b237c27$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $3ec7290d9b237c27$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $3ec7290d9b237c27$export$b692cfadccf4e047);

var $4R6GH = parcelRequire("4R6GH");

var $95bh0 = parcelRequire("95bh0");

var $8YTna = parcelRequire("8YTna");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $gDyED = parcelRequire("gDyED");
const $3ec7290d9b237c27$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === 'servicedesk-boards' || routeName === 'servicedesk-calendar' || query['servicedesk.serviceDeskId'] || (routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-custom-calendar' || routeName === 'servicedesk-queues-practice-custom-board' || routeName === 'servicedesk-queues-practice-custom-calendar' || routeName === 'servicedesk-queues-views-config' || routeName === 'servicedesk-practice-views-config') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) {
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $95bh0.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    const boardId = (0, $8YTna.getBoardId)(match, query);
    return (0, $95bh0.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $3ec7290d9b237c27$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $3ec7290d9b237c27$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $3ec7290d9b237c27$export$f2dfc0f7b2d92691 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    getKey: ({ match: match, query: query, route: { name: name } })=>$3ec7290d9b237c27$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const scopeIdentifier = $3ec7290d9b237c27$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $gDyED.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000
});
const $3ec7290d9b237c27$export$b692cfadccf4e047 = ()=>(0, $2YP9W.useResource)($3ec7290d9b237c27$export$f2dfc0f7b2d92691);

});
parcelRegister("95bh0", function(module, exports) {

$parcel$export(module.exports, "getScopeIdentifier", () => $4cc145d0cf66273c$export$68278f7cf66944f9);

const $4cc145d0cf66273c$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $87844bbe4c23d937$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $87844bbe4c23d937$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $87844bbe4c23d937$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $87844bbe4c23d937$export$b5a308a17bc991f3 = 'projectKey';
const $87844bbe4c23d937$export$929d50f83189406c = 'boardId';
const $87844bbe4c23d937$export$da6f46390e1a426f = 'projectId';


parcelRegister("gDyED", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $b6d61a4c2e3b518c$export$8a51470472777e11);

var $eusud = parcelRequire("eusud");
const $b6d61a4c2e3b518c$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("324W5", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $0c2698427b7aacc1$export$61dad767cf446185);

var $jNUyg = parcelRequire("jNUyg");
var $2YP9W = parcelRequire("2YP9W");

var $geWXd = parcelRequire("geWXd");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $0c2698427b7aacc1$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
function $0c2698427b7aacc1$export$61dad767cf446185(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $jNUyg.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $2YP9W.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $geWXd.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}

});
parcelRegister("geWXd", function(module, exports) {

$parcel$export(module.exports, "usePrefetchableResource", () => $b632b0c18495344b$export$99f17ace416cfe75);

var $5uXOq = parcelRequire("5uXOq");
function $b632b0c18495344b$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("727Q1", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $5300bc04c6e3c00f$export$780174995da89d60);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $ggg5j = parcelRequire("ggg5j");

var $jNUyg = parcelRequire("jNUyg");
var $lODMY = parcelRequire("lODMY");
var $2YP9W = parcelRequire("2YP9W");
const $5300bc04c6e3c00f$export$90dbde7e33e6e21 = ()=>null;
const $5300bc04c6e3c00f$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $jNUyg.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $5300bc04c6e3c00f$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource), {
        routerContext: $5300bc04c6e3c00f$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $5300bc04c6e3c00f$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $jNUyg.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $5300bc04c6e3c00f$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource), {
        routerContext: $5300bc04c6e3c00f$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $5300bc04c6e3c00f$var$useIsOnBoardBasedRoute = (0, $lODMY.createRouterSelector)(({ route: route, query: query, match: match })=>(0, $ggg5j.getIdentifier)(route.name, match, query)?.identifierType === 'boardId');
const $5300bc04c6e3c00f$export$780174995da89d60 = (latestNavInfo)=>{
    const isOnBoardBasedRoute = $5300bc04c6e3c00f$var$useIsOnBoardBasedRoute();
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $5300bc04c6e3c00f$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $5300bc04c6e3c00f$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $5uXOq.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});






parcelRegister("lmyls", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $ee51d260cb059727$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $ee51d260cb059727$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $ee51d260cb059727$export$adf978edbdfaf080);
const $ee51d260cb059727$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $ee51d260cb059727$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};
const $ee51d260cb059727$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    CONTENT: 'CONTENT',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS',
    OPERATIONS_GENERAL_CONFIGURATION: 'OPERATIONS_GENERAL_CONFIGURATION'
};

});

parcelRegister("78U7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f593a4193eb44f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("gvD3C")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar, null)));
var $4f593a4193eb44f7$export$2e2bcd8739ae039 = $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("dZQxE", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $e39fc1e1d73100a0$export$1edc778464f08256);

var $5uXOq = parcelRequire("5uXOq");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $lfTZh = parcelRequire("lfTZh");

var $5Hj3V = parcelRequire("5Hj3V");

var $acDan = parcelRequire("acDan");

var $lGo7j = parcelRequire("lGo7j");
const $e39fc1e1d73100a0$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $acDan.useSidebarFail)();
    const onSuccess = (0, $acDan.useSidebarSuccess)();
    const onError = (0, $5uXOq.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Hj3V.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        })
    }, children));
};

});
parcelRegister("5e7oM", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $83022b592d1d8567$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $83022b592d1d8567$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $83022b592d1d8567$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $83022b592d1d8567$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $83022b592d1d8567$export$1d10ee0c85c3cb21);
const $83022b592d1d8567$export$6635720e40ea7a7a = 'navigation.top';
const $83022b592d1d8567$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $83022b592d1d8567$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $83022b592d1d8567$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $83022b592d1d8567$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});

parcelRegister("azzrO", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", () => $4d07bc740e316cc0$export$8df02628d98cae7e);
$parcel$export(module.exports, "pageSegmentStore", () => $4d07bc740e316cc0$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "useNavPerformanceMetrics", () => $4d07bc740e316cc0$export$906025848d54198d);
$parcel$export(module.exports, "NavTopPerformanceMark", () => $4d07bc740e316cc0$export$b7f4caa65b0906fc);
$parcel$export(module.exports, "NavTopSSRPerformanceMark", () => $4d07bc740e316cc0$export$2c4a101f2cde4fc2);
$parcel$export(module.exports, "NavTopPerformanceReport", () => $4d07bc740e316cc0$export$c64b31449a6177d);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $4d07bc740e316cc0$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarSSRPerformanceMark", () => $4d07bc740e316cc0$export$14f711a2cb6a655a);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $4d07bc740e316cc0$export$a018e347341b3640);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $dGrdR = parcelRequire("dGrdR");

var $cfDZ3 = parcelRequire("cfDZ3");

var $5M3R9 = parcelRequire("5M3R9");

var $4R6GH = parcelRequire("4R6GH");

var $5e7oM = parcelRequire("5e7oM");

const $4d07bc740e316cc0$var$createTopNavPageSegment = ()=>(0, $dGrdR.metrics).pageSegmentLoad({
        key: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $4d07bc740e316cc0$export$8df02628d98cae7e = {
    ADDONS: (0, $dGrdR.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $4d07bc740e316cc0$var$createSidebarPageSegment = ()=>(0, $dGrdR.metrics).pageSegmentLoad({
        key: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $4d07bc740e316cc0$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createTopNavPageSegment,
        [(0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $4d07bc740e316cc0$export$906025848d54198d = (segmentKey = (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $5uXOq.useRef)(false);
    const segment = (0, $5uXOq.useRef)($4d07bc740e316cc0$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $5uXOq.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $5e7oM.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $5M3R9.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $4d07bc740e316cc0$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    (0, $5uXOq.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $4d07bc740e316cc0$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const tmpSsrMetricKey = `${(0, $5e7oM.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>navSegment.markSSR(metricKey), []);
    // All occurrences of this are redundant and importantly, super annoying in the perf portal waterfall (sidebar + app_navigation). Making start&end marks all "end" type means they all get reported as timers that start at 0. Instead of... you know... setting the mark type appropriately.
    return false && !(0, $4R6GH.fg)('jira-ssr-perf-portal-cleanup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "end",
        traceKey: tmpSsrMetricKey
    }) : null;
};
const $4d07bc740e316cc0$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    (0, $5uXOq.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $cfDZ3.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4d07bc740e316cc0$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$2c4a101f2cde4fc2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$14f711a2cb6a655a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("5M3R9", function(module, exports) {

$parcel$export(module.exports, "RenderTracerMark", () => $ca67b9a5090b457c$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $ca67b9a5090b457c$export$345f21b0287f67e5);

var $5uXOq = parcelRequire("5uXOq");

var $6Csk1 = parcelRequire("6Csk1");

var $9XE6b = parcelRequire("9XE6b");

var $jR67t = parcelRequire("jR67t");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

const $ca67b9a5090b457c$var$initialState = {
    start: undefined,
    traces: {}
};
let $ca67b9a5090b457c$var$currentTraces = {};
const $ca67b9a5090b457c$export$2365ecd8218e21c7 = ()=>$ca67b9a5090b457c$var$currentTraces;
const $ca67b9a5090b457c$export$5c757eaa1990d0d7 = (key)=>{
    if ($ca67b9a5090b457c$var$currentTraces[key]) return;
    $ca67b9a5090b457c$var$currentTraces[key] = {
        startTime: (0, $jR67t.performance).now()
    };
};
const $ca67b9a5090b457c$export$16854dc18f8d976 = (key)=>{
    if (!$ca67b9a5090b457c$var$currentTraces[key] || $ca67b9a5090b457c$var$currentTraces[key].duration != null) return;
    $ca67b9a5090b457c$var$currentTraces[key].duration = (0, $jR67t.performance).now() - $ca67b9a5090b457c$var$currentTraces[key].startTime;
};
const $ca67b9a5090b457c$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $ca67b9a5090b457c$var$currentTraces = Object.assign($ca67b9a5090b457c$var$currentTraces, getState().traces);
        }
};
const $ca67b9a5090b457c$var$Store = (0, $iXqE5.createStore)({
    name: 'jira-render-tracer',
    initialState: $ca67b9a5090b457c$var$initialState,
    actions: $ca67b9a5090b457c$var$actions
});
const $ca67b9a5090b457c$var$RenderTracerActions = (0, $51nlc.createSubscriber)($ca67b9a5090b457c$var$Store, {
    selector: null
});
const $ca67b9a5090b457c$export$719a95758870be58 = (0, $3sQ5x.createHook)($ca67b9a5090b457c$var$Store, {
    selector: null
});
const $ca67b9a5090b457c$var$RenderTracerContainerBase = (0, $gg7kZ.createContainer)($ca67b9a5090b457c$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $jR67t.performance).now()
                    }
                }
            });
        }
});
const $ca67b9a5090b457c$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $ca67b9a5090b457c$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $jR67t.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $jR67t.performance).now());
        return null;
    });
const $ca67b9a5090b457c$export$cba8addc8743389c = (appName = 'unknown', traces = $ca67b9a5090b457c$var$currentTraces)=>({
        [(0, $eb0760a6ada94ab6$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $ca67b9a5090b457c$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $eb0760a6ada94ab6$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("jR67t", function(module, exports) {

$parcel$export(module.exports, "performance", () => $c026bc7061377d6e$export$f2d2284f5fec51f8);
const $c026bc7061377d6e$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $c026bc7061377d6e$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $c026bc7061377d6e$var$now();
    }
    now() {
        if (false) return $c026bc7061377d6e$var$now() - this.startAt;
        return $c026bc7061377d6e$var$now();
    }
    constructor(){
        this.startAt = $c026bc7061377d6e$var$now();
    }
}
const $c026bc7061377d6e$export$f2d2284f5fec51f8 = new $c026bc7061377d6e$export$9a0dbed22cbf63be();

});

const $eb0760a6ada94ab6$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';



parcelRegister("5Hj3V", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $c3958cf153a091e2$export$62853c5766dad0c4);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $kqzba = parcelRequire("kqzba");
const $c3958cf153a091e2$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const extraEventData = (0, $5uXOq.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $5uXOq.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqzba.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("kqzba", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $790c5d1c3d335eca$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $kobfu = parcelRequire("kobfu");

var $koVbs = parcelRequire("koVbs");

var $evbHg = parcelRequire("evbHg");

var $h8OaL = parcelRequire("h8OaL");
const $790c5d1c3d335eca$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rko9j3y _11c8dcr7 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $790c5d1c3d335eca$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($evbHg))),
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $h8OaL.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $h8OaL.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.error
        ])
    }, "ERROR: ", (0, $kobfu.getErrorHash)(error)));
};

});
parcelRegister("evbHg", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("h8OaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c8a71ff5065c1e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7c8a71ff5065c1e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("acDan", function(module, exports) {

$parcel$export(module.exports, "SidebarStart", () => $b5a3a4467dac2130$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarRenderStart", () => $b5a3a4467dac2130$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b5a3a4467dac2130$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b5a3a4467dac2130$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b5a3a4467dac2130$export$ddb17534fdfb7dc6);

var $5uXOq = parcelRequire("5uXOq");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $4QcD9 = parcelRequire("4QcD9");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6IzHB = parcelRequire("6IzHB");

var $doZTA = parcelRequire("doZTA");

var $kvHKs = parcelRequire("kvHKs");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b5a3a4467dac2130$var$useSidebarId } = (0, $4QcD9.createValueController)('sidebar-id');
const $b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $kvHKs.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b5a3a4467dac2130$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $doZTA.useRouter)();
    const pageId = (0, $6IzHB.usePageId)();
    const startRef = (0, $5uXOq.useRef)(Date.now());
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $kvHKs.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $5uXOq.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b5a3a4467dac2130$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b5a3a4467dac2130$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b5a3a4467dac2130$var$useSidebarId();
    const route = (0, $6jY6G.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $3bQtK.useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $5uXOq.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $5uXOq.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b5a3a4467dac2130$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $kvHKs.SIDEBAR_EXPERIENCE)
    });
    return (0, $5uXOq.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b5a3a4467dac2130$export$ddb17534fdfb7dc6 = ()=>(0, $3bQtK.useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("93jKl", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $e2626e1ab0692489$export$606da7704d8eaf06);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $bCf8q = parcelRequire("bCf8q");

var $j8DrX = parcelRequire("j8DrX");

var $l9g16 = parcelRequire("l9g16");
const $e2626e1ab0692489$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $bCf8q.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $fZneA.isClientFetchError)(error)) return;
        const shardAndRegionAttributes = {
            shard: (0, $j8DrX.default)('ajs-shard'),
            region: (0, $j8DrX.default)('ajs-region')
        };
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("l9g16", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $79f23c22d88dd8d5$export$be8ec22ac9208049);

var $5uXOq = parcelRequire("5uXOq");

var $bSOOm = parcelRequire("bSOOm");
const $79f23c22d88dd8d5$export$be8ec22ac9208049 = ()=>{
    const context = (0, $5uXOq.useContext)((0, $bSOOm.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("kaHBi", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $e1187df33c58b997$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $e1187df33c58b997$export$f20b867e738a222c);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $l9g16 = parcelRequire("l9g16");
const $e1187df33c58b997$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $5uXOq.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $5uXOq.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $e1187df33c58b997$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $e1187df33c58b997$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $5uXOq.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});
parcelRegister("6jY6G", function(module, exports) {

$parcel$export(module.exports, "useCurrentRoute", () => $dda4cada2257eb1d$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $dda4cada2257eb1d$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $dda4cada2257eb1d$export$1e5fb68306bd0b92);

var $lODMY = parcelRequire("lODMY");
var $doZTA = parcelRequire("doZTA");

var $cfDZ3 = parcelRequire("cfDZ3");

const $dda4cada2257eb1d$export$c4b7ea2942f2d0e = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $dda4cada2257eb1d$export$d69a946e2d0a1c12 = (0, $lODMY.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $dda4cada2257eb1d$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $dda4cada2257eb1d$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $doZTA.useRouter)();
    return (0, $cfDZ3.getPreviousRouterState)();
};

});


parcelRegister("3bQtK", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $f46ca4b214d7cdb6$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $f46ca4b214d7cdb6$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $j8DrX = parcelRequire("j8DrX");

var $l9g16 = parcelRequire("l9g16");
const $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT = {};
const $f46ca4b214d7cdb6$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const self = (0, $5uXOq.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $5uXOq.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        const shardAndRegionAttributes = {
            shard: (0, $j8DrX.default)('ajs-shard'),
            region: (0, $j8DrX.default)('ajs-region')
        };
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes
            }
        });
    }, [
        self
    ]);
};
const $f46ca4b214d7cdb6$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $f46ca4b214d7cdb6$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("4QcD9", function(module, exports) {

$parcel$export(module.exports, "createValueController", () => $3f293f209341d999$export$ff0ab9dd4ceb4a93);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $3f293f209341d999$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $iXqE5.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $gg7kZ.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $3sQ5x.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("6IzHB", function(module, exports) {

$parcel$export(module.exports, "usePageId", () => $57184c749af08735$export$3434ba5eadb360dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $7w9eZ = parcelRequire("7w9eZ");
const $57184c749af08735$var$useSweetStatePageId = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: (state)=>state.currentPage.uuid
});
const $57184c749af08735$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $57184c749af08735$var$useSweetStatePageId();
    return pageId;
};

});

parcelRegister("kvHKs", function(module, exports) {

$parcel$export(module.exports, "REPO_TYPE", () => $f1419662a60c783a$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $f1419662a60c783a$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $f1419662a60c783a$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $f1419662a60c783a$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $f1419662a60c783a$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $f1419662a60c783a$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $f1419662a60c783a$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $f1419662a60c783a$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $f1419662a60c783a$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $f1419662a60c783a$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $f1419662a60c783a$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $f1419662a60c783a$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $f1419662a60c783a$export$f57650e6e7be03dc);
const $f1419662a60c783a$export$399c7e6858236b4 = 'source.code.link';
const $f1419662a60c783a$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $f1419662a60c783a$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $f1419662a60c783a$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $f1419662a60c783a$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $f1419662a60c783a$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $f1419662a60c783a$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $f1419662a60c783a$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $f1419662a60c783a$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $f1419662a60c783a$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $f1419662a60c783a$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $f1419662a60c783a$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $f1419662a60c783a$export$dde074e512e80dff = 'global-create-spotlight';
const $f1419662a60c783a$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $f1419662a60c783a$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $f1419662a60c783a$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
];

});


parcelRegister("lGo7j", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $0c703bf4651638aa$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");
const $0c703bf4651638aa$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c703bf4651638aa$var$BackgroundedWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tem _ca0qidpf _u5f31ejb _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $0c703bf4651638aa$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41k9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gjTBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab78cae21894a64c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $jsTfk = parcelRequire("jsTfk");

var $j9VTE = parcelRequire("j9VTE");
// Type needed on props to extract types with extract react types.
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $ab78cae21894a64c$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        overrides: {
            HeadingItem: {
                cssFn: (0, $jsTfk.sectionHeaderSpacingStyles)
            }
        }
    });
});
var $ab78cae21894a64c$export$2e2bcd8739ae039 = $ab78cae21894a64c$var$Section;

});
parcelRegister("jsTfk", function(module, exports) {

$parcel$export(module.exports, "overrideStyleFunction", () => $0d8b3d5d608d86de$export$505cedac1a39aacf);
$parcel$export(module.exports, "baseSideNavItemStyle", () => $0d8b3d5d608d86de$export$aed216a85ec468ac);
$parcel$export(module.exports, "sectionHeaderSpacingStyles", () => $0d8b3d5d608d86de$export$a5c27bed78cfecb9);

const $0d8b3d5d608d86de$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
    return (state)=>{
        return [
            baseStyle(state),
            newStyle(state)
        ];
    };
};
const $0d8b3d5d608d86de$var$defaultStyles = {
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
    },
    '&:active': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`
    }
};
const $0d8b3d5d608d86de$var$selectedStyles = {
    backgroundColor: `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    ':visited': {
        color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    }
};
const $0d8b3d5d608d86de$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
    return {
        // This padding is set to ensure that the center of the left icon
        // is approximately center aligned with the horizontal app switcher.
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-100, 8px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        // -- TODO: DELETE THESE COLOR OVERRIDES WHEN CLEANING UP FALLBACK THEMING --
        // Menu and side navigation are now color aligned so they do not need this!
        // See: https://product-fabric.atlassian.net/browse/DSP-1684
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        ...!isDisabled && !isSelected && $0d8b3d5d608d86de$var$defaultStyles,
        ...!isDisabled && isSelected && $0d8b3d5d608d86de$var$selectedStyles,
        // -- END TODO --------------------------------------------------------------
        ['& [data-item-elem-before]']: {
            height: '1.5rem',
            width: '1.5rem'
        }
    };
};
const $0d8b3d5d608d86de$export$a5c27bed78cfecb9 = ()=>{
    return {
        paddingInline: "var(--ds-space-100, 8px)"
    };
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("bWqXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c4e822429ecf69c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");

var $jsTfk = parcelRequire("jsTfk");

var $j9VTE = parcelRequire("j9VTE");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $9c4e822429ecf69c$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        cssFn: ()=>({
                ...(0, $jsTfk.sectionHeaderSpacingStyles)(),
                // This doubles up & to get a higher specificity as well as to not overwite the base styles.
                '&&::before': {
                    height: '1.5rem',
                    marginRight: "var(--ds-space-200, 16px)",
                    width: '1.5rem'
                }
            }),
        ...props
    });
};
var $9c4e822429ecf69c$export$2e2bcd8739ae039 = $9c4e822429ecf69c$var$SkeletonItem;

});



parcelRegister("gbGmI", function(module, exports) {

$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $46c186c6902de7dc$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $46c186c6902de7dc$export$edbd543f308bbef5);

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");
const $46c186c6902de7dc$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $azzrO.pageSegmentStore).getSegment((0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $46c186c6902de7dc$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $azzrO.pageSegmentStore).getSegment((0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("gvD3C", function(module, exports) {

let $c04dd68f01cda7c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c04dd68f01cda7c0$var$load("jkFzD").then(()=>parcelRequire('dZptX'));

});


parcelRegister("7NszV", function(module, exports) {

$parcel$export(module.exports, "createEntry", () => $82f1a9156abf3836$export$344b9c9ab5e66c9a);

var $hwKYN = parcelRequire("hwKYN");
const $82f1a9156abf3836$export$344b9c9ab5e66c9a = (0, $hwKYN.createRouteEntry);

});
parcelRegister("hwKYN", function(module, exports) {

$parcel$export(module.exports, "createRouteEntry", () => $d530719601daee4d$export$136cc45b1cabb43);
/**
 * Create route entry with entrypoint, resources, etc. override
 *
 * @param baseRoute Base route object that contains matching info
 * @param opts Route definition to fill and override
 */ function $d530719601daee4d$export$136cc45b1cabb43(baseRoute, opts) {
    // @ts-expect-error Re-using baseRoute to become the full route Object allows us to optimize
    // route transitions as RRR can directly use the route instead of comparing a separate InvariantRoute
    // against the full route list
    // eslint-disable-next-line no-param-reassign
    baseRoute.lazyOpts = opts;
    // @ts-expect-error TODO
    return baseRoute;
}

});


parcelRegister("gB79g", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $7a11591dcb8250ae$export$4f2c2d125c2b811a);
const $7a11591dcb8250ae$export$4f2c2d125c2b811a = {
    name: 'global-settings-issues-explicit-field-association-project-list',
    path: '/jira/settings/issues/explicit-field-association'
};

});

parcelRegister("aYyVm", function(module, exports) {

$parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", () => $95736e1c9d4aba6e$export$7b11685155ada84d);
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", () => $95736e1c9d4aba6e$export$e81c180c4f4833e);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $95736e1c9d4aba6e$export$7b11685155ada84d = (0, $kxZPA.lazyForPaint)(()=>{
    return (0, $7yO8g.markAsProductBundleReady)((parcelRequire("lNJzs")).then((bundle)=>bundle.ExplicitFieldAssociationProjectListApp));
}, {
    moduleId: "./src/packages/admin-pages/explicit-field-association/project-list/src/index.tsx"
});
const $95736e1c9d4aba6e$export$e81c180c4f4833e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $95736e1c9d4aba6e$export$7b11685155ada84d,
        pageId: "jira-admin-pages-explicit-field-association-project-list",
        shouldShowSpinner: true
    });

});
parcelRegister("7yO8g", function(module, exports) {

$parcel$export(module.exports, "markAsProductBundleReady", () => $beda9c6123873bbb$export$ff83c57004505abd);

var $2SVPM = parcelRequire("2SVPM");
const $beda9c6123873bbb$export$ff83c57004505abd = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        (0, $2SVPM.setProductBundleReadyForInitialRender)();
    });
    return importedBundle;
};

});

parcelRegister("5j7Th", function(module, exports) {

$parcel$export(module.exports, "LazyPage", () => $63937a96c08aaddb$export$a18c9c3dd309b8e6);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $2YZCu = parcelRequire("2YZCu");

var $lfTZh = parcelRequire("lfTZh");

var $6jY6G = parcelRequire("6jY6G");

var $7LpuY = parcelRequire("7LpuY");

var $dZw8H = parcelRequire("dZw8H");

var $4R6GH = parcelRequire("4R6GH");

var $egPYN = parcelRequire("egPYN");
const $63937a96c08aaddb$var$LOCATION = 'lazy-page';
const $63937a96c08aaddb$export$fb85bbdbfb3e6869 = ()=>null;
const $63937a96c08aaddb$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $kb4zh.default) : $63937a96c08aaddb$export$fb85bbdbfb3e6869);
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) (0, $2YZCu.default).safeWarnWithoutCustomerData($63937a96c08aaddb$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const fallback = (0, $4R6GH.fg)('jfp_magma_jira-ssr-fail-detection') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egPYN.ReportSSRFailOnUse), {
        pageId: pageId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null);
    const page = (0, $4R6GH.fg)('jfp_magma_jira-ssr-fail-detection') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egPYN.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null);
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LpuY.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy_page",
        fallback: fallback
    }, page)));
};

});
parcelRegister("kb4zh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26967b2e10d397c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");

var $eZJjh = parcelRequire("eZJjh");
function $c26967b2e10d397c$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large",
        testId: testId
    }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c26967b2e10d397c$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $c26967b2e10d397c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7LpuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c62dfc18679e80c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");

var $5h5Fg = parcelRequire("5h5Fg");

var $7N30e = parcelRequire("7N30e");

var $6b6Tk = parcelRequire("6b6Tk");


var $8Qrwl = parcelRequire("8Qrwl");

var $hXKq5 = parcelRequire("hXKq5");
class $6c62dfc18679e80c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Qrwl.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args), this.customMarks = [], this.onStart = ()=>{
            (0, $kUU4G.default)((0, $ce556f125dee8174$export$56940a9488e85199));
            (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$45c4b6bf7935c69a));
        }, this.onCustomMark = (markName)=>{
            (0, $x9xyg.setMark)((0, $hXKq5.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
        };
    }
}

});
parcelRegister("kUU4G", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb4d2f8b5a69f79$export$2e2bcd8739ae039);

var $6RCeq = parcelRequire("6RCeq");
var /*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6cb4d2f8b5a69f79$export$2e2bcd8739ae039 = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $6RCeq.default) && (0, $6RCeq.default).getEntries && (0, $6RCeq.default).clearMarks) return (0, $6RCeq.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $6RCeq.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};

});

parcelRegister("5h5Fg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec2154d63d4be857$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
// eslint-disable-next-line jira/react/no-class-components
class $ec2154d63d4be857$var$OpTrigger extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $ec2154d63d4be857$export$2e2bcd8739ae039 = $ec2154d63d4be857$var$OpTrigger;

});

parcelRegister("7N30e", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $5d68e3874efadecb$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $5d68e3874efadecb$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $5d68e3874efadecb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");

var $3vBBc = parcelRequire("3vBBc");

var $fjcgS = parcelRequire("fjcgS");

var $lsa9q = parcelRequire("lsa9q");

var $6b6Tk = parcelRequire("6b6Tk");

const $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT = 10000;
let $5d68e3874efadecb$var$stopDelayTimeout;
let $5d68e3874efadecb$var$lastDelayActionPromise = (0, $fjcgS.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $5d68e3874efadecb$export$a928755af449867 = ()=>{
    $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $3vBBc.isEventDelayActive)()) return client;
        clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $x9xyg.setMark)((0, $2eb1df3f82c48b0d$export$2d91d3eed1108e72));
        (0, $3vBBc.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $5d68e3874efadecb$export$8bb8df5a93e9525 = ()=>{
    $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $3vBBc.isEventDelayActive)()) {
            (0, $kUU4G.default)((0, $2eb1df3f82c48b0d$export$358721a9d6125914));
            (0, $x9xyg.setMark)((0, $2eb1df3f82c48b0d$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $3vBBc.setEventDelayActive)(true);
        clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
        $5d68e3874efadecb$var$stopDelayTimeout = setTimeout($5d68e3874efadecb$export$a928755af449867, $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $5d68e3874efadecb$export$778ebe2a4fab1ba7 = ()=>$5d68e3874efadecb$var$lastDelayActionPromise;
const $5d68e3874efadecb$var$EventDelayController = ()=>{
    const [loadedState] = (0, $lsa9q.default)();
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) $5d68e3874efadecb$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $5d68e3874efadecb$export$2e2bcd8739ae039 = $5d68e3874efadecb$var$EventDelayController;

});
parcelRegister("3vBBc", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $63f3b8c0745d0500$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $63f3b8c0745d0500$export$3536b0184fa98d19);
let $63f3b8c0745d0500$var$eventDelayActive = false;
const $63f3b8c0745d0500$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $63f3b8c0745d0500$var$eventDelayActive = isEventDelayActive;
};
const $63f3b8c0745d0500$export$3536b0184fa98d19 = ()=>$63f3b8c0745d0500$var$eventDelayActive;

});

parcelRegister("lsa9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f20cb56a66aca22$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");


var $7w9eZ = parcelRequire("7w9eZ");
const $4f20cb56a66aca22$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $146ecce9d079a34d$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $146ecce9d079a34d$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $4f20cb56a66aca22$var$usePageLoadedSubscriber = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $4f20cb56a66aca22$export$4a361c7505f72f5c
});
var $4f20cb56a66aca22$export$2e2bcd8739ae039 = $4f20cb56a66aca22$var$usePageLoadedSubscriber;

});
const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';


const $2eb1df3f82c48b0d$export$358721a9d6125914 = 'event-delay-controller.';
const $2eb1df3f82c48b0d$export$b2122dce85a27912 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}start`;
const $2eb1df3f82c48b0d$export$2d91d3eed1108e72 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}end`;


const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("8Qrwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87d05828c384551$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d87d05828c384551$var$contextName = 'SpaApdexAnalytics';
var $d87d05828c384551$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.createContext)($d87d05828c384551$var$contextName);

});

parcelRegister("hXKq5", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $f6cddc52a08e036c$export$c8f0e9837e7e9425);

const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;

});


parcelRegister("dZw8H", function(module, exports) {

$parcel$export(module.exports, "SpaStateContainer", () => $b1cd152eb196251c$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $b1cd152eb196251c$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $b1cd152eb196251c$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $b1cd152eb196251c$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $b1cd152eb196251c$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $b1cd152eb196251c$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $b1cd152eb196251c$export$6e9ab893e97cccef);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $lODMY = parcelRequire("lODMY");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $bKpgX = parcelRequire("bKpgX");

var $4oDnX = parcelRequire("4oDnX");

var $7w9eZ = parcelRequire("7w9eZ");
const $b1cd152eb196251c$export$e9a92b877fe80e80 = (0, $gg7kZ.createContainer)((0, $7w9eZ.default));
const $b1cd152eb196251c$export$d18dd27183a635c = ()=>{
    const startRef = (0, $5uXOq.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $4oDnX.useSpaState)();
    (0, $5uXOq.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $b1cd152eb196251c$var$useRouterMatchSelector = (0, $lODMY.createRouterSelector)((state)=>state.match);
const $b1cd152eb196251c$var$useSpaStatePagesCount = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $b1cd152eb196251c$export$95a2912d76fb5433 = ()=>{
    const match = $b1cd152eb196251c$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $b1cd152eb196251c$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1cd152eb196251c$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
const $b1cd152eb196251c$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady
        }));
const $b1cd152eb196251c$export$41e70078eeddaddc = ({ comparer: comparer } /* TODO - this should be using only the actions subscriber not state+actions subscriber */ )=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady,
            args: comparer
        }));
const $b1cd152eb196251c$export$2583aa269898885c = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppErrorReady
        }));
class $b1cd152eb196251c$export$ada7e0ec445851a2 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $b1cd152eb196251c$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $bKpgX.defaultRegistry).getStore((0, $7w9eZ.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});

parcelRegister("egPYN", function(module, exports) {

$parcel$export(module.exports, "ReportSSRFailOnUse", () => $a8140c02a0336fa9$export$daa3f09a96683b19);
$parcel$export(module.exports, "DisableSSRFailDetection", () => $a8140c02a0336fa9$export$420f5a45dbda6a67);

var $5uXOq = parcelRequire("5uXOq");
const $a8140c02a0336fa9$export$daa3f09a96683b19 = ()=>{
    // this component does nothing. Its .server. version does
    return null;
};
const $a8140c02a0336fa9$export$420f5a45dbda6a67 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});


parcelRegister("lNJzs", function(module, exports) {

let $fdf185fc6440a040$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fdf185fc6440a040$var$load("eNmuD"),
    $fdf185fc6440a040$var$load("cM9em"),
    $fdf185fc6440a040$var$load("fr9NE"),
    $fdf185fc6440a040$var$load("h2MrD"),
    $fdf185fc6440a040$var$load("bYT2S"),
    $fdf185fc6440a040$var$load("3r4bl")
]).then(()=>parcelRequire('61Yus'));

});



parcelRegister("4kR3A", function(module, exports) {

$parcel$export(module.exports, "addonsEmceePublicRouteEntry", () => $d1782f93dd23769d$export$7922e0b87a833c8e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $cZzAp = parcelRequire("cZzAp");
const $d1782f93dd23769d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).ADDONS
});
const $d1782f93dd23769d$export$7922e0b87a833c8e = (0, $aTZGy.createLegacyEntry)((0, $cZzAp.addonsEmceePublicRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)()
        ],
        entryPoint: ()=>$d1782f93dd23769d$var$pageEntryPoint
    }));

});
parcelRegister("1apF5", function(module, exports) {

$parcel$export(module.exports, "legacyPageEntrypoint", () => $e235b0a3ce205ec4$export$940b6ffb7ea59cb);

var $fEDBv = parcelRequire("fEDBv");

var $eufEc = parcelRequire("eufEc");

const $e235b0a3ce205ec4$export$940b6ffb7ea59cb = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9SwxI")), {
        moduleId: "f7508cc9"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9SwxI", function(module, exports) {

let $7312668c27d1537a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7312668c27d1537a$var$load("4hv23").then(()=>parcelRequire('d2PGZ'));

});


parcelRegister("lkFvK", function(module, exports) {

$parcel$export(module.exports, "createChromelessEntryPoint", () => $6a0b20679c309df7$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $6a0b20679c309df7$export$955a7619d2679b4c);

var $adY3A = parcelRequire("adY3A");


var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");
const $6a0b20679c309df7$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $6a0b20679c309df7$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $adY3A.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.leftSidebar && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $6a0b20679c309df7$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false,
                                isOverviewsExpanded: page.leftSidebar.isOverviewsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.horizontalNavigation && (0, $3HwlS.getWillShowNav4)() ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $6a0b20679c309df7$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
parcelRegister("adY3A", function(module, exports) {

$parcel$export(module.exports, "topNavigationEntryPoint", () => $e6a45c27809ae082$export$f780be9e138f456f);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $e6a45c27809ae082$export$f780be9e138f456f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3V1dy")), {
        moduleId: "1f1265b4"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps
        })
});

});

const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';


parcelRegister("iHiHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $883820dc444dc59c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("gZExY")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $883820dc444dc59c$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar, null)));
$883820dc444dc59c$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $883820dc444dc59c$export$2e2bcd8739ae039 = $883820dc444dc59c$var$GlobalAppsSettingsSidebar;

});
parcelRegister("gZExY", function(module, exports) {

let $c5f1cba21c0a420f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c5f1cba21c0a420f$var$load("h2MrD"),
    $c5f1cba21c0a420f$var$load("bYT2S"),
    $c5f1cba21c0a420f$var$load("cM9em"),
    $c5f1cba21c0a420f$var$load("fr9NE"),
    $c5f1cba21c0a420f$var$load("3EO4A")
]).then(()=>parcelRequire('kO26e'));

});


parcelRegister("aTZGy", function(module, exports) {

$parcel$export(module.exports, "createLegacyEntry", () => $ec6e0d574e40e963$export$3ee7de8548f88c5f);

var $hwKYN = parcelRequire("hwKYN");
const $ec6e0d574e40e963$export$3ee7de8548f88c5f = (0, $hwKYN.createRouteEntry);

});

parcelRegister("cZzAp", function(module, exports) {

$parcel$export(module.exports, "addonsEmceePublicRoute", () => $914a4a2978c69252$export$9f7bcf70c66ebed0);
const $914a4a2978c69252$export$9f7bcf70c66ebed0 = {
    name: 'addons-emcee-public',
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee/enduser-discover'
};

});


parcelRegister("44po0", function(module, exports) {

$parcel$export(module.exports, "legacyAllReportsRouteEntry", () => $821475acb98fe01c$export$b8ab848c3f170ed4);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2lXzr = parcelRequire("2lXzr");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $1apF5 = parcelRequire("1apF5");

var $9dKjw = parcelRequire("9dKjw");
const $821475acb98fe01c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $821475acb98fe01c$export$b8ab848c3f170ed4 = (0, $aTZGy.createLegacyEntry)((0, $2lXzr.legacyAllReportsRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9dKjw.getReportsCommonResource)()
        ],
        entryPoint: ()=>$821475acb98fe01c$var$pageEntryPoint
    }));

});
parcelRegister("gyYxw", function(module, exports) {

$parcel$export(module.exports, "genericProjectLayout", () => $177735c975452188$export$85dad8e9886563f6);

var $18N1t = parcelRequire("18N1t");

var $aPfsS = parcelRequire("aPfsS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e7bC3 = parcelRequire("e7bC3");

var $9Y3Lc = parcelRequire("9Y3Lc");
const $177735c975452188$export$85dad8e9886563f6 = (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $18N1t.coreProjectLayout), (0, $6Z2mh.serviceProjectLayout), (0, $e7bC3.softwareProjectLayout), (0, $9Y3Lc.userBoardLayout));

});
parcelRegister("18N1t", function(module, exports) {

$parcel$export(module.exports, "coreProjectLayout", () => $32b20434a17da609$export$3c06ced9943ca671);

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");
const $32b20434a17da609$export$3c06ced9943ca671 = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));

});
parcelRegister("1Du13", function(module, exports) {

$parcel$export(module.exports, "projectLayout", () => $08491b76212b7395$export$204149bac601d20c);

var $fpzhz = parcelRequire("fpzhz");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $hMrxB = parcelRequire("hMrxB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $08491b76212b7395$var$withAnyProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $08491b76212b7395$var$ProjectTrackers = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("bcZY0")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $08491b76212b7395$var$ProjectFavicon = ()=>{
    (0, $hMrxB.useProjectFavicon)();
    return null;
};
const $08491b76212b7395$var$rightSidebars = ()=>[];
const $08491b76212b7395$var$globalComponents = [
    $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectFavicon),
    $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectTrackers),
    $08491b76212b7395$var$withAnyProjectContext((0, $fpzhz.ProjectRouteListener))
];
const $08491b76212b7395$export$204149bac601d20c = (0, $aPfsS.createLayout)({
    globalComponents: $08491b76212b7395$var$globalComponents,
    rightSidebars: $08491b76212b7395$var$rightSidebars()
});

});
parcelRegister("fpzhz", function(module, exports) {

$parcel$export(module.exports, "ProjectRouteListener", () => $a96b9050ddfb05f9$export$159f09d701320911);

var $5uXOq = parcelRequire("5uXOq");

var $dxCvy = parcelRequire("dxCvy");

var $itmJb = parcelRequire("itmJb");

var $2YP9W = parcelRequire("2YP9W");

var $hVf1M = parcelRequire("hVf1M");
const $a96b9050ddfb05f9$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $itmJb.useIsAdmin)();
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    (0, $5uXOq.useEffect)(()=>{
        if (isSiteAdmin) (0, $hVf1M.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $hVf1M.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $hVf1M.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $5uXOq.useEffect)(()=>()=>(0, $hVf1M.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});
parcelRegister("itmJb", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca);

var $9OXo1 = parcelRequire("9OXo1");
const $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});


parcelRegister("hMrxB", function(module, exports) {

$parcel$export(module.exports, "useProjectFavicon", () => $6ee68e956a566e2d$export$32abcb1f939de016);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");

var $lpwtK = parcelRequire("lpwtK");

var $4R6GH = parcelRequire("4R6GH");
const $6ee68e956a566e2d$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $5uXOq.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const enabled = (0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-favicon-use-projecticon') === 'true', []);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('blu-7193-new-jira-favicons')) {
            const favicon = project ? project.avatarUrl : defaultFavicon;
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
            // Switch back to default favicon
            return ()=>{
                if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
            };
        }
    }, [
        project,
        iconEle,
        defaultFavicon,
        enabled
    ]);
};

});

parcelRegister("bcZY0", function(module, exports) {

let $8290e2012e5cbb8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8290e2012e5cbb8e$var$load("gw9ua").then(()=>parcelRequire('8DuT4'));

});



parcelRegister("6Z2mh", function(module, exports) {

$parcel$export(module.exports, "serviceProjectLayout", () => $0836cf39cca1e468$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $0836cf39cca1e468$export$820f9bb834280408);

var $2vSU6 = parcelRequire("2vSU6");

var $2BrOV = parcelRequire("2BrOV");

var $i90UH = parcelRequire("i90UH");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $ln7rs = parcelRequire("ln7rs");

var $kxZPA = parcelRequire("kxZPA");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0836cf39cca1e468$var$withServiceProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$ProjectBuilder = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("9RzoX")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("j1Nx6")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("juLka")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $0836cf39cca1e468$export$e321cb31c875d1ba = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout), {
    globalComponents: [
        $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$Onboarding),
        ...(0, $ln7rs.serviceProjectFirstImpressionsLayout).globalComponents.map($0836cf39cca1e468$var$withServiceProjectContext),
        $0836cf39cca1e468$var$withServiceProjectContext((0, $i90UH.AsyncJsmCustomDomainChangeBoardingFlag)),
        $0836cf39cca1e468$var$ProjectBuilder
    ],
    rightSidebars: [
        $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$RightSidebars),
        ...(0, $ln7rs.serviceProjectFirstImpressionsLayout).rightSidebars.map($0836cf39cca1e468$var$withServiceProjectContext)
    ]
});
const $0836cf39cca1e468$export$820f9bb834280408 = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    rightSidebars: [
        $0836cf39cca1e468$var$RightSidebars
    ]
});

});
parcelRegister("i90UH", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $3ba5f01428db990d$export$b1ef5e3da6e1959d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $kxZPA.lazy)(()=>(parcelRequire("66ybD")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $3ba5f01428db990d$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("66ybD", function(module, exports) {

let $471dd26449881dff$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $471dd26449881dff$var$load("h2MrD"),
    $471dd26449881dff$var$load("bYT2S"),
    $471dd26449881dff$var$load("fgCot")
]).then(()=>parcelRequire('9d42Z'));

});


parcelRegister("ln7rs", function(module, exports) {

$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $f6f2168537ade4c7$export$2562b2d784eadc10);

var $5uXOq = parcelRequire("5uXOq");

var $ctjgZ = parcelRequire("ctjgZ");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");
const $f6f2168537ade4c7$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctjgZ.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null));
    const name = (0, $aPfsS.coalesce)(Component.displayName) ?? (0, $aPfsS.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f6f2168537ade4c7$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("bcw12")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f6f2168537ade4c7$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("4Ua47")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $f6f2168537ade4c7$export$2562b2d784eadc10 = (0, $aPfsS.createLayout)({
    globalComponents: [
        $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$Onboarding)
    ],
    rightSidebars: [
        $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$RightSidebars)
    ]
});

});
parcelRegister("ctjgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ead1b5a586c4cb4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $1Yett = parcelRequire("1Yett");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $4ead1b5a586c4cb4$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $1Yett.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    }
    return null;
};
$4ead1b5a586c4cb4$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $4ead1b5a586c4cb4$export$2e2bcd8739ae039 = $4ead1b5a586c4cb4$var$AppPermissionsCheck;

});
parcelRegister("1Yett", function(module, exports) {

$parcel$export(module.exports, "isDevelopmentEnv", () => $7b47955f7b675219$export$48e5fb80244b95c5);
const $7b47955f7b675219$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("bcw12", function(module, exports) {

let $8279a6597839e52b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8279a6597839e52b$var$load("eNmuD"),
    $8279a6597839e52b$var$load("cM9em"),
    $8279a6597839e52b$var$load("fr9NE"),
    $8279a6597839e52b$var$load("lBhEF")
]).then(()=>parcelRequire('fY1ne'));

});

parcelRegister("4Ua47", function(module, exports) {

let $39243332315a933e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $39243332315a933e$var$load("eNmuD"),
    $39243332315a933e$var$load("cM9em"),
    $39243332315a933e$var$load("fr9NE"),
    $39243332315a933e$var$load("aEk0C")
]).then(()=>parcelRequire('71Xxe'));

});


parcelRegister("9RzoX", function(module, exports) {

let $72e48650a0354baf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72e48650a0354baf$var$load("eNmuD"),
    $72e48650a0354baf$var$load("9gTl3")
]).then(()=>parcelRequire('ekO4Z'));

});

parcelRegister("j1Nx6", function(module, exports) {

let $dda48883d7c9acd3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dda48883d7c9acd3$var$load("eNmuD"),
    $dda48883d7c9acd3$var$load("h2MrD"),
    $dda48883d7c9acd3$var$load("bYT2S"),
    $dda48883d7c9acd3$var$load("cM9em"),
    $dda48883d7c9acd3$var$load("fr9NE"),
    $dda48883d7c9acd3$var$load("eZivQ")
]).then(()=>parcelRequire('dOvA3'));

});

parcelRegister("juLka", function(module, exports) {

let $e315874985d17ad6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e315874985d17ad6$var$load("eNmuD"),
    $e315874985d17ad6$var$load("h2MrD"),
    $e315874985d17ad6$var$load("bYT2S"),
    $e315874985d17ad6$var$load("cM9em"),
    $e315874985d17ad6$var$load("fr9NE"),
    $e315874985d17ad6$var$load("0xcBC")
]).then(()=>parcelRequire('islsJ'));

});


parcelRegister("e7bC3", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $43d4c7537a1fee65$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $43d4c7537a1fee65$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $43d4c7537a1fee65$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $43d4c7537a1fee65$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $43d4c7537a1fee65$export$ab7e607e8441dc61);

var $2vSU6 = parcelRequire("2vSU6");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $cSD7y = parcelRequire("cSD7y");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $43d4c7537a1fee65$var$withAnySoftwareProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingOld = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("4vukc")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingNew = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4vukc")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});
const $43d4c7537a1fee65$var$Onboarding = (0, $cSD7y.componentWithFG)('onboarding-forpaint-migration-iv-llc', $43d4c7537a1fee65$var$OnboardingNew, $43d4c7537a1fee65$var$OnboardingOld);
$43d4c7537a1fee65$var$Onboarding.displayName = 'Lazy(ui/onboarding/index.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingCode = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("cEw9d")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsOld = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3GTpa")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsNew = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3GTpa")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $43d4c7537a1fee65$var$RightSidebars = (0, $cSD7y.componentWithFG)('onboarding-forpaint-migration-iv-llc', $43d4c7537a1fee65$var$RightSidebarsNew, $43d4c7537a1fee65$var$RightSidebarsOld);
$43d4c7537a1fee65$var$RightSidebars.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsCode = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("a8L0B")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $43d4c7537a1fee65$var$SoftWareOnboarding = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$Onboarding);
const $43d4c7537a1fee65$var$SoftWareOnboardingCode = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$OnboardingCode);
const $43d4c7537a1fee65$var$nonSettingsRightSidebars = [
    $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebars)
];
const $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode = [
    $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebarsCode)
];
const $43d4c7537a1fee65$var$sharedSoftwareProjectLayout = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout), {});
const $43d4c7537a1fee65$export$3791efdd32024063 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboarding
    ]
});
const $43d4c7537a1fee65$export$9a918616afa3328c = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboarding
    ]
});
const $43d4c7537a1fee65$export$ada52b1309832862 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
const $43d4c7537a1fee65$export$6c1958653c44ba37 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
const $43d4c7537a1fee65$export$ab7e607e8441dc61 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("4vukc", function(module, exports) {

let $3481949173c775d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3481949173c775d8$var$load("eNmuD"),
    $3481949173c775d8$var$load("h2MrD"),
    $3481949173c775d8$var$load("bYT2S"),
    $3481949173c775d8$var$load("cM9em"),
    $3481949173c775d8$var$load("fr9NE"),
    $3481949173c775d8$var$load("5zn1B")
]).then(()=>parcelRequire('67mQl'));

});

parcelRegister("cEw9d", function(module, exports) {

let $93622855a419f8d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $93622855a419f8d0$var$load("eNmuD"),
    $93622855a419f8d0$var$load("h2MrD"),
    $93622855a419f8d0$var$load("bYT2S"),
    $93622855a419f8d0$var$load("cM9em"),
    $93622855a419f8d0$var$load("fr9NE"),
    $93622855a419f8d0$var$load("3aL8T")
]).then(()=>parcelRequire('g03yq'));

});

parcelRegister("3GTpa", function(module, exports) {

let $2b004597c191b0c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2b004597c191b0c9$var$load("eNmuD"),
    $2b004597c191b0c9$var$load("h2MrD"),
    $2b004597c191b0c9$var$load("bYT2S"),
    $2b004597c191b0c9$var$load("cM9em"),
    $2b004597c191b0c9$var$load("fr9NE"),
    $2b004597c191b0c9$var$load("9w7x8")
]).then(()=>parcelRequire('jorgl'));

});

parcelRegister("a8L0B", function(module, exports) {

let $761f1db04694acdd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $761f1db04694acdd$var$load("eNmuD"),
    $761f1db04694acdd$var$load("h2MrD"),
    $761f1db04694acdd$var$load("bYT2S"),
    $761f1db04694acdd$var$load("cM9em"),
    $761f1db04694acdd$var$load("fr9NE"),
    $761f1db04694acdd$var$load("4mQEr")
]).then(()=>parcelRequire('egnL1'));

});


parcelRegister("9Y3Lc", function(module, exports) {

$parcel$export(module.exports, "userBoardLayout", () => $1760a1663e36faa5$export$7092b4ee86ae0b71);

var $aPfsS = parcelRequire("aPfsS");
const $1760a1663e36faa5$export$7092b4ee86ae0b71 = (0, $aPfsS.createLayout)();

});


/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';

parcelRegister("iEUaw", function(module, exports) {

$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $681ca3c44ff39b04$export$4847c29b4786b3b4);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $bskkv = parcelRequire("bskkv");
const $681ca3c44ff39b04$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $681ca3c44ff39b04$export$4847c29b4786b3b4 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$681ca3c44ff39b04$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $681ca3c44ff39b04$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $bskkv.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000
});

});
parcelRegister("bskkv", function(module, exports) {

$parcel$export(module.exports, "fetchShortcuts", () => $b1e90e13aab5fe84$export$49d696bf2525d700);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $b1e90e13aab5fe84$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $7f4tk.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("hBv66", function(module, exports) {

$parcel$export(module.exports, "genericProjectSidebars", () => $0b920001492d0ef4$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $0b920001492d0ef4$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $0b920001492d0ef4$export$844d342b575ead35);

var $cin8p = parcelRequire("cin8p");

var $dmKXV = parcelRequire("dmKXV");

var $iHiHz = parcelRequire("iHiHz");

var $cOg46 = parcelRequire("cOg46");

var $koWFd = parcelRequire("koWFd");

var $h0bZU = parcelRequire("h0bZU");

var $9s3j1 = parcelRequire("9s3j1");

var $2IHt2 = parcelRequire("2IHt2");
const $0b920001492d0ef4$export$d88d2d25355bc89a = [
    // delete when cleaning up getWillShowNav4
    (0, $dmKXV.default),
    (0, $koWFd.default),
    (0, $h0bZU.default),
    (0, $9s3j1.default),
    (0, $2IHt2.default)
];
const $0b920001492d0ef4$export$c04daf123cec1f1e = [
    (0, $9s3j1.default),
    (0, $2IHt2.default)
];
const $0b920001492d0ef4$export$844d342b575ead35 = [
    ...$0b920001492d0ef4$export$d88d2d25355bc89a,
    (0, $cin8p.default),
    (0, $iHiHz.default),
    (0, $cOg46.default)
];

});
parcelRegister("cin8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $760a63d3e4200cc2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $760a63d3e4200cc2$var$LazyConnectSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("aoq5h")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $760a63d3e4200cc2$var$ConnectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($760a63d3e4200cc2$var$LazyConnectSidebar, null)));
$760a63d3e4200cc2$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $760a63d3e4200cc2$export$2e2bcd8739ae039 = $760a63d3e4200cc2$var$ConnectSidebar;

});
parcelRegister("aoq5h", function(module, exports) {

let $79106110966e33bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $79106110966e33bf$var$load("h2MrD"),
    $79106110966e33bf$var$load("bYT2S"),
    $79106110966e33bf$var$load("cM9em"),
    $79106110966e33bf$var$load("fr9NE"),
    $79106110966e33bf$var$load("a8u2l")
]).then(()=>parcelRequire('caET0'));

});


parcelRegister("dmKXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac63d95d52d9688b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $ac63d95d52d9688b$var$LazyCoreProjectSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("8JDm8")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
});
// delete when cleaning up getWillShowNav4
const $ac63d95d52d9688b$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac63d95d52d9688b$var$LazyCoreProjectSidebar, null));
var $ac63d95d52d9688b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ac63d95d52d9688b$var$CoreProjectSidebar);

});
parcelRegister("8JDm8", function(module, exports) {

let $65c10dffcba294a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $65c10dffcba294a5$var$load("eNmuD"),
    $65c10dffcba294a5$var$load("h2MrD"),
    $65c10dffcba294a5$var$load("bYT2S"),
    $65c10dffcba294a5$var$load("cM9em"),
    $65c10dffcba294a5$var$load("fr9NE"),
    $65c10dffcba294a5$var$load("bpTJC")
]).then(()=>parcelRequire('8rIQt'));

});


parcelRegister("cOg46", function(module, exports) {

$parcel$export(module.exports, "default", () => $18dc7dd640caeb91$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("6pa7K")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar, null)));
$18dc7dd640caeb91$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $18dc7dd640caeb91$export$2e2bcd8739ae039 = $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar;

});
parcelRegister("6pa7K", function(module, exports) {

let $4a9cee4a23223f39$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4a9cee4a23223f39$var$load("h2MrD"),
    $4a9cee4a23223f39$var$load("bYT2S"),
    $4a9cee4a23223f39$var$load("cM9em"),
    $4a9cee4a23223f39$var$load("fr9NE"),
    $4a9cee4a23223f39$var$load("gQZpl")
]).then(()=>parcelRequire('6Pefo'));

});


parcelRegister("koWFd", function(module, exports) {

$parcel$export(module.exports, "ForPaintSoftwareProjectSidebar", () => $73e9a7a50d60fc40$export$16261c6a2217f29d);
$parcel$export(module.exports, "default", () => $73e9a7a50d60fc40$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

var $lODMY = parcelRequire("lODMY");

const $73e9a7a50d60fc40$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("ikt6r")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});

const $73e9a7a50d60fc40$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("ikt6r")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73e9a7a50d60fc40$var$AfterPaintSoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73e9a7a50d60fc40$export$16261c6a2217f29d = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73e9a7a50d60fc40$var$SoftwareProjectSidebarLazyForPaintIssueRouteOnly = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const isIssueRoute = (0, $lODMY.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$export$16261c6a2217f29d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$AfterPaintSoftwareProjectSidebar, null);
});
const $73e9a7a50d60fc40$var$SoftwareProjectSidebar = (0, $cSD7y.componentWithFG)('nav_sidebar_software_classic_lazyforpaint', $73e9a7a50d60fc40$var$SoftwareProjectSidebarLazyForPaintIssueRouteOnly, $73e9a7a50d60fc40$var$AfterPaintSoftwareProjectSidebar);
$73e9a7a50d60fc40$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
$73e9a7a50d60fc40$export$16261c6a2217f29d.displayName = 'SoftwareProjectSidebar';
var $73e9a7a50d60fc40$export$2e2bcd8739ae039 = $73e9a7a50d60fc40$var$SoftwareProjectSidebar;

});
parcelRegister("ikt6r", function(module, exports) {

let $d580ab8080ffbf4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d580ab8080ffbf4c$var$load("kfXhT"),
    $d580ab8080ffbf4c$var$load("2Lfdl"),
    $d580ab8080ffbf4c$var$load("eNmuD"),
    $d580ab8080ffbf4c$var$load("h2MrD"),
    $d580ab8080ffbf4c$var$load("bYT2S"),
    $d580ab8080ffbf4c$var$load("cM9em"),
    $d580ab8080ffbf4c$var$load("fr9NE"),
    $d580ab8080ffbf4c$var$load("4OI1j")
]).then(()=>parcelRequire('4WgKv'));

});


parcelRegister("h0bZU", function(module, exports) {

$parcel$export(module.exports, "ForPaintServicedeskSidebar", () => $ca3f1b5dd616f02b$export$c72ea37d21335def);
$parcel$export(module.exports, "default", () => $ca3f1b5dd616f02b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

var $lODMY = parcelRequire("lODMY");

const $ca3f1b5dd616f02b$export$4553575c70a669bf = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("epreh")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});

const $ca3f1b5dd616f02b$var$LazyForPaintServicedeskSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("epreh")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $ca3f1b5dd616f02b$var$AfterPaintServicedeskSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$4553575c70a669bf, null)));
const $ca3f1b5dd616f02b$export$c72ea37d21335def = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$var$LazyForPaintServicedeskSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ca3f1b5dd616f02b$var$ServicedeskSidebarLazyForPaintIssueRouteOnly = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const isIssueRoute = (0, $lODMY.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$c72ea37d21335def, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$var$AfterPaintServicedeskSidebar, null);
});
const $ca3f1b5dd616f02b$var$ServicedeskSidebar = (0, $cSD7y.componentWithFG)('nav_sidebar_software_classic_lazyforpaint', $ca3f1b5dd616f02b$var$ServicedeskSidebarLazyForPaintIssueRouteOnly, $ca3f1b5dd616f02b$var$AfterPaintServicedeskSidebar);
$ca3f1b5dd616f02b$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
$ca3f1b5dd616f02b$export$c72ea37d21335def.displayName = 'ServicedeskSidebar';
var $ca3f1b5dd616f02b$export$2e2bcd8739ae039 = $ca3f1b5dd616f02b$var$ServicedeskSidebar;

});
parcelRegister("epreh", function(module, exports) {

let $a7d885a5c6ed3409$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a7d885a5c6ed3409$var$load("kWrFZ"),
    $a7d885a5c6ed3409$var$load("kfXhT"),
    $a7d885a5c6ed3409$var$load("2Lfdl"),
    $a7d885a5c6ed3409$var$load("eNmuD"),
    $a7d885a5c6ed3409$var$load("hPzOn"),
    $a7d885a5c6ed3409$var$load("h2MrD"),
    $a7d885a5c6ed3409$var$load("bYT2S"),
    $a7d885a5c6ed3409$var$load("cM9em"),
    $a7d885a5c6ed3409$var$load("fr9NE"),
    $a7d885a5c6ed3409$var$load("aOxtZ")
]).then(()=>parcelRequire('eufGV'));

});


parcelRegister("9s3j1", function(module, exports) {

$parcel$export(module.exports, "ForPaintClassicSoftwareProjectSidebar", () => $ed71aad279526f75$export$a70fda37b3fc5365);
$parcel$export(module.exports, "default", () => $ed71aad279526f75$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

var $lODMY = parcelRequire("lODMY");

const $ed71aad279526f75$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("hFY22")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});

const $ed71aad279526f75$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("hFY22")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed71aad279526f75$var$AfterPaintClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed71aad279526f75$export$a70fda37b3fc5365 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed71aad279526f75$var$ClassicSoftwareProjectSidebarLazyForPaintIssueRouteOnly = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const isIssueRoute = (0, $lODMY.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$export$a70fda37b3fc5365, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$AfterPaintClassicSoftwareProjectSidebar, null);
});
const $ed71aad279526f75$var$ClassicSoftwareProjectSidebar = (0, $cSD7y.componentWithFG)('nav_sidebar_software_classic_lazyforpaint', $ed71aad279526f75$var$ClassicSoftwareProjectSidebarLazyForPaintIssueRouteOnly, $ed71aad279526f75$var$AfterPaintClassicSoftwareProjectSidebar);
$ed71aad279526f75$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
$ed71aad279526f75$export$a70fda37b3fc5365.displayName = 'ClassicSoftwareProjectSidebar';
var $ed71aad279526f75$export$2e2bcd8739ae039 = $ed71aad279526f75$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("hFY22", function(module, exports) {

let $cde4d51540c0ea10$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cde4d51540c0ea10$var$load("kfXhT"),
    $cde4d51540c0ea10$var$load("2Lfdl"),
    $cde4d51540c0ea10$var$load("hPzOn"),
    $cde4d51540c0ea10$var$load("eNmuD"),
    $cde4d51540c0ea10$var$load("h2MrD"),
    $cde4d51540c0ea10$var$load("bYT2S"),
    $cde4d51540c0ea10$var$load("cM9em"),
    $cde4d51540c0ea10$var$load("fr9NE"),
    $cde4d51540c0ea10$var$load("hXBFn")
]).then(()=>parcelRequire('dydBa'));

});


parcelRegister("2IHt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8627747b0236ab96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $8627747b0236ab96$var$LazyUserSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("arXlp")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8627747b0236ab96$var$UserSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8627747b0236ab96$var$LazyUserSidebar, null)));
$8627747b0236ab96$var$UserSidebar.displayName = 'UserSidebar';
var $8627747b0236ab96$export$2e2bcd8739ae039 = $8627747b0236ab96$var$UserSidebar;

});
parcelRegister("arXlp", function(module, exports) {

let $79ba758f689778fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $79ba758f689778fa$var$load("hPzOn"),
    $79ba758f689778fa$var$load("eNmuD"),
    $79ba758f689778fa$var$load("h2MrD"),
    $79ba758f689778fa$var$load("bYT2S"),
    $79ba758f689778fa$var$load("cM9em"),
    $79ba758f689778fa$var$load("fr9NE"),
    $79ba758f689778fa$var$load("36IoX")
]).then(()=>parcelRequire('3AQ56'));

});



parcelRegister("lNicp", function(module, exports) {

$parcel$export(module.exports, "getBusinessProjectResources", () => $492115de1a4c9f28$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $492115de1a4c9f28$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $492115de1a4c9f28$export$21c5527b459d56fe);

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $g4ZHz = parcelRequire("g4ZHz");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $1E3vT = parcelRequire("1E3vT");

var $iNzEe = parcelRequire("iNzEe");

var $jrO9m = parcelRequire("jrO9m");

var $gNStA = parcelRequire("gNStA");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cSUZZ = parcelRequire("cSUZZ");

var $aFVvc = parcelRequire("aFVvc");

var $9V5k0 = parcelRequire("9V5k0");
const $492115de1a4c9f28$export$20e8c2951e444b08 = ()=>(0, $3HwlS.getWillShowNav4)() ? [
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira_theming_relay_migration'), (0, $9V5k0.projectThemeResource))
    ] : [
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $1E3vT.businessHorizontalNav3Resource),
        (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira_theming_relay_migration'), (0, $9V5k0.projectThemeResource))
    ];
const $492115de1a4c9f28$export$fcbe882e18ee4a35 = ()=>[
        ...$492115de1a4c9f28$export$20e8c2951e444b08(),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $g4ZHz.fieldsResource)
    ];
const $492115de1a4c9f28$export$46471673e66df5c1 = ()=>[
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $jrO9m.overviewDetailsResource)
    ];
const $492115de1a4c9f28$export$21c5527b459d56fe = ()=>[
        ...$492115de1a4c9f28$export$46471673e66df5c1(),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $g4ZHz.fieldsResource)
    ];

});
parcelRegister("g4ZHz", function(module, exports) {

$parcel$export(module.exports, "fieldsResource", () => $410efef54f79d33f$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $410efef54f79d33f$export$c0cd85886917fe89);

var $7q3cr = parcelRequire("7q3cr");

var $jlq4V = parcelRequire("jlq4V");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $ljySl = parcelRequire("ljySl");

var $kig09 = parcelRequire("kig09");
const $410efef54f79d33f$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $410efef54f79d33f$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $kig09.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $410efef54f79d33f$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $kig09.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $410efef54f79d33f$export$8bca6c1954ae9308 = (0, $2M1hQ.createResource)({
    type: $410efef54f79d33f$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $ljySl.fetchFields)((0, $8441414a9e015afb$export$c378ca4a0e2c9fec), $410efef54f79d33f$var$handleOverviewResponse, {
            overviewAri: (0, $7q3cr.JiraProjectOverviewAri).create({
                siteId: cloudId,
                activationId: activationId,
                overviewId: match.params.overviewId
            }).toString()
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $ljySl.fetchFields)((0, $8441414a9e015afb$export$4d41378da3f70f0f), $410efef54f79d33f$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $410efef54f79d33f$export$c0cd85886917fe89 = ()=>(0, $2YP9W.useResource)($410efef54f79d33f$export$8bca6c1954ae9308);

});
parcelRegister("7q3cr", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAri", () => $566d717b3b39d3ba$export$714879003922a622);

var $gPEvR = parcelRequire("gPEvR");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/project-overview/manifest.ts
var $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gPEvR.JiraProjectOverviewAriResourceOwner),
    resourceType: (0, $gPEvR.JiraProjectOverviewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{overviewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        overviewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/project-overview/index.ts
var $566d717b3b39d3ba$export$714879003922a622 = class _JiraProjectOverviewAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._overviewId = opts.resourceIdSegmentValues.overviewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get overviewId() {
        return this._overviewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.qualifier,
            platformQualifier: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.resourceOwner,
            resourceType: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.overviewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                overviewId: opts.overviewId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            overviewId: this.overviewId
        };
    }
};

});
parcelRegister("gPEvR", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAriResourceOwner", () => $c410d5ca87dd2023$export$d68ef32d028cea3e);
$parcel$export(module.exports, "JiraProjectOverviewAriResourceType", () => $c410d5ca87dd2023$export$491d1b3b0151dbc4);
// src/jira/project-overview/types.ts
var $c410d5ca87dd2023$export$d68ef32d028cea3e = "jira", $c410d5ca87dd2023$export$491d1b3b0151dbc4 = "project-overview";

});


parcelRegister("jlq4V", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $503bc83696833cc0$export$89c202e66b2de2b6);

var $7hpBk = parcelRequire("7hpBk");

var $8LQ84 = parcelRequire("8LQ84");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $503bc83696833cc0$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $503bc83696833cc0$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($7hpBk)))(graphQLErrors) : [];
        this.message = $503bc83696833cc0$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("7hpBk", function(module, exports) {

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $54cdfac2bc83c2a9$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $8LQ84(value) ? value : [
        value
    ];
}
module.exports = $54cdfac2bc83c2a9$var$castArray;

});


const $8441414a9e015afb$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $8441414a9e015afb$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("ljySl", function(module, exports) {

$parcel$export(module.exports, "fetchFields", () => $90e7c5e5920e8507$export$f3ddd735c360919);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $90e7c5e5920e8507$var$PAGE_SIZE = 100;
const $90e7c5e5920e8507$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $90e7c5e5920e8507$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("kig09", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $3d209f684c72dca4$export$3ceb62baab058c6b);
const $3d209f684c72dca4$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("1E3vT", function(module, exports) {

$parcel$export(module.exports, "businessHorizontalNav3Resource", () => $4f364072ed560b43$export$b3359003584ee2b0);

var $j5YhT = parcelRequire("j5YhT");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $6YG83 = parcelRequire("6YG83");

var $ktofH = parcelRequire("ktofH");

var $ao2h1 = parcelRequire("ao2h1");

var $6SGt4 = parcelRequire("6SGt4");

var $1nb22 = parcelRequire("1nb22");
const $4f364072ed560b43$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
const $4f364072ed560b43$var$getProjectAri = (projectId, cloudId)=>{
    try {
        return projectId ? (0, $j5YhT.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
    } catch (err) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
        return '';
    }
};
const $4f364072ed560b43$export$b3359003584ee2b0 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: $4f364072ed560b43$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = $4f364072ed560b43$var$getProjectAri(projectId, cloudId);
        return {
            parameters: (0, $6SGt4.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE),
                isConsolidatedQuery: false,
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: false,
                useNewProjectHeader: false,
                projectKey: projectKey,
                projectAri: scopeId,
                useProjectKey: Boolean(projectKey),
                isJiraCustomTemplatesUxEnabled: (0, $4R6GH.fg)('jira_custom_templates_ux')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));

});
parcelRegister("6YG83", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $895edd6ed19f0aa8$export$f4b29e78f4c0a526);
const $895edd6ed19f0aa8$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});

parcelRegister("ktofH", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", () => $e6d4097fc653a273$export$4653cda61a4943d6);
$parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", () => $e6d4097fc653a273$export$d1b9ea3245b6a5de);
$parcel$export(module.exports, "TAB_HEIGHT", () => $e6d4097fc653a273$export$d07bba395c9390f1);
$parcel$export(module.exports, "TAB_GAP", () => $e6d4097fc653a273$export$b61e6f89a9db76de);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports


const $e6d4097fc653a273$export$4653cda61a4943d6 = 75;
const $e6d4097fc653a273$export$d1b9ea3245b6a5de = 2;
const $e6d4097fc653a273$export$d07bba395c9390f1 = 36;
const $e6d4097fc653a273$export$29911ec08ab2ca2d = 5;
const $e6d4097fc653a273$export$b61e6f89a9db76de = 12;
const $e6d4097fc653a273$export$7fd2e391116c6ef5 = 9;
const $e6d4097fc653a273$export$e1633e494d305bfb = 'MORE';

});

parcelRegister("6SGt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed7f561d3a05da6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<820042db950ffe26b91d34ffe7050138>>
 * @relayHash bef16a6db03ecc4506e2c317ed3ec3dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5
const $fed7f561d3a05da6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJiraCustomTemplatesUxEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v11 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "alias": "canEditProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v14 = {
        "condition": "isJiraCustomTemplatesUxEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "customTemplateBusinessProjectBanner_businessHorizontalNav"
            }
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "condition": "isJiraCustomTemplatesUxEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLiveTemplate"
                }
            ]
        },
        v18 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "tabs_businessHorizontalNav_TabsContent"
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataByKey.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataById.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "jwmSavedViewsByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraNavigationItem"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canRemove"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canSetAsDefault"
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "projectIdOrKey"
                            ],
                            "handle": "connection",
                            "key": "tabs_jiraNavigation__navigationItems",
                            "kind": "LinkedHandle",
                            "name": "jwmSavedViewsByProject"
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "projectDataById",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5",
            "metadata": {},
            "name": "projectNavigation_horizontalNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fed7f561d3a05da6$var$node.hash = "73d9509696eb943ac9eaa2deb0444981";
var $fed7f561d3a05da6$export$2e2bcd8739ae039 = $fed7f561d3a05da6$var$node;

});


parcelRegister("iNzEe", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $6b942b0827824c4b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $6b942b0827824c4b$export$c17011c09e042a31);

var $gccSB = parcelRequire("gccSB");

var $j5YhT = parcelRequire("j5YhT");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $geiy6 = parcelRequire("geiy6");

const $6b942b0827824c4b$export$62940941ee574cdc = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectId)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $j5YhT.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        });
        return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, $2YP9W.useResource)($6b942b0827824c4b$export$62940941ee574cdc);

});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;

parcelRegister("geiy6", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $446f8b979bebb841$export$1fc5fff73d9a570c);

var $jlq4V = parcelRequire("jlq4V");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");


var $ifwpM = parcelRequire("ifwpM");
const $446f8b979bebb841$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    shouldHideOverviews: false
};
const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $ifwpM.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $446f8b979bebb841$var$EMPTY_RESPONSE;
};

});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("ifwpM", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9031e5290b70d3d6$export$3ceb62baab058c6b);

var $6cG4N = parcelRequire("6cG4N");


var $027FQ = parcelRequire("027FQ");
const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
    });
const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $027FQ.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        shouldHideOverviews: areOverviewsGone
    };
};

});
parcelRegister("6cG4N", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $cd302866fea6f361$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $cd302866fea6f361$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $cd302866fea6f361$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $cd302866fea6f361$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $cd302866fea6f361$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $cd302866fea6f361$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $cd302866fea6f361$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$4c351ec1dc290344);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $cd302866fea6f361$export$34373eced7ee212e);
$parcel$export(module.exports, "FIXED_COLOR_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$bc16bf654619d060);
$parcel$export(module.exports, "ADAPTIVE_COLOR_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$4b188262dd47f902);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$242b2d2213fedf27);
$parcel$export(module.exports, "ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$8a6c8dd4a86d3f7d);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $cd302866fea6f361$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$cab9d853866386f2);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $cd302866fea6f361$export$8e357501548afe78);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $cd302866fea6f361$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $cd302866fea6f361$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $cd302866fea6f361$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $cd302866fea6f361$export$1c0b806722927549);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", () => $cd302866fea6f361$export$2af5673c2fa63c55);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT_NEW", () => $cd302866fea6f361$export$e03b923d879c011b);
$parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", () => $cd302866fea6f361$export$5771162cdeebfb85);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", () => $cd302866fea6f361$export$a1626d6d785092a2);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $cd302866fea6f361$export$410e3d6221a052e);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $cd302866fea6f361$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $cd302866fea6f361$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout



const $cd302866fea6f361$export$9e0962e0cb41695d = '#FFAB00';
const $cd302866fea6f361$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--project-backdrop-filter',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: '--project-color-background-neutral-subtle-hovered-contrast',
    COLOR_BACKGROUND_ACCENT_SELECTED: '--project-color-background-accent-selected',
    COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--project-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--project-background-selected',
    COLOR_BORDER: '--project-color-border',
    COLOR_BORDER_INPUT: '--project-color-border-input',
    COLOR_BORDER_INVERSE: '--project-color-border-inverse',
    COLOR_BORDER_SELECTED: '--project-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
    COLOR_ELEVATION_SURFACE_SUNKEN: '--project-color-elevation-surface-sunken',
    COLOR_ICON_DANGER: '--project-color-icon-danger',
    COLOR_ICON_INFORMATION: '--project-color-icon-information',
    COLOR_ICON_SUCCESS: '--project-color-icon-success',
    COLOR_ICON_WARNING: '--project-color-icon-warning',
    COLOR_LINK: '--project-color-link',
    COLOR_LINK_PRESSED: '--project-color-link-pressed',
    COLOR_SKELETON: '--project-skeleton',
    COLOR_TEXT: '--project-color-text',
    COLOR_TEXT_ACCENT_SELECTED: '--project-text-accent-selected',
    COLOR_TEXT_DISABLED: '--project-color-text-disabled',
    COLOR_TEXT_INVERSE: '--project-color-text-inverse',
    COLOR_TEXT_SELECTED: '--project-color-text-selected',
    COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
    CONTENT_HEIGHT: '--project-content-height',
    CONTENT_WIDTH: '--project-content-width',
    ELEVATION_SURFACE: '--project-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
    WRAPPER_BACKGROUND: '--project-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
    WRAPPER_HEIGHT: '--project-wrapper-height',
    WRAPPER_PADDING: '--project-wrapper-padding',
    WRAPPER_WIDTH: '--project-wrapper-width'
};
const $cd302866fea6f361$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--project-backdrop-filter)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: 'var(--project-color-background-neutral-subtle-hovered-contrast)',
    COLOR_BACKGROUND_ACCENT_SELECTED: 'var(--project-color-background-accent-selected)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
    COLOR_BORDER: 'var(--project-color-border)',
    COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
    COLOR_ELEVATION_SURFACE_SUNKEN: 'var(--project-color-elevation-surface-sunken)',
    COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
    COLOR_LINK: 'var(--project-color-link)',
    COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
    COLOR_SKELETON: 'var(--project-skeleton)',
    COLOR_TEXT: 'var(--project-color-text)',
    COLOR_TEXT_ACCENT_SELECTED: 'var(--project-text-accent-selected)',
    COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--project-content-height)',
    CONTENT_WIDTH: 'var(--project-content-width)',
    ELEVATION_SURFACE: 'var(--project-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
    WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
    WRAPPER_PADDING: 'var(--project-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--project-wrapper-width)'
};
const $cd302866fea6f361$export$8a6e9b3370a0f87a = {
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.accent.selected': (0, $829f609a65d26a98$exports).B700,
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0C66E4)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0055CC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.neutral': "var(--ds-background-neutral, #091E420F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #091E424F)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #091E4224)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FF)",
    'color.elevation.surface': "var(--ds-surface, #FFFFFF)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.border': "var(--ds-border, #091E4224)",
    'color.border.input': "var(--ds-border-input, #8590A2)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0C66E4)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.information': "var(--ds-icon-information, #1D7AFC)",
    'color.icon.success': "var(--ds-icon-success, #22A06B)",
    'color.icon.warning': "var(--ds-icon-warning, #E56910)",
    'color.link': "var(--ds-link, #0C66E4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055CC)",
    'color.skeleton': "var(--ds-background-neutral, #091E420F)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.selected': "var(--ds-text, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0C66E4)",
    'color.text.subtle': "var(--ds-text-subtle, #44546F)",
    'color.text.subtlest': "var(--ds-text-subtlest, #626F86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent'
};
const $cd302866fea6f361$export$f286efa6bd1e8f9d = {
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': "var(--ds-text-inverse, #FFFFFF)"
};
const $cd302866fea6f361$export$97cb21c6432e07e8 = {
    'color.background.neutral.subtle.hovered.contrast': 'rgba(255, 255, 255, 0.08)',
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $829f609a65d26a98$exports).N0,
    'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
    'color.icon.information': (0, $829f609a65d26a98$exports).N0,
    'color.icon.success': (0, $829f609a65d26a98$exports).N0,
    'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $829f609a65d26a98$exports).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $cd302866fea6f361$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $cd302866fea6f361$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
            'color.icon.information': (0, $829f609a65d26a98$exports).N0,
            'color.icon.success': (0, $829f609a65d26a98$exports).N0,
            'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $829f609a65d26a98$exports).N0,
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        }
    }
};
// Old Colors
const $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $cd302866fea6f361$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $cd302866fea6f361$export$8a6e9b3370a0f87a,
        dark: {
            ...$cd302866fea6f361$export$8a6e9b3370a0f87a,
            'color.text.accent.selected': "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $cd302866fea6f361$export$68930f4689402226 = {
    name: 'adaptive-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-surface-hovered, #F1F2F4)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text, #172B4D)",
            'color.link.pressed': "var(--ds-text, #172B4D)",
            'color.elevation.surface.sunken': "var(--ds-surface-pressed, #DCDFE4)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-surface-hovered, #F1F2F4)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text, #172B4D)",
            'color.link.pressed': "var(--ds-text, #172B4D)",
            'color.elevation.surface.sunken': "var(--ds-surface-pressed, #DCDFE4)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$e013fca1233b4f7f = {
    name: 'adaptive-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-purple, #5E4DB2)",
            'color.link.pressed': "var(--ds-text-accent-purple, #5E4DB2)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-purple, #5E4DB2)",
            'color.link.pressed': "var(--ds-text-accent-purple, #5E4DB2)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$81ad18a6866e27ad = {
    name: 'adaptive-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-blue, #0055CC)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-blue, #0055CC)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$e41eaa7177d56baf = {
    name: 'adaptive-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-teal, #206A83)",
            'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-teal, #206A83)",
            'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$31b6c9185eea93be = {
    name: 'adaptive-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-green, #216E4E)",
            'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtler, #BAF3DB)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-green, #216E4E)",
            'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtler, #BAF3DB)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$3214417ed3fa0b58 = {
    name: 'adaptive-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-magenta, #943D73)",
            'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-magenta, #943D73)",
            'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
// Gradients
const $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_GRAY_TO_BLACK_META = {
    name: 'adaptive-gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#182A46',
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#182A46',
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'adaptive-gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7D014B',
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#7D014B',
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'adaptive-gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01235F',
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#01235F',
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'adaptive-gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'adaptive-gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'adaptive-gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#132564',
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#132564',
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$34373eced7ee212e = [
    $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG
];
const $cd302866fea6f361$export$bc16bf654619d060 = [
    $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $cd302866fea6f361$export$4b188262dd47f902 = [
    $cd302866fea6f361$export$68930f4689402226,
    $cd302866fea6f361$export$e013fca1233b4f7f,
    $cd302866fea6f361$export$81ad18a6866e27ad,
    $cd302866fea6f361$export$e41eaa7177d56baf,
    $cd302866fea6f361$export$31b6c9185eea93be,
    $cd302866fea6f361$export$3214417ed3fa0b58
];
const $cd302866fea6f361$export$242b2d2213fedf27 = [
    $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META
];
const $cd302866fea6f361$export$8a6c8dd4a86d3f7d = [
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_GRAY_TO_BLACK_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_MAGENTA_TO_ORANGE_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_DARK_GREEN_TO_LIME_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_PURPLE_TO_MAGENTA_META
];
const $cd302866fea6f361$export$fe05a238062e2c3d = {
    white: $cd302866fea6f361$export$4c351ec1dc290344,
    'light-purple': $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $cd302866fea6f361$export$cab9d853866386f2 = $cd302866fea6f361$export$4c351ec1dc290344;
const $cd302866fea6f361$export$8e357501548afe78 = 24;
const $cd302866fea6f361$export$baaf8255c30ea280 = 95;
const $cd302866fea6f361$export$d9035bc768f8226d = `${$cd302866fea6f361$export$baaf8255c30ea280}px`;
const $cd302866fea6f361$export$4810531e30462f89 = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$d9035bc768f8226d})`;
const $cd302866fea6f361$export$1c0b806722927549 = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$d9035bc768f8226d} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
const $cd302866fea6f361$export$2af5673c2fa63c55 = 122;
const $cd302866fea6f361$export$e03b923d879c011b = 104;
const $cd302866fea6f361$export$5771162cdeebfb85 = `${$cd302866fea6f361$export$2af5673c2fa63c55}px`;
const $cd302866fea6f361$export$a1626d6d785092a2 = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$5771162cdeebfb85})`;
const $cd302866fea6f361$export$410e3d6221a052e = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$5771162cdeebfb85} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
const $cd302866fea6f361$export$77cdace62a821419 = `calc(100vw - ${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} - ${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)} - ${(0, $565cb8192fc4e070$export$750459958906793)} - ${(0, $565cb8192fc4e070$export$b44ab66843c05a69)}) !important`;
const $cd302866fea6f361$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} - ${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)} - ${(0, $565cb8192fc4e070$export$750459958906793)} - ${(0, $565cb8192fc4e070$export$b44ab66843c05a69)} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px) !important`;

});
// dimension vars
const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
const $565cb8192fc4e070$export$be83e7118304b28e = 56;
const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
const $565cb8192fc4e070$export$539e68c09584883a = 240;
const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;

// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $81918a2ef6db1f93$export$638757b621fbf475 = `${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $81918a2ef6db1f93$export$d60454526e2281af = `(${$81918a2ef6db1f93$export$638757b621fbf475})`;


parcelRegister("027FQ", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $fd4c320fd9ec6c35$export$ddf2fc82885279d);
const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $fd4c320fd9ec6c35$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});




parcelRegister("jrO9m", function(module, exports) {

$parcel$export(module.exports, "overviewDetailsResource", () => $e1715b61e2fa96e9$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $e1715b61e2fa96e9$export$626541a5c6f2cfa1);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $hFi7P = parcelRequire("hFi7P");
const $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $e1715b61e2fa96e9$export$cd57aa046b167312 = (0, $2M1hQ.createResource)({
    type: $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $hFi7P.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $e1715b61e2fa96e9$export$626541a5c6f2cfa1 = ()=>(0, $2YP9W.useResource)($e1715b61e2fa96e9$export$cd57aa046b167312);

});
parcelRegister("hFi7P", function(module, exports) {

$parcel$export(module.exports, "fetchOverviewDetails", () => $692d3aa28ecf0a74$export$f0395142dbdd6c61);

var $7q3cr = parcelRequire("7q3cr");

var $63wRx = parcelRequire("63wRx");

var $jlq4V = parcelRequire("jlq4V");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $dpLxG = parcelRequire("dpLxG");

const $692d3aa28ecf0a74$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $dpLxG.QUERY),
                variables: {
                    id: (0, $7q3cr.JiraProjectOverviewAri).create({
                        siteId: cloudId,
                        activationId: activationId,
                        overviewId: overviewId
                    }).toString()
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $4bd5c695609ae115$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $63wRx.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $jlq4V.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if (error?.statusCode === 410) throw error;
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("63wRx", function(module, exports) {

$parcel$export(module.exports, "mapOverviewFragment", () => $bc1a4d4cd369fa52$export$e79bf238de33eabb);
const $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc1a4d4cd369fa52$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                assignIssues: false,
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $bc1a4d4cd369fa52$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $bc1a4d4cd369fa52$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("dpLxG", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $42259e945f9fd88b$export$2b91517d6d5b4365);

const $42259e945f9fd88b$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892)}
`;

});
const $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $4bd5c695609ae115$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';



parcelRegister("l2N2a", function(module, exports) {

$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $a72df1053ff3c9a0$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $a72df1053ff3c9a0$export$97def3841413167f);
$parcel$export(module.exports, "useMediaConfiguration_DEPRECATED_DO_NOT_USE", () => $a72df1053ff3c9a0$export$a16859df2012e349);
/* eslint-disable camelcase */ 
var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $8s4PA = parcelRequire("8s4PA");
const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $a72df1053ff3c9a0$export$ced53bf9d9551fef = (0, $2M1hQ.createResource)({
    type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $8s4PA.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $a72df1053ff3c9a0$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($a72df1053ff3c9a0$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};
const $a72df1053ff3c9a0$export$a16859df2012e349 = ()=>{
    const { data: data } = (0, $2YP9W.useResource)($a72df1053ff3c9a0$export$ced53bf9d9551fef);
    return data?.media ?? null;
};

});
parcelRegister("8s4PA", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $3400333a67b09775$export$78aa221476efa1c6);

var $j5YhT = parcelRequire("j5YhT");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");


var $2D9kr = parcelRequire("2D9kr");
const $3400333a67b09775$var$EMPTY_VALUE = {
    themeSetting: null,
    media: null
};
const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $j5YhT.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : '',
                    isJiraThemingInRelay: (0, $4R6GH.fg)('jira_theming_relay_migration')
                }
            })
        });
        return (0, $2D9kr.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $3400333a67b09775$var$EMPTY_VALUE;
};

});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!, $isJiraThemingInRelay: Boolean!) {
  jira @skip(if: $isJiraThemingInRelay) {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) @skip(if: $isJiraThemingInRelay) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;

parcelRegister("2D9kr", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $a9016a2d391e1663$export$3ceb62baab058c6b);

var $4R6GH = parcelRequire("4R6GH");
const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $a9016a2d391e1663$var$parseThemeSetting = (data)=>{
    const theme = data?.jwmSidebar?.theme;
    if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.colorValue
    };
    if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.gradientValue
    };
    if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
        const { customBackground: customBackground } = theme;
        const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'image',
            value: 'image',
            id: id,
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            sourceType: sourceType,
            sourceIdentifier: sourceIdentifier,
            altText: altText
        };
    }
    return null;
};
const $a9016a2d391e1663$var$parseMediaConfiguration = (data)=>{
    const clientId = data?.jira?.mediaClientId;
    const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
    if (clientId == null || externalEndpointUrl == null) return null;
    return {
        clientId: clientId,
        externalEndpointUrl: externalEndpointUrl
    };
};
const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        ...(0, $4R6GH.fg)('jira_theming_relay_migration') ? {} : {
            themeSetting: $a9016a2d391e1663$var$parseThemeSetting(data)
        },
        currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey,
        ...(0, $4R6GH.fg)('jira_theming_relay_migration') ? {} : {
            media: $a9016a2d391e1663$var$parseMediaConfiguration(data)
        }
    });

});



parcelRegister("cSUZZ", function(module, exports) {

$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $203c641f0a3380f5$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $203c641f0a3380f5$export$90749419e9042370);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $9dQKJ = parcelRequire("9dQKJ");
const $203c641f0a3380f5$export$92c4069b5349d086 = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $9dQKJ.fetchLicenseDetails)((0, $2993c3eadd0dda3e$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $203c641f0a3380f5$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $2YP9W.useResource)($203c641f0a3380f5$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
const $2993c3eadd0dda3e$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("9dQKJ", function(module, exports) {

$parcel$export(module.exports, "fetchLicenseDetails", () => $164a09ef89830ae9$export$ec058a82eccb31e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $164a09ef89830ae9$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $164a09ef89830ae9$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $164a09ef89830ae9$var$EMPTY_RESPONSE;
};

});


parcelRegister("aFVvc", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $9880b75bed11d4d0$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $9880b75bed11d4d0$export$2bd0d3b374549a68);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9880b75bed11d4d0$var$getDataLoader = ()=>(parcelRequire("dTuZJ"));
const $9880b75bed11d4d0$export$f6c05eaea53ab4ae = (0, $2M1hQ.createResource)({
    type: (0, $acc15b1fbe2101c5$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $9880b75bed11d4d0$var$getDataLoader,
    maxAge: Infinity
});
const $9880b75bed11d4d0$export$2bd0d3b374549a68 = ()=>(0, $2YP9W.useResource)($9880b75bed11d4d0$export$f6c05eaea53ab4ae);

});
const $acc15b1fbe2101c5$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("dTuZJ", function(module, exports) {

let $a1d8744defbc7f9d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1d8744defbc7f9d$var$load("bqWWL").then(()=>parcelRequire('5Yzmr'));

});


parcelRegister("9V5k0", function(module, exports) {

$parcel$export(module.exports, "projectThemeResource", () => $3c09c2af07d8e6b3$export$84730adce8987203);

var $cEpZ8 = parcelRequire("cEpZ8");

var $1nb22 = parcelRequire("1nb22");

var $ao2h1 = parcelRequire("ao2h1");

var $9Yclo = parcelRequire("9Yclo");
const $3c09c2af07d8e6b3$export$84730adce8987203 = (0, $9Yclo.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'JIRA_PROJECT_THEME',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $cEpZ8.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectKey ?? projectId ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}));

});
parcelRegister("cEpZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e482e6cdf4681d7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a19b0ee1237722cea826fe3e759bd4aa>>
 * @relayHash 3363f5643451362c315aa623a9a6eca6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f053a7beff09849363174d0715005f1055d86b9a61f13d7519b416ad239b2f0c

var $eiowN = parcelRequire("eiowN");
const $e482e6cdf4681d7d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaClientId"
            },
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaExternalEndpointUrl"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ThemeSetterQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v3 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ThemeSetterBackground"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ThemeSetterQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorValue"
                                        }
                                    ],
                                    "type": "JiraColorBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "gradientValue"
                                        }
                                    ],
                                    "type": "JiraGradientBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraCustomBackground",
                                            "kind": "LinkedField",
                                            "name": "customBackground",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaApiFileId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "durationInSeconds",
                                                            "value": 900
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "mediaReadToken",
                                                    "storageKey": "mediaReadToken(durationInSeconds:900)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceIdentifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "altText"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraMediaBackground"
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f053a7beff09849363174d0715005f1055d86b9a61f13d7519b416ad239b2f0c",
            "metadata": {},
            "name": "ThemeSetterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e482e6cdf4681d7d$var$node.hash = "9864ab22015f44482ad59ad489f945e0";
(0, $eiowN.PreloadableQueryRegistry).set($e482e6cdf4681d7d$var$node.params.id, $e482e6cdf4681d7d$var$node);
var $e482e6cdf4681d7d$export$2e2bcd8739ae039 = $e482e6cdf4681d7d$var$node;

});

parcelRegister("9Yclo", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $ee875458deba4a50$export$f4b29e78f4c0a526);
const $ee875458deba4a50$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});



parcelRegister("7GnDe", function(module, exports) {

$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $08a008dcde68e650$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $08a008dcde68e650$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $08a008dcde68e650$export$31c6945718067be3);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3Only", () => $08a008dcde68e650$export$6fc19cf1d90e9453);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes", () => $08a008dcde68e650$export$2e6b9e6402ff1d9b);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $08a008dcde68e650$export$b2b94ce8ba590cc8 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("dLBCq"))
});

const $08a008dcde68e650$export$e81d7afef87ae597 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("imXLO"))
});

const $08a008dcde68e650$export$31c6945718067be3 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("hL2wD")),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $08a008dcde68e650$export$6fc19cf1d90e9453 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && ((0, $4R6GH.fg)('perf-push-big-components-remove-incidents-resource') || (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources'))), $08a008dcde68e650$export$31c6945718067be3);
const $08a008dcde68e650$export$2e6b9e6402ff1d9b = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-5573-remove-incident-resouce')), $08a008dcde68e650$export$31c6945718067be3);

});
const $0ec4f2aa733ae93d$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $0ec4f2aa733ae93d$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("dLBCq", function(module, exports) {

let $a05cd876f683a893$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a05cd876f683a893$var$load("jEfvB").then(()=>parcelRequire('8lQN4'));

});

parcelRegister("imXLO", function(module, exports) {

let $d5f8a52d9862c97d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5f8a52d9862c97d$var$load("8rk6s").then(()=>parcelRequire('i0mY9'));

});

parcelRegister("hL2wD", function(module, exports) {

let $ced8c8f4a6c90a12$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ced8c8f4a6c90a12$var$load("ajWVH").then(()=>parcelRequire('iwLnj'));

});


parcelRegister("2lXzr", function(module, exports) {

$parcel$export(module.exports, "legacyAllReportsRoute", () => $b2d7e46ef8180055$export$549d32fceee24980);
const $b2d7e46ef8180055$export$549d32fceee24980 = {
    name: 'legacy-all-reports',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=(.*report-page.*)'
    ]
};

});

parcelRegister("fo6b8", function(module, exports) {

$parcel$export(module.exports, "jiraHorizontalNavEntrypoint", () => $a30042c3f693dfff$export$e9ee9fa1097f370e);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $LjVkh = parcelRequire("LjVkh");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $j5YhT = parcelRequire("j5YhT");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

const $a30042c3f693dfff$export$e9ee9fa1097f370e = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("dDJOG")), {
        moduleId: "99477251",
        moduleName: "HorizontalNavJiraInner"
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { cloudId: cloudId } })=>{
        const boardId = match.params.boardId;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectId || projectKey;
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
        const projectAri = projectId ? (0, $j5YhT.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        let containerNavigationInput;
        if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
            scopeId: boardAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        else containerNavigationInput = boardAri || projectAri ? {
            scopeId: boardAri || projectAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $LjVkh.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        withProject: Boolean(projectIdOrKey),
                        boardId: boardAri,
                        withBoard: Boolean(boardAri),
                        containerNavigationInput: containerNavigationInput,
                        isTMPBoardRoute: isTMPBoardRoute,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("LjVkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $153fec52554cdddf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8acc2bb4d423b1a64e57504f0dca893>>
 * @relayHash 3e46c73d092c57994860733b90d1d2eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36391aace986cda37532e00e3788ef8fbb4d823fd902c96261b7c95638a451ce

var $58v9Y = parcelRequire("58v9Y");

var $9pmwJ = parcelRequire("9pmwJ");
const $153fec52554cdddf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "36391aace986cda37532e00e3788ef8fbb4d823fd902c96261b7c95638a451ce",
        "metadata": {},
        "name": "HorizontalNavJiraInnerQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default)
        }
    }
};
var $153fec52554cdddf$export$2e2bcd8739ae039 = $153fec52554cdddf$var$node;

});
parcelRegister("58v9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a08f169582fc62e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2a08f169582fc62e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_custom_templates_ux');
    }
};

});

parcelRegister("9pmwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $979d1b4861d86eeb$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $979d1b4861d86eeb$var$JiraTeamButtonRelayProvider = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('team-connection-visibility-in-jira') && (0, $6s1PB.expVal)('team_and_container_m1', 'isEnabled', false));
    }
};
var $979d1b4861d86eeb$export$2e2bcd8739ae039 = $979d1b4861d86eeb$var$JiraTeamButtonRelayProvider;

});


parcelRegister("dDJOG", function(module, exports) {

let $9ee27513b8256f26$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9ee27513b8256f26$var$load("hPzOn"),
    $9ee27513b8256f26$var$load("eNmuD"),
    $9ee27513b8256f26$var$load("cM9em"),
    $9ee27513b8256f26$var$load("fr9NE"),
    $9ee27513b8256f26$var$load("h2MrD"),
    $9ee27513b8256f26$var$load("bYT2S"),
    $9ee27513b8256f26$var$load("luVbU")
]).then(()=>parcelRequire('l7ScM'));

});


parcelRegister("9dKjw", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $a33e8671883cd449$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $a33e8671883cd449$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $a33e8671883cd449$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("48Ij3", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $d94d5098764be5f8$export$5910307042ab3f6f);

var $8YTna = parcelRequire("8YTna");

var $2M1hQ = parcelRequire("2M1hQ");

var $7xeIG = parcelRequire("7xeIG");
const $d94d5098764be5f8$export$5910307042ab3f6f = (0, $2M1hQ.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $7xeIG.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000
});

});
parcelRegister("7xeIG", function(module, exports) {

$parcel$export(module.exports, "fetchJSWReports", () => $61400f9195fc4c28$export$a93a577d6971da2c);

var $eusud = parcelRequire("eusud");
const $61400f9195fc4c28$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $eusud.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("4Bwc0", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $5073d432665dfcf8$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $5073d432665dfcf8$export$e9adc6103e9ed514);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $5073d432665dfcf8$export$96cb0eae1b3413f4 = (0, $2M1hQ.createResource)({
    type: (0, $16165c7eb855363c$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("llYR0")),
    maxAge: 60000
});
const $5073d432665dfcf8$export$e9adc6103e9ed514 = ()=>(0, $2YP9W.useResource)($5073d432665dfcf8$export$96cb0eae1b3413f4);

});
const $16165c7eb855363c$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $16165c7eb855363c$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $16165c7eb855363c$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("llYR0", function(module, exports) {

let $f8bac370a50ce0d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8bac370a50ce0d2$var$load("goFaC").then(()=>parcelRequire('5aldt'));

});




parcelRegister("9lEpL", function(module, exports) {

$parcel$export(module.exports, "legacyBacklogRouteEntry", () => $6302afabc1b48086$export$e64dbc2432a0bfba);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6QKrH = parcelRequire("6QKrH");

var $9qrxm = parcelRequire("9qrxm");

var $5f2bR = parcelRequire("5f2bR");
const $6302afabc1b48086$export$e64dbc2432a0bfba = (0, $aTZGy.createLegacyEntry)((0, $9qrxm.legacyBacklogRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $6QKrH.LegacyPage),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource)
        ]
    }));

});
parcelRegister("7uLIV", function(module, exports) {

$parcel$export(module.exports, "horizontalNavJiraResource", () => $1769860a1d0fe224$export$faeb8c89315e20da);

var $ao2h1 = parcelRequire("ao2h1");

var $ivm9B = parcelRequire("ivm9B");

var $j5YhT = parcelRequire("j5YhT");

var $1nb22 = parcelRequire("1nb22");

var $3HwlS = parcelRequire("3HwlS");

var $ktofH = parcelRequire("ktofH");

var $gNStA = parcelRequire("gNStA");

var $6YG83 = parcelRequire("6YG83");
const $1769860a1d0fe224$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    const boardId = match.params.boardId;
    let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
    const projectAri = projectId ? (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString() : '';
    let containerNavigationInput;
    if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
        scopeId: boardAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    else containerNavigationInput = boardAri || projectAri ? {
        scopeId: boardAri || projectAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $ivm9B.default),
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            withProject: Boolean(projectIdOrKey),
            boardId: boardAri,
            withBoard: Boolean(boardAri),
            containerNavigationInput: containerNavigationInput,
            isTMPBoardRoute: isTMPBoardRoute,
            first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $1769860a1d0fe224$var$horizontalNavJiraResourceActual = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $1769860a1d0fe224$export$71eec30d9db46a56
}));
const $1769860a1d0fe224$export$faeb8c89315e20da = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)(), $1769860a1d0fe224$var$horizontalNavJiraResourceActual);

});
parcelRegister("ivm9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7cee9907baeab7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65aa3d0e80afa1ef1974b040e02308e6>>
 * @relayHash 3e46c73d092c57994860733b90d1d2eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36391aace986cda37532e00e3788ef8fbb4d823fd902c96261b7c95638a451ce

var $58v9Y = parcelRequire("58v9Y");

var $9pmwJ = parcelRequire("9pmwJ");

var $eiowN = parcelRequire("eiowN");
const $5e7cee9907baeab7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                                            "kind": "LinkedField",
                                            "name": "teamsConnected",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "36391aace986cda37532e00e3788ef8fbb4d823fd902c96261b7c95638a451ce",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default)
            }
        }
    };
}();
$5e7cee9907baeab7$var$node.hash = "cfedd5347d81ca2f36fa810c25c638f4";
(0, $eiowN.PreloadableQueryRegistry).set($5e7cee9907baeab7$var$node.params.id, $5e7cee9907baeab7$var$node);
var $5e7cee9907baeab7$export$2e2bcd8739ae039 = $5e7cee9907baeab7$var$node;

});


parcelRegister("9qrxm", function(module, exports) {

$parcel$export(module.exports, "legacyBacklogRoute", () => $c1f126a508d98f9f$export$c51fda014ab27b5d);
const $c1f126a508d98f9f$export$c51fda014ab27b5d = {
    name: 'legacy-backlog',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(.*planning.*)'
    ]
};

});

parcelRegister("5f2bR", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavJira", () => $8a898ce31719feb2$export$ea83697d960a1a23);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");

var $3HwlS = parcelRequire("3HwlS");

var $7XYc4 = parcelRequire("7XYc4");

var $5NiYd = parcelRequire("5NiYd");

var $l71WK = parcelRequire("l71WK");

var $lfTZh = parcelRequire("lfTZh");

const $8a898ce31719feb2$var$LazyHorizontalNavJira = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gQ387")).then((HorizontalNavJira)=>HorizontalNavJira), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jira/src/ui/HorizontalNavJira.tsx"
});
const $8a898ce31719feb2$var$AsyncHorizontalNav = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-nav-jira",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NiYd.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8a898ce31719feb2$var$LazyHorizontalNavJira, null));
const $8a898ce31719feb2$export$ea83697d960a1a23 = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $8a898ce31719feb2$var$AsyncHorizontalNav, (0, $l71WK.AsyncHorizontalProjectNav));

});
parcelRegister("5NiYd", function(module, exports) {

$parcel$export(module.exports, "HorizontalNavSkeleton", () => $0a3d218ca404c936$export$e29d51df5420bf39);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");
const $0a3d218ca404c936$export$807fef2beb9debc2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $0a3d218ca404c936$var$tabsWrapperSkeletonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }));
const $0a3d218ca404c936$export$e29d51df5420bf39 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050",
        alignBlock: "end",
        xcss: [
            $0a3d218ca404c936$var$horizontalNavWrapperStyles,
            (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && $0a3d218ca404c936$var$horizontalNavWrapperStylesNew
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$breadcrumbStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        xcss: $0a3d218ca404c936$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3d218ca404c936$var$primaryContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$projectTitleStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.150",
        xcss: $0a3d218ca404c936$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a3d218ca404c936$export$807fef2beb9debc2, null));
const $0a3d218ca404c936$var$tabsWrapperSkeletonStyles = (0, $8CUq3.xcss)({
    gap: 'space.150',
    height: '32px',
    paddingInlineStart: 'space.300',
    paddingInlineEnd: 'space.300',
    paddingBlockEnd: 'space.150',
    marginBlockStart: 'space.100',
    position: 'relative',
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'color.skeleton',
        height: '2px',
        left: '0',
        right: '0'
    }
});
const $0a3d218ca404c936$var$tabSkeletonStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-1000, 80px)",
    backgroundColor: 'color.skeleton',
    borderRadius: "var(--ds-border-radius, 4px)"
});
const $0a3d218ca404c936$var$horizontalNavWrapperStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.300',
    minBlockSize: '122px'
});
// merge to main styling and remove it when cleaning blu-6305_tab_item_styling_in_horizontal_navigation
const $0a3d218ca404c936$var$horizontalNavWrapperStylesNew = (0, $8CUq3.xcss)({
    minBlockSize: '130px'
});
const $0a3d218ca404c936$var$baseSkeletonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $0a3d218ca404c936$var$breadcrumbStyles = (0, $8CUq3.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '60px',
    marginInlineStart: 'space.300',
    marginBlockEnd: 'space.025'
});
const $0a3d218ca404c936$var$primaryContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.100',
    marginInlineStart: 'space.300'
});
const $0a3d218ca404c936$var$squareStyles = (0, $8CUq3.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: "var(--ds-space-300, 24px)"
});
const $0a3d218ca404c936$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.050'
});
const $0a3d218ca404c936$var$projectTitleStyles = (0, $8CUq3.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '180px'
});
const $0a3d218ca404c936$var$actionStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.300'
});

});

parcelRegister("l71WK", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalProjectNav", () => $7e6dac351b79a914$export$862dd1c0126bb181);
$parcel$export(module.exports, "AsyncHorizontalOverviewNav", () => $7e6dac351b79a914$export$beabdf5c49f01377);
/* eslint-disable jira/import/webpack-magic-comment-entries */ 
var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $7e6dac351b79a914$var$LazyHorizontalProjectNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cX2JU")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
});
const $7e6dac351b79a914$export$862dd1c0126bb181 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalProjectNav, null));

const $7e6dac351b79a914$var$LazyHorizontalOverviewNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dpjvY")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
});
const $7e6dac351b79a914$export$beabdf5c49f01377 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalOverviewNav, null));

});
parcelRegister("cX2JU", function(module, exports) {

let $96dd1ebb71ff5b61$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $96dd1ebb71ff5b61$var$load("kfXhT"),
    $96dd1ebb71ff5b61$var$load("2Lfdl"),
    $96dd1ebb71ff5b61$var$load("hPzOn"),
    $96dd1ebb71ff5b61$var$load("eNmuD"),
    $96dd1ebb71ff5b61$var$load("h2MrD"),
    $96dd1ebb71ff5b61$var$load("bYT2S"),
    $96dd1ebb71ff5b61$var$load("cM9em"),
    $96dd1ebb71ff5b61$var$load("fr9NE"),
    $96dd1ebb71ff5b61$var$load("4RRJO")
]).then(()=>parcelRequire('bwmXM'));

});

parcelRegister("dpjvY", function(module, exports) {

let $9c2cbf5bd1101a0d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9c2cbf5bd1101a0d$var$load("hPzOn"),
    $9c2cbf5bd1101a0d$var$load("h2MrD"),
    $9c2cbf5bd1101a0d$var$load("bYT2S"),
    $9c2cbf5bd1101a0d$var$load("eNmuD"),
    $9c2cbf5bd1101a0d$var$load("cM9em"),
    $9c2cbf5bd1101a0d$var$load("fr9NE"),
    $9c2cbf5bd1101a0d$var$load("hTo1l")
]).then(()=>parcelRequire('bNzBR'));

});


parcelRegister("gQ387", function(module, exports) {

let $c423ee3cd4a1308d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c423ee3cd4a1308d$var$load("hPzOn"),
    $c423ee3cd4a1308d$var$load("eNmuD"),
    $c423ee3cd4a1308d$var$load("cM9em"),
    $c423ee3cd4a1308d$var$load("fr9NE"),
    $c423ee3cd4a1308d$var$load("h2MrD"),
    $c423ee3cd4a1308d$var$load("bYT2S"),
    $c423ee3cd4a1308d$var$load("2Ed9h")
]).then(()=>parcelRequire('5zGmz'));

});



parcelRegister("BHTa6", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRapidViewRouteEntry", () => $4db09604e5b94206$export$36cfd1ed8d73fe4e);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6QKrH = parcelRequire("6QKrH");

var $1ZEY4 = parcelRequire("1ZEY4");

var $5f2bR = parcelRequire("5f2bR");
const $4db09604e5b94206$export$36cfd1ed8d73fe4e = (0, $aTZGy.createLegacyEntry)((0, $1ZEY4.legacyBoardRapidViewRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $6QKrH.LegacyPage),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource)
        ]
    }));

});
parcelRegister("1ZEY4", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRapidViewRoute", () => $2a9b6a00e38d37d3$export$4c8472ef2f57845f);
const $2a9b6a00e38d37d3$export$4c8472ef2f57845f = {
    name: 'legacy-board',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ]
};

});


parcelRegister("lOa5w", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRouteEntry", () => $e72e71ac2e5a85f0$export$e3d172b0d9fd0d47);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6QKrH = parcelRequire("6QKrH");

var $03e8Z = parcelRequire("03e8Z");

var $5f2bR = parcelRequire("5f2bR");
const $e72e71ac2e5a85f0$export$e3d172b0d9fd0d47 = (0, $aTZGy.createLegacyEntry)((0, $03e8Z.legacyBoardRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $6QKrH.LegacyPage),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource)
        ]
    }));

});
parcelRegister("03e8Z", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRoute", () => $5a545e4ef344123c$export$9259d0f05fc27139);
const $5a545e4ef344123c$export$9259d0f05fc27139 = {
    name: 'legacy-board',
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("V8lCn", function(module, exports) {

$parcel$export(module.exports, "legacyConnectGeneralRouteEntry", () => $cf28abc1cd318a7d$export$5f816cf76ff922b8);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $aPfsS = parcelRequire("aPfsS");

var $hz6Yb = parcelRequire("hz6Yb");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $lv287 = parcelRequire("lv287");
const $cf28abc1cd318a7d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $cf28abc1cd318a7d$export$5f816cf76ff922b8 = (0, $aTZGy.createLegacyEntry)((0, $lv287.legacyConnectGeneralRoute), ()=>({
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        resources: [
            (0, $hz6Yb.connectGeneralResources),
            (0, $atU1t.navigationSidebarGlobalResource),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$cf28abc1cd318a7d$var$pageEntryPoint
    }));

});
parcelRegister("hz6Yb", function(module, exports) {

$parcel$export(module.exports, "connectGeneralResources", () => $07e636c36bc19b52$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $07e636c36bc19b52$export$53479840ec6d4024);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $07e636c36bc19b52$export$f34ab0d904621847 = (0, $2M1hQ.createResource)({
    type: (0, $1130bd470474fe6f$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("68gkZ"))
});
const $07e636c36bc19b52$export$53479840ec6d4024 = ()=>(0, $2YP9W.useResource)($07e636c36bc19b52$export$f34ab0d904621847);

});
const $1130bd470474fe6f$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("68gkZ", function(module, exports) {

let $0126f86a480a67fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0126f86a480a67fd$var$load("W2aDd").then(()=>parcelRequire('6LiLg'));

});


parcelRegister("lv287", function(module, exports) {

$parcel$export(module.exports, "legacyConnectGeneralRoute", () => $c2b6643a232d7c03$export$837edad42702a8e5);
const $c2b6643a232d7c03$export$837edad42702a8e5 = {
    name: 'legacy-connect-general',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey'
};

});


parcelRegister("dG4Nb", function(module, exports) {

$parcel$export(module.exports, "legacyConnectProjectRouteEntry", () => $f8bbf7b06484c6af$export$c7f411b1904e5c2a);

var $fo6b8 = parcelRequire("fo6b8");

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $9UABi = parcelRequire("9UABi");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $7GnDe = parcelRequire("7GnDe");

var $7QSkt = parcelRequire("7QSkt");
const $f8bbf7b06484c6af$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $f8bbf7b06484c6af$export$c7f411b1904e5c2a = (0, $aTZGy.createLegacyEntry)((0, $7QSkt.legacyConnectProjectRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            (0, $9UABi.connectProjectResources),
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f8bbf7b06484c6af$var$pageEntryPoint
    }));

});
parcelRegister("9UABi", function(module, exports) {

$parcel$export(module.exports, "connectProjectResources", () => $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $8Vh1q = parcelRequire("8Vh1q");

var $ggg5j = parcelRequire("ggg5j");

var $2M1hQ = parcelRequire("2M1hQ");


const $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7 = (0, $2M1hQ.createResource)({
    type: (0, $35b0c7feb103121f$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $8Vh1q.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $ggg5j.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("3lgtI"))
});

});
parcelRegister("8Vh1q", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $beff5be7f4728df2$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $beff5be7f4728df2$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $beff5be7f4728df2$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $beff5be7f4728df2$export$752ef5ab3d7ab15f);

var $2YZCu = parcelRequire("2YZCu");

var $6VnTH = parcelRequire("6VnTH");

var $3HwlS = parcelRequire("3HwlS");

var $bsuuc = parcelRequire("bsuuc");
const $beff5be7f4728df2$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        structuredContext = {
            ...structuredContext,
            jira: {
                ...structuredContext.jira,
                horizontalNavigation: (0, $3HwlS.getWillShowNav4)()
            }
        };
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $2YZCu.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $beff5be7f4728df2$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $beff5be7f4728df2$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $beff5be7f4728df2$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $bsuuc.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $6VnTH.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $beff5be7f4728df2$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $beff5be7f4728df2$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $beff5be7f4728df2$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("6VnTH", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4d73b10ca351bbb3$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $4d73b10ca351bbb3$export$67db9e2d1b6ed865);
const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $35b0c7feb103121f$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("3lgtI", function(module, exports) {

let $26f01d85e144aa9e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $26f01d85e144aa9e$var$load("g7yss").then(()=>parcelRequire('4ECv0'));

});


parcelRegister("fpjJX", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $491f4fde535ee8ab$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $491f4fde535ee8ab$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $491f4fde535ee8ab$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $491f4fde535ee8ab$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $491f4fde535ee8ab$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $491f4fde535ee8ab$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getIssueListSsrResource", () => $491f4fde535ee8ab$export$e1016cce62543991);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $491f4fde535ee8ab$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $491f4fde535ee8ab$export$9e0cf1fab0581096);
$parcel$export(module.exports, "getQueueConfigResource", () => $491f4fde535ee8ab$export$5f7bcaa978a3e51);
$parcel$export(module.exports, "getQueueViewConfigResource", () => $491f4fde535ee8ab$export$54079077c6768752);

var $aIZdc = parcelRequire("aIZdc");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $b2pl3 = parcelRequire("b2pl3");

var $gS5PF = parcelRequire("gS5PF");

var $jYeNO = parcelRequire("jYeNO");

var $6zFAI = parcelRequire("6zFAI");

var $gcI3W = parcelRequire("gcI3W");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $bjZiV = parcelRequire("bjZiV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $8H3A4 = parcelRequire("8H3A4");

var $cAofY = parcelRequire("cAofY");

var $aNLeB = parcelRequire("aNLeB");

var $eUvlM = parcelRequire("eUvlM");

var $lbaDt = parcelRequire("lbaDt");

var $1WlLE = parcelRequire("1WlLE");

var $2cxgG = parcelRequire("2cxgG");

var $6sNnq = parcelRequire("6sNnq");

var $7GnDe = parcelRequire("7GnDe");

var $gNStA = parcelRequire("gNStA");

var $gRzZD = parcelRequire("gRzZD");

var $6s1PB = parcelRequire("6s1PB");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $lJ1FP = parcelRequire("lJ1FP");
const $491f4fde535ee8ab$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...$491f4fde535ee8ab$export$41a9145ddbba28e5()
    ];
const $491f4fde535ee8ab$var$fetchPriorityGroupByProjectId = ()=>(0, $4R6GH.fg)('jsm_flash_priority_group_api_optimisation') && !(0, $3HwlS.getWillShowNav4)();
const $491f4fde535ee8ab$export$41a9145ddbba28e5 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>$491f4fde535ee8ab$var$fetchPriorityGroupByProjectId(), (0, $dxCvy.projectContextResource)),
        ...$491f4fde535ee8ab$export$9c1c5e389bd00e56(),
        ...$491f4fde535ee8ab$export$2c543d6accc1eb9b()
    ];
const $491f4fde535ee8ab$var$isNav4ResourcesFixEnabled = ()=>(0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('hot-113350-ssr-jsm-project-menu-fix', 'isEnabled', false);
const $491f4fde535ee8ab$export$9c1c5e389bd00e56 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!$491f4fde535ee8ab$var$fetchPriorityGroupByProjectId(), (0, $1WlLE.priorityGroupResource)),
        (0, $gNStA.resourceWithCondition2)(()=>$491f4fde535ee8ab$var$fetchPriorityGroupByProjectId(), (0, $1WlLE.priorityGroupByProjectIdResource)),
        (0, $6sNnq.featuresResource),
        (0, $gS5PF.staticSidebarJsmReportsResource),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $bHhiy.getConsolidationStateResource)()),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $aNLeB.servicedeskIsItsmProjectResource))
    ];
const $491f4fde535ee8ab$export$2c543d6accc1eb9b = ()=>[
        (0, $1WlLE.queuesNavigationItems),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_nav4_queues_sidebar'), (0, $lbaDt.requiredProjectProperties)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_nav4_queues_sidebar'), (0, $lbaDt.requiredFrontendProperties)),
        (0, $5bkvv.forgeServiceDeskQueueModuleResource),
        (0, $b2pl3.staticJSMProjectConnectAddonsNavigationResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        // for Getting Started menu item
        // resourceWithCondition2(isNav4ResourcesFixEnabled, requiredFrontendProperties),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $dxCvy.projectContextResourceWithCache)),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $lbaDt.firstProjectResource))
    ];
const $491f4fde535ee8ab$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $eUvlM.servicedeskPracticesResource),
        (0, $cAofY.serviceDeskContextResource),
        (0, $8H3A4.serviceDeskAnalyticsContextResource),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $aIZdc.isFedRamp)(), (0, $2cxgG.virtualAgentOnboardingResource))
    ];
const $491f4fde535ee8ab$export$a8b852f03a310dc0 = ()=>[
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $cAofY.serviceDeskContextResource),
        (0, $8H3A4.serviceDeskAnalyticsContextResource)
    ];
const $491f4fde535ee8ab$export$70b97995f4d5ef9f = ()=>[
        ...$491f4fde535ee8ab$export$a8b852f03a310dc0(),
        ...$491f4fde535ee8ab$export$bc0bd65e6da57c1f(),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $co1wz.ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, $eUvlM.servicedeskPracticesResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues'), (0, $jYeNO.getCalendarFilterFieldsResource)())
    ];
const $491f4fde535ee8ab$export$e1016cce62543991 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_view_queues_issuelist'), (0, $1WlLE.issueListSsrResource))
    ];
const $491f4fde535ee8ab$export$ed87d3b71544c4ef = ()=>[
        (0, $bjZiV.kbConfluenceContextResource)
    ];
const $491f4fde535ee8ab$export$9e0cf1fab0581096 = ()=>[
        (0, $gRzZD.workspaceResource)
    ];
const $491f4fde535ee8ab$export$5f7bcaa978a3e51 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $1WlLE.priorityGroupResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dxCvy.projectContextResource))
    ];
const $491f4fde535ee8ab$export$54079077c6768752 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $f5kpo.getRapidBoardDataResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $lJ1FP.getEditModelResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $lfnsv.getBoardDetailsResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $1WlLE.priorityGroupResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dxCvy.projectContextResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $f7Y15.uifBoardResource)),
        ...(0, $f5kpo.getRapidboardResources)().map((resource)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), resource))
    ];

});
parcelRegister("gS5PF", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $e7e607725980fdf6$export$ec28065a31cce4ce);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $cQGRH = parcelRequire("cQGRH");
const $e7e607725980fdf6$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e7e607725980fdf6$export$ec28065a31cce4ce = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$e7e607725980fdf6$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e7e607725980fdf6$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $cQGRH.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("cQGRH", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $ed2ba0d649a8d8eb$export$c1dd51127051647d);

var $eusud = parcelRequire("eusud");
const $ed2ba0d649a8d8eb$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("jYeNO", function(module, exports) {

$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $4dc70aab7904ddfa$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $4dc70aab7904ddfa$export$70361b748d216408);

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4R6GH = parcelRequire("4R6GH");

var $3ezTL = parcelRequire("3ezTL");


var $30Hlr = parcelRequire("30Hlr");
const $4dc70aab7904ddfa$var$fetchFilterFields = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $8c2713286c62bdd7$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: {
                        searchString: (0, $3ezTL.REQUEST_TYPE_FILTER)
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return (0, $30Hlr.transformAndReport)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) (0, $30Hlr.reportError)(error);
        return 0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $4dc70aab7904ddfa$var$filterFieldsResource = (0, $2M1hQ.createResource)({
    type: (0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ({ match: match, query: query })=>{
        if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) {
            const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD) + projectIdOrKey;
        }
        return 0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD;
    },
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        const jqlContext = `project = '${projectIdOrKey}'`;
        return $4dc70aab7904ddfa$var$fetchFilterFields(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $4dc70aab7904ddfa$export$5f02bf5f04197ed7 = ()=>$4dc70aab7904ddfa$var$filterFieldsResource;
const $4dc70aab7904ddfa$export$70361b748d216408 = ()=>(0, $2YP9W.useResource)($4dc70aab7904ddfa$var$filterFieldsResource);

});
parcelRegister("3ezTL", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $2fdfca9bb2287268$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $2fdfca9bb2287268$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $2fdfca9bb2287268$export$d57b6b390e78d90f);
$parcel$export(module.exports, "REQUEST_TYPE_FILTER", () => $2fdfca9bb2287268$export$2c388650eabddf5e);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $2fdfca9bb2287268$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $2fdfca9bb2287268$export$2912f30d4328fc00);
const $2fdfca9bb2287268$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $2fdfca9bb2287268$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $2fdfca9bb2287268$export$d57b6b390e78d90f = 'jsd-shield';
const $2fdfca9bb2287268$export$2c388650eabddf5e = 'request type';
const $2fdfca9bb2287268$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $2fdfca9bb2287268$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

const $8c2713286c62bdd7$export$2b91517d6d5b4365 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;

parcelRegister("30Hlr", function(module, exports) {

$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $f86becf4a18b4f1f$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $f86becf4a18b4f1f$export$b33b857ad1d9900e);
$parcel$export(module.exports, "transformAndReport", () => $f86becf4a18b4f1f$export$af2aa11c88c551af);

var $jcw0u = parcelRequire("jcw0u");

var $3ezTL = parcelRequire("3ezTL");
const $f86becf4a18b4f1f$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $f86becf4a18b4f1f$export$b33b857ad1d9900e = (error)=>{
    (0, $jcw0u.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $3ezTL.RESOURCE_TYPE_NAME),
            packageName: (0, $3ezTL.PACKAGE_NAME),
            teamName: (0, $3ezTL.TEAM_NAME)
        }
    });
};
const $f86becf4a18b4f1f$export$af2aa11c88c551af = (response)=>{
    const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
    // There may be ambigious custom fields with same name, so find the correct one and pass to JQLBuilder
    const requestType = edges?.find((edge)=>edge?.node?.type === $f86becf4a18b4f1f$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
    if (!requestType) $f86becf4a18b4f1f$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
    // if requestType field found, add it to existing default calendar filter fields
    return requestType ? [
        {
            ...requestType,
            searchTemplate: requestType.searchTemplate.key,
            fieldType: requestType.type
        },
        ...(0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS)
    ] : (0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS);
};

});


parcelRegister("bjZiV", function(module, exports) {

$parcel$export(module.exports, "kbConfluenceContextResource", () => $450040dc63d5cc0e$export$8b58be1423986d17);

var $2M1hQ = parcelRequire("2M1hQ");


const $450040dc63d5cc0e$var$getDataLoader = ()=>(parcelRequire("9vHSl"));
const $450040dc63d5cc0e$export$8b58be1423986d17 = (0, $2M1hQ.createResource)({
    type: (0, $3139e13cdf89be01$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $450040dc63d5cc0e$var$getDataLoader,
    maxAge: Infinity
});

});
const $3139e13cdf89be01$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("9vHSl", function(module, exports) {

let $6ec90b0ff8c4d279$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ec90b0ff8c4d279$var$load("2CTCs").then(()=>parcelRequire('2SeLy'));

});


parcelRegister("8H3A4", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $4d76b3bac8f2b7c8$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $4d76b3bac8f2b7c8$export$bc2de1c42df30b10);

var $5uXOq = parcelRequire("5uXOq");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $4d76b3bac8f2b7c8$var$getDataLoader = ()=>(parcelRequire("6CvjL"));
const $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS = 86400000;
const $4d76b3bac8f2b7c8$export$d6f4f0483916919f = (0, $2M1hQ.createResource)({
    type: (0, $3b4b6bf0bbdfa955$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $4d76b3bac8f2b7c8$var$getDataLoader,
    maxAge: $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS
});
const $4d76b3bac8f2b7c8$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($4d76b3bac8f2b7c8$export$d6f4f0483916919f);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $3b4b6bf0bbdfa955$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("6CvjL", function(module, exports) {

let $4d1e95bdbe0f0190$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4d1e95bdbe0f0190$var$load("eNmuD"),
    $4d1e95bdbe0f0190$var$load("3rvO2")
]).then(()=>parcelRequire('btHFe'));

});


parcelRegister("cAofY", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $9c517de0cdc23225$export$5eaaf465969a9171);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("2WfJW"));
const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, $2M1hQ.createResource)({
    type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $dK8AG.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $9c517de0cdc23225$var$getDataLoader,
    maxAge: Infinity
});

});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("2WfJW", function(module, exports) {

let $223d3531a11189cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $223d3531a11189cf$var$load("iNITq").then(()=>parcelRequire('g4PUK'));

});


parcelRegister("aNLeB", function(module, exports) {

$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $31e43d0718118496$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $31e43d0718118496$export$7bb46948fb84f164);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $31e43d0718118496$var$getDataLoader = ()=>(parcelRequire("llgGA"));
const $31e43d0718118496$var$ONE_DAY_IN_MILLIS = 86400000;
const $31e43d0718118496$export$920308cef4e291b1 = (0, $2M1hQ.createResource)({
    type: (0, $6249ccfa4eeeb82a$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $31e43d0718118496$var$getDataLoader,
    maxAge: $31e43d0718118496$var$ONE_DAY_IN_MILLIS
});
const $31e43d0718118496$export$7bb46948fb84f164 = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)($31e43d0718118496$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $6249ccfa4eeeb82a$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("llgGA", function(module, exports) {

let $f8988094fa9dc0bc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f8988094fa9dc0bc$var$load("eNmuD"),
    $f8988094fa9dc0bc$var$load("4CXUh")
]).then(()=>parcelRequire('k9PUn'));

});


parcelRegister("eUvlM", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $9479f477b801290f$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $9479f477b801290f$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $9479f477b801290f$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $9479f477b801290f$export$4d46346ef0bdc6b9);

var $5uXOq = parcelRequire("5uXOq");

var $dK8AG = parcelRequire("dK8AG");

var $oCMSG = parcelRequire("oCMSG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9479f477b801290f$var$getDataLoader = ()=>(parcelRequire("4Wb3o"));
const $9479f477b801290f$var$ONE_DAY_IN_MILLIS = 86400000;
const $9479f477b801290f$export$2ae319305481e7de = (0, $2M1hQ.createResource)({
    type: (0, $990f0449915d93bf$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $9479f477b801290f$var$getDataLoader,
    maxAge: $9479f477b801290f$var$ONE_DAY_IN_MILLIS
});
const $9479f477b801290f$var$queuesOrder = [
    ...(0, $oCMSG.WORK_CATEGORIES_QUEUE_SUPPORTED)
];
const $9479f477b801290f$var$workCategoryOrder = [
    ...$9479f477b801290f$var$queuesOrder,
    (0, $oCMSG.DEVELOPER_ESCALATION)
];
const $9479f477b801290f$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
parcelRegister("oCMSG", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $4f9c4406e75c8aa5$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $4f9c4406e75c8aa5$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $4f9c4406e75c8aa5$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $4f9c4406e75c8aa5$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $4f9c4406e75c8aa5$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $4f9c4406e75c8aa5$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $4f9c4406e75c8aa5$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $4f9c4406e75c8aa5$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $4f9c4406e75c8aa5$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $4f9c4406e75c8aa5$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $4f9c4406e75c8aa5$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $4f9c4406e75c8aa5$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", () => $4f9c4406e75c8aa5$export$a2b1f8f055150f02);
$parcel$export(module.exports, "ItsmPracticeToShortForm", () => $4f9c4406e75c8aa5$export$56c57f7ad650c45c);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $4f9c4406e75c8aa5$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $4f9c4406e75c8aa5$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", () => $4f9c4406e75c8aa5$export$45952424a7f29b99);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $4f9c4406e75c8aa5$export$6c24c440228eac9c);
$parcel$export(module.exports, "INCIDENTS_JQL_NAME", () => $4f9c4406e75c8aa5$export$5b65d27ec2d28d18);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $4f9c4406e75c8aa5$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $4f9c4406e75c8aa5$export$b78213db77524b5b);

var $7c0in = parcelRequire("7c0in");

var $kVZSN = parcelRequire("kVZSN");
const $4f9c4406e75c8aa5$export$8598196f74460271 = 'change-management';
const $4f9c4406e75c8aa5$export$a50b49a533b5f7bc = 'incident-management';
const $4f9c4406e75c8aa5$export$ceba70db1edb1def = 'problem-management';
const $4f9c4406e75c8aa5$export$3d1cda9bd50505e8 = 'service-request';
const $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f = 'post-incident-review';
const $4f9c4406e75c8aa5$export$81e62964cc725098 = 'developer-escalation';
const $4f9c4406e75c8aa5$export$485b1216c42d8d4 = 'no-category';
const $4f9c4406e75c8aa5$var$NO_CATEGORY_NEW = 'no-category-new';
const $4f9c4406e75c8aa5$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $4f9c4406e75c8aa5$export$a50185c8e9fb007e = 'changes';
const $4f9c4406e75c8aa5$export$a54a30a3c3cce634 = 'incidents';
const $4f9c4406e75c8aa5$export$354f3a4c6ac0c903 = 'problems';
const $4f9c4406e75c8aa5$export$335d3ac0c367f03f = 'service-requests';
const $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $4f9c4406e75c8aa5$export$cb41b99ca54e6bd = 'developer-escalations';
const $4f9c4406e75c8aa5$export$a613d808168c7b25 = [
    $4f9c4406e75c8aa5$export$8598196f74460271,
    $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
    $4f9c4406e75c8aa5$export$ceba70db1edb1def,
    $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
    $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f,
    $4f9c4406e75c8aa5$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $4f9c4406e75c8aa5$export$a2b1f8f055150f02 = [
    $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
    $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
    $4f9c4406e75c8aa5$export$ceba70db1edb1def,
    $4f9c4406e75c8aa5$export$8598196f74460271,
    $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $4f9c4406e75c8aa5$export$5a9122a4028fb8ef = [
    ...$4f9c4406e75c8aa5$export$a2b1f8f055150f02,
    $4f9c4406e75c8aa5$export$485b1216c42d8d4
];
const $4f9c4406e75c8aa5$export$f1b813cd23817ade = [
    $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
    $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
    $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
    $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
    $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
    $4f9c4406e75c8aa5$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $4f9c4406e75c8aa5$export$56c57f7ad650c45c = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
    [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: $4f9c4406e75c8aa5$var$NO_CATEGORY_NEW
};
const $4f9c4406e75c8aa5$export$fbf0dfd01228e38d = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, $kVZSN.default).changes,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, $kVZSN.default).serviceRequests,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, $kVZSN.default).problems,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, $kVZSN.default).incidents,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, $kVZSN.default).postIncidentReviews,
    [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, $kVZSN.default).queues,
    [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, $kVZSN.default).developerEscalation,
    [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, $kVZSN.default).noCategory
};
const $4f9c4406e75c8aa5$export$45ba5f49e9509c4d = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, $kVZSN.default).changesLower,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, $kVZSN.default).serviceRequestsLower,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, $kVZSN.default).problemsLower,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, $kVZSN.default).incidentsLower,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, $kVZSN.default).postIncidentReviewsLower,
    [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, $kVZSN.default).queuesLower,
    [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, $kVZSN.default).developerEscalationLower,
    [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, $kVZSN.default).noCategoryLower
};
const $4f9c4406e75c8aa5$export$45952424a7f29b99 = (0, $7c0in.getTypedKeys)($4f9c4406e75c8aa5$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
    // cannot type .indexOf() as not-string in Ts, therefore need to use .find(). And shows error if `key` in acc[key] being of wider type than the result (than ItsmPracticeCategory), therefore, need to use different keys in the `acc[queueKey] =` line
    const queueKey = $4f9c4406e75c8aa5$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
    if (queueKey) acc[queueKey] = $4f9c4406e75c8aa5$export$fbf0dfd01228e38d[labelMapKey];
    return acc;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
}, {});
const $4f9c4406e75c8aa5$export$6c24c440228eac9c = 'Changes';
const $4f9c4406e75c8aa5$export$5b65d27ec2d28d18 = 'Incidents';
const $4f9c4406e75c8aa5$var$PROBLEMS_JQL_NAME = 'Problems';
const $4f9c4406e75c8aa5$var$SERVICE_REQUEST_JQL_NAME = 'Service requests';
const $4f9c4406e75c8aa5$var$POST_INCIDENT_REVIEWS_JQL_NAME = 'Post-incident reviews';
const $4f9c4406e75c8aa5$export$3f757c5e00588ffd = 'Developer escalation';
const $4f9c4406e75c8aa5$export$b78213db77524b5b = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$6c24c440228eac9c,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$5b65d27ec2d28d18,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$var$PROBLEMS_JQL_NAME,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$var$SERVICE_REQUEST_JQL_NAME,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$var$POST_INCIDENT_REVIEWS_JQL_NAME,
    [$4f9c4406e75c8aa5$export$81e62964cc725098]: $4f9c4406e75c8aa5$export$3f757c5e00588ffd
};

});
parcelRegister("7c0in", function(module, exports) {

$parcel$export(module.exports, "hasProp", () => $2dc9189f096b533d$export$dd642ef726dcde21);
$parcel$export(module.exports, "getTypedKeys", () => $2dc9189f096b533d$export$5206d47972fefe20);
/**
 * Use to remove `TS2339: Property 'id' does not exist on type 'object'` errors, e.g. when checking/refining variable of `unknown' type
 */ const $2dc9189f096b533d$export$dd642ef726dcde21 = (data, prop)=>prop in data;
const $2dc9189f096b533d$export$5206d47972fefe20 = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(obj);
};

});

parcelRegister("kVZSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d218b9a030da8fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5d218b9a030da8fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});


const $990f0449915d93bf$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("4Wb3o", function(module, exports) {

let $39852742b1504c54$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39852742b1504c54$var$load("jhLKO").then(()=>parcelRequire('8khb6'));

});


parcelRegister("lbaDt", function(module, exports) {

$parcel$export(module.exports, "requiredProjectProperties", () => $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $3477ceb4f9b98b2e$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $3477ceb4f9b98b2e$export$f620cebb7e8eeeae);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
const $3477ceb4f9b98b2e$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];

const $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("cB0XL"));
const $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader,
    maxAge: 300000
});

const $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("5QIw2"));
const $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS = 86400000;
const $3477ceb4f9b98b2e$export$47241956725e3029 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS
});

const $3477ceb4f9b98b2e$var$getFirstProjectDataLoader = ()=>(parcelRequire("3sevG"));
const $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS = 43200000;
const $3477ceb4f9b98b2e$export$f620cebb7e8eeeae = (0, $2M1hQ.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: $3477ceb4f9b98b2e$var$getFirstProjectDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS
});

});
parcelRegister("cB0XL", function(module, exports) {

let $92b9aff04352e21b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92b9aff04352e21b$var$load("7aPU6").then(()=>parcelRequire('d4USv'));

});

parcelRegister("5QIw2", function(module, exports) {

let $442456f5c4332281$var$load = (parcelRequire("28QjX"))(4);
module.exports = $442456f5c4332281$var$load("4Lrpj").then(()=>parcelRequire('7UDgf'));

});

parcelRegister("3sevG", function(module, exports) {

let $283f3e089e6ae6ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $283f3e089e6ae6ab$var$load("i5GnG").then(()=>parcelRequire('KbkKO'));

});


parcelRegister("1WlLE", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $c68314f43531feff$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $c68314f43531feff$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResource", () => $c68314f43531feff$export$f6133a181a1ec201);
$parcel$export(module.exports, "issueListSsrResource", () => $c68314f43531feff$export$3d03cbaac8581e65);

var $9XE6b = parcelRequire("9XE6b");

var $jcw0u = parcelRequire("jcw0u");


var $jthxb = parcelRequire("jthxb");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $8w6CZ = parcelRequire("8w6CZ");

var $fRrvi = parcelRequire("fRrvi");

const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("17Fyq"));

const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("5u46E"));

const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("57gkn"));
const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
const $c68314f43531feff$export$4fed8be571897bef = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $c68314f43531feff$var$getDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$1f9ab301771fe42e = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $c68314f43531feff$export$f6133a181a1ec201 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    isBrowserOnly: true,
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
});
const $c68314f43531feff$export$3d03cbaac8581e65 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});

});
parcelRegister("jthxb", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $c406e66b8b597668$export$a973ef9e17a326f);
async function $c406e66b8b597668$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("8w6CZ", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $a4c66eaf20e13a4d$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $a4c66eaf20e13a4d$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID", () => $a4c66eaf20e13a4d$export$efa043b0bbc0ab6d);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $a4c66eaf20e13a4d$export$2733615da5b906f0);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $a4c66eaf20e13a4d$export$5a00268156ea5027);
const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $a4c66eaf20e13a4d$export$efa043b0bbc0ab6d = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID';
const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;

});

parcelRegister("fRrvi", function(module, exports) {

$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $2d01df2d1057a1ad$export$cf2bd2ec601ed920);

var $fn8B5 = parcelRequire("fn8B5");

var $bFU4G = parcelRequire("bFU4G");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $2d01df2d1057a1ad$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsById = async (projectId, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectId=${projectId}`);
};
const $2d01df2d1057a1ad$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    const fetchStartTime = performance.now();
    let data;
    if (projectId) {
        data = await $2d01df2d1057a1ad$var$fetchGroupsById(projectId, cloudId);
        (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroupsByProjectId', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    } else {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $2d01df2d1057a1ad$var$fetchGroupsByKey(projectKey, cloudId);
        (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroups', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category'); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});


parcelRegister("17Fyq", function(module, exports) {

let $0d16adb72e72a0d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0d16adb72e72a0d2$var$load("eNmuD"),
    $0d16adb72e72a0d2$var$load("fYHqp")
]).then(()=>parcelRequire('lini2'));

});

parcelRegister("5u46E", function(module, exports) {

let $3fe2f07d36e8f0eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fe2f07d36e8f0eb$var$load("2mLKW").then(()=>parcelRequire('etJR3'));

});

parcelRegister("57gkn", function(module, exports) {

let $3b9a45894e4111de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b9a45894e4111de$var$load("jmkWj").then(()=>parcelRequire('bmzqI'));

});


parcelRegister("2cxgG", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $e9d51fb7135f5412$export$d39827c053fda3aa);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $2j6fy = parcelRequire("2j6fy");
const $e9d51fb7135f5412$export$d39827c053fda3aa = (0, $ao2h1.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $2j6fy.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("2j6fy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b605658e5ce20d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8391836c727c96074b367b5cee339a0d>>
 * @relayHash a752dde009c93b4975b47e740db8b1bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf

var $7oHmH = parcelRequire("7oHmH");
const $45b605658e5ce20d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf",
        "metadata": {},
        "name": "mainVirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $45b605658e5ce20d$export$2e2bcd8739ae039 = $45b605658e5ce20d$var$node;

});
parcelRegister("7oHmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f0ef421b1798a33$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3f0ef421b1798a33$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});



parcelRegister("6sNnq", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $d0a02e466fb63798$export$16f81cc9da2c6c47);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $d0a02e466fb63798$var$getDataLoader = ()=>(parcelRequire("its7u"));
const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $2M1hQ.createResource)({
    type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $d0a02e466fb63798$var$getDataLoader,
    maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
});

});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';

parcelRegister("its7u", function(module, exports) {

let $d730bf6f328ec7ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d730bf6f328ec7ad$var$load("eNmuD"),
    $d730bf6f328ec7ad$var$load("aOISr")
]).then(()=>parcelRequire('frQmB'));

});


parcelRegister("gRzZD", function(module, exports) {

$parcel$export(module.exports, "workspaceResource", () => $d68afc54033ea939$export$2f02c3f971168d17);

var $2M1hQ = parcelRequire("2M1hQ");

var $ahEft = parcelRequire("ahEft");
const $d68afc54033ea939$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $d68afc54033ea939$export$2f02c3f971168d17 = (0, $2M1hQ.createResource)({
    type: $d68afc54033ea939$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $ahEft.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("ahEft", function(module, exports) {

$parcel$export(module.exports, "getUserJsmLicenceState", () => $b8bed038f2dce149$export$65bf73aad2afa39);
$parcel$export(module.exports, "isPremiumInstance", () => $b8bed038f2dce149$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $b8bed038f2dce149$export$d7b4c32773b1c643);
$parcel$export(module.exports, "default", () => $b8bed038f2dce149$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $4VpwK = parcelRequire("4VpwK");

var $ktP1V = parcelRequire("ktP1V");

var $5Ny9E = parcelRequire("5Ny9E");

var $ldyPw = parcelRequire("ldyPw");

const $b8bed038f2dce149$export$530f260cc76f04ff = (baseUrl)=>`${baseUrl}/rest/servicedesk/cmdb/latest/workspace`;
const $b8bed038f2dce149$export$65bf73aad2afa39 = (tenantContext)=>{
    const { licensedProducts: licensedProducts, appPermissions: appPermissions } = tenantContext;
    const hasJsmLicence = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    const isJsmLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if (!hasJsmLicence) return {
        siteHasJsmInstalled: false
    };
    return {
        siteHasJsmInstalled: true,
        siteIsPremium: $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext),
        userLicensed: isJsmLicensedUser
    };
};
const $b8bed038f2dce149$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremium = serviceDeskAppEdition === (0, $ldyPw.PREMIUM_EDITION);
    return isPremium;
};
const $b8bed038f2dce149$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $b8bed038f2dce149$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? (0, $5Ny9E.toWorkspaceId)(ids[0].id) : null;
};
const $b8bed038f2dce149$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    const { baseUrl: baseUrl } = tenantContext;
    if ($b8bed038f2dce149$export$d7b4c32773b1c643(tenantContext) === false || !(0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP)) return null;
    return (0, $4VpwK.performCmdbGetRequest)($b8bed038f2dce149$export$530f260cc76f04ff(baseUrl)).then($b8bed038f2dce149$var$transformResponse).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $b8bed038f2dce149$export$2e2bcd8739ae039 = $b8bed038f2dce149$export$e1d718dfe6dad973;

});
parcelRegister("4VpwK", function(module, exports) {

$parcel$export(module.exports, "performCmdbGetRequest", () => $270bf98960acb19c$export$a252413f43ec7247);
$parcel$export(module.exports, "performCmdbPostRequest", () => $270bf98960acb19c$export$d68a9f67166d25a2);
$parcel$export(module.exports, "performCmdbPutRequest", () => $270bf98960acb19c$export$326b7407f501f98b);
$parcel$export(module.exports, "performCmdbDeleteRequest", () => $270bf98960acb19c$export$b198eb14f22c12e6);

var $4R6GH = parcelRequire("4R6GH");

var $5HnTq = parcelRequire("5HnTq");

var $eusud = parcelRequire("eusud");
const $270bf98960acb19c$export$d5e211a0106aa636 = {
    'X-Request-Source': 'cmdb-frontend'
};
const $270bf98960acb19c$export$a252413f43ec7247 = (url, options)=>(0, $eusud.performGetRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$d68a9f67166d25a2 = (url, options)=>(0, $eusud.performPostRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$326b7407f501f98b = (url, options)=>(0, $eusud.performPutRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$b198eb14f22c12e6 = (url, options)=>(0, $eusud.performDeleteRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$235b7fc70b9fc359 = (url, options)=>{
    const defaultOptions = (0, $5HnTq.getDefaultOptions)(url);
    return (0, $4R6GH.fg)('fly-2529-cmdb-client-send-request-source-header') ? {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers,
            ...$270bf98960acb19c$export$d5e211a0106aa636
        }
    } : options;
};

});

parcelRegister("ktP1V", function(module, exports) {

$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $84a32a7226f836c4$export$6dbfb62369f79a64);

var $aIZdc = parcelRequire("aIZdc");

var $4R6GH = parcelRequire("4R6GH");
const $84a32a7226f836c4$export$6dbfb62369f79a64 = (cmdbDisabledInFedRAMPForTenant)=>!(0, $aIZdc.isFedRamp)() || (0, $aIZdc.isFedRamp)() && ((0, $4R6GH.fg)('use_cmdb_scr12_enabled') ? cmdbDisabledInFedRAMPForTenant != null && !cmdbDisabledInFedRAMPForTenant : (0, $4R6GH.fg)('jsm-assets-fedramp-ui'));

});

parcelRegister("5Ny9E", function(module, exports) {

$parcel$export(module.exports, "toSchemaId", () => $a330a4171d28d64c$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $a330a4171d28d64c$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $a330a4171d28d64c$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $a330a4171d28d64c$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toWorkspaceId", () => $a330a4171d28d64c$export$d002b8d7821b6b59);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $a330a4171d28d64c$export$cfd92c18cee8add7);
const $a330a4171d28d64c$export$d577b7f3b832f656 = (id)=>id;
const $a330a4171d28d64c$export$1ba342595bc7be13 = (id)=>id;
const $a330a4171d28d64c$export$b46e25afa2bab6a = (id)=>id;
const $a330a4171d28d64c$export$ece2917434bb0a8c = (id)=>id;
const $a330a4171d28d64c$export$d002b8d7821b6b59 = (id)=>id;
const $a330a4171d28d64c$export$cfd92c18cee8add7 = (id)=>id;

});

const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';



parcelRegister("lfnsv", function(module, exports) {

$parcel$export(module.exports, "boardDetailsResource", () => $d78990d38f225e07$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $d78990d38f225e07$export$b67eabcfc08e7c62);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $PK2Tm = parcelRequire("PK2Tm");
const $d78990d38f225e07$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $7f4tk.default)(`/rest/agile/1.0/board/${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $d78990d38f225e07$export$6c6984c55b171c5d = (0, $2M1hQ.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>(0, $PK2Tm.getConfigFromRouterContext)(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if ((0, $PK2Tm.getConfigFromRouterContext)(routerContext)) return $d78990d38f225e07$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $d78990d38f225e07$export$b67eabcfc08e7c62 = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk'), $d78990d38f225e07$export$6c6984c55b171c5d);

});
parcelRegister("PK2Tm", function(module, exports) {

$parcel$export(module.exports, "buildAllDataQueryParams", () => $df00ee708c57537c$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $df00ee708c57537c$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $df00ee708c57537c$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $df00ee708c57537c$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $df00ee708c57537c$export$1705c550e5b835bf);

var $4R6GH = parcelRequire("4R6GH");

var $1odlY = parcelRequire("1odlY");

var $9hNId = parcelRequire("9hNId");
const $df00ee708c57537c$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $df00ee708c57537c$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $df00ee708c57537c$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $df00ee708c57537c$var$cleanUpInlineScript(dataName);
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $df00ee708c57537c$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values((0, $9hNId.RAPID_VIEW_ROUTE_CONFIG))){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return (0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT;
};
const $df00ee708c57537c$export$7bff98a3d459b1b8 = (view)=>{
    let rapidboardResources = (0, $1odlY.WRM_RESOURCES_ARRAY);
    if ((0, $4R6GH.fg)('reports-overview-page-migration')) {
        if (view) {
            const routeConfig = $df00ee708c57537c$export$62c86c4062215346(view);
            return [
                ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
                ...routeConfig.resources
            ];
        }
        return [
            ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...(0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT.resources
        ];
    }
    // eslint-disable-next-line default-case
    switch(view){
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-user-board':
        case 'servicedesk-boards':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-practice-custom-board':
            rapidboardResources = (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY);
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
        case 'rapidboard-backlog-embed':
            rapidboardResources = (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY);
            break;
    }
    return [
        ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...rapidboardResources
    ];
};
function $df00ee708c57537c$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("1odlY", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $fa7f7a1583a8dcf1$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $fa7f7a1583a8dcf1$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $fa7f7a1583a8dcf1$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $fa7f7a1583a8dcf1$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $fa7f7a1583a8dcf1$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1f599d2eef0a7281);
const $fa7f7a1583a8dcf1$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $fa7f7a1583a8dcf1$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $fa7f7a1583a8dcf1$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $fa7f7a1583a8dcf1$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $fa7f7a1583a8dcf1$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $fa7f7a1583a8dcf1$export$ccd0929652c235de = [];
const $fa7f7a1583a8dcf1$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $fa7f7a1583a8dcf1$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("9hNId", function(module, exports) {

$parcel$export(module.exports, "RAPID_VIEW_ROUTE_CONFIG", () => $f34cebd5a04e9077$export$99d0df2f58f37dfe);

var $1odlY = parcelRequire("1odlY");
const $f34cebd5a04e9077$export$99d0df2f58f37dfe = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $1odlY.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};

});



parcelRegister("f5kpo", function(module, exports) {

$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $e96bf35f407138bb$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $e96bf35f407138bb$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $e96bf35f407138bb$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $e96bf35f407138bb$export$ee826506b3baa13a);

var $4R6GH = parcelRequire("4R6GH");

var $5Nutl = parcelRequire("5Nutl");

var $gNStA = parcelRequire("gNStA");

var $i6CNv = parcelRequire("i6CNv");

var $kdyVI = parcelRequire("kdyVI");

var $gQ2J4 = parcelRequire("gQ2J4");

var $fox5Q = parcelRequire("fox5Q");
const $e96bf35f407138bb$export$d8d4641986a9ac7f = ()=>!false;
const $e96bf35f407138bb$export$462ca08d6ce67848 = ()=>!$e96bf35f407138bb$export$d8d4641986a9ac7f();
const $e96bf35f407138bb$export$3a5e56bd5231a56b = ()=>[
        (0, $fox5Q.wrmBundleResource),
        (0, $i6CNv.boardConfigApiResource),
        (0, $gNStA.resourceWithCondition2)($e96bf35f407138bb$export$462ca08d6ce67848, (0, $gQ2J4.rapidboardResource))
    ];
const $e96bf35f407138bb$export$1c63de7f548f965f = ()=>(0, $kdyVI.boardDataResource);
const $e96bf35f407138bb$export$ee826506b3baa13a = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('jsw-backlog-preload-config-data'), (0, $5Nutl.backlogConfigResource)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('jsw-backlog-preload-config-data'), (0, $5Nutl.backlogGlobalConfigResource)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && !(0, $4R6GH.fg)('indexeddb_cache_for_backlog'), (0, $5Nutl.uifBacklogResourceOld)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('indexeddb_cache_for_backlog'), (0, $5Nutl.uifBacklogResource))
    ];

});
parcelRegister("5Nutl", function(module, exports) {

$parcel$export(module.exports, "uifBacklogResourceOld", () => $9905b3c28d313f7e$export$db83ef0443397b85);
$parcel$export(module.exports, "uifBacklogResource", () => $9905b3c28d313f7e$export$c182dffb98985208);
$parcel$export(module.exports, "backlogConfigResource", () => $9905b3c28d313f7e$export$f894eb38e7ada0d6);
$parcel$export(module.exports, "backlogGlobalConfigResource", () => $9905b3c28d313f7e$export$ee2927bb14d7fd87);

var $2M1hQ = parcelRequire("2M1hQ");


const $9905b3c28d313f7e$export$db83ef0443397b85 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$8f9824ba4409b537),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("co9mN")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $9905b3c28d313f7e$export$c182dffb98985208 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$d15ce4feabd76ea),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("8Ax6r")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $9905b3c28d313f7e$export$f894eb38e7ada0d6 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$213e774bb8f521ee),
    getKey: ({ match: { params: { boardId: boardId } } })=>`backlog-config-data-${boardId ?? ''}`,
    getDataLoader: ()=>(parcelRequire("jY5eD"))
});

const $9905b3c28d313f7e$export$ee2927bb14d7fd87 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$285d72b0274b22cc),
    getKey: ({ match: { params: { boardId: boardId } } })=>`backlog-global-config-data-${boardId ?? ''}`,
    getDataLoader: ()=>(parcelRequire("ccl9g"))
});

});
const $2fdbe99f6cbea4f1$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $2fdbe99f6cbea4f1$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';
const $2fdbe99f6cbea4f1$export$213e774bb8f521ee = 'NEXTGEN_BACKLOG_CONFIG_DATA';
const $2fdbe99f6cbea4f1$export$285d72b0274b22cc = 'NEXTGEN_BACKLOG_GLOBAL_CONFIG_DATA';

parcelRegister("co9mN", function(module, exports) {

let $904efdee7a70da66$var$load = (parcelRequire("28QjX"))(4);
module.exports = $904efdee7a70da66$var$load("hgAfI").then(()=>parcelRequire('gTjY8'));

});

parcelRegister("8Ax6r", function(module, exports) {

let $640b5d17b6b42f1a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $640b5d17b6b42f1a$var$load("8723H").then(()=>parcelRequire('cpSf8'));

});

parcelRegister("jY5eD", function(module, exports) {

let $e897ae7f423abd03$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e897ae7f423abd03$var$load("7gWra").then(()=>parcelRequire('fARTX'));

});

parcelRegister("ccl9g", function(module, exports) {

let $8e1702ac327d92bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e1702ac327d92bb$var$load("8d4vK").then(()=>parcelRequire('sSRsi'));

});


parcelRegister("i6CNv", function(module, exports) {

$parcel$export(module.exports, "boardConfigApiResource", () => $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e);
// eslint-disable-next-line jira/import-whitelist

var $6s1PB = parcelRequire("6s1PB");

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");
const $8a55ba0bef7e0e2a$var$getMaxAge = ()=>false ? 0 : (0, $6s1PB.expVal)('jsw-classic-board-api-calls-config-cache-time', 'value', 0) * 1000;

const $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
    getKey: ({ match: match, query: query })=>{
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        return `rapidViewConfig-${boardId}`; // Should Also have a mode but for now lets use only id
    },
    getDataLoader: ()=>(parcelRequire("gsqVU")),
    maxAge: $8a55ba0bef7e0e2a$var$getMaxAge(),
    isBrowserOnly: true
});

});
parcelRegister("gsqVU", function(module, exports) {

let $bfb4273a60bf77b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bfb4273a60bf77b0$var$load("dz3p9").then(()=>parcelRequire('aCQV9'));

});


parcelRegister("kdyVI", function(module, exports) {

$parcel$export(module.exports, "boardDataResource", () => $18aa0ee73b651f62$export$138fa635416978f7);

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");

var $9g2vH = parcelRequire("9g2vH");

const $18aa0ee73b651f62$export$138fa635416978f7 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $9g2vH.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $9g2vH.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("ma8fm")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("9g2vH", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $ccbac8c858ea0da2$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $ccbac8c858ea0da2$export$bcb853db5e3e8054);
const $ccbac8c858ea0da2$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $ccbac8c858ea0da2$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

parcelRegister("ma8fm", function(module, exports) {

let $0429ea31ef544334$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0429ea31ef544334$var$load("75jqm").then(()=>parcelRequire('iW9CS'));

});


parcelRegister("gQ2J4", function(module, exports) {

$parcel$export(module.exports, "rapidboardResource", () => $b172ecb4db4f1d22$export$d0f42a55e7c5752c);

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");

const $b172ecb4db4f1d22$export$d0f42a55e7c5752c = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("EuXLN")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("EuXLN", function(module, exports) {

let $079bc1279c32054a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $079bc1279c32054a$var$load("hq4Ox").then(()=>parcelRequire('LP66E'));

});


parcelRegister("fox5Q", function(module, exports) {

$parcel$export(module.exports, "wrmBundleResource", () => $bb15c3971b88e6fc$export$f199d15b7cd18df1);

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");

var $1odlY = parcelRequire("1odlY");

var $PK2Tm = parcelRequire("PK2Tm");

const $bb15c3971b88e6fc$export$f199d15b7cd18df1 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ({ route: route })=>{
        if ((0, $4R6GH.fg)('reports-overview-page-migration')) return (0, $PK2Tm.getRapidViewConfigFromRouteName)(route.name).stateKey;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("dbFSD")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("dbFSD", function(module, exports) {

let $999cc9fff1a468f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $999cc9fff1a468f5$var$load("3c33e").then(()=>parcelRequire('bdOyr'));

});



parcelRegister("f7Y15", function(module, exports) {

$parcel$export(module.exports, "uifBoardResource", () => $6f8724e78df4e830$export$b65bcbbccad354ac);

var $2M1hQ = parcelRequire("2M1hQ");


const $6f8724e78df4e830$export$b65bcbbccad354ac = (0, $2M1hQ.createResource)({
    type: (0, $16d4c226f5e6f5f8$export$cfae566ecf2855f8),
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("bjRyj")),
    maxAge: 0
});

});
const $16d4c226f5e6f5f8$export$cfae566ecf2855f8 = 'UIF_BOARD';

parcelRegister("bjRyj", function(module, exports) {

let $83db0270c34ab46d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $83db0270c34ab46d$var$load("bLcEa").then(()=>parcelRequire('1HjYz'));

});


parcelRegister("lJ1FP", function(module, exports) {

$parcel$export(module.exports, "editModelResource", () => $16cc53c7df259df5$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $16cc53c7df259df5$export$5b9bac2cc4bf4511);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $PK2Tm = parcelRequire("PK2Tm");
const $16cc53c7df259df5$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $7f4tk.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $16cc53c7df259df5$export$ab9a4786826fd2d = (0, $2M1hQ.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>(0, $PK2Tm.getConfigFromRouterContext)(routerContext) ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if ((0, $PK2Tm.getConfigFromRouterContext)(routerContext)) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $16cc53c7df259df5$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $16cc53c7df259df5$export$5b9bac2cc4bf4511 = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk') && !(0, $4R6GH.fg)('board-settings-graphql-refactor_cyvz9'), $16cc53c7df259df5$export$ab9a4786826fd2d);

});


parcelRegister("7QSkt", function(module, exports) {

$parcel$export(module.exports, "legacyConnectProjectRoute", () => $18377aae3bd69384$export$dfdf98c5b58cfa04);
const $18377aae3bd69384$export$dfdf98c5b58cfa04 = {
    name: 'legacy-connect-project',
    path: '/projects/:projectKey',
    query: [
        'selectedItem'
    ]
};

});


parcelRegister("eHVIE", function(module, exports) {

$parcel$export(module.exports, "legacyCustomReportRouteEntry", () => $e93453658ffe8fac$export$12938ba85bf5fe54);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $3jYge = parcelRequire("3jYge");

var $g2CTo = parcelRequire("g2CTo");
const $e93453658ffe8fac$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $e93453658ffe8fac$export$12938ba85bf5fe54 = (0, $aTZGy.createLegacyEntry)((0, $3jYge.legacyCustomReportRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $g2CTo.getReportsCommonResource)()
        ],
        entryPoint: ()=>$e93453658ffe8fac$var$pageEntryPoint
    }));

});
parcelRegister("3jYge", function(module, exports) {

$parcel$export(module.exports, "legacyCustomReportRoute", () => $145a94b4f9586ce4$export$6f4b8901e7772b05);
const $145a94b4f9586ce4$export$6f4b8901e7772b05 = {
    name: 'legacy-custom-report',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});

parcelRegister("g2CTo", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $8bbca6d516ecad1e$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $8bbca6d516ecad1e$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $8bbca6d516ecad1e$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("a3M7u", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsAddRouteEntry", () => $4d84e4b9762a6fd0$export$6cc9527a3f96c0a5);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $2aEBf = parcelRequire("2aEBf");
const $4d84e4b9762a6fd0$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS
});
const $4d84e4b9762a6fd0$export$6cc9527a3f96c0a5 = (0, $aTZGy.createLegacyEntry)((0, $2aEBf.legacyDashboardsAddRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$4d84e4b9762a6fd0$var$pageEntryPoint
    }));

});
parcelRegister("2aEBf", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsAddRoute", () => $7b9bc4c644b80ae9$export$1e88394d2d12a4bc);
const $7b9bc4c644b80ae9$export$1e88394d2d12a4bc = {
    name: 'legacy-dashboards-add',
    path: '(/secure/|/)AddPortalPage([!%]?[\\w]*).jspa'
};

});


parcelRegister("av6XZ", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsConfigureRouteEntry", () => $1ce3478b22e286f0$export$18ff609f147595cc);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $f2zZ5 = parcelRequire("f2zZ5");
const $1ce3478b22e286f0$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS
});
const $1ce3478b22e286f0$export$18ff609f147595cc = (0, $aTZGy.createLegacyEntry)((0, $f2zZ5.legacyDashboardsConfigureRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$1ce3478b22e286f0$var$pageEntryPoint
    }));

});
parcelRegister("f2zZ5", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsConfigureRoute", () => $70eb734f0e2b64db$export$549a0bcc3a0017a7);
const $70eb734f0e2b64db$export$549a0bcc3a0017a7 = {
    name: 'legacy-dashboards-configure',
    path: '(/secure/|/)ConfigurePortalPages([!%]?[\\w]*).jspa'
};

});


parcelRegister("dWjmB", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsDeleteRouteEntry", () => $0e78eb8ae682085e$export$4f59d0a9276c0c9b);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $iKIe7 = parcelRequire("iKIe7");
const $0e78eb8ae682085e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS
});
const $0e78eb8ae682085e$export$4f59d0a9276c0c9b = (0, $aTZGy.createLegacyEntry)((0, $iKIe7.legacyDashboardsDeleteRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$0e78eb8ae682085e$var$pageEntryPoint
    }));

});
parcelRegister("iKIe7", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsDeleteRoute", () => $93f2b7b4b798a07b$export$dfa5dcc35e497330);
const $93f2b7b4b798a07b$export$dfa5dcc35e497330 = {
    name: 'legacy-dashboards-delete',
    path: '(/secure/|/)DeletePortalPage([!%]?[\\w]*).jspa'
};

});


parcelRegister("46ldp", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $f8276b008dc2b288$export$748e329bd0c282a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $jACk9 = parcelRequire("jACk9");
const $f8276b008dc2b288$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS
});
const $f8276b008dc2b288$export$748e329bd0c282a = (0, $aTZGy.createLegacyEntry)((0, $jACk9.dashboardsDirectoryRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$f8276b008dc2b288$var$pageEntryPoint
    }));

});
parcelRegister("jACk9", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $1353efff94ab4016$export$41bba408475cab16);
const $1353efff94ab4016$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});


parcelRegister("7j0wg", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsEditRouteEntry", () => $d9ecf2edade045e8$export$60414c63c9cd3646);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $5EmaY = parcelRequire("5EmaY");
const $d9ecf2edade045e8$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS
});
const $d9ecf2edade045e8$export$60414c63c9cd3646 = (0, $aTZGy.createLegacyEntry)((0, $5EmaY.legacyDashboardsEditRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$d9ecf2edade045e8$var$pageEntryPoint
    }));

});
parcelRegister("5EmaY", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsEditRoute", () => $9d40ddf5ab8ef095$export$4f028eb17334a195);
const $9d40ddf5ab8ef095$export$4f028eb17334a195 = {
    name: 'legacy-dashboards-edit',
    path: '(/secure/|/)EditPortalPage([!%]?[\\w]*).jspa'
};

});


parcelRegister("3sDS0", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsRestoreRouteEntry", () => $77142015108992bc$export$4bf748e39cc28644);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $4Doqg = parcelRequire("4Doqg");
const $77142015108992bc$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS
});
const $77142015108992bc$export$4bf748e39cc28644 = (0, $aTZGy.createLegacyEntry)((0, $4Doqg.legacyDashboardsRestoreRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$77142015108992bc$var$pageEntryPoint
    }));

});
parcelRegister("4Doqg", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsRestoreRoute", () => $77fba9f9b5e8aeae$export$110af57b4332630d);
const $77fba9f9b5e8aeae$export$110af57b4332630d = {
    name: 'legacy-dashboards-restore',
    path: '/secure/RestoreDefaultDashboard([!%]?[\\w]*).jspa'
};

});


parcelRegister("9qiL2", function(module, exports) {

$parcel$export(module.exports, "legacyFallbackRouteEntry", () => $7886c6337becdb49$export$1af0a6dff57e40e7);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $eOgFs = parcelRequire("eOgFs");
const $7886c6337becdb49$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $7886c6337becdb49$export$1af0a6dff57e40e7 = (0, $aTZGy.createLegacyEntry)((0, $eOgFs.legacyFallbackRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$7886c6337becdb49$var$pageEntryPoint
    }));

});
parcelRegister("eOgFs", function(module, exports) {

$parcel$export(module.exports, "legacyFallbackRoute", () => $a08287e111457e04$export$27cd5ba2ad569682);
const $a08287e111457e04$export$27cd5ba2ad569682 = {
    name: 'legacy-fallback',
    path: '/:any'
};

});


parcelRegister("1piRd", function(module, exports) {

$parcel$export(module.exports, "legacyGinActionRouteEntry", () => $74d295aa50dee30d$export$8d542f975e38405d);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $lhmtA = parcelRequire("lhmtA");
const $74d295aa50dee30d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).FILTERS
});
const $74d295aa50dee30d$export$8d542f975e38405d = (0, $aTZGy.createLegacyEntry)((0, $lhmtA.legacyGinActionRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS,
            sidebar: (0, $8Wi6S.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$74d295aa50dee30d$var$pageEntryPoint
    }));

});
parcelRegister("8Wi6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9fa7b304f828b3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncSidebarFiltersGlobal", () => $7c9fa7b304f828b3$export$1af88ebe65f50e73);
$parcel$export(module.exports, "AsyncForPaintSidebarFiltersGlobal", () => $7c9fa7b304f828b3$export$7655c90db6341aa6);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

// Legacy GIN Sidebar
const $7c9fa7b304f828b3$var$LazySidebarFiltersLegacy = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("a8bqI")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersLegacy, null)));
var $7c9fa7b304f828b3$export$2e2bcd8739ae039 = $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $7c9fa7b304f828b3$var$LazyAfterPaintSidebarFiltersGlobal = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("kwzAX")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});

const $7c9fa7b304f828b3$var$LazyForPaintSidebarFiltersGlobal = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("kwzAX")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $7c9fa7b304f828b3$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazyAfterPaintSidebarFiltersGlobal, null)));
const $7c9fa7b304f828b3$export$7655c90db6341aa6 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazyForPaintSidebarFiltersGlobal, null)));

});
parcelRegister("a8bqI", function(module, exports) {

let $760384795adb5a55$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $760384795adb5a55$var$load("cM9em"),
    $760384795adb5a55$var$load("fr9NE"),
    $760384795adb5a55$var$load("h2MrD"),
    $760384795adb5a55$var$load("bYT2S"),
    $760384795adb5a55$var$load("iTs3w")
]).then(()=>parcelRequire('7T8w9'));

});

parcelRegister("kwzAX", function(module, exports) {

let $ef12683b3df1ce72$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ef12683b3df1ce72$var$load("cM9em"),
    $ef12683b3df1ce72$var$load("fr9NE"),
    $ef12683b3df1ce72$var$load("h2MrD"),
    $ef12683b3df1ce72$var$load("bYT2S"),
    $ef12683b3df1ce72$var$load("2dpYI")
]).then(()=>parcelRequire('hcPI1'));

});


parcelRegister("lhmtA", function(module, exports) {

$parcel$export(module.exports, "legacyGinActionRoute", () => $a72744e861078609$export$796a8e79b017f80d);
const $a72744e861078609$export$796a8e79b017f80d = {
    name: 'legacy-gin-action',
    path: '/secure/IssueNavAction!default.jspa',
    query: [
        'filter|jql|issueKey'
    ]
};

});


parcelRegister("5j7oE", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkRouteEntry", () => $89f8c0d2b1dddc69$export$fa36e59125fc7266);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $aRPbJ = parcelRequire("aRPbJ");
const $89f8c0d2b1dddc69$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $89f8c0d2b1dddc69$export$fa36e59125fc7266 = (0, $aTZGy.createLegacyEntry)((0, $aRPbJ.legacyGinBulkRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$89f8c0d2b1dddc69$var$pageEntryPoint
    }));

});
parcelRegister("aRPbJ", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkRoute", () => $87a871569e8ccf7b$export$73e4833202a78627);
const $87a871569e8ccf7b$export$73e4833202a78627 = {
    name: 'legacy-gin-bulk',
    path: '/secure/Bulk(\\w+)([!%]?[\\w]*).jspa'
};

});


parcelRegister("02Sse", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkeditRouteEntry", () => $ba298fe2c80f84f4$export$f591688aa6cd2d3);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $94Xju = parcelRequire("94Xju");
const $ba298fe2c80f84f4$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $ba298fe2c80f84f4$export$f591688aa6cd2d3 = (0, $aTZGy.createLegacyEntry)((0, $94Xju.legacyGinBulkeditRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$ba298fe2c80f84f4$var$pageEntryPoint
    }));

});
parcelRegister("94Xju", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkeditRoute", () => $571cf1f96220b978$export$7c8f48fad7f31e42);
const $571cf1f96220b978$export$7c8f48fad7f31e42 = {
    name: 'legacy-gin-bulkedit',
    path: '/(secure/views|issue)/bulkedit/Bulk(\\w+)([!%]?[\\w]*).jspa'
};

});


parcelRegister("eEYQp", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueAssignRouteEntry", () => $3d6a36140b3f5604$export$b7bc71c8e27d96);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $3SRvb = parcelRequire("3SRvb");
const $3d6a36140b3f5604$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $3d6a36140b3f5604$export$b7bc71c8e27d96 = (0, $aTZGy.createLegacyEntry)((0, $3SRvb.legacyGinIssueAssignRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$3d6a36140b3f5604$var$pageEntryPoint
    }));

});
parcelRegister("3SRvb", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueAssignRoute", () => $5fab0f62236fc400$export$6cc1fcd71b2e06ad);
const $5fab0f62236fc400$export$6cc1fcd71b2e06ad = {
    name: 'legacy-gin-issue-assign',
    path: '/secure/(\\w*)AssignIssue([!%]?[\\w]*).jspa'
};

});


parcelRegister("5l2vg", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCloneRouteEntry", () => $3493cea242bbaa1f$export$b54f23b666808992);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $cNy7q = parcelRequire("cNy7q");
const $3493cea242bbaa1f$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $3493cea242bbaa1f$export$b54f23b666808992 = (0, $aTZGy.createLegacyEntry)((0, $cNy7q.legacyGinIssueCloneRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$3493cea242bbaa1f$var$pageEntryPoint
    }));

});
parcelRegister("cNy7q", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCloneRoute", () => $a05b889593b98ab2$export$55ba9c8834c09ade);
const $a05b889593b98ab2$export$55ba9c8834c09ade = {
    name: 'legacy-gin-issue-clone',
    path: '/(secure|issue)/CloneIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("627SN", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueConvertRouteEntry", () => $ca940786a4ac397c$export$45f0108fe367a800);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $4qPIE = parcelRequire("4qPIE");
const $ca940786a4ac397c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $ca940786a4ac397c$export$45f0108fe367a800 = (0, $aTZGy.createLegacyEntry)((0, $4qPIE.legacyGinIssueConvertRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$ca940786a4ac397c$var$pageEntryPoint
    }));

});
parcelRegister("4qPIE", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueConvertRoute", () => $a898dd3537324dbf$export$338f229cb5c21a79);
const $a898dd3537324dbf$export$338f229cb5c21a79 = {
    name: 'legacy-gin-issue-convert',
    path: '/secure/ConvertIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("e0Qo3", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCreateRouteEntry", () => $3350c818e9677c2b$export$86ab2339e662875a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $MVnwQ = parcelRequire("MVnwQ");
const $3350c818e9677c2b$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $3350c818e9677c2b$export$86ab2339e662875a = (0, $aTZGy.createLegacyEntry)((0, $MVnwQ.legacyGinIssueCreateRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$3350c818e9677c2b$var$pageEntryPoint
    }));

});
parcelRegister("MVnwQ", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCreateRoute", () => $9fd9919c36d28dc9$export$f27db894d3724085);
const $9fd9919c36d28dc9$export$f27db894d3724085 = {
    name: 'legacy-gin-issue-create',
    path: '(/secure/|/)CreateIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("3PPM5", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueEditRouteEntry", () => $25c38a7074318306$export$944b36cf4b5cef62);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $kjUVQ = parcelRequire("kjUVQ");
const $25c38a7074318306$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $25c38a7074318306$export$944b36cf4b5cef62 = (0, $aTZGy.createLegacyEntry)((0, $kjUVQ.legacyGinIssueEditRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$25c38a7074318306$var$pageEntryPoint
    }));

});
parcelRegister("kjUVQ", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueEditRoute", () => $167d48c303ba9e65$export$5286735392e527fb);
const $167d48c303ba9e65$export$5286735392e527fb = {
    name: 'legacy-gin-issue-edit',
    path: '/secure/EditIssue([!%]?[\\w]*).jspaa'
};

});


parcelRegister("2gA3M", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueMoveRouteEntry", () => $1543f93a5b8b93f2$export$9c2ab973bb46413b);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $gN5D9 = parcelRequire("gN5D9");
const $1543f93a5b8b93f2$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $1543f93a5b8b93f2$export$9c2ab973bb46413b = (0, $aTZGy.createLegacyEntry)((0, $gN5D9.legacyGinIssueMoveRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$1543f93a5b8b93f2$var$pageEntryPoint
    }));

});
parcelRegister("gN5D9", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueMoveRoute", () => $fe374fd669357711$export$338e257c93d678f9);
const $fe374fd669357711$export$338e257c93d678f9 = {
    name: 'legacy-gin-issue-move',
    path: '/secure/MoveIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("1Sanm", function(module, exports) {

$parcel$export(module.exports, "legacyGinManageRouteEntry", () => $b067712fd991fcde$export$2b56a5623615dd47);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $7TBoN = parcelRequire("7TBoN");
const $b067712fd991fcde$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).FILTERS
});
const $b067712fd991fcde$export$2b56a5623615dd47 = (0, $aTZGy.createLegacyEntry)((0, $7TBoN.legacyGinManageRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS,
            sidebar: (0, $8Wi6S.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b067712fd991fcde$var$pageEntryPoint
    }));

});
parcelRegister("7TBoN", function(module, exports) {

$parcel$export(module.exports, "legacyGinManageRoute", () => $c0ac35e95b18bb0f$export$e6c509778313a0c1);
const $c0ac35e95b18bb0f$export$e6c509778313a0c1 = {
    name: 'legacy-gin-manage',
    path: '(/secure/|/)ManageFilters.jspa'
};

});


parcelRegister("2WPhO", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionEditRouteEntry", () => $7d49cf89da5cf440$export$5255243cc56f26c3);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $2iObJ = parcelRequire("2iObJ");
const $7d49cf89da5cf440$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).FILTERS
});
const $7d49cf89da5cf440$export$5255243cc56f26c3 = (0, $aTZGy.createLegacyEntry)((0, $2iObJ.legacyGinSubscriptionEditRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS,
            sidebar: (0, $8Wi6S.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$7d49cf89da5cf440$var$pageEntryPoint
    }));

});
parcelRegister("2iObJ", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionEditRoute", () => $134966e56a82ebfc$export$20e6c550a55cf8f4);
const $134966e56a82ebfc$export$20e6c550a55cf8f4 = {
    name: 'legacy-gin-subscription-edit',
    path: '(/secure/|/)EditSubscription([!%]?[\\w]*).jspa'
};

});


parcelRegister("3zYiE", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionsRouteEntry", () => $1de701ed10b09c9c$export$e739dd8af3aee54a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $9r9hN = parcelRequire("9r9hN");
const $1de701ed10b09c9c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).FILTERS
});
const $1de701ed10b09c9c$export$e739dd8af3aee54a = (0, $aTZGy.createLegacyEntry)((0, $9r9hN.legacyGinSubscriptionsRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS,
            sidebar: (0, $8Wi6S.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$1de701ed10b09c9c$var$pageEntryPoint
    }));

});
parcelRegister("9r9hN", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionsRoute", () => $34010bef4eba5d10$export$cbcaf00bd4f92b0);
const $34010bef4eba5d10$export$cbcaf00bd4f92b0 = {
    name: 'legacy-gin-subscriptions',
    path: '(/secure/|/)ViewSubscriptions([!%]?[\\w]*).jspa'
};

});


parcelRegister("6304k", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubtaskActionRouteEntry", () => $b4afd324edd67297$export$31f29cb95c5903fc);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $6wWmR = parcelRequire("6wWmR");
const $b4afd324edd67297$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $b4afd324edd67297$export$31f29cb95c5903fc = (0, $aTZGy.createLegacyEntry)((0, $6wWmR.legacyGinSubtaskActionRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$b4afd324edd67297$var$pageEntryPoint
    }));

});
parcelRegister("6wWmR", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubtaskActionRoute", () => $2bc2773c06ab4170$export$d9c87b9b27d73f7c);
const $2bc2773c06ab4170$export$d9c87b9b27d73f7c = {
    name: 'legacy-gin-subtask-action',
    path: '/secure/(Move|Convert)SubTask(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("3Gl8S", function(module, exports) {

$parcel$export(module.exports, "legacyGinWatchersIssueRouteEntry", () => $3ada851ce7d5dd98$export$97a124d7b834ca82);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $8KfD5 = parcelRequire("8KfD5");
const $3ada851ce7d5dd98$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $3ada851ce7d5dd98$export$97a124d7b834ca82 = (0, $aTZGy.createLegacyEntry)((0, $8KfD5.legacyGinWatchersIssueRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$3ada851ce7d5dd98$var$pageEntryPoint
    }));

});
parcelRegister("8KfD5", function(module, exports) {

$parcel$export(module.exports, "legacyGinWatchersIssueRoute", () => $269a7dfacd2b88f7$export$b3198e66bf5d49ae);
const $269a7dfacd2b88f7$export$b3198e66bf5d49ae = {
    name: 'legacy-gin-watchers-issue',
    path: '/secure/ManageWatchers!default.jspa'
};

});


parcelRegister("hTDEk", function(module, exports) {

$parcel$export(module.exports, "globalAutomationRouteEntry", () => $182686f8e4a93731$export$652cb0c5f80823c0);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $2sjt9 = parcelRequire("2sjt9");
const $182686f8e4a93731$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $182686f8e4a93731$export$652cb0c5f80823c0 = (0, $aTZGy.createLegacyEntry)((0, $2sjt9.globalAutomationRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$182686f8e4a93731$var$pageEntryPoint
    }));

});
parcelRegister("2sjt9", function(module, exports) {

$parcel$export(module.exports, "globalAutomationRoute", () => $867116ccc994e615$export$5276d514cac1db59);
const $867116ccc994e615$export$5276d514cac1db59 = {
    name: 'global-automation',
    path: '/secure/Automation([!%]?[\\w]*).jspa'
};

});


parcelRegister("adtuy", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseRouteEntry", () => $70f43330b8b233b0$export$b1b791616cdb9491);

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6QKrH = parcelRequire("6QKrH");

var $lbyK5 = parcelRequire("lbyK5");
const $70f43330b8b233b0$export$b1b791616cdb9491 = (0, $aTZGy.createLegacyEntry)((0, $lbyK5.globalIssueNavigatorBrowseRoute), ()=>({
        canTransitionIn: ()=>false,
        component: (0, $6QKrH.LegacyPage),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS,
            sidebar: (0, $8Wi6S.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("lbyK5", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseRoute", () => $3348b73237497170$export$c1b37e392499fccf);
const $3348b73237497170$export$c1b37e392499fccf = {
    name: 'legacy-gin-issue',
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});


parcelRegister("iKdOk", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRedirectRouteEntry", () => $334c12031fe78e56$export$8cbe781346b8b4a2);

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6QKrH = parcelRequire("6QKrH");

var $g0W1y = parcelRequire("g0W1y");
const $334c12031fe78e56$export$8cbe781346b8b4a2 = (0, $aTZGy.createLegacyEntry)((0, $g0W1y.globalIssueNavigatorRedirectRoute), ()=>({
        canTransitionIn: ()=>false,
        component: (0, $6QKrH.LegacyPage),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS,
            sidebar: (0, $8Wi6S.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("g0W1y", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRedirectRoute", () => $45cb68cbb060b3b1$export$b2cd2888fd62d62e);
const $45cb68cbb060b3b1$export$b2cd2888fd62d62e = {
    name: 'legacy-gin-quicksearch',
    path: '/secure/QuickSearch.jspa',
    query: [
        'searchString'
    ]
};

});


parcelRegister("jSUYz", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRouteEntry", () => $2f48723b112f7130$export$690b5fd7062ce607);

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $f4La7 = parcelRequire("f4La7");

var $7Ec5O = parcelRequire("7Ec5O");
const $2f48723b112f7130$export$690b5fd7062ce607 = (0, $aTZGy.createLegacyEntry)((0, $f4La7.globalIssueNavigatorRoute), ()=>({
        apdexIgnoreParams: [
            'issueKey'
        ],
        canTransitionIn: ()=>false,
        component: (0, $7Ec5O.LegacyPageWithTeamProfileCardView),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS,
            sidebar: (0, $8Wi6S.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("f4La7", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRoute", () => $4d3f2b1accc05e7a$export$f4c8e8bc55cd2008);
const $4d3f2b1accc05e7a$export$f4c8e8bc55cd2008 = {
    name: 'legacy-gin',
    path: '/issues/:issueKey(.*)?'
};

});

parcelRegister("7Ec5O", function(module, exports) {

$parcel$export(module.exports, "LegacyPageWithTeamProfileCardView", () => $9442fba15e52fbb6$export$bc3f01ea4ac19d59);

var $5uXOq = parcelRequire("5uXOq");

var $9FUIO = parcelRequire("9FUIO");

var $1ukJn = parcelRequire("1ukJn");

var $6QKrH = parcelRequire("6QKrH");
const $9442fba15e52fbb6$export$bc3f01ea4ac19d59 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6QKrH.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FUIO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ukJn.default), null));

});
parcelRegister("9FUIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1259b4dcb355d8f8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener = (0, $kxZPA.lazy)(()=>(parcelRequire("k0qGN")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
});
const $1259b4dcb355d8f8$export$9b28d5c0f56030a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "open-help-panel-link-through-event-listener",
        packageName: "jira-help-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-open-help-panel-link-through-event-listener",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener, null)));
var $1259b4dcb355d8f8$export$2e2bcd8739ae039 = $1259b4dcb355d8f8$export$9b28d5c0f56030a7;

});
parcelRegister("k0qGN", function(module, exports) {

let $e90882aee0c820d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e90882aee0c820d8$var$load("h2MrD"),
    $e90882aee0c820d8$var$load("bYT2S"),
    $e90882aee0c820d8$var$load("li0NF")
]).then(()=>parcelRequire('LS48m'));

});


parcelRegister("1ukJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c755f0a1cb7bd3d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3c755f0a1cb7bd3d$var$LegacyTeamProfileCard = (0, $kxZPA.lazy)(()=>(parcelRequire("gLzQU")), {
    moduleId: "./src/packages/profilecard-next/src/ui/team-profilecard-legacy/index.tsx"
});
const $3c755f0a1cb7bd3d$export$c8a3662e461b7707 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "legacy-team-profile-card",
        packageName: "profilecard-next"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-legacy-team-profile-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c755f0a1cb7bd3d$var$LegacyTeamProfileCard, props)));
var $3c755f0a1cb7bd3d$export$2e2bcd8739ae039 = $3c755f0a1cb7bd3d$export$c8a3662e461b7707;

});
parcelRegister("gLzQU", function(module, exports) {

let $c34cd8adaaf18ffe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c34cd8adaaf18ffe$var$load("cM9em"),
    $c34cd8adaaf18ffe$var$load("fr9NE"),
    $c34cd8adaaf18ffe$var$load("hPzOn"),
    $c34cd8adaaf18ffe$var$load("h2MrD"),
    $c34cd8adaaf18ffe$var$load("bYT2S"),
    $c34cd8adaaf18ffe$var$load("7JCRv")
]).then(()=>parcelRequire('bLirh'));

});




parcelRegister("4G8Hg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsAddonsOauthRouteEntry", () => $b535d026b2ea865f$export$b674e2feb3ded4d1);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $89wUx = parcelRequire("89wUx");
const $b535d026b2ea865f$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $b535d026b2ea865f$export$b674e2feb3ded4d1 = (0, $aTZGy.createLegacyEntry)((0, $89wUx.globalSettingsAddonsOauthRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)()
        ],
        entryPoint: ()=>$b535d026b2ea865f$var$pageEntryPoint
    }));

});
parcelRegister("89wUx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsAddonsOauthRoute", () => $129f8a09fdd6f09e$export$13884c00b567e541);
const $129f8a09fdd6f09e$export$13884c00b567e541 = {
    name: 'global-settings-addons-oauth',
    path: '/secure/oauth-credentials'
};

});


parcelRegister("atx0K", function(module, exports) {

$parcel$export(module.exports, "emceeAppRouteEntry", () => $2616544b1928eb83$export$881c7d683ab02802);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6QKrH = parcelRequire("6QKrH");

var $9DQ5s = parcelRequire("9DQ5s");
const $2616544b1928eb83$export$881c7d683ab02802 = (0, $aTZGy.createLegacyEntry)((0, $9DQ5s.emceeAppRoute), ()=>({
        canTransitionIn: ()=>false,
        component: (0, $6QKrH.LegacyPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)()
        ]
    }));

});
parcelRegister("9DQ5s", function(module, exports) {

$parcel$export(module.exports, "emceeAppRoute", () => $e518a5969a9a06a6$export$5149e7851c6c4f53);
const $e518a5969a9a06a6$export$5149e7851c6c4f53 = {
    name: 'global-settings-addons-emcee',
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee:environment(.?[\\w.]*)?/:page'
};

});


parcelRegister("3JFtk", function(module, exports) {

$parcel$export(module.exports, "manageAppsRouteEntry", () => $3dfab1aba2242167$export$4ce557e11b5e9d68);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6QKrH = parcelRequire("6QKrH");

var $8K9T4 = parcelRequire("8K9T4");
const $3dfab1aba2242167$export$4ce557e11b5e9d68 = (0, $aTZGy.createLegacyEntry)((0, $8K9T4.manageAppsRoute), ()=>({
        canTransitionIn: ()=>false,
        component: (0, $6QKrH.LegacyPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)()
        ]
    }));

});
parcelRegister("8K9T4", function(module, exports) {

$parcel$export(module.exports, "manageAppsRoute", () => $796c64c2599268cb$export$d5409be3b4016aab);
const $796c64c2599268cb$export$d5409be3b4016aab = {
    name: 'global-settings-addons-upm',
    path: '/plugins/servlet/upm'
};

});


parcelRegister("ji0AJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $24df04d7c39cec30$export$d83c2e469d070766);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $6E1ET = parcelRequire("6E1ET");

var $5pSYQ = parcelRequire("5pSYQ");
const $24df04d7c39cec30$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $24df04d7c39cec30$export$d83c2e469d070766 = (0, $aTZGy.createLegacyEntry)((0, $6E1ET.globalSettingsCustomFieldsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$24df04d7c39cec30$var$pageEntryPoint
    }));

});
parcelRegister("6E1ET", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $cd660fa970c4c34c$export$45e7d93edcc9507f);
const $cd660fa970c4c34c$export$45e7d93edcc9507f = {
    name: 'global-settings-issues-custom-fields-view',
    path: '/secure/admin/ViewCustomFields.jspa'
};

});


parcelRegister("eH0Vd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRouteEntry", () => $d848fd84f5e320b7$export$c493b601f2512cdb);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $4IIjy = parcelRequire("4IIjy");

var $5pSYQ = parcelRequire("5pSYQ");
const $d848fd84f5e320b7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $d848fd84f5e320b7$export$c493b601f2512cdb = (0, $aTZGy.createLegacyEntry)((0, $4IIjy.globalSettingsFieldLayoutSchemesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$d848fd84f5e320b7$var$pageEntryPoint
    }));

});
parcelRegister("4IIjy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRoute", () => $0adaa0b1592f735c$export$6e04f01d8f54ad08);
const $0adaa0b1592f735c$export$6e04f01d8f54ad08 = {
    name: 'global-settings-issues-fieldlayouts-schemes-view',
    path: '/secure/admin/ViewFieldLayoutSchemes.jspa'
};

});


parcelRegister("GeoVa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutsRouteEntry", () => $dfca527829bb711d$export$9988358457e7d230);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $5K8wl = parcelRequire("5K8wl");

var $5pSYQ = parcelRequire("5pSYQ");
const $dfca527829bb711d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $dfca527829bb711d$export$9988358457e7d230 = (0, $aTZGy.createLegacyEntry)((0, $5K8wl.globalSettingsFieldLayoutsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$dfca527829bb711d$var$pageEntryPoint
    }));

});
parcelRegister("5K8wl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutsRoute", () => $399ade7ed867e9ad$export$ead41dd3ea1da5b3);
const $399ade7ed867e9ad$export$ead41dd3ea1da5b3 = {
    name: 'global-settings-issues-fieldlayouts-view',
    path: '/secure/admin/ViewFieldLayouts.jspa'
};

});


parcelRegister("dRasN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueSubtasksRouteEntry", () => $f784087ae55d8508$export$625e23490e28fdb5);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $aNehM = parcelRequire("aNehM");

var $5pSYQ = parcelRequire("5pSYQ");
const $f784087ae55d8508$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $f784087ae55d8508$export$625e23490e28fdb5 = (0, $aTZGy.createLegacyEntry)((0, $aNehM.globalSettingsIssueSubtasksRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$f784087ae55d8508$var$pageEntryPoint
    }));

});
parcelRegister("aNehM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueSubtasksRoute", () => $45285ec69469de83$export$1327adfb7eea6607);
const $45285ec69469de83$export$1327adfb7eea6607 = {
    name: 'global-settings-issues-subtasks-manage',
    path: '/secure/admin/subtasks/ManageSubTasks.jspa'
};

});


parcelRegister("5sKph", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTimeTrackingRouteEntry", () => $b0f2b56984e370d0$export$ad6c1602c9fe5020);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $jnwXM = parcelRequire("jnwXM");

var $5pSYQ = parcelRequire("5pSYQ");
const $b0f2b56984e370d0$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $b0f2b56984e370d0$export$ad6c1602c9fe5020 = (0, $aTZGy.createLegacyEntry)((0, $jnwXM.globalSettingsIssueTimeTrackingRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$b0f2b56984e370d0$var$pageEntryPoint
    }));

});
parcelRegister("jnwXM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTimeTrackingRoute", () => $318352fe2501d153$export$8596beec8543d958);
// like !default / !edit / %21viewLogs
const $318352fe2501d153$export$8596beec8543d958 = {
    name: 'global-settings-issues-time-tracking',
    path: '/secure/admin/TimeTrackingAdmin([!%]?[\\w]*).jspa'
};

});


parcelRegister("giS9p", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowRouteEntry", () => $ff544a9f6ac28615$export$460b4d1709d73a2e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $lqkPk = parcelRequire("lqkPk");

var $5pSYQ = parcelRequire("5pSYQ");
const $ff544a9f6ac28615$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $ff544a9f6ac28615$export$460b4d1709d73a2e = (0, $aTZGy.createLegacyEntry)((0, $lqkPk.globalSettingsIssueWorkflowRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$ff544a9f6ac28615$var$pageEntryPoint
    }));

});
parcelRegister("lqkPk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowRoute", () => $ef26848aa769782a$export$83c76a9f38e044d2);
const $ef26848aa769782a$export$83c76a9f38e044d2 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/secure/admin/workflows/:page'
};

});


parcelRegister("gCRNR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRouteEntry", () => $8be46498d622d580$export$cfc4572fe7838d46);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $8ZxwV = parcelRequire("8ZxwV");

var $5pSYQ = parcelRequire("5pSYQ");
const $8be46498d622d580$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $8be46498d622d580$export$cfc4572fe7838d46 = (0, $aTZGy.createLegacyEntry)((0, $8ZxwV.globalSettingsIssueWorkflowSchemesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$8be46498d622d580$var$pageEntryPoint
    }));

});
parcelRegister("8ZxwV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRoute", () => $0620b4f2413702cf$export$fabaf6e717c3f1b6);
const $0620b4f2413702cf$export$fabaf6e717c3f1b6 = {
    name: 'global-settings-issues-workflows-schemes-view',
    path: '/secure/admin/ViewWorkflowSchemes.jspa'
};

});


parcelRegister("8dktk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRouteEntry", () => $8f6a9a96fb457aad$export$580990afd7fb8505);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gYM7U = parcelRequire("gYM7U");
const $8f6a9a96fb457aad$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $8f6a9a96fb457aad$export$580990afd7fb8505 = (0, $aTZGy.createLegacyEntry)((0, $gYM7U.globalSettingsIssuesCustomFieldsAssociateRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8f6a9a96fb457aad$var$pageEntryPoint
    }));

});
parcelRegister("gYM7U", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRoute", () => $75a6b8f3f4c6028f$export$4e17e29838928fe7);
const $75a6b8f3f4c6028f$export$4e17e29838928fe7 = {
    name: 'global-settings-issues-custom-fields-associate',
    path: '/secure/admin/AssociateFieldToScreens!default.jspa'
};

});


parcelRegister("bf7on", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRouteEntry", () => $edc9b4fef6cb4409$export$f2078b26bfdef553);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $lJwqJ = parcelRequire("lJwqJ");
const $edc9b4fef6cb4409$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $edc9b4fef6cb4409$export$f2078b26bfdef553 = (0, $aTZGy.createLegacyEntry)((0, $lJwqJ.globalSettingsIssuesCustomFieldsConfigRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$edc9b4fef6cb4409$var$pageEntryPoint
    }));

});
parcelRegister("lJwqJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRoute", () => $4a51fe356f08b2ad$export$db330236178a2eb2);
const $4a51fe356f08b2ad$export$db330236178a2eb2 = {
    name: 'global-settings-issues-custom-fields-config',
    path: '/secure/admin/ConfigureCustomField!default.jspa'
};

});


parcelRegister("14GxZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRouteEntry", () => $879893f7f6bcec7c$export$504c6fb2862492a1);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $88Mfp = parcelRequire("88Mfp");
const $879893f7f6bcec7c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $879893f7f6bcec7c$export$504c6fb2862492a1 = (0, $aTZGy.createLegacyEntry)((0, $88Mfp.globalSettingsIssuesCustomFieldsDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$879893f7f6bcec7c$var$pageEntryPoint
    }));

});
parcelRegister("88Mfp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRoute", () => $ed91dc0eb81fad53$export$36f7f639e35c6980);
const $ed91dc0eb81fad53$export$36f7f639e35c6980 = {
    name: 'global-settings-issues-custom-fields-delete',
    path: '/secure/admin/DeleteCustomField!default.jspa'
};

});


parcelRegister("hJtWy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRouteEntry", () => $8c4b3dab330996dd$export$68ff9a44323b27ca);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $hLdGS = parcelRequire("hLdGS");
const $8c4b3dab330996dd$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $8c4b3dab330996dd$export$68ff9a44323b27ca = (0, $aTZGy.createLegacyEntry)((0, $hLdGS.globalSettingsIssuesCustomFieldsEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8c4b3dab330996dd$var$pageEntryPoint
    }));

});
parcelRegister("hLdGS", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRoute", () => $74e46ab896d3b78b$export$ca7a3fa1760c59bf);
const $74e46ab896d3b78b$export$ca7a3fa1760c59bf = {
    name: 'global-settings-issues-custom-fields-edit',
    path: '/secure/admin/EditCustomField(\\w*)!default.jspa'
};

});


parcelRegister("hJf2R", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRouteEntry", () => $52a42a80a16ec41d$export$12970e70b4c77f98);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $hA1X7 = parcelRequire("hA1X7");
const $52a42a80a16ec41d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $52a42a80a16ec41d$export$12970e70b4c77f98 = (0, $aTZGy.createLegacyEntry)((0, $hA1X7.globalSettingsIssuesCustomFieldsManageRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$52a42a80a16ec41d$var$pageEntryPoint
    }));

});
parcelRegister("hA1X7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRoute", () => $44c91aabaaaef215$export$441ab7e26eb9710);
const $44c91aabaaaef215$export$441ab7e26eb9710 = {
    name: 'global-settings-issues-custom-fields-manage',
    path: '/secure/admin/ManageConfigurationScheme!default.jspa'
};

});


parcelRegister("2oYAN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRouteEntry", () => $5b77393d93576abd$export$df186d4a4dcc70d6);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $jU1jY = parcelRequire("jU1jY");
const $5b77393d93576abd$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $5b77393d93576abd$export$df186d4a4dcc70d6 = (0, $aTZGy.createLegacyEntry)((0, $jU1jY.globalSettingsIssuesCustomFieldsTranslateRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5b77393d93576abd$var$pageEntryPoint
    }));

});
parcelRegister("jU1jY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRoute", () => $75d0e13d42d980e5$export$13f985d12cff8c13);
const $75d0e13d42d980e5$export$13f985d12cff8c13 = {
    name: 'global-settings-issues-custom-fields-translate',
    path: '/secure/admin/TranslateCustomField!default.jspa'
};

});


parcelRegister("gh1kZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldAddRouteEntry", () => $f8bef7a62cfe82a1$export$a0f9d2aa72494978);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $9Ziov = parcelRequire("9Ziov");
const $f8bef7a62cfe82a1$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $f8bef7a62cfe82a1$export$a0f9d2aa72494978 = (0, $aTZGy.createLegacyEntry)((0, $9Ziov.globalSettingsIssuesFieldAddRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$f8bef7a62cfe82a1$var$pageEntryPoint
    }));

});
parcelRegister("9Ziov", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldAddRoute", () => $95a47cc829c4ea5d$export$7bb3a869061a8016);
const $95a47cc829c4ea5d$export$7bb3a869061a8016 = {
    name: 'global-settings-issues-field-add',
    path: '/secure/admin/AddNewFieldScreen.jspa'
};

});


parcelRegister("isGPI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRouteEntry", () => $5ae15173705db5a2$export$26b162cdb704f0a0);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $cd34Y = parcelRequire("cd34Y");
const $5ae15173705db5a2$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $5ae15173705db5a2$export$26b162cdb704f0a0 = (0, $aTZGy.createLegacyEntry)((0, $cd34Y.globalSettingsIssuesFieldConfigureEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$5ae15173705db5a2$var$pageEntryPoint
    }));

});
parcelRegister("cd34Y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRoute", () => $0bd613c449aa0543$export$37908ebd0fc6f94c);
const $0bd613c449aa0543$export$37908ebd0fc6f94c = {
    name: 'global-settings-issues-field-configure-edit',
    path: '/secure/admin/EditDefaultFieldLayoutItem!default.jspa'
};

});


parcelRegister("fPw7u", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRouteEntry", () => $f573b7b6fd54e8fe$export$ce20a01bf6cc22e8);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $bW0Te = parcelRequire("bW0Te");
const $f573b7b6fd54e8fe$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $f573b7b6fd54e8fe$export$ce20a01bf6cc22e8 = (0, $aTZGy.createLegacyEntry)((0, $bW0Te.globalSettingsIssuesFieldConfigureRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$f573b7b6fd54e8fe$var$pageEntryPoint
    }));

});
parcelRegister("bW0Te", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRoute", () => $1ac864500a5ef0a1$export$47585e3c198123be);
const $1ac864500a5ef0a1$export$47585e3c198123be = {
    name: 'global-settings-issues-field-configure',
    path: '/secure/admin/ConfigureFieldScreen.jspa'
};

});


parcelRegister("cxEqO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldCopyRouteEntry", () => $6a0888f8f3391889$export$4d899a20474ade0);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $6qAz3 = parcelRequire("6qAz3");
const $6a0888f8f3391889$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $6a0888f8f3391889$export$4d899a20474ade0 = (0, $aTZGy.createLegacyEntry)((0, $6qAz3.globalSettingsIssuesFieldCopyRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$6a0888f8f3391889$var$pageEntryPoint
    }));

});
parcelRegister("6qAz3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldCopyRoute", () => $982d4fef818f6e36$export$ec5bbfc3593b01b7);
const $982d4fef818f6e36$export$ec5bbfc3593b01b7 = {
    name: 'global-settings-issues-field-copy',
    path: '/secure/admin/ViewCopyFieldScreen.jspa'
};

});


parcelRegister("7RDxI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRouteEntry", () => $519f655b5dad0a9a$export$9170e2ce6999793e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $bfDyu = parcelRequire("bfDyu");
const $519f655b5dad0a9a$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $519f655b5dad0a9a$export$9170e2ce6999793e = (0, $aTZGy.createLegacyEntry)((0, $bfDyu.globalSettingsIssuesFieldDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$519f655b5dad0a9a$var$pageEntryPoint
    }));

});
parcelRegister("bfDyu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRoute", () => $b8e3abc25d44cadd$export$9a0bc2a1c24ad312);
const $b8e3abc25d44cadd$export$9a0bc2a1c24ad312 = {
    name: 'global-settings-issues-field-delete',
    path: '/secure/admin/ViewDeleteFieldScreen.jspa'
};

});


parcelRegister("heNmF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldEditRouteEntry", () => $5ab3bff56b925f82$export$4f6f7197ee5fbd88);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $eJbHm = parcelRequire("eJbHm");
const $5ab3bff56b925f82$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $5ab3bff56b925f82$export$4f6f7197ee5fbd88 = (0, $aTZGy.createLegacyEntry)((0, $eJbHm.globalSettingsIssuesFieldEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5ab3bff56b925f82$var$pageEntryPoint
    }));

});
parcelRegister("eJbHm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldEditRoute", () => $cc504750d5fb65fe$export$e41329d1f04b5b51);
const $cc504750d5fb65fe$export$e41329d1f04b5b51 = {
    name: 'global-settings-issues-field-edit',
    path: '/secure/admin/EditFieldScreen!default.jspa'
};

});


parcelRegister("1YKIi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRouteEntry", () => $1234d7045b0df622$export$3a842eb59e795637);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $ec0rp = parcelRequire("ec0rp");
const $1234d7045b0df622$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $1234d7045b0df622$export$3a842eb59e795637 = (0, $aTZGy.createLegacyEntry)((0, $ec0rp.globalSettingsIssuesFieldSchemesAddRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$1234d7045b0df622$var$pageEntryPoint
    }));

});
parcelRegister("ec0rp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRoute", () => $532857595ba99bee$export$8b20e975ade5b676);
const $532857595ba99bee$export$8b20e975ade5b676 = {
    name: 'global-settings-issues-field-schemes-add',
    path: '/secure/admin/AddFieldConfigurationScheme!default.jspa'
};

});


parcelRegister("e5Z3j", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRouteEntry", () => $5e661f7ed6cf338b$export$5f5a8b65a56acfea);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $72GxP = parcelRequire("72GxP");
const $5e661f7ed6cf338b$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $5e661f7ed6cf338b$export$5f5a8b65a56acfea = (0, $aTZGy.createLegacyEntry)((0, $72GxP.globalSettingsIssuesFieldSchemesConfigureRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5e661f7ed6cf338b$var$pageEntryPoint
    }));

});
parcelRegister("72GxP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRoute", () => $cbed1e1f72bd95fa$export$6401bf37dfa17226);
const $cbed1e1f72bd95fa$export$6401bf37dfa17226 = {
    name: 'global-settings-issues-field-schemes-configure',
    path: '/secure/admin/ConfigureFieldScreenScheme.jspa'
};

});


parcelRegister("bXosp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRouteEntry", () => $9b9ec5bcc964d852$export$4c126f203951bdce);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $kN5BQ = parcelRequire("kN5BQ");
const $9b9ec5bcc964d852$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $9b9ec5bcc964d852$export$4c126f203951bdce = (0, $aTZGy.createLegacyEntry)((0, $kN5BQ.globalSettingsIssuesFieldSchemesCopyRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9b9ec5bcc964d852$var$pageEntryPoint
    }));

});
parcelRegister("kN5BQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRoute", () => $fa4a048cc3d216aa$export$195423dd1ef4cf0a);
const $fa4a048cc3d216aa$export$195423dd1ef4cf0a = {
    name: 'global-settings-issues-field-schemes-copy',
    path: '/secure/admin/ViewCopyFieldScreenScheme.jspa'
};

});


parcelRegister("k5iyb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRouteEntry", () => $4c4f8adff8f983cd$export$a4609f789aeed81f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $aqJIz = parcelRequire("aqJIz");
const $4c4f8adff8f983cd$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $4c4f8adff8f983cd$export$a4609f789aeed81f = (0, $aTZGy.createLegacyEntry)((0, $aqJIz.globalSettingsIssuesFieldSchemesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$4c4f8adff8f983cd$var$pageEntryPoint
    }));

});
parcelRegister("aqJIz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRoute", () => $7bd84ac90497295d$export$998546ee0d8d0995);
const $7bd84ac90497295d$export$998546ee0d8d0995 = {
    name: 'global-settings-issues-field-schemes-delete',
    path: '/secure/admin/ViewDeleteFieldScreenScheme.jspa'
};

});


parcelRegister("d20Tk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRouteEntry", () => $0a9c54dea5aef6f9$export$aabed4f53fb4f921);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gO79E = parcelRequire("gO79E");
const $0a9c54dea5aef6f9$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $0a9c54dea5aef6f9$export$aabed4f53fb4f921 = (0, $aTZGy.createLegacyEntry)((0, $gO79E.globalSettingsIssuesFieldSchemesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$0a9c54dea5aef6f9$var$pageEntryPoint
    }));

});
parcelRegister("gO79E", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRoute", () => $b9ee7177eaa85e0a$export$c7b713e1fe2e026f);
const $b9ee7177eaa85e0a$export$c7b713e1fe2e026f = {
    name: 'global-settings-issues-field-schemes-edit',
    path: '/secure/admin/EditFieldScreenScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("53AfD", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRouteEntry", () => $bedcf7bd309da7f5$export$e38b78ff4a960db6);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $6M0Qc = parcelRequire("6M0Qc");
const $bedcf7bd309da7f5$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $bedcf7bd309da7f5$export$e38b78ff4a960db6 = (0, $aTZGy.createLegacyEntry)((0, $6M0Qc.globalSettingsIssuesFieldSchemesEditItemRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$bedcf7bd309da7f5$var$pageEntryPoint
    }));

});
parcelRegister("6M0Qc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRoute", () => $8b9343f2ac724442$export$4606c3f78e4ec3db);
const $8b9343f2ac724442$export$4606c3f78e4ec3db = {
    name: 'global-settings-issues-field-schemes-edit-item',
    path: '/secure/admin/EditFieldScreenSchemeItem([!%]?[\\w]*).jspa'
};

});


parcelRegister("emSra", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldViewRouteEntry", () => $62f83a847dc093a0$export$25331ec7b1b8ebfb);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $sE1aQ = parcelRequire("sE1aQ");
const $62f83a847dc093a0$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $62f83a847dc093a0$export$25331ec7b1b8ebfb = (0, $aTZGy.createLegacyEntry)((0, $sE1aQ.globalSettingsIssuesFieldViewRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$62f83a847dc093a0$var$pageEntryPoint
    }));

});
parcelRegister("sE1aQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldViewRoute", () => $b766cae09d1edba1$export$1a32944e52a128e5);
const $b766cae09d1edba1$export$1a32944e52a128e5 = {
    name: 'global-settings-issues-field-view',
    path: '/secure/admin/ViewFieldsScreen.jspa'
};

});


parcelRegister("kzk0Z", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRouteEntry", () => $5db434dc2605965c$export$8946e190202a15c7);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $b1cju = parcelRequire("b1cju");
const $5db434dc2605965c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $5db434dc2605965c$export$8946e190202a15c7 = (0, $aTZGy.createLegacyEntry)((0, $b1cju.globalSettingsIssuesFieldlayoutsConfigRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5db434dc2605965c$var$pageEntryPoint
    }));

});
parcelRegister("b1cju", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRoute", () => $45a5a75729aa06df$export$b469488e0c133a32);
const $45a5a75729aa06df$export$b469488e0c133a32 = {
    name: 'global-settings-issues-fieldlayouts-config',
    path: '/secure/admin/ConfigureFieldLayout([!%]?[\\w]*).jspa'
};

});


parcelRegister("b6Js4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRouteEntry", () => $72d654eb9745b1f7$export$c4d25de70db36bde);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $eWMYy = parcelRequire("eWMYy");
const $72d654eb9745b1f7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $72d654eb9745b1f7$export$c4d25de70db36bde = (0, $aTZGy.createLegacyEntry)((0, $eWMYy.globalSettingsIssuesFieldlayoutsCopyRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$72d654eb9745b1f7$var$pageEntryPoint
    }));

});
parcelRegister("eWMYy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRoute", () => $5b153889683b3ee7$export$3a9552d4b0f71408);
const $5b153889683b3ee7$export$3a9552d4b0f71408 = {
    name: 'global-settings-issues-fieldlayouts-copy',
    path: '/secure/admin/CopyFieldLayout!default.jspa'
};

});


parcelRegister("1yPEz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRouteEntry", () => $81ad70b7344418d9$export$f2dfb8808ab4e2f2);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $78A2M = parcelRequire("78A2M");
const $81ad70b7344418d9$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $81ad70b7344418d9$export$f2dfb8808ab4e2f2 = (0, $aTZGy.createLegacyEntry)((0, $78A2M.globalSettingsIssuesFieldlayoutsDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$81ad70b7344418d9$var$pageEntryPoint
    }));

});
parcelRegister("78A2M", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRoute", () => $4553c84c21f7de82$export$3ef4c145c5aa96b6);
const $4553c84c21f7de82$export$3ef4c145c5aa96b6 = {
    name: 'global-settings-issues-fieldlayouts-delete',
    path: '/secure/admin/DeleteFieldLayout!default.jspa'
};

});


parcelRegister("7l2eC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRouteEntry", () => $ac86ed8456491f15$export$10710e2f7971e271);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $9aA7r = parcelRequire("9aA7r");
const $ac86ed8456491f15$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $ac86ed8456491f15$export$10710e2f7971e271 = (0, $aTZGy.createLegacyEntry)((0, $9aA7r.globalSettingsIssuesFieldlayoutsEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ac86ed8456491f15$var$pageEntryPoint
    }));

});
parcelRegister("9aA7r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRoute", () => $b339ef0dd17cc469$export$3a0534b35ee08e33);
const $b339ef0dd17cc469$export$3a0534b35ee08e33 = {
    name: 'global-settings-issues-fieldlayouts-edit',
    path: '/secure/admin/EditFieldLayout!default.jspa'
};

});


parcelRegister("nXJme", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry", () => $939dc6f2c5f0ee0c$export$5b791b0a90dab069);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $2yp8z = parcelRequire("2yp8z");
const $939dc6f2c5f0ee0c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $939dc6f2c5f0ee0c$export$5b791b0a90dab069 = (0, $aTZGy.createLegacyEntry)((0, $2yp8z.globalSettingsIssuesFieldlayoutsSchemesConfigRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$939dc6f2c5f0ee0c$var$pageEntryPoint
    }));

});
parcelRegister("2yp8z", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRoute", () => $fde8480744c86e6d$export$97921be5feed3adf);
const $fde8480744c86e6d$export$97921be5feed3adf = {
    name: 'global-settings-issues-fieldlayouts-schemes-config',
    path: '/secure/admin/ConfigureFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("cn2JB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry", () => $deeb7847d402d582$export$e5d2e7b8b7eb3bf5);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gK8kk = parcelRequire("gK8kk");
const $deeb7847d402d582$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $deeb7847d402d582$export$e5d2e7b8b7eb3bf5 = (0, $aTZGy.createLegacyEntry)((0, $gK8kk.globalSettingsIssuesFieldlayoutsSchemesCopyRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$deeb7847d402d582$var$pageEntryPoint
    }));

});
parcelRegister("gK8kk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRoute", () => $ea086597c996e95e$export$71563f57601b0e2);
const $ea086597c996e95e$export$71563f57601b0e2 = {
    name: 'global-settings-issues-fieldlayouts-schemes-copy',
    path: '/secure/admin/CopyFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("cTxQ0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry", () => $59b5aae3357af503$export$c1e57f90dca7eb4c);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $h2Thh = parcelRequire("h2Thh");
const $59b5aae3357af503$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $59b5aae3357af503$export$c1e57f90dca7eb4c = (0, $aTZGy.createLegacyEntry)((0, $h2Thh.globalSettingsIssuesFieldlayoutsSchemesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$59b5aae3357af503$var$pageEntryPoint
    }));

});
parcelRegister("h2Thh", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRoute", () => $080721bf84bba9b7$export$e1a49cd1071690c4);
const $080721bf84bba9b7$export$e1a49cd1071690c4 = {
    name: 'global-settings-issues-fieldlayouts-schemes-delete',
    path: '/secure/admin/DeleteFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("6yYh1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry", () => $c101764d955f9a6f$export$99138c4ced2f05f7);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $4rRFo = parcelRequire("4rRFo");
const $c101764d955f9a6f$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $c101764d955f9a6f$export$99138c4ced2f05f7 = (0, $aTZGy.createLegacyEntry)((0, $4rRFo.globalSettingsIssuesFieldlayoutsSchemesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c101764d955f9a6f$var$pageEntryPoint
    }));

});
parcelRegister("4rRFo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRoute", () => $5c4a6246b486ce01$export$a14fc516b4846e63);
const $5c4a6246b486ce01$export$a14fc516b4846e63 = {
    name: 'global-settings-issues-fieldlayouts-schemes-edit',
    path: '/secure/admin/EditFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("gmU6D", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry", () => $c909ad93f91359bb$export$a860d5fef4b2c724);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gtu5J = parcelRequire("gtu5J");
const $c909ad93f91359bb$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $c909ad93f91359bb$export$a860d5fef4b2c724 = (0, $aTZGy.createLegacyEntry)((0, $gtu5J.globalSettingsIssuesFieldlayoutsSchemesEntityRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c909ad93f91359bb$var$pageEntryPoint
    }));

});
parcelRegister("gtu5J", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRoute", () => $3eb4e6a39492645c$export$54dfcbcea4cc773c);
const $3eb4e6a39492645c$export$54dfcbcea4cc773c = {
    name: 'global-settings-issues-fieldlayouts-schemes-entity',
    path: '/secure/admin/ViewEditFieldLayoutSchemeEntity([!%]?[\\w]*).jspa'
};

});


parcelRegister("fBKKy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldviewRouteEntry", () => $48ed10d44f4b1194$export$1258f6b3b3168b6a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $8UQV6 = parcelRequire("8UQV6");
const $48ed10d44f4b1194$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $48ed10d44f4b1194$export$1258f6b3b3168b6a = (0, $aTZGy.createLegacyEntry)((0, $8UQV6.globalSettingsIssuesFieldviewRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$48ed10d44f4b1194$var$pageEntryPoint
    }));

});
parcelRegister("8UQV6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldviewRoute", () => $323e7263a931932d$export$4e15d6f42067a40d);
const $323e7263a931932d$export$4e15d6f42067a40d = {
    name: 'global-settings-issues-fieldview',
    path: '/secure/admin/ViewIssueFields.jspa'
};

});


parcelRegister("6flsA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRouteEntry", () => $8aae375be40933bb$export$611de8afc4baaba5);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $hu1HX = parcelRequire("hu1HX");
const $8aae375be40933bb$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $8aae375be40933bb$export$611de8afc4baaba5 = (0, $aTZGy.createLegacyEntry)((0, $hu1HX.globalSettingsIssuesGeneralTranslationsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8aae375be40933bb$var$pageEntryPoint
    }));

});
parcelRegister("hu1HX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRoute", () => $1bf84c30454a7bb6$export$82d4e60692b6b82);
const $1bf84c30454a7bb6$export$82d4e60692b6b82 = {
    name: 'global-settings-issues-general-translations',
    path: '/secure/admin/ViewTranslations!default.jspa'
};

});


parcelRegister("6G6iV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRouteEntry", () => $71e35df2492aa153$export$a7de28edcb387644);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $i5b8D = parcelRequire("i5b8D");
const $71e35df2492aa153$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $71e35df2492aa153$export$a7de28edcb387644 = (0, $aTZGy.createLegacyEntry)((0, $i5b8D.globalSettingsIssuesLinkTypesActivateRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$71e35df2492aa153$var$pageEntryPoint
    }));

});
parcelRegister("i5b8D", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRoute", () => $6a7f67524cf7261d$export$3669b743a852443d);
const $6a7f67524cf7261d$export$3669b743a852443d = {
    name: 'global-settings-issues-linktypes-activate',
    path: '/secure/admin/IssueLinkingActivate.jspa'
};

});


parcelRegister("fkydJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRouteEntry", () => $f3820522b9e438f3$export$bcae6091ca248a97);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $eJEMv = parcelRequire("eJEMv");
const $f3820522b9e438f3$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $f3820522b9e438f3$export$bcae6091ca248a97 = (0, $aTZGy.createLegacyEntry)((0, $eJEMv.globalSettingsIssuesLinkTypesDeactivateRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$f3820522b9e438f3$var$pageEntryPoint
    }));

});
parcelRegister("eJEMv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRoute", () => $8656299f2423bffa$export$3b168b9635205cc2);
const $8656299f2423bffa$export$3b168b9635205cc2 = {
    name: 'global-settings-issues-linktypes-deactivate',
    path: '/secure/admin/IssueLinkingDeActivate.jspa'
};

});


parcelRegister("h2Jra", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesRouteEntry", () => $b718a9330d826e4d$export$a96d582e6ce3db7f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3aqlp = parcelRequire("3aqlp");

var $5pSYQ = parcelRequire("5pSYQ");
const $b718a9330d826e4d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $b718a9330d826e4d$export$a96d582e6ce3db7f = (0, $aTZGy.createLegacyEntry)((0, $3aqlp.globalSettingsIssuesLinkTypesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$b718a9330d826e4d$var$pageEntryPoint
    }));

});
parcelRegister("3aqlp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesRoute", () => $4856e7605981c0ad$export$ee4b5d966d77c912);
const $4856e7605981c0ad$export$ee4b5d966d77c912 = {
    name: 'global-settings-issues-linktypes-view',
    path: '/secure/admin/ViewLinkTypes!default.jspa'
};

});


parcelRegister("2MUGS", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRouteEntry", () => $0199cbb548ec2523$export$5fed41168399db0a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $hj9Qm = parcelRequire("hj9Qm");
const $0199cbb548ec2523$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $0199cbb548ec2523$export$5fed41168399db0a = (0, $aTZGy.createLegacyEntry)((0, $hj9Qm.globalSettingsIssuesLinktypesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$0199cbb548ec2523$var$pageEntryPoint
    }));

});
parcelRegister("hj9Qm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRoute", () => $05e526756ea372b0$export$da95e063618de37b);
const $05e526756ea372b0$export$da95e063618de37b = {
    name: 'global-settings-issues-linktypes-delete',
    path: '/secure/admin/DeleteLinkType!default.jspa'
};

});


parcelRegister("7HMEh", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRouteEntry", () => $ad95e681f61de091$export$58d36c7fbe66c9af);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $k1d03 = parcelRequire("k1d03");
const $ad95e681f61de091$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $ad95e681f61de091$export$58d36c7fbe66c9af = (0, $aTZGy.createLegacyEntry)((0, $k1d03.globalSettingsIssuesLinktypesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ad95e681f61de091$var$pageEntryPoint
    }));

});
parcelRegister("k1d03", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRoute", () => $16959c76f7348b72$export$670f7372491286fd);
const $16959c76f7348b72$export$670f7372491286fd = {
    name: 'global-settings-issues-linktypes-edit',
    path: '/secure/admin/EditLinkType!default.jspa'
};

});


parcelRegister("dWO0i", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationAddRouteEntry", () => $0c4a6dd2cf92761d$export$d52d95e2669ccb14);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $8n61z = parcelRequire("8n61z");
const $0c4a6dd2cf92761d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $0c4a6dd2cf92761d$export$d52d95e2669ccb14 = (0, $aTZGy.createLegacyEntry)((0, $8n61z.globalSettingsIssuesNotificationAddRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$0c4a6dd2cf92761d$var$pageEntryPoint
    }));

});
parcelRegister("8n61z", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationAddRoute", () => $c52ab5f581480f27$export$493378d37b4f830);
const $c52ab5f581480f27$export$493378d37b4f830 = {
    name: 'global-settings-issues-notification-add',
    path: '/secure/admin/AddNotification([!%]?[\\w]*).jspa'
};

});


parcelRegister("hLsgj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRouteEntry", () => $2a4106d2fb4dbb4d$export$e3ff68e9ac0a92e2);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $jpFYd = parcelRequire("jpFYd");
const $2a4106d2fb4dbb4d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $2a4106d2fb4dbb4d$export$e3ff68e9ac0a92e2 = (0, $aTZGy.createLegacyEntry)((0, $jpFYd.globalSettingsIssuesNotificationDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2a4106d2fb4dbb4d$var$pageEntryPoint
    }));

});
parcelRegister("jpFYd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRoute", () => $f94c5c2c17b23f50$export$7497920ead69d08f);
const $f94c5c2c17b23f50$export$7497920ead69d08f = {
    name: 'global-settings-issues-notification-delete',
    path: '/secure/admin/DeleteNotification([!%]?[\\w]*).jspa'
};

});


parcelRegister("j87Pk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationEditRouteEntry", () => $5b28af2712625e58$export$256c34b63a2221ee);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $5hSIs = parcelRequire("5hSIs");
const $5b28af2712625e58$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $5b28af2712625e58$export$256c34b63a2221ee = (0, $aTZGy.createLegacyEntry)((0, $5hSIs.globalSettingsIssuesNotificationEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5b28af2712625e58$var$pageEntryPoint
    }));

});
parcelRegister("5hSIs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationEditRoute", () => $2a43056798f8058b$export$715522cf2d547eaf);
const $2a43056798f8058b$export$715522cf2d547eaf = {
    name: 'global-settings-issues-notification-edit',
    path: '/secure/admin/EditNotifications([!%]?[\\w]*).jspa'
};

});


parcelRegister("h83U2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRouteEntry", () => $9319b8e221d29936$export$f1f02571fc623886);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $jxpp2 = parcelRequire("jxpp2");
const $9319b8e221d29936$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $9319b8e221d29936$export$f1f02571fc623886 = (0, $aTZGy.createLegacyEntry)((0, $jxpp2.globalSettingsIssuesNotificationSchemeAddRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9319b8e221d29936$var$pageEntryPoint
    }));

});
parcelRegister("jxpp2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRoute", () => $35a0638f4eb1b7c8$export$629ba048f31d2c0f);
const $35a0638f4eb1b7c8$export$629ba048f31d2c0f = {
    name: 'global-settings-issues-notification-scheme-add',
    path: '/secure/admin/AddNotificationScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("koRHn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRouteEntry", () => $15db710b7626f00c$export$40145c5de888865f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3D6ZZ = parcelRequire("3D6ZZ");
const $15db710b7626f00c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $15db710b7626f00c$export$40145c5de888865f = (0, $aTZGy.createLegacyEntry)((0, $3D6ZZ.globalSettingsIssuesNotificationSchemeDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$15db710b7626f00c$var$pageEntryPoint
    }));

});
parcelRegister("3D6ZZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRoute", () => $e744dd4c7a52e6ab$export$64a190266a30ffd6);
const $e744dd4c7a52e6ab$export$64a190266a30ffd6 = {
    name: 'global-settings-issues-notification-scheme-delete',
    path: '/secure/admin/DeleteNotificationScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("fFHok", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRouteEntry", () => $bc02f798ab26a2be$export$856d15be55b1a791);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gPOcj = parcelRequire("gPOcj");
const $bc02f798ab26a2be$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $bc02f798ab26a2be$export$856d15be55b1a791 = (0, $aTZGy.createLegacyEntry)((0, $gPOcj.globalSettingsIssuesNotificationSchemeEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$bc02f798ab26a2be$var$pageEntryPoint
    }));

});
parcelRegister("gPOcj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRoute", () => $a2835bc7664b1956$export$a7f8c6170a6db933);
const $a2835bc7664b1956$export$a7f8c6170a6db933 = {
    name: 'global-settings-issues-notification-scheme-edit',
    path: '/secure/admin/EditNotificationScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("b6nn0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationViewRouteEntry", () => $619b829372367830$export$45dd8c9548b0054e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $fwXCn = parcelRequire("fwXCn");

var $5pSYQ = parcelRequire("5pSYQ");
const $619b829372367830$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $619b829372367830$export$45dd8c9548b0054e = (0, $aTZGy.createLegacyEntry)((0, $fwXCn.globalSettingsIssuesNotificationViewRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$619b829372367830$var$pageEntryPoint
    }));

});
parcelRegister("fwXCn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationViewRoute", () => $eae3b8a6ab8172fa$export$bc2109e7325d1a16);
// like !default / !edit / %21viewLogs
const $eae3b8a6ab8172fa$export$bc2109e7325d1a16 = {
    name: 'global-settings-issues-notification-view',
    path: '/secure/admin/ViewNotificationSchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("ldD1A", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRouteEntry", () => $b1e28a2f10f5aa46$export$f49580b73c3ba83);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $jczgF = parcelRequire("jczgF");

var $1szwt = parcelRequire("1szwt");
const $b1e28a2f10f5aa46$export$f49580b73c3ba83 = (0, $aTZGy.createLegacyEntry)((0, $jczgF.globalSettingsIssuesPermissionsEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        component: (0, $1szwt.LegacyEditPermissionsPage),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("jczgF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRoute", () => $e7a93d784a931816$export$c7d87b3baf9e9a67);
const $e7a93d784a931816$export$c7d87b3baf9e9a67 = {
    name: 'global-settings-issues-permissions-edit',
    path: '/secure/admin/EditPermissions([!%]?[\\w]*).jspa'
};

});

parcelRegister("1szwt", function(module, exports) {

$parcel$export(module.exports, "LegacyEditPermissionsPage", () => $fd77ea98c0506931$export$fb0bf0e5f8e439b9);

var $5uXOq = parcelRequire("5uXOq");

var $6QKrH = parcelRequire("6QKrH");
const $fd77ea98c0506931$export$fb0bf0e5f8e439b9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6QKrH.LegacyPage), props));
var $fd77ea98c0506931$export$2e2bcd8739ae039 = $fd77ea98c0506931$export$fb0bf0e5f8e439b9;

});


parcelRegister("bLPvl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRouteEntry", () => $be97a6e14b160297$export$d475751e96368b33);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $5fisL = parcelRequire("5fisL");
const $be97a6e14b160297$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $be97a6e14b160297$export$d475751e96368b33 = (0, $aTZGy.createLegacyEntry)((0, $5fisL.globalSettingsIssuesPermissionsSchemesAddRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$be97a6e14b160297$var$pageEntryPoint
    }));

});
parcelRegister("5fisL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRoute", () => $9f9fe0c976b108df$export$f9c900df1268958);
const $9f9fe0c976b108df$export$f9c900df1268958 = {
    name: 'global-settings-issues-permissions-schemes-add',
    path: '/secure/admin/AddPermissionScheme!default.jspa'
};

});


parcelRegister("1E84W", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRouteEntry", () => $a4a78743c4da696f$export$af3ca420f50b74f8);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3nkvu = parcelRequire("3nkvu");
const $a4a78743c4da696f$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $a4a78743c4da696f$export$af3ca420f50b74f8 = (0, $aTZGy.createLegacyEntry)((0, $3nkvu.globalSettingsIssuesPermissionsSchemesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a4a78743c4da696f$var$pageEntryPoint
    }));

});
parcelRegister("3nkvu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRoute", () => $0041d15ee326c021$export$9cbf97d551da6de6);
const $0041d15ee326c021$export$9cbf97d551da6de6 = {
    name: 'global-settings-issues-permissions-schemes-delete',
    path: '/secure/admin/DeletePermissionScheme!default.jspa'
};

});


parcelRegister("38hbb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRouteEntry", () => $aa7e4011ab3aa9c1$export$a1aace45fc58c0c0);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $1k1Ts = parcelRequire("1k1Ts");
const $aa7e4011ab3aa9c1$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $aa7e4011ab3aa9c1$export$a1aace45fc58c0c0 = (0, $aTZGy.createLegacyEntry)((0, $1k1Ts.globalSettingsIssuesPermissionsSchemesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$aa7e4011ab3aa9c1$var$pageEntryPoint
    }));

});
parcelRegister("1k1Ts", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRoute", () => $61336b29f9aa0893$export$baed669ce740350d);
const $61336b29f9aa0893$export$baed669ce740350d = {
    name: 'global-settings-issues-permissions-schemes-edit',
    path: '/secure/admin/EditPermissionScheme!default.jspa'
};

});


parcelRegister("kF9VY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRouteEntry", () => $2ec9b98fc0c26d73$export$92306855354418dd);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $d0I7y = parcelRequire("d0I7y");

var $5pSYQ = parcelRequire("5pSYQ");
const $2ec9b98fc0c26d73$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $2ec9b98fc0c26d73$export$92306855354418dd = (0, $aTZGy.createLegacyEntry)((0, $d0I7y.globalSettingsIssuesPermissionsSchemesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$2ec9b98fc0c26d73$var$pageEntryPoint
    }));

});
parcelRegister("d0I7y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRoute", () => $012d19833b7ad856$export$152abbb6f806c87);
// like !default / !edit / %21viewLogs
const $012d19833b7ad856$export$152abbb6f806c87 = {
    name: 'global-settings-issues-permissions-schemes-view',
    path: '/secure/admin/ViewPermissionSchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("c0M7D", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRouteEntry", () => $6c8c58a749b641b6$export$79f7bd4999f40475);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $9ltYO = parcelRequire("9ltYO");
const $6c8c58a749b641b6$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $6c8c58a749b641b6$export$79f7bd4999f40475 = (0, $aTZGy.createLegacyEntry)((0, $9ltYO.globalSettingsIssuesPermissionsSchemesProjectRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$6c8c58a749b641b6$var$pageEntryPoint
    }));

});
parcelRegister("9ltYO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRoute", () => $ef463a1c1d19238f$export$c29ffdea8ba3226d);
const $ef463a1c1d19238f$export$c29ffdea8ba3226d = {
    name: 'legacy-project-settings-permissions-associate',
    path: '/secure/project/SelectProjectPermissionScheme!default.jspa'
};

});


parcelRegister("f2ROg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRouteEntry", () => $9696ada3b0956af2$export$88a39202914c5905);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $aW9LB = parcelRequire("aW9LB");
const $9696ada3b0956af2$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $9696ada3b0956af2$export$88a39202914c5905 = (0, $aTZGy.createLegacyEntry)((0, $aW9LB.globalSettingsIssuesPrioritiesDefaultRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9696ada3b0956af2$var$pageEntryPoint
    }));

});
parcelRegister("aW9LB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRoute", () => $f7b82b73ce2660ae$export$83a29d1cc0270f5a);
const $f7b82b73ce2660ae$export$83a29d1cc0270f5a = {
    name: 'global-settings-issues-priorities-default',
    path: '/secure/admin/MakeDefaultPriority([!%]?[\\w]*).jspa'
};

});


parcelRegister("9XTKv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRouteEntry", () => $ef1edf983ddad153$export$e13fff0f49e2648b);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $dX4Td = parcelRequire("dX4Td");
const $ef1edf983ddad153$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $ef1edf983ddad153$export$e13fff0f49e2648b = (0, $aTZGy.createLegacyEntry)((0, $dX4Td.globalSettingsIssuesPrioritiesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ef1edf983ddad153$var$pageEntryPoint
    }));

});
parcelRegister("dX4Td", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRoute", () => $141a1a6bfdc47cb0$export$1092268c69e42aa4);
const $141a1a6bfdc47cb0$export$1092268c69e42aa4 = {
    name: 'global-settings-issues-priorities-delete',
    path: '/secure/admin/DeletePriority!default.jspa'
};

});


parcelRegister("2RECB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRouteEntry", () => $9ebe767404327180$export$cd447ff81bd82138);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $6uxGj = parcelRequire("6uxGj");
const $9ebe767404327180$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $9ebe767404327180$export$cd447ff81bd82138 = (0, $aTZGy.createLegacyEntry)((0, $6uxGj.globalSettingsIssuesPrioritiesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9ebe767404327180$var$pageEntryPoint
    }));

});
parcelRegister("6uxGj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRoute", () => $314c8e21a4129551$export$c0f633caf37ba40d);
const $314c8e21a4129551$export$c0f633caf37ba40d = {
    name: 'global-settings-issues-priorities-edit',
    path: '/secure/admin/EditPriority!default.jspa'
};

});


parcelRegister("kirc0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $0e17498a42d21c0e$export$63a56a096ab0d260);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $Bodkp = parcelRequire("Bodkp");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $39mPd = parcelRequire("39mPd");
const $0e17498a42d21c0e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $0e17498a42d21c0e$export$63a56a096ab0d260 = (0, $aTZGy.createLegacyEntry)((0, $39mPd.globalSettingsIssuesPrioritiesRoute), ()=>({
        layout: (0, $Bodkp.priorityMappingGlobalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$0e17498a42d21c0e$var$pageEntryPoint
    }));

});
parcelRegister("Bodkp", function(module, exports) {

$parcel$export(module.exports, "priorityMappingGlobalSettingsLayout", () => $65268f1a363ddd1a$export$233c4c28b2b79294);

var $ibkIl = parcelRequire("ibkIl");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65268f1a363ddd1a$var$LegacyAsyncModals = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("78V7v")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-priorities-mapping-global-settings-layout/src/ui/legacy-async-modals/index.tsx"
});
const $65268f1a363ddd1a$export$4219cc7dcaa1716c = [
    $65268f1a363ddd1a$var$LegacyAsyncModals
];
const $65268f1a363ddd1a$export$233c4c28b2b79294 = (0, $aPfsS.composeLayouts)((0, $ibkIl.globalSettingsLayout), {
    globalComponents: $65268f1a363ddd1a$export$4219cc7dcaa1716c
});

});
parcelRegister("78V7v", function(module, exports) {

let $5335969bef2bfee5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5335969bef2bfee5$var$load("eNmuD"),
    $5335969bef2bfee5$var$load("zydG7")
]).then(()=>parcelRequire('1oQ9c'));

});


parcelRegister("39mPd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $0c2158fc4c2ebccd$export$518516cdf6b7cd83);
const $0c2158fc4c2ebccd$export$518516cdf6b7cd83 = {
    name: 'global-settings-issues-priorities',
    path: '/secure/admin/ViewPriorities.jspa'
};

});


parcelRegister("dZTGv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRouteEntry", () => $29af63db43092efb$export$3dd9e223f9189ad8);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $6vABj = parcelRequire("6vABj");
const $29af63db43092efb$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $29af63db43092efb$export$3dd9e223f9189ad8 = (0, $aTZGy.createLegacyEntry)((0, $6vABj.globalSettingsIssuesPrioritiesTranslationsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$29af63db43092efb$var$pageEntryPoint
    }));

});
parcelRegister("6vABj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRoute", () => $814a47c599bf5115$export$ac50c32d38c2abe0);
const $814a47c599bf5115$export$ac50c32d38c2abe0 = {
    name: 'global-settings-issues-priorities-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=priority'
    ]
};

});


parcelRegister("kevOU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRouteEntry", () => $f8cd87ed8d973331$export$48a6536027e4aff8);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3oIan = parcelRequire("3oIan");
const $f8cd87ed8d973331$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $f8cd87ed8d973331$export$48a6536027e4aff8 = (0, $aTZGy.createLegacyEntry)((0, $3oIan.globalSettingsIssuesResolutionsDefaultRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$f8cd87ed8d973331$var$pageEntryPoint
    }));

});
parcelRegister("3oIan", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRoute", () => $57199508a46849c2$export$3069447d64064849);
const $57199508a46849c2$export$3069447d64064849 = {
    name: 'global-settings-issues-resolutions-default',
    path: '/secure/admin/MakeDefaultResolution([!%]?[\\w]*).jspa'
};

});


parcelRegister("h2wuj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRouteEntry", () => $1c334ed0e1a0616c$export$e4f8ecf8d9862ad4);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $bDwSR = parcelRequire("bDwSR");
const $1c334ed0e1a0616c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $1c334ed0e1a0616c$export$e4f8ecf8d9862ad4 = (0, $aTZGy.createLegacyEntry)((0, $bDwSR.globalSettingsIssuesResolutionsDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$1c334ed0e1a0616c$var$pageEntryPoint
    }));

});
parcelRegister("bDwSR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRoute", () => $24e4259c4b976630$export$cef4d5289f287690);
const $24e4259c4b976630$export$cef4d5289f287690 = {
    name: 'global-settings-issues-resolutions-delete',
    path: '/secure/admin/DeleteResolution!default.jspa'
};

});


parcelRegister("8Q961", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRouteEntry", () => $bd77f030054a8cdb$export$abc7d0979f67b53f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $5243I = parcelRequire("5243I");
const $bd77f030054a8cdb$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $bd77f030054a8cdb$export$abc7d0979f67b53f = (0, $aTZGy.createLegacyEntry)((0, $5243I.globalSettingsIssuesResolutionsEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$bd77f030054a8cdb$var$pageEntryPoint
    }));

});
parcelRegister("5243I", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRoute", () => $d49c5008becc2c06$export$92b7f2cef28676);
const $d49c5008becc2c06$export$92b7f2cef28676 = {
    name: 'global-settings-issues-resolutions-edit',
    path: '/secure/admin/EditResolution!default.jspa'
};

});


parcelRegister("brK7m", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsRouteEntry", () => $9d5c3926ca102299$export$2fc29b05ae7ea40);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $468sC = parcelRequire("468sC");

var $5pSYQ = parcelRequire("5pSYQ");
const $9d5c3926ca102299$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $9d5c3926ca102299$export$2fc29b05ae7ea40 = (0, $aTZGy.createLegacyEntry)((0, $468sC.globalSettingsIssuesResolutionsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$9d5c3926ca102299$var$pageEntryPoint
    }));

});
parcelRegister("468sC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsRoute", () => $38ac9c3ab0ad867e$export$7ad0e4697ed2a3ec);
const $38ac9c3ab0ad867e$export$7ad0e4697ed2a3ec = {
    name: 'global-settings-issues-resolutions',
    path: '/secure/admin/ViewResolutions.jspa'
};

});


parcelRegister("3s8fE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRouteEntry", () => $9c87f1185e8d7cb2$export$93bb5b2fc4a9a739);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $iYt7d = parcelRequire("iYt7d");
const $9c87f1185e8d7cb2$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $9c87f1185e8d7cb2$export$93bb5b2fc4a9a739 = (0, $aTZGy.createLegacyEntry)((0, $iYt7d.globalSettingsIssuesResolutionsTranslationsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9c87f1185e8d7cb2$var$pageEntryPoint
    }));

});
parcelRegister("iYt7d", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRoute", () => $431ef0bd873c1da7$export$c84118fcbe41734c);
const $431ef0bd873c1da7$export$c84118fcbe41734c = {
    name: 'global-settings-issues-resolutions-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=resolution'
    ]
};

});


parcelRegister("3740v", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityEditRouteEntry", () => $7395970eaa4b0b6a$export$fe5197eff63a479c);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gG5B2 = parcelRequire("gG5B2");
const $7395970eaa4b0b6a$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $7395970eaa4b0b6a$export$fe5197eff63a479c = (0, $aTZGy.createLegacyEntry)((0, $gG5B2.globalSettingsIssuesSecurityEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$7395970eaa4b0b6a$var$pageEntryPoint
    }));

});
parcelRegister("gG5B2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityEditRoute", () => $08f2ff1afef8fd8d$export$5f1d8fd298c25945);
const $08f2ff1afef8fd8d$export$5f1d8fd298c25945 = {
    name: 'global-settings-issues-security-edit',
    path: '/secure/admin/EditIssueSecurities([!%]?[\\w]*).jspa'
};

});


parcelRegister("e4xQQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRouteEntry", () => $37aefe052e9d15aa$export$32a0f47c80094c8a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $h41bN = parcelRequire("h41bN");
const $37aefe052e9d15aa$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $37aefe052e9d15aa$export$32a0f47c80094c8a = (0, $aTZGy.createLegacyEntry)((0, $h41bN.globalSettingsIssuesSecurityLevelAddRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$37aefe052e9d15aa$var$pageEntryPoint
    }));

});
parcelRegister("h41bN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRoute", () => $f5c3aa4272114e5d$export$27fd05d5eac2b88);
const $f5c3aa4272114e5d$export$27fd05d5eac2b88 = {
    name: 'global-settings-issues-security-level-add',
    path: '/secure/admin/AddIssueSecurity!default.jspa'
};

});


parcelRegister("8ytbz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRouteEntry", () => $8f94d9b433198fd6$export$566f3107971a2203);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $j3bID = parcelRequire("j3bID");
const $8f94d9b433198fd6$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $8f94d9b433198fd6$export$566f3107971a2203 = (0, $aTZGy.createLegacyEntry)((0, $j3bID.globalSettingsIssuesSecurityLevelDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$8f94d9b433198fd6$var$pageEntryPoint
    }));

});
parcelRegister("j3bID", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRoute", () => $6df936b574b17a6b$export$9d60d6418ce002aa);
const $6df936b574b17a6b$export$9d60d6418ce002aa = {
    name: 'global-settings-issues-security-level-delete',
    path: '/secure/admin/DeleteIssueSecurityLevel!default.jspa'
};

});


parcelRegister("gcILV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRouteEntry", () => $a639109ee4fcd9bd$export$d5da255e04fa662f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $a2a0b = parcelRequire("a2a0b");
const $a639109ee4fcd9bd$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $a639109ee4fcd9bd$export$d5da255e04fa662f = (0, $aTZGy.createLegacyEntry)((0, $a2a0b.globalSettingsIssuesSecurityLevelEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$a639109ee4fcd9bd$var$pageEntryPoint
    }));

});
parcelRegister("a2a0b", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRoute", () => $47bab7779e69f733$export$882588e58b7b7aa4);
const $47bab7779e69f733$export$882588e58b7b7aa4 = {
    name: 'global-settings-issues-security-level-edit',
    path: '/secure/admin/EditSecurityLevel!default.jspa'
};

});


parcelRegister("5ga67", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRouteEntry", () => $a1cc7ba61f67bf9d$export$a0157f60ff5930b1);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $63A7h = parcelRequire("63A7h");
const $a1cc7ba61f67bf9d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $a1cc7ba61f67bf9d$export$a0157f60ff5930b1 = (0, $aTZGy.createLegacyEntry)((0, $63A7h.globalSettingsIssuesSecuritySchemesAddRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a1cc7ba61f67bf9d$var$pageEntryPoint
    }));

});
parcelRegister("63A7h", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRoute", () => $8cf43e809f40281a$export$1f38848b5541a84a);
const $8cf43e809f40281a$export$1f38848b5541a84a = {
    name: 'global-settings-issues-security-schemes-add',
    path: '/secure/admin/AddIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("1W2Gl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRouteEntry", () => $573dfff311ce41fd$export$9a262260e12c79c8);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $hLZFm = parcelRequire("hLZFm");
const $573dfff311ce41fd$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $573dfff311ce41fd$export$9a262260e12c79c8 = (0, $aTZGy.createLegacyEntry)((0, $hLZFm.globalSettingsIssuesSecuritySchemesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$573dfff311ce41fd$var$pageEntryPoint
    }));

});
parcelRegister("hLZFm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRoute", () => $f7ea295ffe35c416$export$c653091a64df0f25);
const $f7ea295ffe35c416$export$c653091a64df0f25 = {
    name: 'global-settings-issues-security-schemes-delete',
    path: '/secure/admin/DeleteIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("Ty8f6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRouteEntry", () => $8542de96cd2e21d1$export$fd9e3acdd660a584);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gJHyj = parcelRequire("gJHyj");
const $8542de96cd2e21d1$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $8542de96cd2e21d1$export$fd9e3acdd660a584 = (0, $aTZGy.createLegacyEntry)((0, $gJHyj.globalSettingsIssuesSecuritySchemesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8542de96cd2e21d1$var$pageEntryPoint
    }));

});
parcelRegister("gJHyj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRoute", () => $556f88c70cfdf276$export$bea68ab25bef976c);
const $556f88c70cfdf276$export$bea68ab25bef976c = {
    name: 'global-settings-issues-security-schemes-edit',
    path: '/secure/admin/EditIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("4NQSs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRouteEntry", () => $410ca0ce08c78d0e$export$97cc0de5c7b8411a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $6KRmZ = parcelRequire("6KRmZ");

var $5pSYQ = parcelRequire("5pSYQ");
const $410ca0ce08c78d0e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $410ca0ce08c78d0e$export$97cc0de5c7b8411a = (0, $aTZGy.createLegacyEntry)((0, $6KRmZ.globalSettingsIssuesSecuritySchemesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$410ca0ce08c78d0e$var$pageEntryPoint
    }));

});
parcelRegister("6KRmZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRoute", () => $502f533b259b63d5$export$35f866ec59eb6111);
// like !default / !edit / %21viewLogs
const $502f533b259b63d5$export$35f866ec59eb6111 = {
    name: 'global-settings-issues-security-schemes',
    path: '/secure/admin/ViewIssueSecuritySchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("gVtbv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesRouteEntry", () => $bee16b080b80caba$export$f736a667e7868236);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $ae434 = parcelRequire("ae434");

var $5pSYQ = parcelRequire("5pSYQ");
const $bee16b080b80caba$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $bee16b080b80caba$export$f736a667e7868236 = (0, $aTZGy.createLegacyEntry)((0, $ae434.globalSettingsIssuesStatusesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$bee16b080b80caba$var$pageEntryPoint
    }));

});
parcelRegister("ae434", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesRoute", () => $31b61ae37ee57b48$export$4f249f1de6014aa8);
const $31b61ae37ee57b48$export$4f249f1de6014aa8 = {
    name: 'global-settings-issues-statuses',
    path: '/secure/admin/ViewStatuses.jspa'
};

});


parcelRegister("fdER9", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRouteEntry", () => $424d02080ff84a5d$export$6ae705ef4b0a0174);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $eQDxa = parcelRequire("eQDxa");
const $424d02080ff84a5d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $424d02080ff84a5d$export$6ae705ef4b0a0174 = (0, $aTZGy.createLegacyEntry)((0, $eQDxa.globalSettingsIssuesStatusesTranslationsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$424d02080ff84a5d$var$pageEntryPoint
    }));

});
parcelRegister("eQDxa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRoute", () => $8dba0273ebd8b4dd$export$1766642f43dd1413);
const $8dba0273ebd8b4dd$export$1766642f43dd1413 = {
    name: 'global-settings-issues-statuses-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=status'
    ]
};

});


parcelRegister("3LHeo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRouteEntry", () => $92869084100538eb$export$62334310a9f11802);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $b1KvS = parcelRequire("b1KvS");
const $92869084100538eb$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $92869084100538eb$export$62334310a9f11802 = (0, $aTZGy.createLegacyEntry)((0, $b1KvS.globalSettingsIssuesSubtasksDisableRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$92869084100538eb$var$pageEntryPoint
    }));

});
parcelRegister("b1KvS", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRoute", () => $aec0919fedfc11ff$export$d2a6ab37bbab7a2d);
const $aec0919fedfc11ff$export$d2a6ab37bbab7a2d = {
    name: 'global-settings-issues-subtasks-disable',
    path: '/secure/admin/subtasks/DisableSubTasks!default.jspa'
};

});


parcelRegister("coMZk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRouteEntry", () => $6929f45bc939294d$export$ffc845bbb3fd5a36);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $cddtc = parcelRequire("cddtc");
const $6929f45bc939294d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $6929f45bc939294d$export$ffc845bbb3fd5a36 = (0, $aTZGy.createLegacyEntry)((0, $cddtc.globalSettingsIssuesSubtasksEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$6929f45bc939294d$var$pageEntryPoint
    }));

});
parcelRegister("cddtc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRoute", () => $c52b4f5ec9d4bbb2$export$6ab3581cc7d5f524);
const $c52b4f5ec9d4bbb2$export$6ab3581cc7d5f524 = {
    name: 'global-settings-issues-subtasks-edit',
    path: '/secure/admin/subtasks/EditSubTaskIssueTypes!default.jspa'
};

});


parcelRegister("7LrwN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRouteEntry", () => $0c75db793e41c6c7$export$e03cf52d50503939);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $8R8iH = parcelRequire("8R8iH");
const $0c75db793e41c6c7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $0c75db793e41c6c7$export$e03cf52d50503939 = (0, $aTZGy.createLegacyEntry)((0, $8R8iH.globalSettingsIssuesSubtasksTranlationsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$0c75db793e41c6c7$var$pageEntryPoint
    }));

});
parcelRegister("8R8iH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRoute", () => $53e0c03e2f6f9851$export$5ebaadfa47e727e6);
const $53e0c03e2f6f9851$export$5ebaadfa47e727e6 = {
    name: 'global-settings-issues-subtasks-tranlations',
    path: '/secure/admin/subtasks/ViewTranslations!default.jspa'
};

});


parcelRegister("26OFn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRouteEntry", () => $880989a6c43fa817$export$5d0300325c3e456c);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3ZXw0 = parcelRequire("3ZXw0");
const $880989a6c43fa817$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $880989a6c43fa817$export$5d0300325c3e456c = (0, $aTZGy.createLegacyEntry)((0, $3ZXw0.globalSettingsIssuesTypesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$880989a6c43fa817$var$pageEntryPoint
    }));

});
parcelRegister("3ZXw0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRoute", () => $b8f7438c124e183d$export$53c2f4353355a41b);
const $b8f7438c124e183d$export$53c2f4353355a41b = {
    name: 'global-settings-issues-types-delete',
    path: '/secure/admin/DeleteIssueType!default.jspa'
};

});


parcelRegister("jbXVA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesEditRouteEntry", () => $b72357e7efebb390$export$7e3e6487b18f13dd);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $izrjI = parcelRequire("izrjI");
const $b72357e7efebb390$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $b72357e7efebb390$export$7e3e6487b18f13dd = (0, $aTZGy.createLegacyEntry)((0, $izrjI.globalSettingsIssuesTypesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b72357e7efebb390$var$pageEntryPoint
    }));

});
parcelRegister("izrjI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesEditRoute", () => $c5be8a50d47e2766$export$26b7c50d91022a7);
const $c5be8a50d47e2766$export$26b7c50d91022a7 = {
    name: 'global-settings-issues-types-edit',
    path: '/secure/admin/EditIssueType!default.jspa'
};

});


parcelRegister("94XVt", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRouteEntry", () => $77ec703e77605c5b$export$5d1defdba7aabb03);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $1zTxo = parcelRequire("1zTxo");
const $77ec703e77605c5b$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $77ec703e77605c5b$export$5d1defdba7aabb03 = (0, $aTZGy.createLegacyEntry)((0, $1zTxo.globalSettingsIssuesTypesMigrateRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$77ec703e77605c5b$var$pageEntryPoint
    }));

});
parcelRegister("1zTxo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRoute", () => $dcecf3e9586147aa$export$6f6923c45a7c3d7d);
const $dcecf3e9586147aa$export$6f6923c45a7c3d7d = {
    name: 'global-settings-issues-types-migrate',
    path: '/secure/admin/MigrateIssueTypes([!%]?[\\w]*).jspa'
};

});


parcelRegister("aayfE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry", () => $8c8af6b806cb49a3$export$7c04fddca02bf5e5);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $lon9P = parcelRequire("lon9P");
const $8c8af6b806cb49a3$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $8c8af6b806cb49a3$export$7c04fddca02bf5e5 = (0, $aTZGy.createLegacyEntry)((0, $lon9P.globalSettingsIssuesTypesSchemesAssociateDefaultRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8c8af6b806cb49a3$var$pageEntryPoint
    }));

});
parcelRegister("lon9P", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRoute", () => $173fdbd4b815c021$export$ce555a4492eeb41);
const $173fdbd4b815c021$export$ce555a4492eeb41 = {
    name: 'global-settings-issues-types-schemes-associate-default',
    path: '/secure/admin/AssociateIssueTypeSchemesWithDefault!default.jspa'
};

});


parcelRegister("cxoJv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRouteEntry", () => $5ff2244406166d01$export$a4322d0977a716ec);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $7AiY9 = parcelRequire("7AiY9");
const $5ff2244406166d01$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $5ff2244406166d01$export$a4322d0977a716ec = (0, $aTZGy.createLegacyEntry)((0, $7AiY9.globalSettingsIssuesTypesSchemesAssociateRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5ff2244406166d01$var$pageEntryPoint
    }));

});
parcelRegister("7AiY9", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRoute", () => $c5fbaf4510e0d0ac$export$695947f4bf787b08);
const $c5fbaf4510e0d0ac$export$695947f4bf787b08 = {
    name: 'global-settings-issues-types-schemes-associate',
    path: '/secure/admin/AssociateIssueTypeSchemes!default.jspa'
};

});


parcelRegister("2Y1h4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry", () => $84ec84b145b13009$export$2486d5cbf90be36f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $57eTV = parcelRequire("57eTV");
const $84ec84b145b13009$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $84ec84b145b13009$export$2486d5cbf90be36f = (0, $aTZGy.createLegacyEntry)((0, $57eTV.globalSettingsIssuesTypesSchemesOptionDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$84ec84b145b13009$var$pageEntryPoint
    }));

});
parcelRegister("57eTV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRoute", () => $1d092657631b56f0$export$c6dca032125109f7);
const $1d092657631b56f0$export$c6dca032125109f7 = {
    name: 'global-settings-issues-types-schemes-option-delete',
    path: '/secure/admin/DeleteOptionScheme!default.jspa'
};

});


parcelRegister("jxBgp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRouteEntry", () => $fdfcf68c1a4cbf97$export$c604bf31fc1ec79f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $feVaw = parcelRequire("feVaw");
const $fdfcf68c1a4cbf97$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $fdfcf68c1a4cbf97$export$c604bf31fc1ec79f = (0, $aTZGy.createLegacyEntry)((0, $feVaw.globalSettingsIssuesTypesSchemesOptionRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$fdfcf68c1a4cbf97$var$pageEntryPoint
    }));

});
parcelRegister("feVaw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRoute", () => $65df499327bfecac$export$e77dd31f52063355);
const $65df499327bfecac$export$e77dd31f52063355 = {
    name: 'global-settings-issues-types-schemes-option',
    path: '/secure/admin/ConfigureOptionSchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("iG5yV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry", () => $6a015d38aa633fd7$export$953b618d4334efe8);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $957Iw = parcelRequire("957Iw");
const $6a015d38aa633fd7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $6a015d38aa633fd7$export$953b618d4334efe8 = (0, $aTZGy.createLegacyEntry)((0, $957Iw.globalSettingsIssuesTypesScreenSchemesConfigureRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$6a015d38aa633fd7$var$pageEntryPoint
    }));

});
parcelRegister("957Iw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRoute", () => $1a8012e6c51767bb$export$35a08f15e9b959ee);
const $1a8012e6c51767bb$export$35a08f15e9b959ee = {
    name: 'global-settings-issues-types-screen-schemes-configure',
    path: '/secure/admin/ConfigureIssueTypeScreenScheme.jspa'
};

});


parcelRegister("8yO2T", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRouteEntry", () => $ef58723bd4521e03$export$7f2d678246700c2);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $rN6NO = parcelRequire("rN6NO");
const $ef58723bd4521e03$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $ef58723bd4521e03$export$7f2d678246700c2 = (0, $aTZGy.createLegacyEntry)((0, $rN6NO.globalSettingsIssuesTypesScreenSchemesCopyRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ef58723bd4521e03$var$pageEntryPoint
    }));

});
parcelRegister("rN6NO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRoute", () => $bda451b4f17f50eb$export$56cacc1b264d8eec);
const $bda451b4f17f50eb$export$56cacc1b264d8eec = {
    name: 'global-settings-issues-types-screen-schemes-copy',
    path: '/secure/admin/ViewCopyIssueTypeScreenScheme.jspa'
};

});


parcelRegister("6nlgB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry", () => $76f31e8235fad92f$export$5776296a4d01ebfc);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $ctE5r = parcelRequire("ctE5r");
const $76f31e8235fad92f$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $76f31e8235fad92f$export$5776296a4d01ebfc = (0, $aTZGy.createLegacyEntry)((0, $ctE5r.globalSettingsIssuesTypesScreenSchemesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$76f31e8235fad92f$var$pageEntryPoint
    }));

});
parcelRegister("ctE5r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRoute", () => $979f50169eaccf5c$export$3e0cfa858e2af787);
const $979f50169eaccf5c$export$3e0cfa858e2af787 = {
    name: 'global-settings-issues-types-screen-schemes-delete',
    path: '/secure/admin/ViewDeleteIssueTypeScreenScheme.jspa'
};

});


parcelRegister("iViDO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRouteEntry", () => $fc71fa09ebc0d204$export$c4d5ef3d480983a7);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $5Vs3R = parcelRequire("5Vs3R");
const $fc71fa09ebc0d204$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $fc71fa09ebc0d204$export$c4d5ef3d480983a7 = (0, $aTZGy.createLegacyEntry)((0, $5Vs3R.globalSettingsIssuesTypesScreenSchemesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$fc71fa09ebc0d204$var$pageEntryPoint
    }));

});
parcelRegister("5Vs3R", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRoute", () => $179f197e32cb8e2a$export$1ddbfff8d0b6f652);
const $179f197e32cb8e2a$export$1ddbfff8d0b6f652 = {
    name: 'global-settings-issues-types-screen-schemes-edit',
    path: '/secure/admin/EditIssueTypeScreenScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("7aXIN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRouteEntry", () => $93b1f1c2854fb3e4$export$13bfbf88a9e3596d);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gmhEh = parcelRequire("gmhEh");
const $93b1f1c2854fb3e4$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $93b1f1c2854fb3e4$export$13bfbf88a9e3596d = (0, $aTZGy.createLegacyEntry)((0, $gmhEh.globalSettingsIssuesTypesScreenSchemesEntityRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$93b1f1c2854fb3e4$var$pageEntryPoint
    }));

});
parcelRegister("gmhEh", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRoute", () => $8295645cc011317d$export$dbd4ba90dd0ca938);
const $8295645cc011317d$export$dbd4ba90dd0ca938 = {
    name: 'global-settings-issues-types-screen-schemes-entity',
    path: '/secure/admin/ViewEditIssueTypeScreenSchemeEntity.jspa'
};

});


parcelRegister("43xSO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRouteEntry", () => $75f58eca8b616721$export$4f9686f0681ca4ae);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3cDPf = parcelRequire("3cDPf");
const $75f58eca8b616721$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $75f58eca8b616721$export$4f9686f0681ca4ae = (0, $aTZGy.createLegacyEntry)((0, $3cDPf.globalSettingsIssuesTypesTranslationsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$75f58eca8b616721$var$pageEntryPoint
    }));

});
parcelRegister("3cDPf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRoute", () => $8d58c3f897f15a03$export$58b39a591d56ebd2);
const $8d58c3f897f15a03$export$58b39a591d56ebd2 = {
    name: 'global-settings-issues-types-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=issuetype'
    ]
};

});


parcelRegister("6qiOQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry", () => $0a9c62f4871ec60f$export$bf03c0c6f11d43ea);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $jEFzB = parcelRequire("jEFzB");
const $0a9c62f4871ec60f$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $0a9c62f4871ec60f$export$bf03c0c6f11d43ea = (0, $aTZGy.createLegacyEntry)((0, $jEFzB.globalSettingsIssuesWorkflowTransitionMetaAttributesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$0a9c62f4871ec60f$var$pageEntryPoint
    }));

});
parcelRegister("jEFzB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRoute", () => $6f45ff54855c8099$export$bc1d4dae621df0c5);
const $6f45ff54855c8099$export$bc1d4dae621df0c5 = {
    name: 'global-settings-issues-workflow-transition-meta-attributes',
    path: '/secure/admin/ViewWorkflowTransitionMetaAttributes.jspa'
};

});


parcelRegister("7gf5D", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRouteEntry", () => $febaf8cae77c5df3$export$fc7a930108b9d172);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $lqGEU = parcelRequire("lqGEU");
const $febaf8cae77c5df3$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $febaf8cae77c5df3$export$fc7a930108b9d172 = (0, $aTZGy.createLegacyEntry)((0, $lqGEU.globalSettingsIssuesWorkflowTransitionRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$febaf8cae77c5df3$var$pageEntryPoint
    }));

});
parcelRegister("lqGEU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRoute", () => $99b63d61e79e8fec$export$1579038a55dade21);
const $99b63d61e79e8fec$export$1579038a55dade21 = {
    name: 'global-settings-issues-workflow-transition',
    path: '/secure/admin/ViewWorkflowTransition.jspa'
};

});


parcelRegister("kVX9A", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRouteEntry", () => $82a21fcda6e592f4$export$3c5fdd60ca22958d);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $9NBxV = parcelRequire("9NBxV");
const $82a21fcda6e592f4$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $82a21fcda6e592f4$export$3c5fdd60ca22958d = (0, $aTZGy.createLegacyEntry)((0, $9NBxV.globalSettingsIssuesWorkflowsImportRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$82a21fcda6e592f4$var$pageEntryPoint
    }));

});
parcelRegister("9NBxV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRoute", () => $7830152de0eb41e9$export$81f075f719f41037);
const $7830152de0eb41e9$export$81f075f719f41037 = {
    name: 'global-settings-issues-workflows-import',
    path: '/plugins/servlet/wfshare-(import|export)'
};

});


parcelRegister("eFO8D", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRouteEntry", () => $89ba3810817663fb$export$22172eb9e4a9e4ae);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $60Xh1 = parcelRequire("60Xh1");
const $89ba3810817663fb$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $89ba3810817663fb$export$22172eb9e4a9e4ae = (0, $aTZGy.createLegacyEntry)((0, $60Xh1.globalSettingsIssuesWorkflowsSchemesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$89ba3810817663fb$var$pageEntryPoint
    }));

});
parcelRegister("60Xh1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRoute", () => $2391413dfe028d00$export$51a0d34ef3d00da8);
const $2391413dfe028d00$export$51a0d34ef3d00da8 = {
    name: 'global-settings-issues-workflows-schemes-edit',
    path: '/secure/admin/EditWorkflowScheme.jspa'
};

});


parcelRegister("cm20p", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAccessRouteEntry", () => $2024bd78d18b93f5$export$1a764e0ec9764809);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $aTZGy = parcelRequire("aTZGy");

var $3RJkv = parcelRequire("3RJkv");

var $aEPkF = parcelRequire("aEPkF");
const $2024bd78d18b93f5$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $2024bd78d18b93f5$export$1a764e0ec9764809 = (0, $aTZGy.createLegacyEntry)((0, $aEPkF.globalSettingsProductsAccessRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: (0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$2024bd78d18b93f5$var$pageEntryPoint
    }));

});
parcelRegister("2Fj5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ddf603830cf6c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("dWVny")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar, null)));
$a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $a9ddf603830cf6c5$export$2e2bcd8739ae039 = $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar;

});
parcelRegister("dWVny", function(module, exports) {

let $a27d33650e3052b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a27d33650e3052b5$var$load("eNmuD"),
    $a27d33650e3052b5$var$load("h2MrD"),
    $a27d33650e3052b5$var$load("bYT2S"),
    $a27d33650e3052b5$var$load("cM9em"),
    $a27d33650e3052b5$var$load("fr9NE"),
    $a27d33650e3052b5$var$load("3FDyC")
]).then(()=>parcelRequire('hTSvC'));

});


parcelRegister("aEPkF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAccessRoute", () => $6723cb2a6e1572b8$export$622d63534e0526a7);
const $6723cb2a6e1572b8$export$622d63534e0526a7 = {
    name: 'global-settings-products-access',
    path: '/secure/admin/ApplicationAccess.jspa'
};

});


parcelRegister("JOjYa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry", () => $f377762eca8b2886$export$c3b9f18ebde289c);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $aTZGy = parcelRequire("aTZGy");

var $3RJkv = parcelRequire("3RJkv");

var $h8hCl = parcelRequire("h8hCl");
const $f377762eca8b2886$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $f377762eca8b2886$export$c3b9f18ebde289c = (0, $aTZGy.createLegacyEntry)((0, $h8hCl.globalSettingsProductsAdvancedRoadmapsHierarchyRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: (0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$f377762eca8b2886$var$pageEntryPoint
    }));

});
parcelRegister("h8hCl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRoute", () => $fef6a8f96da6377b$export$40d4fd2626eca72c);
const $fef6a8f96da6377b$export$40d4fd2626eca72c = {
    name: 'global-settings-products-advanced-roadmaps-hierarchy',
    path: '/secure/PortfolioHierarchy.jspa'
};

});


parcelRegister("5guhB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsApplinksRouteEntry", () => $5331f265bd3570ad$export$3dcc4ef9452eebbe);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $aTZGy = parcelRequire("aTZGy");

var $3RJkv = parcelRequire("3RJkv");

var $7bPbw = parcelRequire("7bPbw");
const $5331f265bd3570ad$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $5331f265bd3570ad$export$3dcc4ef9452eebbe = (0, $aTZGy.createLegacyEntry)((0, $7bPbw.globalSettingsProductsApplinksRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: (0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$5331f265bd3570ad$var$pageEntryPoint
    }));

});
parcelRegister("7bPbw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsApplinksRoute", () => $85f946123b109743$export$8ff9863beab5519d);
const $85f946123b109743$export$8ff9863beab5519d = {
    name: 'global-settings-products-applinks',
    path: '/plugins/servlet/applinks/listApplicationLinks'
};

});


parcelRegister("1Va65", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRouteEntry", () => $dc33ac112ce62266$export$8d7fb911e3ad15ce);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $aTZGy = parcelRequire("aTZGy");

var $3RJkv = parcelRequire("3RJkv");

var $crSeE = parcelRequire("crSeE");
const $dc33ac112ce62266$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $dc33ac112ce62266$export$8d7fb911e3ad15ce = (0, $aTZGy.createLegacyEntry)((0, $crSeE.globalSettingsProductsDvcsBitbucketRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            // NOTE: the sidebar is rendered for this in Nav V2 too, but there's no corresponding sidebar item?
            sidebar: (0, $2Fj5v.default)
        },
        resources: (0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$dc33ac112ce62266$var$pageEntryPoint
    }));

});
parcelRegister("crSeE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRoute", () => $3d6af0a4410161f6$export$463d647a53bdebee);
const $3d6af0a4410161f6$export$463d647a53bdebee = {
    name: 'global-settings-products-dvcs-bitbucket',
    path: '/secure/BitbucketPostInstallApprovalAction.jspa'
};

});


parcelRegister("4hYtG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsRouteEntry", () => $53ad4eb70716ac16$export$7970dfc3b824c864);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $aTZGy = parcelRequire("aTZGy");

var $3RJkv = parcelRequire("3RJkv");

var $expGA = parcelRequire("expGA");
const $53ad4eb70716ac16$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $53ad4eb70716ac16$export$7970dfc3b824c864 = (0, $aTZGy.createLegacyEntry)((0, $expGA.globalSettingsProductsDvcsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: (0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$53ad4eb70716ac16$var$pageEntryPoint
    }));

});
parcelRegister("expGA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsRoute", () => $b03c3b754820a1eb$export$75d086bb3dd16edc);
const $b03c3b754820a1eb$export$75d086bb3dd16edc = {
    name: 'global-settings-products-dvcs',
    path: '/secure/admin/ConfigureDvcsOrganizations!default.jspa'
};

});


parcelRegister("lSmMA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsJsdStatusRouteEntry", () => $c57c578662866d14$export$5f4b9c737cade2ac);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $aTZGy = parcelRequire("aTZGy");

var $3RJkv = parcelRequire("3RJkv");

var $hv5yw = parcelRequire("hv5yw");
const $c57c578662866d14$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $c57c578662866d14$export$5f4b9c737cade2ac = (0, $aTZGy.createLegacyEntry)((0, $hv5yw.globalSettingsProductsJsdStatusRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: (0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$c57c578662866d14$var$pageEntryPoint
    }));

});
parcelRegister("hv5yw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsJsdStatusRoute", () => $e297abb11a15775c$export$a0292a772bf703a0);
const $e297abb11a15775c$export$a0292a772bf703a0 = {
    name: 'global-settings-products-jsd-status',
    path: '/plugins/servlet/ac/jsd-status-page'
};

});


parcelRegister("82PdT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdconfigRouteEntry", () => $7e96ffd827d38110$export$cb6362a400fffb25);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $aTZGy = parcelRequire("aTZGy");

var $3RJkv = parcelRequire("3RJkv");

var $4rYn5 = parcelRequire("4rYn5");
const $7e96ffd827d38110$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $7e96ffd827d38110$export$cb6362a400fffb25 = (0, $aTZGy.createLegacyEntry)((0, $4rYn5.globalSettingsProductsSdconfigRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: (0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$7e96ffd827d38110$var$pageEntryPoint
    }));

});
parcelRegister("4rYn5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdconfigRoute", () => $1b435b73879153a0$export$846e5cd0d5151fde);
const $1b435b73879153a0$export$846e5cd0d5151fde = {
    name: 'global-settings-products-sdconfig',
    path: '/secure/admin/SDConfiguration.jspa'
};

});


parcelRegister("jIr9s", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdmailRouteEntry", () => $adf7a533f01bbdf7$export$e296aae86525a621);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $aTZGy = parcelRequire("aTZGy");

var $3RJkv = parcelRequire("3RJkv");

var $kNfNN = parcelRequire("kNfNN");
const $adf7a533f01bbdf7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $adf7a533f01bbdf7$export$e296aae86525a621 = (0, $aTZGy.createLegacyEntry)((0, $kNfNN.globalSettingsProductsSdmailRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: (0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$adf7a533f01bbdf7$var$pageEntryPoint
    }));

});
parcelRegister("kNfNN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdmailRoute", () => $3091dbe6a260ac05$export$e35c6c6fbfbb5111);
const $3091dbe6a260ac05$export$e35c6c6fbfbb5111 = {
    name: 'global-settings-products-sdmail',
    path: '/secure/admin/SDMailInfo.jspa'
};

});


parcelRegister("5cpbg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRouteEntry", () => $c4d61674af941734$export$3e9459c1e240d138);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $aTZGy = parcelRequire("aTZGy");

var $3RJkv = parcelRequire("3RJkv");

var $2o8UE = parcelRequire("2o8UE");
const $c4d61674af941734$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $c4d61674af941734$export$3e9459c1e240d138 = (0, $aTZGy.createLegacyEntry)((0, $2o8UE.globalSettingsProductsSoftwareConfigRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: (0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$c4d61674af941734$var$pageEntryPoint
    }));

});
parcelRegister("2o8UE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRoute", () => $5d461100bc2f0a59$export$5b270f25cf4ae11c);
const $5d461100bc2f0a59$export$5b270f25cf4ae11c = {
    name: 'global-settings-products-software-config',
    path: '/secure/SoftwareConfig.jspa',
    query: [
        'decorator=admin'
    ]
};

});


parcelRegister("29xMF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRouteEntry", () => $a7ef83442353e730$export$ecfb2cc5a7593980);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $1WkA7 = parcelRequire("1WkA7");
const $a7ef83442353e730$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $a7ef83442353e730$export$ecfb2cc5a7593980 = (0, $aTZGy.createLegacyEntry)((0, $1WkA7.globalSettingsProjectsCategoriesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a7ef83442353e730$var$pageEntryPoint
    }));

});
parcelRegister("4jMkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7b1354cffbd527$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("lMg9f")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar, null)));
$bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $bb7b1354cffbd527$export$2e2bcd8739ae039 = $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("lMg9f", function(module, exports) {

let $fdaa9b5cc9e99622$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdaa9b5cc9e99622$var$load("lhVk0").then(()=>parcelRequire('1tunp'));

});


parcelRegister("1WkA7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRoute", () => $d64ecd93b1be6650$export$f155c76657570a56);
const $d64ecd93b1be6650$export$f155c76657570a56 = {
    name: 'global-settings-projects-categories-delete',
    path: '/secure/admin/projectcategories/DeleteProjectCategory([!%]?[\\w]*).jspa'
};

});


parcelRegister("fLmiZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRouteEntry", () => $32657b3729cad773$export$8364dd961ae6c494);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $1FmYF = parcelRequire("1FmYF");
const $32657b3729cad773$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $32657b3729cad773$export$8364dd961ae6c494 = (0, $aTZGy.createLegacyEntry)((0, $1FmYF.globalSettingsProjectsCategoriesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$32657b3729cad773$var$pageEntryPoint
    }));

});
parcelRegister("1FmYF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRoute", () => $78a6964c8f6cf043$export$53d7a3e6e69ec873);
const $78a6964c8f6cf043$export$53d7a3e6e69ec873 = {
    name: 'global-settings-projects-categories-edit',
    path: '/secure/admin/projectcategories/EditProjectCategory([!%]?[\\w]*).jspa'
};

});


parcelRegister("g2P0y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRouteEntry", () => $0948a79eec297861$export$f53b9ac05cdf2fe8);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $c0f0r = parcelRequire("c0f0r");
const $0948a79eec297861$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $0948a79eec297861$export$f53b9ac05cdf2fe8 = (0, $aTZGy.createLegacyEntry)((0, $c0f0r.globalSettingsProjectsCategoriesViewRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$0948a79eec297861$var$pageEntryPoint
    }));

});
parcelRegister("c0f0r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRoute", () => $7f86aa3717b8868e$export$17ada00b0bde9ebc);
const $7f86aa3717b8868e$export$17ada00b0bde9ebc = {
    name: 'global-settings-projects-categories-view',
    path: '/secure/admin/projectcategories/ViewProjectCategories([!%]?[\\w]*).jspa'
};

});


parcelRegister("1KhKT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRouteEntry", () => $1f84266c1c16d9ff$export$48579ce5caedb688);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gYg7r = parcelRequire("gYg7r");
const $1f84266c1c16d9ff$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $1f84266c1c16d9ff$export$48579ce5caedb688 = (0, $aTZGy.createLegacyEntry)((0, $gYg7r.globalSettingsSystemApplicationAdvancedRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$1f84266c1c16d9ff$var$pageEntryPoint
    }));

});
parcelRegister("gYg7r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRoute", () => $0c6a5a05ec1ef000$export$e79dd086a8ca16b7);
const $0c6a5a05ec1ef000$export$e79dd086a8ca16b7 = {
    name: 'global-settings-system-application-advanced',
    path: '/secure/admin/AdvancedApplicationProperties.jspa'
};

});


parcelRegister("lz4Nv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationEditRouteEntry", () => $9ef203b7cec1f365$export$cb756194922d59f5);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $hQ5nz = parcelRequire("hQ5nz");
const $9ef203b7cec1f365$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $9ef203b7cec1f365$export$cb756194922d59f5 = (0, $aTZGy.createLegacyEntry)((0, $hQ5nz.globalSettingsSystemApplicationEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9ef203b7cec1f365$var$pageEntryPoint
    }));

});
parcelRegister("hQ5nz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationEditRoute", () => $b758bac26e4d4cf5$export$3cfb7004aee9915c);
const $b758bac26e4d4cf5$export$3cfb7004aee9915c = {
    name: 'global-settings-system-application-edit',
    path: '/secure/admin/EditApplicationProperties([!%]?[\\w]*).jspa'
};

});


parcelRegister("iIXYD", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationViewRouteEntry", () => $af67fbebc0bc330f$export$c97a0463677004d2);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $icBtV = parcelRequire("icBtV");
const $af67fbebc0bc330f$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $af67fbebc0bc330f$export$c97a0463677004d2 = (0, $aTZGy.createLegacyEntry)((0, $icBtV.globalSettingsSystemApplicationViewRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$af67fbebc0bc330f$var$pageEntryPoint
    }));

});
parcelRegister("icBtV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationViewRoute", () => $f21b2235a5f34af8$export$5ddf1dd9c57a9326);
const $f21b2235a5f34af8$export$5ddf1dd9c57a9326 = {
    name: 'global-settings-system-application-view',
    path: '/secure/admin/ViewApplicationProperties.jspa'
};

});


parcelRegister("fxYAK", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAttachmentsRouteEntry", () => $6c16f069caae4b2e$export$a692196c89a01817);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $l23Yk = parcelRequire("l23Yk");

var $5pSYQ = parcelRequire("5pSYQ");
const $6c16f069caae4b2e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $6c16f069caae4b2e$export$a692196c89a01817 = (0, $aTZGy.createLegacyEntry)((0, $l23Yk.globalSettingsSystemAttachmentsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$6c16f069caae4b2e$var$pageEntryPoint
    }));

});
parcelRegister("l23Yk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAttachmentsRoute", () => $b9e8029d6b83941e$export$717d7ab74cb9ce91);
const $b9e8029d6b83941e$export$717d7ab74cb9ce91 = {
    name: 'global-settings-system-attachments',
    path: '/secure/admin/ViewAttachmentSettings.jspa'
};

});


parcelRegister("dPq7r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAuditingRouteEntry", () => $a41516d10bce5b90$export$7484cb4db3cfbf3f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $lKtRG = parcelRequire("lKtRG");

var $5pSYQ = parcelRequire("5pSYQ");
const $a41516d10bce5b90$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $a41516d10bce5b90$export$7484cb4db3cfbf3f = (0, $aTZGy.createLegacyEntry)((0, $lKtRG.globalSettingsSystemAuditingRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$a41516d10bce5b90$var$pageEntryPoint
    }));

});
parcelRegister("lKtRG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAuditingRoute", () => $e259cef3340babd0$export$b8241cf6a8335186);
const $e259cef3340babd0$export$b8241cf6a8335186 = {
    name: 'global-settings-system-auditing',
    path: '/auditing/:page'
};

});


parcelRegister("dHtcq", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemCollectorsRouteEntry", () => $fe775920e0919c87$export$a46b2c4865857bde);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $9FtFv = parcelRequire("9FtFv");

var $5pSYQ = parcelRequire("5pSYQ");
const $fe775920e0919c87$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $fe775920e0919c87$export$a46b2c4865857bde = (0, $aTZGy.createLegacyEntry)((0, $9FtFv.globalSettingsSystemCollectorsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$fe775920e0919c87$var$pageEntryPoint
    }));

});
parcelRegister("9FtFv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemCollectorsRoute", () => $59582e428d821ea0$export$69ef22f1d54c39dc);
const $59582e428d821ea0$export$69ef22f1d54c39dc = {
    name: 'global-settings-system-collectors',
    path: '/secure/admin/ViewGlobalCollectors([!%]?[\\w]*).jspa'
};

});


parcelRegister("imHTN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRouteEntry", () => $4205e9aa0549916c$export$3ba7ed3247e0da7);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $arrJE = parcelRequire("arrJE");

var $5pSYQ = parcelRequire("5pSYQ");
const $4205e9aa0549916c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $4205e9aa0549916c$export$3ba7ed3247e0da7 = (0, $aTZGy.createLegacyEntry)((0, $arrJE.globalSettingsSystemDefaultSettingsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$4205e9aa0549916c$var$pageEntryPoint
    }));

});
parcelRegister("arrJE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRoute", () => $242456d8439873ec$export$d8f4254e5ee116aa);
const $242456d8439873ec$export$d8f4254e5ee116aa = {
    name: 'global-settings-system-default-settings',
    path: '/secure/admin/ViewUserDefaultSettings([!%]?[\\w]*).jspa'
};

});


parcelRegister("76Qj6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsAddRouteEntry", () => $1f3fa09ff3d7b49d$export$18dc7c450d001255);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $6BrNv = parcelRequire("6BrNv");
const $1f3fa09ff3d7b49d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $1f3fa09ff3d7b49d$export$18dc7c450d001255 = (0, $aTZGy.createLegacyEntry)((0, $6BrNv.globalSettingsSystemEventsAddRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$1f3fa09ff3d7b49d$var$pageEntryPoint
    }));

});
parcelRegister("6BrNv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsAddRoute", () => $47aa9a9af4b78ab9$export$3bafc84a5f76a507);
const $47aa9a9af4b78ab9$export$3bafc84a5f76a507 = {
    name: 'global-settings-system-events-add',
    path: '/secure/admin/AddEventType.jspa'
};

});


parcelRegister("1WWKh", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsDeleteRouteEntry", () => $712d3fbe213660bb$export$82ec56d45583ff5a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $JsdS1 = parcelRequire("JsdS1");
const $712d3fbe213660bb$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $712d3fbe213660bb$export$82ec56d45583ff5a = (0, $aTZGy.createLegacyEntry)((0, $JsdS1.globalSettingsSystemEventsDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$712d3fbe213660bb$var$pageEntryPoint
    }));

});
parcelRegister("JsdS1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsDeleteRoute", () => $e951927bb7b0638b$export$cf0c62e05603f7e1);
const $e951927bb7b0638b$export$cf0c62e05603f7e1 = {
    name: 'global-settings-system-events-delete',
    path: '/secure/admin/DeleteEventType.jspa'
};

});


parcelRegister("9yaGy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsEditRouteEntry", () => $37a8a9d8065b20f3$export$5700f7202370e9c4);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $6LLbs = parcelRequire("6LLbs");
const $37a8a9d8065b20f3$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $37a8a9d8065b20f3$export$5700f7202370e9c4 = (0, $aTZGy.createLegacyEntry)((0, $6LLbs.globalSettingsSystemEventsEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$37a8a9d8065b20f3$var$pageEntryPoint
    }));

});
parcelRegister("6LLbs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsEditRoute", () => $3134f6d6b686b7ab$export$9bf98baef9abe3eb);
const $3134f6d6b686b7ab$export$9bf98baef9abe3eb = {
    name: 'global-settings-system-events-edit',
    path: '/secure/admin/EditEventType.jspa'
};

});


parcelRegister("eWZIp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsRouteEntry", () => $798e6ca5ede8ecee$export$431e68e0ed553cca);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $hAWBX = parcelRequire("hAWBX");

var $5pSYQ = parcelRequire("5pSYQ");
const $798e6ca5ede8ecee$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $798e6ca5ede8ecee$export$431e68e0ed553cca = (0, $aTZGy.createLegacyEntry)((0, $hAWBX.globalSettingsSystemEventsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$798e6ca5ede8ecee$var$pageEntryPoint
    }));

});
parcelRegister("hAWBX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsRoute", () => $079fe3268ea4ab4f$export$c294ba50eb736e7b);
const $079fe3268ea4ab4f$export$c294ba50eb736e7b = {
    name: 'global-settings-system-events',
    path: '/secure/admin/ListEventTypes.jspa'
};

});


parcelRegister("88PgZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemExportRouteEntry", () => $467687eb2022cbf0$export$78effb39671690ca);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $hsUej = parcelRequire("hsUej");

var $5pSYQ = parcelRequire("5pSYQ");
const $467687eb2022cbf0$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $467687eb2022cbf0$export$78effb39671690ca = (0, $aTZGy.createLegacyEntry)((0, $hsUej.globalSettingsSystemExportRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$467687eb2022cbf0$var$pageEntryPoint
    }));

});
parcelRegister("hsUej", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemExportRoute", () => $282550bb68b912d8$export$e398684ea718a2e7);
const $282550bb68b912d8$export$e398684ea718a2e7 = {
    name: 'global-settings-system-export',
    path: '/secure/admin/CloudExport.jspa'
};

});


parcelRegister("dlgy2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRouteEntry", () => $a669218f59cf1de9$export$ebb311f9ff3b5efb);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gOaBI = parcelRequire("gOaBI");

var $5pSYQ = parcelRequire("5pSYQ");
const $a669218f59cf1de9$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $a669218f59cf1de9$export$ebb311f9ff3b5efb = (0, $aTZGy.createLegacyEntry)((0, $gOaBI.globalSettingsSystemGlobalPermissionsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$a669218f59cf1de9$var$pageEntryPoint
    }));

});
parcelRegister("gOaBI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRoute", () => $676e42c756fdc5bc$export$38ac3717b046eb26);
const $676e42c756fdc5bc$export$38ac3717b046eb26 = {
    name: 'global-settings-system-global-permissions',
    path: '/secure/admin/jira/GlobalPermissions!default.jspa'
};

});


parcelRegister("38qLO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperNotificationRouteEntry", () => $fffb9ec3f6928464$export$e2befb3c6371d2f2);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $b1e5y = parcelRequire("b1e5y");
const $fffb9ec3f6928464$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $fffb9ec3f6928464$export$e2befb3c6371d2f2 = (0, $aTZGy.createLegacyEntry)((0, $b1e5y.globalSettingsSystemHelperNotificationRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$fffb9ec3f6928464$var$pageEntryPoint
    }));

});
parcelRegister("b1e5y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperNotificationRoute", () => $4e72f6f4b1c9f3c7$export$7dab38c28c574395);
const $4e72f6f4b1c9f3c7$export$7dab38c28c574395 = {
    name: 'global-settings-system-helper-notification',
    path: '/secure/admin/NotificationHelperAdmin.jspa'
};

});


parcelRegister("ipHzu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperPermissionRouteEntry", () => $005460872f5cfb5b$export$b7f8ebfe77163756);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $du3X8 = parcelRequire("du3X8");

var $5pSYQ = parcelRequire("5pSYQ");
const $005460872f5cfb5b$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $005460872f5cfb5b$export$b7f8ebfe77163756 = (0, $aTZGy.createLegacyEntry)((0, $du3X8.globalSettingsSystemHelperPermissionRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$005460872f5cfb5b$var$pageEntryPoint
    }));

});
parcelRegister("du3X8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperPermissionRoute", () => $66b0dc3804b6bcfe$export$5c1770f1a1797fa5);
const $66b0dc3804b6bcfe$export$5c1770f1a1797fa5 = {
    name: 'global-settings-system-helper-permission',
    path: '/secure/admin/PermissionHelperAdmin.jspa'
};

});


parcelRegister("f3jZ3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportBulkRouteEntry", () => $e0f7ef424ccbe325$export$dd20078389577d29);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $guEYe = parcelRequire("guEYe");
const $e0f7ef424ccbe325$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $e0f7ef424ccbe325$export$dd20078389577d29 = (0, $aTZGy.createLegacyEntry)((0, $guEYe.globalSettingsSystemImportBulkRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$e0f7ef424ccbe325$var$pageEntryPoint
    }));

});
parcelRegister("guEYe", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportBulkRoute", () => $a6e5a868502fc86f$export$9de82cbc931fb7d0);
const $a6e5a868502fc86f$export$9de82cbc931fb7d0 = {
    name: 'global-settings-system-import-bulk',
    path: '/secure/admin/BulkCreate(\\w+)([!%]?[\\w]*).jspa'
};

});


parcelRegister("7xiPB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCloudRouteEntry", () => $02e3dca2d495954b$export$9d598c957e5bddde);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $7AZZ7 = parcelRequire("7AZZ7");

var $5pSYQ = parcelRequire("5pSYQ");
const $02e3dca2d495954b$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $02e3dca2d495954b$export$9d598c957e5bddde = (0, $aTZGy.createLegacyEntry)((0, $7AZZ7.globalSettingsSystemImportCloudRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$02e3dca2d495954b$var$pageEntryPoint
    }));

});
parcelRegister("7AZZ7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCloudRoute", () => $b5f756296cd62273$export$9953342c4b995f8);
const $b5f756296cd62273$export$9953342c4b995f8 = {
    name: 'global-settings-system-import-cloud',
    path: '/secure/admin/CloudImport([!%]?[\\w]*).jspa'
};

});


parcelRegister("lRq3t", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCsvRouteEntry", () => $54dedf6346ad861e$export$9e23dd51b331426c);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $aqwzL = parcelRequire("aqwzL");
const $54dedf6346ad861e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $54dedf6346ad861e$export$9e23dd51b331426c = (0, $aTZGy.createLegacyEntry)((0, $aqwzL.globalSettingsSystemImportCsvRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$54dedf6346ad861e$var$pageEntryPoint
    }));

});
parcelRegister("aqwzL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCsvRoute", () => $8c87a607502f22fb$export$49f0cc3d88107d6b);
const $8c87a607502f22fb$export$49f0cc3d88107d6b = {
    name: 'global-settings-system-import-csv',
    path: '/(secure|secure/admin)/Csv(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("gZe42", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalRouteEntry", () => $41cc832588ca7871$export$bf4a85badc8c82c9);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $5LA9O = parcelRequire("5LA9O");
const $41cc832588ca7871$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $41cc832588ca7871$export$bf4a85badc8c82c9 = (0, $aTZGy.createLegacyEntry)((0, $5LA9O.globalSettingsSystemImportExternalRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$41cc832588ca7871$var$pageEntryPoint
    }));

});
parcelRegister("5LA9O", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalRoute", () => $7c8f3dd849c88787$export$afcc884cbc873f9f);
const $7c8f3dd849c88787$export$afcc884cbc873f9f = {
    name: 'global-settings-system-import-external',
    path: '/secure/admin/ExternalImport1.jspa'
};

});


parcelRegister("4DWPZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRouteEntry", () => $9165fe4159fc7bbd$export$7ca884816be2470a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $1L66F = parcelRequire("1L66F");
const $9165fe4159fc7bbd$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $9165fe4159fc7bbd$export$7ca884816be2470a = (0, $aTZGy.createLegacyEntry)((0, $1L66F.globalSettingsSystemImportExternalPagesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9165fe4159fc7bbd$var$pageEntryPoint
    }));

});
parcelRegister("1L66F", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRoute", () => $249bd04dfe154d96$export$dffab00ceab69eb2);
const $249bd04dfe154d96$export$dffab00ceab69eb2 = {
    name: 'global-settings-system-import-external-pages',
    path: '/secure/admin/Importer(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("4DO1F", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportJsonRouteEntry", () => $77b11aabd37660de$export$fbac3139112fe654);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $j3Is6 = parcelRequire("j3Is6");
const $77b11aabd37660de$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $77b11aabd37660de$export$fbac3139112fe654 = (0, $aTZGy.createLegacyEntry)((0, $j3Is6.globalSettingsSystemImportJsonRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$77b11aabd37660de$var$pageEntryPoint
    }));

});
parcelRegister("j3Is6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportJsonRoute", () => $14a7297c3ff1ed71$export$169bd8bcabed089d);
const $14a7297c3ff1ed71$export$169bd8bcabed089d = {
    name: 'global-settings-system-import-json',
    path: '/secure/admin/Json(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("aCW6m", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportTrelloRouteEntry", () => $c9767eafd3973fed$export$19f57ac143eecd95);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $bGRx7 = parcelRequire("bGRx7");
const $c9767eafd3973fed$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $c9767eafd3973fed$export$19f57ac143eecd95 = (0, $aTZGy.createLegacyEntry)((0, $bGRx7.globalSettingsSystemImportTrelloRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c9767eafd3973fed$var$pageEntryPoint
    }));

});
parcelRegister("bGRx7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportTrelloRoute", () => $2e8916ddb8fb5d04$export$b6753e755954098b);
const $2e8916ddb8fb5d04$export$b6753e755954098b = {
    name: 'global-settings-system-import-trello',
    path: '/secure/admin/Trello(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("7781P", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLexorankRouteEntry", () => $62fbaca9d971b553$export$5163204c27a4b60f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $5LvN7 = parcelRequire("5LvN7");

var $5pSYQ = parcelRequire("5pSYQ");
const $62fbaca9d971b553$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $62fbaca9d971b553$export$5163204c27a4b60f = (0, $aTZGy.createLegacyEntry)((0, $5LvN7.globalSettingsSystemLexorankRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$62fbaca9d971b553$var$pageEntryPoint
    }));

});
parcelRegister("5LvN7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLexorankRoute", () => $b3c064cd48c5e357$export$d4ce3155385fd8cf);
const $b3c064cd48c5e357$export$d4ce3155385fd8cf = {
    name: 'global-settings-system-lexorank',
    path: '/secure/GHLexoRankManage.jspa',
    query: [
        'decorator=admin'
    ]
};

});


parcelRegister("eAMh2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLookRouteEntry", () => $4127b9bac7cc32ca$export$bf366af006cda74e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $8dElf = parcelRequire("8dElf");

var $5pSYQ = parcelRequire("5pSYQ");
const $4127b9bac7cc32ca$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $4127b9bac7cc32ca$export$bf366af006cda74e = (0, $aTZGy.createLegacyEntry)((0, $8dElf.globalSettingsSystemLookRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$4127b9bac7cc32ca$var$pageEntryPoint
    }));

});
parcelRegister("8dElf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLookRoute", () => $b37fbd9b8c4d9fb8$export$61f7b12ec2ac6aa1);
const $b37fbd9b8c4d9fb8$export$61f7b12ec2ac6aa1 = {
    name: 'global-settings-system-look',
    path: '/secure/admin/LookAndFeel!default.jspa'
};

});


parcelRegister("lS7PF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailAddRouteEntry", () => $cd53cf7f02d8076d$export$c48daf66fa2bb3e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $aUyRh = parcelRequire("aUyRh");
const $cd53cf7f02d8076d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $cd53cf7f02d8076d$export$c48daf66fa2bb3e = (0, $aTZGy.createLegacyEntry)((0, $aUyRh.globalSettingsSystemMailAddRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$cd53cf7f02d8076d$var$pageEntryPoint
    }));

});
parcelRegister("aUyRh", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailAddRoute", () => $c1c77581706bed7f$export$2874a3735d7cb330);
const $c1c77581706bed7f$export$2874a3735d7cb330 = {
    name: 'global-settings-system-mail-add',
    path: '/secure/admin/(Add|Update)PopMailServer!default.jspa'
};

});


parcelRegister("5QGoI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRouteEntry", () => $a30a27b91b1bcf00$export$a14468794f1b5c83);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $3Jvyu = parcelRequire("3Jvyu");
const $a30a27b91b1bcf00$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $a30a27b91b1bcf00$export$a14468794f1b5c83 = (0, $aTZGy.createLegacyEntry)((0, $3Jvyu.globalSettingsSystemMailDeleteMailHandlerRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$a30a27b91b1bcf00$var$pageEntryPoint
    }));

});
parcelRegister("3Jvyu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRoute", () => $6acf899e367d54a7$export$140403398c884f90);
const $6acf899e367d54a7$export$140403398c884f90 = {
    name: 'global-settings-system-delete-mail-handler',
    path: '/secure/admin/DeleteMailHandler.jspa'
};

});


parcelRegister("dOEiY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailIncomingRouteEntry", () => $98a09653b5b5494f$export$3ae66df5766592ef);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $gIrCk = parcelRequire("gIrCk");

var $5pSYQ = parcelRequire("5pSYQ");
const $98a09653b5b5494f$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $98a09653b5b5494f$export$3ae66df5766592ef = (0, $aTZGy.createLegacyEntry)((0, $gIrCk.globalSettingsSystemMailIncomingRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$98a09653b5b5494f$var$pageEntryPoint
    }));

});
parcelRegister("gIrCk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailIncomingRoute", () => $317e7ace92f4e6ef$export$90c9c127e433d888);
const $317e7ace92f4e6ef$export$90c9c127e433d888 = {
    name: 'global-settings-system-mail-incoming',
    path: '/secure/admin/IncomingMailServers.jspa'
};

});


parcelRegister("4k7ly", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailOutgoingRouteEntry", () => $481ae497019ebd89$export$cb267b8986031cb7);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $jF6uq = parcelRequire("jF6uq");

var $5pSYQ = parcelRequire("5pSYQ");
const $481ae497019ebd89$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $481ae497019ebd89$export$cb267b8986031cb7 = (0, $aTZGy.createLegacyEntry)((0, $jF6uq.globalSettingsSystemMailOutgoingRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$481ae497019ebd89$var$pageEntryPoint
    }));

});
parcelRegister("jF6uq", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailOutgoingRoute", () => $9fee223f0a19371b$export$6da120a8b84a7872);
const $9fee223f0a19371b$export$6da120a8b84a7872 = {
    name: 'global-settings-system-mail-outgoing',
    path: '/secure/admin/OutgoingMailServers.jspa'
};

});


parcelRegister("8Y3IU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSendRouteEntry", () => $7b089ea44aea959b$export$bff9c3c6b0aba389);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $a170i = parcelRequire("a170i");

var $5pSYQ = parcelRequire("5pSYQ");
const $7b089ea44aea959b$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $7b089ea44aea959b$export$bff9c3c6b0aba389 = (0, $aTZGy.createLegacyEntry)((0, $a170i.globalSettingsSystemMailSendRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$7b089ea44aea959b$var$pageEntryPoint
    }));

});
parcelRegister("a170i", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSendRoute", () => $6eb027f6563ee3fb$export$a2ae5fa2accd6e5f);
const $6eb027f6563ee3fb$export$a2ae5fa2accd6e5f = {
    name: 'global-settings-system-mail-send',
    path: '/secure/admin/SendBulkMail!default.jspa'
};

});


parcelRegister("486WL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSettingsRouteEntry", () => $ad871ec64455d825$export$3c0d52a24b499e7c);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $yXjNA = parcelRequire("yXjNA");

var $5pSYQ = parcelRequire("5pSYQ");
const $ad871ec64455d825$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $ad871ec64455d825$export$3c0d52a24b499e7c = (0, $aTZGy.createLegacyEntry)((0, $yXjNA.globalSettingsSystemMailSettingsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$ad871ec64455d825$var$pageEntryPoint
    }));

});
parcelRegister("yXjNA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSettingsRoute", () => $f836a105d0b6621c$export$8423ad7a1177552);
const $f836a105d0b6621c$export$8423ad7a1177552 = {
    name: 'global-settings-system-mail-settings',
    path: '/secure/admin/GlobalMailSettings([!%]?[\\w]*).jspa'
};

});


parcelRegister("kQECV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailVerifyRouteEntry", () => $2dbb84757399bfd6$export$2fd491752a9501a2);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $5lAHf = parcelRequire("5lAHf");
const $2dbb84757399bfd6$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $2dbb84757399bfd6$export$2fd491752a9501a2 = (0, $aTZGy.createLegacyEntry)((0, $5lAHf.globalSettingsSystemMailVerifyRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2dbb84757399bfd6$var$pageEntryPoint
    }));

});
parcelRegister("5lAHf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailVerifyRoute", () => $7804842adf937967$export$51b4ff8214b9fd7f);
const $7804842adf937967$export$51b4ff8214b9fd7f = {
    name: 'global-settings-system-mail-verify',
    path: '/secure/admin/VerifyPopServerConnection([!%]?[\\w]*).jspa'
};

});


parcelRegister("kk5yP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemPermissionsRouteEntry", () => $369b4eb45d237b2c$export$9fe6a3bc70d75bae);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $j0UEO = parcelRequire("j0UEO");

var $5pSYQ = parcelRequire("5pSYQ");
const $369b4eb45d237b2c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $369b4eb45d237b2c$export$9fe6a3bc70d75bae = (0, $aTZGy.createLegacyEntry)((0, $j0UEO.globalSettingsSystemPermissionsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$369b4eb45d237b2c$var$pageEntryPoint
    }));

});
parcelRegister("j0UEO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemPermissionsRoute", () => $f77d29023bf3ebb0$export$1382458fd6826787);
const $f77d29023bf3ebb0$export$1382458fd6826787 = {
    name: 'global-settings-system-permissions',
    path: '/secure/admin/GlobalPermissions([!%]?[\\w]*).jspa'
};

});


parcelRegister("5nUrq", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRouteEntry", () => $ffaf126ea89a63af$export$b78eddbedd30951d);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $wrExs = parcelRequire("wrExs");
const $ffaf126ea89a63af$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $ffaf126ea89a63af$export$b78eddbedd30951d = (0, $aTZGy.createLegacyEntry)((0, $wrExs.globalSettingsSystemProjectAssignSecurityRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ffaf126ea89a63af$var$pageEntryPoint
    }));

});
parcelRegister("wrExs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRoute", () => $55c4cb1e1e3e5c5e$export$f53750f3a4fc2fde);
const $55c4cb1e1e3e5c5e$export$f53750f3a4fc2fde = {
    name: 'global-settings-system-project-assign-security',
    path: '/secure/project/AssignIssueSecuritySchemeProgress.jspa'
};

});


parcelRegister("kPUF4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectDeleteRouteEntry", () => $2454711a256eb535$export$849f3666529d049e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $iAxn1 = parcelRequire("iAxn1");
const $2454711a256eb535$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $2454711a256eb535$export$849f3666529d049e = (0, $aTZGy.createLegacyEntry)((0, $iAxn1.globalSettingsSystemProjectDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2454711a256eb535$var$pageEntryPoint
    }));

});
parcelRegister("iAxn1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectDeleteRoute", () => $b90d4b6cec694e1e$export$f31d8748a56aa638);
const $b90d4b6cec694e1e$export$f31d8748a56aa638 = {
    name: 'global-settings-system-project-delete',
    path: '/secure/project/DeleteProject.jspa'
};

});


parcelRegister("jXCBD", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectSelectRouteEntry", () => $717567493441fad6$export$a1869de90837dac8);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $g2bAF = parcelRequire("g2bAF");
const $717567493441fad6$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $717567493441fad6$export$a1869de90837dac8 = (0, $aTZGy.createLegacyEntry)((0, $g2bAF.globalSettingsSystemProjectSelectRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$717567493441fad6$var$pageEntryPoint
    }));

});
parcelRegister("g2bAF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectSelectRoute", () => $ba7ef529b7a4dfd1$export$8f44b9e5553dccec);
const $ba7ef529b7a4dfd1$export$8f44b9e5553dccec = {
    name: 'global-settings-system-project-select',
    path: '/secure/project/SelectProject(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("9uymn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsRouteEntry", () => $4581f0ee157b1c2e$export$7dc567ad40905890);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $ksEWL = parcelRequire("ksEWL");
const $4581f0ee157b1c2e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $4581f0ee157b1c2e$export$7dc567ad40905890 = (0, $aTZGy.createLegacyEntry)((0, $ksEWL.globalSettingsSystemRolesActorsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$4581f0ee157b1c2e$var$pageEntryPoint
    }));

});
parcelRegister("ksEWL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsRoute", () => $c7cff380d3d7045d$export$3dca5fcf3b98db1e);
const $c7cff380d3d7045d$export$3dca5fcf3b98db1e = {
    name: 'global-settings-system-roles-actors',
    path: '/secure/project/ViewDefaultProjectRoleActors([!%]?[\\w]*).jspa'
};

});


parcelRegister("llWtm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRouteEntry", () => $f2d3d1560d6e64a3$export$ac1028baf6d1bd60);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $lvg6l = parcelRequire("lvg6l");
const $f2d3d1560d6e64a3$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $f2d3d1560d6e64a3$export$ac1028baf6d1bd60 = (0, $aTZGy.createLegacyEntry)((0, $lvg6l.globalSettingsSystemRolesActorsGroupsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$f2d3d1560d6e64a3$var$pageEntryPoint
    }));

});
parcelRegister("lvg6l", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRoute", () => $f0f25fca34e37044$export$836f3cdea3e238a4);
const $f0f25fca34e37044$export$836f3cdea3e238a4 = {
    name: 'global-settings-system-roles-actors-groups',
    path: '/secure/project/GroupRoleActorAction.jspa'
};

});


parcelRegister("2esMz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRouteEntry", () => $fac31dc315bca77f$export$3186176f09045f35);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $C8ujW = parcelRequire("C8ujW");
const $fac31dc315bca77f$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $fac31dc315bca77f$export$3186176f09045f35 = (0, $aTZGy.createLegacyEntry)((0, $C8ujW.globalSettingsSystemRolesActorsUsersRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$fac31dc315bca77f$var$pageEntryPoint
    }));

});
parcelRegister("C8ujW", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRoute", () => $dacef4390742ea19$export$119e823548eefd4f);
const $dacef4390742ea19$export$119e823548eefd4f = {
    name: 'global-settings-system-roles-actors-users',
    path: '/secure/project/UserRoleActorAction.jspa'
};

});


parcelRegister("eey6O", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesDeleteRouteEntry", () => $903c98c0a30eb4a6$export$4f2756ef0230f213);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $bKX77 = parcelRequire("bKX77");
const $903c98c0a30eb4a6$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $903c98c0a30eb4a6$export$4f2756ef0230f213 = (0, $aTZGy.createLegacyEntry)((0, $bKX77.globalSettingsSystemRolesDeleteRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$903c98c0a30eb4a6$var$pageEntryPoint
    }));

});
parcelRegister("bKX77", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesDeleteRoute", () => $609a18bbfeef7a19$export$c4b2dba31a4a29c8);
const $609a18bbfeef7a19$export$c4b2dba31a4a29c8 = {
    name: 'global-settings-system-roles-delete',
    path: '/secure/project/DeleteProjectRole([!%]?[\\w]*).jspa'
};

});


parcelRegister("av0Fi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesEditRouteEntry", () => $12576ad969c93354$export$18cfabcb0c0c21e5);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $83tff = parcelRequire("83tff");
const $12576ad969c93354$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $12576ad969c93354$export$18cfabcb0c0c21e5 = (0, $aTZGy.createLegacyEntry)((0, $83tff.globalSettingsSystemRolesEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$12576ad969c93354$var$pageEntryPoint
    }));

});
parcelRegister("83tff", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesEditRoute", () => $ffe43918711c624c$export$88917fe447558e55);
const $ffe43918711c624c$export$88917fe447558e55 = {
    name: 'global-settings-system-roles-edit',
    path: '/secure/project/EditProjectRole([!%]?[\\w]*).jspa'
};

});


parcelRegister("5JGis", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesUsageRouteEntry", () => $b87362da57c067f5$export$d9f7c60572f36835);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $22LmS = parcelRequire("22LmS");
const $b87362da57c067f5$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $b87362da57c067f5$export$d9f7c60572f36835 = (0, $aTZGy.createLegacyEntry)((0, $22LmS.globalSettingsSystemRolesUsageRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b87362da57c067f5$var$pageEntryPoint
    }));

});
parcelRegister("22LmS", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesUsageRoute", () => $d03937559d5c97ec$export$91305e5cb99eb005);
const $d03937559d5c97ec$export$91305e5cb99eb005 = {
    name: 'global-settings-system-roles-usage',
    path: '/secure/project/ViewProjectRoleUsage([!%]?[\\w]*).jspa'
};

});


parcelRegister("kbANj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesViewRouteEntry", () => $300f3167c2bfbd5e$export$47efc3b9a4cedfba);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $aVqV6 = parcelRequire("aVqV6");

var $5pSYQ = parcelRequire("5pSYQ");
const $300f3167c2bfbd5e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $300f3167c2bfbd5e$export$47efc3b9a4cedfba = (0, $aTZGy.createLegacyEntry)((0, $aVqV6.globalSettingsSystemRolesViewRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$300f3167c2bfbd5e$var$pageEntryPoint
    }));

});
parcelRegister("aVqV6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesViewRoute", () => $1df65f5c48225a22$export$81d6a9112f47a229);
const $1df65f5c48225a22$export$81d6a9112f47a229 = {
    name: 'global-settings-system-roles-view',
    path: '/secure/project/ViewProjectRoles([!%]?[\\w]*).jspa'
};

});


parcelRegister("b0VF1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemServicesRouteEntry", () => $17cf2f51c6e4d0f1$export$f08661656eef7ad1);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $fPXT5 = parcelRequire("fPXT5");

var $5pSYQ = parcelRequire("5pSYQ");
const $17cf2f51c6e4d0f1$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $17cf2f51c6e4d0f1$export$f08661656eef7ad1 = (0, $aTZGy.createLegacyEntry)((0, $fPXT5.globalSettingsSystemServicesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$17cf2f51c6e4d0f1$var$pageEntryPoint
    }));

});
parcelRegister("fPXT5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemServicesRoute", () => $67ffbd05aead034d$export$a176af71f8d6d872);
const $67ffbd05aead034d$export$a176af71f8d6d872 = {
    name: 'global-settings-system-services',
    path: '/secure/admin/ViewServices!default.jspa'
};

});


parcelRegister("1Q4PR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRouteEntry", () => $9f59e0133aa489ce$export$48cce4d971c37598);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $b7oMc = parcelRequire("b7oMc");

var $5pSYQ = parcelRequire("5pSYQ");
const $9f59e0133aa489ce$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $9f59e0133aa489ce$export$48cce4d971c37598 = (0, $aTZGy.createLegacyEntry)((0, $b7oMc.globalSettingsSystemSharedDashboardsRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$9f59e0133aa489ce$var$pageEntryPoint
    }));

});
parcelRegister("b7oMc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRoute", () => $a740345c705081c5$export$64739c332d5146ba);
const $a740345c705081c5$export$64739c332d5146ba = {
    name: 'global-settings-system-shared-dashboards',
    path: '/secure/admin/dashboards/ViewSharedDashboards.jspa'
};

});


parcelRegister("li7Ec", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedFiltersRouteEntry", () => $18fc02046ed692d4$export$6777672075f7d618);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $aP9zj = parcelRequire("aP9zj");

var $5pSYQ = parcelRequire("5pSYQ");
const $18fc02046ed692d4$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $18fc02046ed692d4$export$6777672075f7d618 = (0, $aTZGy.createLegacyEntry)((0, $aP9zj.globalSettingsSystemSharedFiltersRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$18fc02046ed692d4$var$pageEntryPoint
    }));

});
parcelRegister("aP9zj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedFiltersRoute", () => $c735ea2c5532f1ff$export$684d93e5438fcd69);
const $c735ea2c5532f1ff$export$684d93e5438fcd69 = {
    name: 'global-settings-system-shared-filters',
    path: '/secure/admin/filters/ViewSharedFilters.jspa'
};

});


parcelRegister("4u3md", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRouteEntry", () => $074a1e6e8607339e$export$dbe314c372e965d4);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $28Pb7 = parcelRequire("28Pb7");
const $074a1e6e8607339e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $074a1e6e8607339e$export$dbe314c372e965d4 = (0, $aTZGy.createLegacyEntry)((0, $28Pb7.globalSettingsSystemUserInterfaceDashboardEditRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$074a1e6e8607339e$var$pageEntryPoint
    }));

});
parcelRegister("28Pb7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRoute", () => $5efe3387aa3831a3$export$78c9a0475c2f9cd0);
const $5efe3387aa3831a3$export$78c9a0475c2f9cd0 = {
    name: 'global-settings-system-ui-dashboard-edit',
    path: '/secure/admin/jira/EditApplicationProperties!default.jspa'
};

});


parcelRegister("kRES4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRouteEntry", () => $0cab658361432bca$export$7025983c5e996386);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $8VNOT = parcelRequire("8VNOT");
const $0cab658361432bca$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $0cab658361432bca$export$7025983c5e996386 = (0, $aTZGy.createLegacyEntry)((0, $8VNOT.globalSettingsSystemUserInterfacePreferencesRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$0cab658361432bca$var$pageEntryPoint
    }));

});
parcelRegister("8VNOT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRoute", () => $a9c4f4eeba6278f3$export$6f46032e4fc13ea0);
const $a9c4f4eeba6278f3$export$6f46032e4fc13ea0 = {
    name: 'global-settings-system-ui-default-user-preferences-apply',
    path: '/secure/admin/SetGlobalEmailPreference!default.jspa'
};

});


parcelRegister("3vVvx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemWebhooksRouteEntry", () => $974817428397a39b$export$aff2563c719af2aa);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $aTZGy = parcelRequire("aTZGy");

var $atU1t = parcelRequire("atU1t");

var $1QAun = parcelRequire("1QAun");

var $5pSYQ = parcelRequire("5pSYQ");
const $974817428397a39b$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $974817428397a39b$export$aff2563c719af2aa = (0, $aTZGy.createLegacyEntry)((0, $1QAun.globalSettingsSystemWebhooksRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$974817428397a39b$var$pageEntryPoint
    }));

});
parcelRegister("1QAun", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemWebhooksRoute", () => $0a1e46e4d59dc069$export$2c20f3aef4ea16aa);
const $0a1e46e4d59dc069$export$2c20f3aef4ea16aa = {
    name: 'global-settings-system-webhooks',
    path: '/plugins/servlet/webhooks'
};

});


parcelRegister("2RsFl", function(module, exports) {

$parcel$export(module.exports, "legacyIssueRouteEntry", () => $41f5add591bf99b5$export$e8ba55056b4fde20);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $eOlBz = parcelRequire("eOlBz");

var $dxCvy = parcelRequire("dxCvy");

var $1WlLE = parcelRequire("1WlLE");

var $7GnDe = parcelRequire("7GnDe");

var $kP3J4 = parcelRequire("kP3J4");

var $2K2lw = parcelRequire("2K2lw");
const $41f5add591bf99b5$export$e8ba55056b4fde20 = (0, $aTZGy.createLegacyEntry)((0, $kP3J4.legacyIssueRoute), ()=>({
        group: 'legacy',
        layout: (0, $gyYxw.genericProjectLayout),
        component: (0, $2K2lw.LegacyIssueView),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $1WlLE.queuesNavigationItems),
            (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("kP3J4", function(module, exports) {

$parcel$export(module.exports, "legacyIssueRoute", () => $ff77becf1a564cf7$export$71da6fcc13745fba);
const $ff77becf1a564cf7$export$71da6fcc13745fba = {
    name: 'legacy-issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)',
    query: [
        'jql!=(.+)',
        'filter!=(.+)'
    ]
};

});

parcelRegister("2K2lw", function(module, exports) {

$parcel$export(module.exports, "LegacyIssueView", () => $3e6f7c82e1ea76a6$export$34dc6596952b042c);

var $5uXOq = parcelRequire("5uXOq");

var $6QKrH = parcelRequire("6QKrH");
const $3e6f7c82e1ea76a6$export$34dc6596952b042c = (props)=>{
    const { route: route } = props;
    if (!route) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6QKrH.LegacyPage), props));
};

});


parcelRegister("jagxj", function(module, exports) {

$parcel$export(module.exports, "legacyJsdCustomersRouteEntry", () => $67aff8381d75368b$export$f458747db287136e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hVeOg = parcelRequire("hVeOg");

var $6Z2mh = parcelRequire("6Z2mh");
const $67aff8381d75368b$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $67aff8381d75368b$export$f458747db287136e = (0, $aTZGy.createLegacyEntry)((0, $hVeOg.legacyJsdCustomersRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$67aff8381d75368b$var$pageEntryPoint
    }));

});
parcelRegister("hVeOg", function(module, exports) {

$parcel$export(module.exports, "legacyJsdCustomersRoute", () => $ba8a69d9c34bd759$export$3af39e70a286821c);
const $ba8a69d9c34bd759$export$3af39e70a286821c = {
    name: 'legacy-jsd-customers',
    path: '/projects/:projectKey/customers'
};

});


parcelRegister("9QqjO", function(module, exports) {

$parcel$export(module.exports, "legacyJsdGettingStartedRouteEntry", () => $efa4b1323f76bc66$export$3c4b4abb062b10e3);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $eu9bp = parcelRequire("eu9bp");

var $6Z2mh = parcelRequire("6Z2mh");
const $efa4b1323f76bc66$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $efa4b1323f76bc66$export$3c4b4abb062b10e3 = (0, $aTZGy.createLegacyEntry)((0, $eu9bp.legacyJsdGettingStartedRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$efa4b1323f76bc66$var$pageEntryPoint
    }));

});
parcelRegister("eu9bp", function(module, exports) {

$parcel$export(module.exports, "legacyJsdGettingStartedRoute", () => $211c6178ad1e4cf6$export$71b946ee427d710);
const $211c6178ad1e4cf6$export$71b946ee427d710 = {
    name: 'legacy-jsd-getting-started',
    path: '/projects/:projectKey/getting-started'
};

});


parcelRegister("9U4Np", function(module, exports) {

$parcel$export(module.exports, "legacyJsdJiraAutomationRouteEntry", () => $125a270ea99111b7$export$d2d1cb3e56d9ba93);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $1VTdO = parcelRequire("1VTdO");

var $6Z2mh = parcelRequire("6Z2mh");
const $125a270ea99111b7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $125a270ea99111b7$export$d2d1cb3e56d9ba93 = (0, $aTZGy.createLegacyEntry)((0, $1VTdO.legacyJsdJiraAutomationRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$125a270ea99111b7$var$pageEntryPoint
    }));

});
parcelRegister("1VTdO", function(module, exports) {

$parcel$export(module.exports, "legacyJsdJiraAutomationRoute", () => $41613ef6d68048d4$export$7d38596d701d5776);
const $41613ef6d68048d4$export$7d38596d701d5776 = {
    name: 'legacy-jsd-jira-automation',
    path: '/servicedesk/admin/:projectKey/automation'
};

});


parcelRegister("kaVHd", function(module, exports) {

$parcel$export(module.exports, "legacyJsdKnowledgeRouteEntry", () => $d1e6b8e1abf68f43$export$352579e39711e17);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $irWVR = parcelRequire("irWVR");

var $6Z2mh = parcelRequire("6Z2mh");
const $d1e6b8e1abf68f43$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $d1e6b8e1abf68f43$export$352579e39711e17 = (0, $aTZGy.createLegacyEntry)((0, $irWVR.legacyJsdKnowledgeRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d1e6b8e1abf68f43$var$pageEntryPoint
    }));

});
parcelRegister("irWVR", function(module, exports) {

$parcel$export(module.exports, "legacyJsdKnowledgeRoute", () => $9f5566df6136b61d$export$7c7fc282c0c143d);
const $9f5566df6136b61d$export$7c7fc282c0c143d = {
    name: 'legacy-jsd-knowledge',
    path: '/projects/:projectKey/knowledge/:page?'
};

});


parcelRegister("kLemY", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesRouteEntry", () => $d2babbb043851c59$export$7c006e8310e2641a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9Hqtf = parcelRequire("9Hqtf");

var $6Z2mh = parcelRequire("6Z2mh");
const $d2babbb043851c59$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $d2babbb043851c59$export$7c006e8310e2641a = (0, $aTZGy.createLegacyEntry)((0, $9Hqtf.legacyJsdQueuesRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d2babbb043851c59$var$pageEntryPoint
    }));

});
parcelRegister("9Hqtf", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesRoute", () => $3bbaa265023be131$export$2d08dc2a8c573cf3);
const $3bbaa265023be131$export$2d08dc2a8c573cf3 = {
    name: 'legacy-jsd-queues',
    path: '/projects/:projectKey/queues/:custom(custom)?/:id?'
};

});


parcelRegister("9WV4g", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesManageRouteEntry", () => $a858201e5db33c7d$export$cdabf798cd8727fd);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $02dAO = parcelRequire("02dAO");

var $6Z2mh = parcelRequire("6Z2mh");
const $a858201e5db33c7d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $a858201e5db33c7d$export$cdabf798cd8727fd = (0, $aTZGy.createLegacyEntry)((0, $02dAO.legacyJsdQueuesManageRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$a858201e5db33c7d$var$pageEntryPoint
    }));

});
parcelRegister("02dAO", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesManageRoute", () => $bdcd7fc1ec97fc1a$export$af365e550fae80);
const $bdcd7fc1ec97fc1a$export$af365e550fae80 = {
    name: 'legacy-jsd-queues-manage',
    path: '/projects/:projectKey/queues/manage'
};

});


parcelRegister("grES6", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsCustomRouteEntry", () => $76b3b302d6fe70da$export$e133645c1a4bdfe7);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $k5SFo = parcelRequire("k5SFo");

var $6Z2mh = parcelRequire("6Z2mh");
const $76b3b302d6fe70da$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $76b3b302d6fe70da$export$e133645c1a4bdfe7 = (0, $aTZGy.createLegacyEntry)((0, $k5SFo.legacyJsdReportsCustomRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$76b3b302d6fe70da$var$pageEntryPoint
    }));

});
parcelRegister("k5SFo", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsCustomRoute", () => $75a16ae54035efc5$export$e5d83d06029b0f71);
const $75a16ae54035efc5$export$e5d83d06029b0f71 = {
    name: 'legacy-jsd-reports-custom',
    path: '/projects/:projectKey/reports/custom/:id?'
};

});


parcelRegister("bF5bS", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsRouteEntry", () => $6feb691d1d511f2c$export$893692ad278d4aa2);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $3MTR9 = parcelRequire("3MTR9");

var $6Z2mh = parcelRequire("6Z2mh");
const $6feb691d1d511f2c$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $6feb691d1d511f2c$export$893692ad278d4aa2 = (0, $aTZGy.createLegacyEntry)((0, $3MTR9.legacyJsdReportsRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$6feb691d1d511f2c$var$pageEntryPoint
    }));

});
parcelRegister("3MTR9", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsRoute", () => $21354684477139d4$export$253418b9005ff89e);
const $21354684477139d4$export$253418b9005ff89e = {
    name: 'legacy-jsd-reports',
    path: '/projects/:projectKey/reports/:reportType'
};

});


parcelRegister("36pks", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsFallbackRouteEntry", () => $c8c5f46489679adc$export$f0bcff1cea783147);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9z08i = parcelRequire("9z08i");

var $6Z2mh = parcelRequire("6Z2mh");
const $c8c5f46489679adc$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $c8c5f46489679adc$export$f0bcff1cea783147 = (0, $aTZGy.createLegacyEntry)((0, $9z08i.legacyJsdSettingsFallbackRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$c8c5f46489679adc$var$pageEntryPoint
    }));

});
parcelRegister("9z08i", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsFallbackRoute", () => $4e1af37fd1432ea0$export$831971c91fbdcd5b);
const $4e1af37fd1432ea0$export$831971c91fbdcd5b = {
    name: 'legacy-jsd-settings-fallback',
    path: '/servicedesk/admin/:projectKey/:adminOption'
};

});


parcelRegister("DGgtd", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguageRouteEntry", () => $8a80ab09a10d8ce5$export$d9063e63677bfd5d);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $ipV72 = parcelRequire("ipV72");

var $6Z2mh = parcelRequire("6Z2mh");
const $8a80ab09a10d8ce5$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $8a80ab09a10d8ce5$export$d9063e63677bfd5d = (0, $aTZGy.createLegacyEntry)((0, $ipV72.legacyJsdSettingsLanguageRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$8a80ab09a10d8ce5$var$pageEntryPoint
    }));

});
parcelRegister("ipV72", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguageRoute", () => $056111690218a960$export$453ac1bfce2eb20e);
const $056111690218a960$export$453ac1bfce2eb20e = {
    name: 'legacy-jsd-settings-language',
    path: '/servicedesk/admin/:projectKey/language',
    exact: true
};

});


parcelRegister("eEyXO", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRouteEntry", () => $7dbf568c6dde3c06$export$492207df7adc0823);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hOtZA = parcelRequire("hOtZA");

var $6Z2mh = parcelRequire("6Z2mh");
const $7dbf568c6dde3c06$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $7dbf568c6dde3c06$export$492207df7adc0823 = (0, $aTZGy.createLegacyEntry)((0, $hOtZA.legacyJsdSettingsLanguagePagesRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$7dbf568c6dde3c06$var$pageEntryPoint
    }));

});
parcelRegister("hOtZA", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRoute", () => $36df26a5edaecc11$export$2fd783c1d45b1a9f);
const $36df26a5edaecc11$export$2fd783c1d45b1a9f = {
    name: 'legacy-jsd-settings-language-pages',
    path: '/servicedesk/admin/:projectKey/language/:languageKey/:sidebarItemKey?'
};

});


parcelRegister("tvLh3", function(module, exports) {

$parcel$export(module.exports, "legacyJsdWidgetsRouteEntry", () => $21b870b72f2fdd6e$export$8b6c493f34b243fb);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $aTZGy = parcelRequire("aTZGy");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $66az1 = parcelRequire("66az1");

var $6Z2mh = parcelRequire("6Z2mh");
const $21b870b72f2fdd6e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $21b870b72f2fdd6e$export$8b6c493f34b243fb = (0, $aTZGy.createLegacyEntry)((0, $66az1.legacyJsdWidgetsRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$21b870b72f2fdd6e$var$pageEntryPoint
    }));

});
parcelRegister("66az1", function(module, exports) {

$parcel$export(module.exports, "legacyJsdWidgetsRoute", () => $cfd923ef7cc89729$export$ecfee0d843d9f28a);
const $cfd923ef7cc89729$export$ecfee0d843d9f28a = {
    name: 'legacy-jsd-widgets',
    path: '/servicedesk/admin/:projectKey/addon/:addonName',
    exact: true
};

});


parcelRegister("4iAyz", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRouteEntry", () => $37c3e86a0a5cb492$export$30ce3fd3c9377561);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $aTZGy = parcelRequire("aTZGy");

var $eoIOO = parcelRequire("eoIOO");
const $37c3e86a0a5cb492$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint)
});
const $37c3e86a0a5cb492$export$30ce3fd3c9377561 = (0, $aTZGy.createLegacyEntry)((0, $eoIOO.legacyPersonalSettingsAccessTokensRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        entryPoint: ()=>$37c3e86a0a5cb492$var$pageEntryPoint
    }));

});
parcelRegister("eoIOO", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRoute", () => $5507ee9d944bc310$export$49a90c7c39db3dd3);
const $5507ee9d944bc310$export$49a90c7c39db3dd3 = {
    name: 'legacy-personal-settings-access-tokens',
    path: '/plugins/servlet/oauth/users/access-tokens'
};

});


parcelRegister("kFwno", function(module, exports) {

$parcel$export(module.exports, "legacyPinRouteEntry", () => $93ee54689135a9c1$export$2311541dfc64683c);

var $fo6b8 = parcelRequire("fo6b8");

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7D4nf = parcelRequire("7D4nf");
const $93ee54689135a9c1$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $93ee54689135a9c1$export$2311541dfc64683c = (0, $aTZGy.createLegacyEntry)((0, $7D4nf.legacyPinRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$93ee54689135a9c1$var$pageEntryPoint
    }));

});
parcelRegister("7D4nf", function(module, exports) {

$parcel$export(module.exports, "legacyPinRoute", () => $0d0eea7fbac08431$export$5600fbce403620b6);
const $0d0eea7fbac08431$export$5600fbce403620b6 = {
    name: 'legacy-pin',
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("argbs", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioPagesRouteEntry", () => $ee6278b5a94f2f0d$export$200d6f7de97d1e96);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $gGC01 = parcelRequire("gGC01");
const $ee6278b5a94f2f0d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});
const $ee6278b5a94f2f0d$export$200d6f7de97d1e96 = (0, $aTZGy.createLegacyEntry)((0, $gGC01.legacyPortfolioPagesRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        entryPoint: ()=>$ee6278b5a94f2f0d$var$pageEntryPoint
    }));

});
parcelRegister("gGC01", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioPagesRoute", () => $b07761e72c454a90$export$c8591b40ac25c22d);
const $b07761e72c454a90$export$c8591b40ac25c22d = {
    name: 'legacy-portfolio-pages',
    path: '/secure/PortfolioPlan(\\w+).jspa'
};

});


parcelRegister("cJhQw", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioTeamRouteEntry", () => $29d83c9cebcc1b7e$export$67d1a57e72c969e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $aTZGy = parcelRequire("aTZGy");

var $aBkuX = parcelRequire("aBkuX");
const $29d83c9cebcc1b7e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});
const $29d83c9cebcc1b7e$export$67d1a57e72c969e = (0, $aTZGy.createLegacyEntry)((0, $aBkuX.legacyPortfolioTeamRoute), ()=>({
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        entryPoint: ()=>$29d83c9cebcc1b7e$var$pageEntryPoint
    }));

});
parcelRegister("aBkuX", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioTeamRoute", () => $302654f7399aad61$export$b61cebfbe2ae0da2);
const $302654f7399aad61$export$b61cebfbe2ae0da2 = {
    name: 'legacy-portfolio-team',
    path: '/secure/TeamManagement.jspa'
};

});


parcelRegister("loZyq", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesBambooRouteEntry", () => $04908027f5fd1526$export$929a483dcf3c101d);

var $fo6b8 = parcelRequire("fo6b8");

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kpWZ3 = parcelRequire("kpWZ3");
const $04908027f5fd1526$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $04908027f5fd1526$export$929a483dcf3c101d = (0, $aTZGy.createLegacyEntry)((0, $kpWZ3.legacyProjectReleasesBambooRoute), ()=>({
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        layout: (0, $gyYxw.genericProjectLayout),
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$04908027f5fd1526$var$pageEntryPoint
    }));

});
parcelRegister("kpWZ3", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesBambooRoute", () => $b186c0c0619ef268$export$df7f0213f2f22fc8);
const $b186c0c0619ef268$export$df7f0213f2f22fc8 = {
    name: 'legacy-project-releases-bamboo',
    path: '/secure/ConfigureBambooRelease([!%]?[\\w]*).jspa'
};

});


parcelRegister("et6S9", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesRouteEntry", () => $c5cd71441ced1565$export$5d0e55986ed5e2c9);

var $fo6b8 = parcelRequire("fo6b8");

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kpgU0 = parcelRequire("kpgU0");
const $c5cd71441ced1565$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $c5cd71441ced1565$export$5d0e55986ed5e2c9 = (0, $aTZGy.createLegacyEntry)((0, $kpgU0.legacyProjectReleasesRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$c5cd71441ced1565$var$pageEntryPoint
    }));

});
parcelRegister("kpgU0", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesRoute", () => $4a221fe4e4d20ee7$export$577b2cf03e294477);
const $4a221fe4e4d20ee7$export$577b2cf03e294477 = {
    name: 'legacy-project-releases',
    path: '/projects/:projectKey/versions/:id?'
};

});


parcelRegister("ez710", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $84a03644a6eaf929$export$836428e7b33b6c6c);

var $fo6b8 = parcelRequire("fo6b8");

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $8GnNO = parcelRequire("8GnNO");
const $84a03644a6eaf929$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $84a03644a6eaf929$export$836428e7b33b6c6c = (0, $aTZGy.createLegacyEntry)((0, $8GnNO.legacyProjectReleasesNoteConfigRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$84a03644a6eaf929$var$pageEntryPoint
    }));

});
parcelRegister("8GnNO", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $4c79cd6288320bcb$export$a9509017cabb1e30);
const $4c79cd6288320bcb$export$a9509017cabb1e30 = {
    name: 'legacy-project-releases-note-config',
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("3Ig4M", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $f7119f43ade8ceb7$export$781dd53d465d270d);

var $fo6b8 = parcelRequire("fo6b8");

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cZKz0 = parcelRequire("cZKz0");
const $f7119f43ade8ceb7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $f7119f43ade8ceb7$export$781dd53d465d270d = (0, $aTZGy.createLegacyEntry)((0, $cZKz0.legacyProjectReleasesNoteRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f7119f43ade8ceb7$var$pageEntryPoint
    }));

});
parcelRegister("cZKz0", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $3e45a70208e81732$export$6ef734887b6da0c8);
const $3e45a70208e81732$export$6ef734887b6da0c8 = {
    name: 'legacy-project-releases-note',
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("64onD", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRouteEntry", () => $4d1666cc11e86fd0$export$256375c5bbf6166a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $7GnvT = parcelRequire("7GnvT");
const $4d1666cc11e86fd0$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $4d1666cc11e86fd0$export$256375c5bbf6166a = (0, $aTZGy.createLegacyEntry)((0, $7GnvT.legacyProjectSettingsCollectorsAddRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$4d1666cc11e86fd0$var$pageEntryPoint
    }));

});
parcelRegister("7GnvT", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRoute", () => $63eff20ebe323e3e$export$a3909b9ad3f61ae6);
const $63eff20ebe323e3e$export$a3909b9ad3f61ae6 = {
    name: 'legacy-project-settings-collectors-add',
    path: '/secure/AddCollector([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("kL5a2", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsRouteEntry", () => $e5e8707d55eb6f76$export$e3a7328abebdc329);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $bq958 = parcelRequire("bq958");
const $e5e8707d55eb6f76$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $e5e8707d55eb6f76$export$e3a7328abebdc329 = (0, $aTZGy.createLegacyEntry)((0, $bq958.legacyProjectSettingsCollectorsRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$e5e8707d55eb6f76$var$pageEntryPoint
    }));

});
parcelRegister("bq958", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsRoute", () => $ca3a844bc315a553$export$956a041d0b6694e3);
const $ca3a844bc315a553$export$956a041d0b6694e3 = {
    name: 'legacy-project-settings-collectors',
    path: '/secure/ViewCollectors([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("lhxTN", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRouteEntry", () => $aaca076d84b89b43$export$10edcec0926752a6);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $hbJ7U = parcelRequire("hbJ7U");
const $aaca076d84b89b43$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $aaca076d84b89b43$export$10edcec0926752a6 = (0, $aTZGy.createLegacyEntry)((0, $hbJ7U.legacyProjectSettingsCollectorsHelpRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$aaca076d84b89b43$var$pageEntryPoint
    }));

});
parcelRegister("hbJ7U", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRoute", () => $62bf0899fb5827c8$export$7433cef5cafafb17);
const $62bf0899fb5827c8$export$7433cef5cafafb17 = {
    name: 'legacy-project-settings-collectors-help',
    path: '/secure/InsertCollectorHelp([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("1vxGF", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRouteEntry", () => $a5b8036dc0e6d1b1$export$7b10472641e87ea);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $bJ4iJ = parcelRequire("bJ4iJ");
const $a5b8036dc0e6d1b1$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $a5b8036dc0e6d1b1$export$7b10472641e87ea = (0, $aTZGy.createLegacyEntry)((0, $bJ4iJ.legacyProjectSettingsCollectorsViewRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$a5b8036dc0e6d1b1$var$pageEntryPoint
    }));

});
parcelRegister("bJ4iJ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRoute", () => $5da579604a038068$export$c3f8831257e68c5a);
const $5da579604a038068$export$c3f8831257e68c5a = {
    name: 'legacy-project-settings-collectors-view',
    path: '/secure/ViewCollector([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("kDz1I", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsConfigRouteEntry", () => $91599c7ff26b9ce4$export$3c4ea5135028082);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $4muVi = parcelRequire("4muVi");
const $91599c7ff26b9ce4$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $91599c7ff26b9ce4$export$3c4ea5135028082 = (0, $aTZGy.createLegacyEntry)((0, $4muVi.legacyProjectSettingsConfigRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$91599c7ff26b9ce4$var$pageEntryPoint
    }));

});
parcelRegister("4muVi", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsConfigRoute", () => $1711a7d7b7017dc7$export$3403c95bb82037b2);
const $1711a7d7b7017dc7$export$3403c95bb82037b2 = {
    name: 'legacy-project-settings-config',
    path: '/plugins/servlet/project-config/:projectKey/:adminOption'
};

});


parcelRegister("49VqI", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDeleteRouteEntry", () => $d2041eecb19b1061$export$f5fadab402705bc4);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9khaB = parcelRequire("9khaB");
const $d2041eecb19b1061$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $d2041eecb19b1061$export$f5fadab402705bc4 = (0, $aTZGy.createLegacyEntry)((0, $9khaB.legacyProjectSettingsDeleteRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d2041eecb19b1061$var$pageEntryPoint
    }));

});
parcelRegister("9khaB", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDeleteRoute", () => $921d2f178acfa92f$export$4e8f3a153f80bfa1);
const $921d2f178acfa92f$export$4e8f3a153f80bfa1 = {
    name: 'legacy-project-settings-delete',
    path: '(/secure/|/)project/DeleteProject([!%]?[\\w]*).jspa',
    query: [
        'pid'
    ]
};

});


parcelRegister("hD3MI", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDevRouteEntry", () => $7cd1b77d5e477909$export$bb5131b6203b8f3a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $2rFd2 = parcelRequire("2rFd2");
const $7cd1b77d5e477909$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $7cd1b77d5e477909$export$bb5131b6203b8f3a = (0, $aTZGy.createLegacyEntry)((0, $2rFd2.legacyProjectSettingsDevRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$7cd1b77d5e477909$var$pageEntryPoint
    }));

});
parcelRegister("2rFd2", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDevRoute", () => $1d7cd694aebe26d0$export$d3fca8ea951ff47f);
const $1d7cd694aebe26d0$export$d3fca8ea951ff47f = {
    name: 'legacy-project-settings-dev',
    path: '/secure/ConfigureDevStatus.jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("afhYz", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsEditRouteEntry", () => $b42dd79869fe6c52$export$1b930b1155c7c95d);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $6oxl6 = parcelRequire("6oxl6");
const $b42dd79869fe6c52$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b42dd79869fe6c52$export$1b930b1155c7c95d = (0, $aTZGy.createLegacyEntry)((0, $6oxl6.legacyProjectSettingsEditRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$b42dd79869fe6c52$var$pageEntryPoint
    }));

});
parcelRegister("6oxl6", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsEditRoute", () => $e7b9ac552930800c$export$69813bfb3aa0feb9);
const $e7b9ac552930800c$export$69813bfb3aa0feb9 = {
    name: 'legacy-project-settings-edit',
    path: '(/secure/|/)project/EditProject([!%]?[\\w]*).jspa',
    query: [
        'pid'
    ]
};

});


parcelRegister("4h7pu", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRouteEntry", () => $5b9b6afe98a164f5$export$c7cd1115d3e90593);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $34GG7 = parcelRequire("34GG7");
const $5b9b6afe98a164f5$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $5b9b6afe98a164f5$export$c7cd1115d3e90593 = (0, $aTZGy.createLegacyEntry)((0, $34GG7.legacyProjectSettingsFieldsAssociateRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$5b9b6afe98a164f5$var$pageEntryPoint
    }));

});
parcelRegister("34GG7", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRoute", () => $61c522814c7196b7$export$b45ad52ceda09b54);
const $61c522814c7196b7$export$b45ad52ceda09b54 = {
    name: 'legacy-project-settings-fields-associate',
    path: '/secure/admin/SelectFieldLayoutScheme!default.jspa'
};

});


parcelRegister("6FSmK", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsRouteEntry", () => $d07936bdcf7994fd$export$cf5230efac88ec18);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $frjFq = parcelRequire("frjFq");
const $d07936bdcf7994fd$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $d07936bdcf7994fd$export$cf5230efac88ec18 = (0, $aTZGy.createLegacyEntry)((0, $frjFq.legacyProjectSettingsFieldsRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d07936bdcf7994fd$var$pageEntryPoint
    }));

});
parcelRegister("frjFq", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsRoute", () => $1ac3505b7c962b93$export$f8d801c531c09b6e);
const $1ac3505b7c962b93$export$f8d801c531c09b6e = {
    name: 'legacy-project-settings-fields',
    path: '/plugins/servlet/project-config/:projectKey/fields'
};

});


parcelRegister("laBkp", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRouteEntry", () => $c97b746077d1a32a$export$ba112336170e9374);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $gJeb6 = parcelRequire("gJeb6");
const $c97b746077d1a32a$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $c97b746077d1a32a$export$ba112336170e9374 = (0, $aTZGy.createLegacyEntry)((0, $gJeb6.legacyProjectSettingsIssueLayoutRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$c97b746077d1a32a$var$pageEntryPoint
    }));

});
parcelRegister("gJeb6", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRoute", () => $02eb23396140dc89$export$b9490f2a02690c81);
const $02eb23396140dc89$export$b9490f2a02690c81 = {
    name: 'legacy-project-settings-issue-layout',
    path: '/plugins/servlet/project-config/:projectKey/issuelayout'
};

});


parcelRegister("37pp9", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRouteEntry", () => $de12de6af07ab15e$export$31f276ec8affeb65);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $kD1Gq = parcelRequire("kD1Gq");
const $de12de6af07ab15e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $de12de6af07ab15e$export$31f276ec8affeb65 = (0, $aTZGy.createLegacyEntry)((0, $kD1Gq.legacyProjectSettingsIssueSecurityAssociateRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$de12de6af07ab15e$var$pageEntryPoint
    }));

});
parcelRegister("kD1Gq", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRoute", () => $d77ad05a26d62cd3$export$8fb428d7ca4ce850);
const $d77ad05a26d62cd3$export$8fb428d7ca4ce850 = {
    name: 'legacy-project-settings-issue-security-associate',
    path: '/secure/project/SelectProjectIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("gflji", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRouteEntry", () => $95b95ff1642d8e9a$export$50c072825de9f7ec);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $9Fb0y = parcelRequire("9Fb0y");
const $95b95ff1642d8e9a$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $95b95ff1642d8e9a$export$50c072825de9f7ec = (0, $aTZGy.createLegacyEntry)((0, $9Fb0y.legacyProjectSettingsIssueSecurityRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$95b95ff1642d8e9a$var$pageEntryPoint
    }));

});
parcelRegister("9Fb0y", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRoute", () => $c1e98f4b92dc03d0$export$71aa1b769739b378);
const $c1e98f4b92dc03d0$export$71aa1b769739b378 = {
    name: 'legacy-project-settings-issue-security',
    path: '/plugins/servlet/project-config/:projectKey/issuesecurity'
};

});


parcelRegister("6jDzT", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRouteEntry", () => $ee9f149624411273$export$997736bd2e54a14b);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $jaqtM = parcelRequire("jaqtM");
const $ee9f149624411273$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $ee9f149624411273$export$997736bd2e54a14b = (0, $aTZGy.createLegacyEntry)((0, $jaqtM.legacyProjectSettingsIssueTypesAssociateRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$ee9f149624411273$var$pageEntryPoint
    }));

});
parcelRegister("jaqtM", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRoute", () => $7a6b17a888776beb$export$64a3a3a4a9e32ab2);
const $7a6b17a888776beb$export$64a3a3a4a9e32ab2 = {
    name: 'legacy-project-settings-issue-types-associate',
    path: '/secure/admin/SelectIssueTypeSchemeForProject!default.jspa'
};

});


parcelRegister("jmaPx", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesRouteEntry", () => $bee4d19c41d2ec21$export$664d9bccf509eab1);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $57aKE = parcelRequire("57aKE");
const $bee4d19c41d2ec21$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $bee4d19c41d2ec21$export$664d9bccf509eab1 = (0, $aTZGy.createLegacyEntry)((0, $57aKE.legacyProjectSettingsIssueTypesRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$bee4d19c41d2ec21$var$pageEntryPoint
    }));

});
parcelRegister("57aKE", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesRoute", () => $66355d99a0dd8322$export$f22d4a1fbe6ce2d);
const $66355d99a0dd8322$export$f22d4a1fbe6ce2d = {
    name: 'legacy-project-settings-issue-types',
    path: '/plugins/servlet/project-config/:projectKey/issuetypes'
};

});


parcelRegister("8wzgb", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRouteEntry", () => $db3e50f05a9d1245$export$756ebd18bdb87829);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $4qEnh = parcelRequire("4qEnh");
const $db3e50f05a9d1245$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $db3e50f05a9d1245$export$756ebd18bdb87829 = (0, $aTZGy.createLegacyEntry)((0, $4qEnh.legacyProjectSettingsNotificationsAssociateRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$db3e50f05a9d1245$var$pageEntryPoint
    }));

});
parcelRegister("4qEnh", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRoute", () => $6fffaa353b18d026$export$c3b586e70bfcdfe);
const $6fffaa353b18d026$export$c3b586e70bfcdfe = {
    name: 'legacy-project-settings-notifications-associate',
    path: '/secure/project/SelectProjectScheme!default.jspa'
};

});


parcelRegister("4YpQx", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsRouteEntry", () => $052ea5ae004ea00d$export$ec9c71381b367931);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $3MnLC = parcelRequire("3MnLC");
const $052ea5ae004ea00d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $052ea5ae004ea00d$export$ec9c71381b367931 = (0, $aTZGy.createLegacyEntry)((0, $3MnLC.legacyProjectSettingsNotificationsRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$052ea5ae004ea00d$var$pageEntryPoint
    }));

});
parcelRegister("3MnLC", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsRoute", () => $bcc1a9d98779cf4f$export$3053634181f5a1e4);
const $bcc1a9d98779cf4f$export$3053634181f5a1e4 = {
    name: 'legacy-project-settings-notifications',
    path: '/plugins/servlet/project-config/:projectKey/notifications'
};

});


parcelRegister("3HICX", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsOpsgenieRouteEntry", () => $dfe8e954922fe1f2$export$a0ee66fa0f02ab9a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $52ooI = parcelRequire("52ooI");
const $dfe8e954922fe1f2$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $dfe8e954922fe1f2$export$a0ee66fa0f02ab9a = (0, $aTZGy.createLegacyEntry)((0, $52ooI.legacyProjectSettingsOpsgenieRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$dfe8e954922fe1f2$var$pageEntryPoint
    }));

});
parcelRegister("52ooI", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsOpsgenieRoute", () => $caf7e9399f3d740d$export$9bc923c0dc9a3144);
const $caf7e9399f3d740d$export$9bc923c0dc9a3144 = {
    name: 'legacy-project-settings-opsgenie',
    path: '/plugins/servlet/project-config/:projectKey/opsgenie'
};

});


parcelRegister("hEiRG", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPeopleRouteEntry", () => $456162ef1a571d54$export$a3355a805216689d);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6QKrH = parcelRequire("6QKrH");

var $cSUZZ = parcelRequire("cSUZZ");

var $88hpi = parcelRequire("88hpi");
const $456162ef1a571d54$export$a3355a805216689d = (0, $aTZGy.createLegacyEntry)((0, $88hpi.legacyProjectSettingsPeopleRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $6QKrH.LegacyPage),
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("88hpi", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPeopleRoute", () => $e734a80a5a02899a$export$69b69c5831576686);
const $e734a80a5a02899a$export$69b69c5831576686 = {
    name: 'legacy-project-settings-people',
    path: '/plugins/servlet/project-config/:projectKey/people'
};

});


parcelRegister("adWCc", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPermissionsRouteEntry", () => $706afdab38cc1255$export$f941d7668bb5b4b9);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6QKrH = parcelRequire("6QKrH");

var $cSUZZ = parcelRequire("cSUZZ");

var $l0Aq6 = parcelRequire("l0Aq6");
const $706afdab38cc1255$export$f941d7668bb5b4b9 = (0, $aTZGy.createLegacyEntry)((0, $l0Aq6.legacyProjectSettingsPermissionsRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $6QKrH.LegacyPage),
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("l0Aq6", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPermissionsRoute", () => $193ca9014a97c21b$export$e5e3b10fbd5b967);
const $193ca9014a97c21b$export$e5e3b10fbd5b967 = {
    name: 'legacy-project-settings-permissions',
    path: '/plugins/servlet/project-config/:projectKey/permissions'
};

});


parcelRegister("8hgsj", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRouteEntry", () => $e90eb3155c119894$export$c4a7c46acad95724);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $9pp9t = parcelRequire("9pp9t");
const $e90eb3155c119894$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $e90eb3155c119894$export$c4a7c46acad95724 = (0, $aTZGy.createLegacyEntry)((0, $9pp9t.legacyProjectSettingsScreensAssociateRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$e90eb3155c119894$var$pageEntryPoint
    }));

});
parcelRegister("9pp9t", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRoute", () => $2c2e798c66b4eef0$export$e97df9c9d8af2495);
const $2c2e798c66b4eef0$export$e97df9c9d8af2495 = {
    name: 'legacy-project-settings-screens-associate',
    path: '/secure/project/SelectIssueTypeScreenScheme!default.jspa'
};

});


parcelRegister("1YU78", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensRouteEntry", () => $5da3c6f993b4e853$export$f0c4185be35123a4);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $ZngYx = parcelRequire("ZngYx");
const $5da3c6f993b4e853$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $5da3c6f993b4e853$export$f0c4185be35123a4 = (0, $aTZGy.createLegacyEntry)((0, $ZngYx.legacyProjectSettingsScreensRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$5da3c6f993b4e853$var$pageEntryPoint
    }));

});
parcelRegister("ZngYx", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensRoute", () => $3120d784181d4c90$export$a132d85f94cbc75c);
const $3120d784181d4c90$export$a132d85f94cbc75c = {
    name: 'legacy-project-settings-screens',
    path: '/plugins/servlet/project-config/:projectKey/screens'
};

});


parcelRegister("bJ1QL", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsSummaryRouteEntry", () => $f438d46cc4d9b7f8$export$b79434e4cc24dab2);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $hrMnO = parcelRequire("hrMnO");
const $f438d46cc4d9b7f8$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $f438d46cc4d9b7f8$export$b79434e4cc24dab2 = (0, $aTZGy.createLegacyEntry)((0, $hrMnO.legacyProjectSettingsSummaryRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f438d46cc4d9b7f8$var$pageEntryPoint
    }));

});
parcelRegister("hrMnO", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsSummaryRoute", () => $1651b2618d7469be$export$2c4b88224ff6b238);
const $1651b2618d7469be$export$2c4b88224ff6b238 = {
    name: 'legacy-project-settings-summary',
    path: '/plugins/servlet/project-config/:projectKey/summary'
};

});


parcelRegister("3vlci", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRouteEntry", () => $dfe9c3c512d6b9d3$export$496170aba3d2c90a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $5PAnP = parcelRequire("5PAnP");
const $dfe9c3c512d6b9d3$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $dfe9c3c512d6b9d3$export$496170aba3d2c90a = (0, $aTZGy.createLegacyEntry)((0, $5PAnP.legacyProjectSettingsWorkflowsAssociateRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$dfe9c3c512d6b9d3$var$pageEntryPoint
    }));

});
parcelRegister("5PAnP", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRoute", () => $ee742b23f9235e39$export$c70512e2d6fd53d);
const $ee742b23f9235e39$export$c70512e2d6fd53d = {
    name: 'legacy-project-settings-workflows-associate',
    path: '/secure/project/SelectProjectWorkflowScheme!default.jspa'
};

});


parcelRegister("7z8HU", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRouteEntry", () => $67c46f0f94012539$export$a69fefbe6504422d);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $l3Iek = parcelRequire("l3Iek");
const $67c46f0f94012539$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $67c46f0f94012539$export$a69fefbe6504422d = (0, $aTZGy.createLegacyEntry)((0, $l3Iek.legacyProjectSettingsWorkflowsRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$67c46f0f94012539$var$pageEntryPoint
    }));

});
parcelRegister("l3Iek", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $31816b9f42bcb36a$export$b03606cedffdadf6);
const $31816b9f42bcb36a$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});


parcelRegister("8DSg9", function(module, exports) {

$parcel$export(module.exports, "legacyReportsAverageAgeRouteEntry", () => $ceaf4105a45239e2$export$dae04c73273ef29a);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9OJ9f = parcelRequire("9OJ9f");

var $6sPah = parcelRequire("6sPah");
const $ceaf4105a45239e2$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $ceaf4105a45239e2$export$dae04c73273ef29a = (0, $aTZGy.createLegacyEntry)((0, $9OJ9f.legacyReportsAverageAgeRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6sPah.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$ceaf4105a45239e2$var$pageEntryPoint
    }));

});
parcelRegister("9OJ9f", function(module, exports) {

$parcel$export(module.exports, "legacyReportsAverageAgeRoute", () => $1c11fc6cf67cf9fc$export$b40e93dd1042f869);
const $1c11fc6cf67cf9fc$export$b40e93dd1042f869 = {
    name: 'legacy-reports-average-age-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:averageage-report'
    ]
};

});

parcelRegister("6sPah", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $9ee2e9a72d658e32$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $9ee2e9a72d658e32$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $9ee2e9a72d658e32$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("eRLno", function(module, exports) {

$parcel$export(module.exports, "legacyReportsConfigRouteEntry", () => $48f0dbbfa652bc1e$export$6dee3bbbe4ff04f);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cr1rV = parcelRequire("cr1rV");

var $3WgkN = parcelRequire("3WgkN");
const $48f0dbbfa652bc1e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $48f0dbbfa652bc1e$export$6dee3bbbe4ff04f = (0, $aTZGy.createLegacyEntry)((0, $cr1rV.legacyReportsConfigRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3WgkN.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$48f0dbbfa652bc1e$var$pageEntryPoint
    }));

});
parcelRegister("cr1rV", function(module, exports) {

$parcel$export(module.exports, "legacyReportsConfigRoute", () => $54d3476741ea5327$export$b2ef61435fecef69);
const $54d3476741ea5327$export$b2ef61435fecef69 = {
    name: 'legacy-reports-configure',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey'
    ]
};

});

parcelRegister("3WgkN", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $189e4bc2b233ebe2$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $189e4bc2b233ebe2$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $189e4bc2b233ebe2$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("4ufmY", function(module, exports) {

$parcel$export(module.exports, "legacyReportsCreatedVsResolvedRouteEntry", () => $ba00bebd578f8ce7$export$b2ed165752bdb8e5);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7kwYv = parcelRequire("7kwYv");

var $kJCHC = parcelRequire("kJCHC");
const $ba00bebd578f8ce7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $ba00bebd578f8ce7$export$b2ed165752bdb8e5 = (0, $aTZGy.createLegacyEntry)((0, $7kwYv.legacyReportsCreatedVsResolvedRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $kJCHC.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$ba00bebd578f8ce7$var$pageEntryPoint
    }));

});
parcelRegister("7kwYv", function(module, exports) {

$parcel$export(module.exports, "legacyReportsCreatedVsResolvedRoute", () => $0d20e395ca85858f$export$832846047e142646);
const $0d20e395ca85858f$export$832846047e142646 = {
    name: 'legacy-reports-created-vs-resolved-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:createdvsresolved-report'
    ]
};

});

parcelRegister("kJCHC", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $07ae8c5e26d47517$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $07ae8c5e26d47517$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $07ae8c5e26d47517$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("6reNT", function(module, exports) {

$parcel$export(module.exports, "legacyReportsDeveloperWorkloadRouteEntry", () => $31c429ce4b2b13e3$export$29e29cddbc430ebe);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $559ER = parcelRequire("559ER");

var $6sDGD = parcelRequire("6sDGD");
const $31c429ce4b2b13e3$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $31c429ce4b2b13e3$export$29e29cddbc430ebe = (0, $aTZGy.createLegacyEntry)((0, $559ER.legacyReportsDeveloperWorkloadRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6sDGD.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$31c429ce4b2b13e3$var$pageEntryPoint
    }));

});
parcelRegister("559ER", function(module, exports) {

$parcel$export(module.exports, "legacyReportsDeveloperWorkloadRoute", () => $10f596c4e73719a7$export$a64e86bcf65b3432);
const $10f596c4e73719a7$export$a64e86bcf65b3432 = {
    name: 'legacy-reports-developer-workload-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:developer-workload'
    ]
};

});

parcelRegister("6sDGD", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $5468c4274e7a4fc6$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $5468c4274e7a4fc6$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $5468c4274e7a4fc6$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("jD4ED", function(module, exports) {

$parcel$export(module.exports, "legacyReportsPieRouteEntry", () => $657722427dbdd96b$export$fd3a1495328fefba);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $349Rg = parcelRequire("349Rg");

var $l5bpw = parcelRequire("l5bpw");
const $657722427dbdd96b$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $657722427dbdd96b$export$fd3a1495328fefba = (0, $aTZGy.createLegacyEntry)((0, $349Rg.legacyReportsPieRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $l5bpw.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$657722427dbdd96b$var$pageEntryPoint
    }));

});
parcelRegister("349Rg", function(module, exports) {

$parcel$export(module.exports, "legacyReportsPieRoute", () => $d4d91520ed86f9a5$export$327da6ce208593c2);
const $d4d91520ed86f9a5$export$327da6ce208593c2 = {
    name: 'legacy-reports-pie-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:pie-report'
    ]
};

});

parcelRegister("l5bpw", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $03bf9879e83bb142$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $03bf9879e83bb142$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $03bf9879e83bb142$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("eYfVu", function(module, exports) {

$parcel$export(module.exports, "legacyReportsRecentlyCreatedRouteEntry", () => $a8e1cb43babba64d$export$666b8efa07780ffb);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hGt79 = parcelRequire("hGt79");

var $10Hh4 = parcelRequire("10Hh4");
const $a8e1cb43babba64d$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $a8e1cb43babba64d$export$666b8efa07780ffb = (0, $aTZGy.createLegacyEntry)((0, $hGt79.legacyReportsRecentlyCreatedRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $10Hh4.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$a8e1cb43babba64d$var$pageEntryPoint
    }));

});
parcelRegister("hGt79", function(module, exports) {

$parcel$export(module.exports, "legacyReportsRecentlyCreatedRoute", () => $cc0205b16fcf507e$export$f81f42a6de9ebb5a);
const $cc0205b16fcf507e$export$f81f42a6de9ebb5a = {
    name: 'legacy-reports-recently-created-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:recentlycreated-report'
    ]
};

});

parcelRegister("10Hh4", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $60e3cc3cccc0d55e$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $60e3cc3cccc0d55e$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $60e3cc3cccc0d55e$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("9D2fh", function(module, exports) {

$parcel$export(module.exports, "legacyReportsResolutionTimeRouteEntry", () => $31b77e105ff71f36$export$53c5b89c8f6f5d76);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6Oz7w = parcelRequire("6Oz7w");

var $03epm = parcelRequire("03epm");
const $31b77e105ff71f36$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $31b77e105ff71f36$export$53c5b89c8f6f5d76 = (0, $aTZGy.createLegacyEntry)((0, $6Oz7w.legacyReportsResolutionTimeRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $03epm.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$31b77e105ff71f36$var$pageEntryPoint
    }));

});
parcelRegister("6Oz7w", function(module, exports) {

$parcel$export(module.exports, "legacyReportsResolutionTimeRoute", () => $55cd68524fdc8c0d$export$c27dcd4a756d7860);
const $55cd68524fdc8c0d$export$c27dcd4a756d7860 = {
    name: 'legacy-reports-resolution-time-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:resolutiontime-report'
    ]
};

});

parcelRegister("03epm", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $2fbc10637fd48123$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $2fbc10637fd48123$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $2fbc10637fd48123$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("7wJID", function(module, exports) {

$parcel$export(module.exports, "legacyReportsSingleLevelGroupByRouteEntry", () => $8c4f195e96e9b1c8$export$80cd34d8b30c9fff);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $3vSxz = parcelRequire("3vSxz");

var $curbE = parcelRequire("curbE");
const $8c4f195e96e9b1c8$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $8c4f195e96e9b1c8$export$80cd34d8b30c9fff = (0, $aTZGy.createLegacyEntry)((0, $3vSxz.legacyReportsSingleLevelGroupByRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $curbE.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$8c4f195e96e9b1c8$var$pageEntryPoint
    }));

});
parcelRegister("3vSxz", function(module, exports) {

$parcel$export(module.exports, "legacyReportsSingleLevelGroupByRoute", () => $0bda8ba5df07a21d$export$4b7de6966d0318ae);
const $0bda8ba5df07a21d$export$4b7de6966d0318ae = {
    name: 'legacy-reports-single-level-group-by-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:singlelevelgroupby'
    ]
};

});

parcelRegister("curbE", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $cccb613036f94172$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $cccb613036f94172$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $cccb613036f94172$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("04xzx", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeSinceRouteEntry", () => $3dc0380ece5bc10e$export$c0837717e37bba3b);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $jZ9Rj = parcelRequire("jZ9Rj");

var $4k3iT = parcelRequire("4k3iT");
const $3dc0380ece5bc10e$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $3dc0380ece5bc10e$export$c0837717e37bba3b = (0, $aTZGy.createLegacyEntry)((0, $jZ9Rj.legacyReportsTimeSinceRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4k3iT.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$3dc0380ece5bc10e$var$pageEntryPoint
    }));

});
parcelRegister("jZ9Rj", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeSinceRoute", () => $f24eb951860efa28$export$e9d8f7977a3e63a8);
const $f24eb951860efa28$export$e9d8f7977a3e63a8 = {
    name: 'legacy-reports-time-since-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:timesince-report'
    ]
};

});

parcelRegister("4k3iT", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $2bddc68cf89b666e$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $2bddc68cf89b666e$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $2bddc68cf89b666e$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("c6Si3", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeTrackingReportRouteEntry", () => $86cda3131721b311$export$d911abc03d9aac0e);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $a6Cuw = parcelRequire("a6Cuw");

var $6arIg = parcelRequire("6arIg");
const $86cda3131721b311$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $86cda3131721b311$export$d911abc03d9aac0e = (0, $aTZGy.createLegacyEntry)((0, $a6Cuw.legacyReportsTimeTrackingReportRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6arIg.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$86cda3131721b311$var$pageEntryPoint
    }));

});
parcelRegister("a6Cuw", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeTrackingReportRoute", () => $fec8ec145143e6d7$export$5c05df6c5a65a436);
const $fec8ec145143e6d7$export$5c05df6c5a65a436 = {
    name: 'legacy-reports-time-tracking-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:time-tracking'
    ]
};

});

parcelRegister("6arIg", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $d46a8656727f44dc$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $d46a8656727f44dc$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $d46a8656727f44dc$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("8k7EA", function(module, exports) {

$parcel$export(module.exports, "legacyReportsVersionWorkloadRouteEntry", () => $445ff1b4f7c716db$export$225a265884367582);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $arlaq = parcelRequire("arlaq");

var $5VYNR = parcelRequire("5VYNR");
const $445ff1b4f7c716db$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $445ff1b4f7c716db$export$225a265884367582 = (0, $aTZGy.createLegacyEntry)((0, $arlaq.legacyReportsVersionWorkloadRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5VYNR.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$445ff1b4f7c716db$var$pageEntryPoint
    }));

});
parcelRegister("arlaq", function(module, exports) {

$parcel$export(module.exports, "legacyReportsVersionWorkloadRoute", () => $d9cb161aeddf1ead$export$b7a951738ffd54ac);
const $d9cb161aeddf1ead$export$b7a951738ffd54ac = {
    name: 'legacy-reports-version-workload-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'
    ]
};

});

parcelRegister("5VYNR", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $ab3ac09d2b00fa0e$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $ab3ac09d2b00fa0e$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $ab3ac09d2b00fa0e$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("6pjPD", function(module, exports) {

$parcel$export(module.exports, "legacyReportsWorkloadPieRouteEntry", () => $f66a3f8265962292$export$371af7520206fe98);

var $1apF5 = parcelRequire("1apF5");

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $aTZGy = parcelRequire("aTZGy");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6204a = parcelRequire("6204a");

var $avo9P = parcelRequire("avo9P");
const $f66a3f8265962292$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1apF5.legacyPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $f66a3f8265962292$export$371af7520206fe98 = (0, $aTZGy.createLegacyEntry)((0, $6204a.legacyReportsWorkloadPieRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $avo9P.getReportsCommonResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f66a3f8265962292$var$pageEntryPoint
    }));

});
parcelRegister("6204a", function(module, exports) {

$parcel$export(module.exports, "legacyReportsWorkloadPieRoute", () => $e12f56914e92775e$export$e8a2e4a5ccbbeff6);
const $e12f56914e92775e$export$e8a2e4a5ccbbeff6 = {
    name: 'legacy-reports-workload-pie-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.ext.charting:workloadpie-report'
    ]
};

});

parcelRegister("avo9P", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $3224e03e72e77e31$export$8cb713295e6b7204);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $3224e03e72e77e31$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $3224e03e72e77e31$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("gaHy8", function(module, exports) {

$parcel$export(module.exports, "workflowDesignerRouteEntry", () => $7622f4a0f1b015dc$export$5863c71049541219);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $2k2yL = parcelRequire("2k2yL");

var $159aY = parcelRequire("159aY");
const $7622f4a0f1b015dc$export$5863c71049541219 = (0, $7NszV.createEntry)((0, $2k2yL.workflowDesignerRoute), ()=>({
        component: (0, $159aY.LegacyWorkflowDesigner),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)()
        ]
    }));

});
parcelRegister("2k2yL", function(module, exports) {

$parcel$export(module.exports, "workflowDesignerRoute", () => $072048a86393712c$export$7cd61529f5fa5e43);
const $072048a86393712c$export$7cd61529f5fa5e43 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/secure/admin/(workflows/|)(WorkflowDesigner|ViewWorkflowSteps).jspa'
};

});

parcelRegister("159aY", function(module, exports) {

$parcel$export(module.exports, "LegacyWorkflowDesigner", () => $307a5b1ba1a50b29$export$c264c6032a3fa865);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $7CMCs = parcelRequire("7CMCs");

var $6QKrH = parcelRequire("6QKrH");

var $8M7vf = parcelRequire("8M7vf");
const $307a5b1ba1a50b29$export$c264c6032a3fa865 = (props)=>{
    const elm = false ? null : globalThis.document?.getElementById('workflow-editor-preference-dropdown');
    const workflowId = elm?.getAttribute('data-workflow-id') ?? '';
    const workflowName = elm?.getAttribute('data-workflow-name') ?? '';
    const editMode = elm?.getAttribute('data-edit-mode') ?? undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jsm-dropdown-error-boundary",
        packageName: "jiraRouterRoutesLegacyWorkflowDesignerEntries",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6QKrH.LegacyPage), props), elm && /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8M7vf.WorkflowEditorPreferenceDropdown), {
        workflowId: workflowId,
        workflowName: workflowName,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        editMode: editMode
    }), elm));
};

});
parcelRegister("8M7vf", function(module, exports) {

$parcel$export(module.exports, "WorkflowEditorPreferenceDropdown", () => $bbc7832248e4e47c$export$7194565c2a06a25d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $c8Oei = parcelRequire("c8Oei");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gz6NJ = parcelRequire("gz6NJ");

var $4V5oU = parcelRequire("4V5oU");

var $lvRwX = parcelRequire("lvRwX");

var $4K5zd = parcelRequire("4K5zd");

var $8iMd2 = parcelRequire("8iMd2");

const $bbc7832248e4e47c$export$7194565c2a06a25d = ({ workflowId: workflowId, workflowName: workflowName, editMode: editMode })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [showDialog, setShowDialog] = (0, $5uXOq.useState)(false);
    const openDialog = ()=>setShowDialog(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Show flag when show old editor flag is true in session storage
    (0, $lvRwX.useChangeToOldEditorSuccessFlag)({
        openDefaultEditorDialog: openDialog
    });
    const fireTrackEvent = (0, $5uXOq.useCallback)((mode)=>{
        const dropdownItemClickEvent = createAnalyticsEvent({
            action: 'click',
            actionSubject: 'dropdownItem'
        });
        (0, $8zOmE.fireUIAnalytics)(dropdownItemClickEvent, 'workflowEditorToolbarNewEditorLink', {
            workflowLegacyEditMode: mode === 'draft' ? 'Draft' : 'Live'
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        testId: "workflow-editor-preference-settings.ui.dropdown-menu",
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bbc7832248e4e47c$var$LegacyButtonText, null, formatMessage((0, $8iMd2.default).switchEditorButton)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: (0, $gz6NJ.getNewEditorLink)(workflowId),
        onClick: ()=>fireTrackEvent(editMode),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $8iMd2.default).openInNewEditor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: openDialog
    }, formatMessage((0, $8iMd2.default).changeDefaultEditor)))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4K5zd.DefaultWorkflowEditorDialog), {
        workflowName: workflowName,
        workflowId: workflowId,
        workflowPublicationStatus: editMode === 'draft' ? (0, $4V5oU.WorkflowPublicationStatus).Draft : (0, $4V5oU.WorkflowPublicationStatus).Live,
        onClose: ()=>setShowDialog(false),
        onOpenDefaultEditorDialog: openDialog
    }));
};
const $bbc7832248e4e47c$var$LegacyButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pi7a9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gz6NJ", function(module, exports) {

$parcel$export(module.exports, "orderStatusesByCategoryAndName", () => $cc944276ef5866fb$export$2068d124b6d003c3);
$parcel$export(module.exports, "getLegacyEditorLink", () => $cc944276ef5866fb$export$ff5bc033c9b0efb4);
$parcel$export(module.exports, "getNewEditorLink", () => $cc944276ef5866fb$export$540456165b615498);
$parcel$export(module.exports, "openLegacyEditor", () => $cc944276ef5866fb$export$766368a57fd33bad);
$parcel$export(module.exports, "buildEditWorkflowJSPUrl", () => $cc944276ef5866fb$export$2e17b62c233ea33b);
$parcel$export(module.exports, "findRuleDefinitionForConfiguredRule", () => $cc944276ef5866fb$export$5abcac058edd2986);

var $7qDUb = parcelRequire("7qDUb");

var $ebyGx = parcelRequire("ebyGx");

var $gKZoD = parcelRequire("gKZoD");

var $4tcSU = parcelRequire("4tcSU");

var $lUJY8 = parcelRequire("lUJY8");
const $cc944276ef5866fb$export$2068d124b6d003c3 = (statuses)=>(0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(statuses, [
        (status)=>(0, $lUJY8.STATUS_CATEGORY_WEIGHTS)[status.statusCategory],
        'name'
    ]);
const $cc944276ef5866fb$export$ff5bc033c9b0efb4 = (workflowName)=>`/secure/admin/workflows/WorkflowDesigner.jspa?workflowMode=live&wfName=${encodeURIComponent(workflowName)}`;
const $cc944276ef5866fb$export$540456165b615498 = (workflowId)=>`/jira/settings/issues/workflows/${workflowId}`;
const $cc944276ef5866fb$export$766368a57fd33bad = (workflowName)=>{
    (0, $gKZoD.di)(window);
    const url = $cc944276ef5866fb$export$ff5bc033c9b0efb4(workflowName);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
};
const $cc944276ef5866fb$export$2e17b62c233ea33b = (workflowName)=>`/secure/admin/workflows/EditWorkflowDispatcher.jspa?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        atl_token: (0, $4tcSU.default)(),
        wfName: workflowName
    })}`;
const $cc944276ef5866fb$export$1a907429044213b9 = (value, condition)=>condition;
const $cc944276ef5866fb$export$5abcac058edd2986 = (rule, availableRules)=>{
    const ruleKey = rule.ruleKey;
    if (ruleKey.startsWith('connect')) return availableRules.find((definition)=>definition.variety === 'connect' && definition.key === ruleKey && definition.id === rule.config.appKey);
    if (ruleKey.startsWith('forge')) return availableRules.find((definition)=>definition.variety === 'forge' && definition.key === ruleKey && definition.id === rule.config.key);
    return availableRules.find((definition)=>definition.key === ruleKey);
};

});
parcelRegister("7qDUb", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $kE90z = parcelRequire("kE90z");

var $g7i7g = parcelRequire("g7i7g");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5689ea6dce44e1ca$var$sortBy = $g7i7g(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $4rDUz(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $4rDUz(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $kE90z(collection, $ekcP3(iteratees, 1), []);
});
module.exports = $5689ea6dce44e1ca$var$sortBy;

});
parcelRegister("kE90z", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $fTwLR = parcelRequire("fTwLR");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $iWpGN = parcelRequire("iWpGN");

var $cW28x = parcelRequire("cW28x");

var $4pePQ = parcelRequire("4pePQ");

var $etyzk = parcelRequire("etyzk");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $f07e87ec0cad1451$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $1nIHN(iteratees, function(iteratee) {
        if ($8LQ84(iteratee)) return function(value) {
            return $fTwLR(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $etyzk
    ];
    var index = -1;
    iteratees = $1nIHN(iteratees, $cW28x($bxDef));
    var result = $jXnVG(collection, function(value, key, collection) {
        var criteria = $1nIHN(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $iWpGN(result, function(object, other) {
        return $4pePQ(object, other, orders);
    });
}
module.exports = $f07e87ec0cad1451$var$baseOrderBy;

});
parcelRegister("jXnVG", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");

var $hTJwX = parcelRequire("hTJwX");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e87616de80329acf$var$baseMap(collection, iteratee) {
    var index = -1, result = $hTJwX(collection) ? Array(collection.length) : [];
    $e7pfQ(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e87616de80329acf$var$baseMap;

});

parcelRegister("iWpGN", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $dca1921d42c9de26$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $dca1921d42c9de26$var$baseSortBy;

});

parcelRegister("4pePQ", function(module, exports) {

var $7JssJ = parcelRequire("7JssJ");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $3355012d40661daa$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $7JssJ(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $3355012d40661daa$var$compareMultiple;

});
parcelRegister("7JssJ", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $5a12d0703028d451$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $4faK3(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $4faK3(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $5a12d0703028d451$var$compareAscending;

});




parcelRegister("lUJY8", function(module, exports) {

$parcel$export(module.exports, "START_NODE_ID", () => $9b2ad0bd1b0ec248$export$e117396b0784c7cc);
$parcel$export(module.exports, "transitionType", () => $9b2ad0bd1b0ec248$export$331d6399b2e33350);
$parcel$export(module.exports, "SCOPE_GLOBAL", () => $9b2ad0bd1b0ec248$export$9bb188cec3fcc43d);
$parcel$export(module.exports, "SCOPE_PROJECT", () => $9b2ad0bd1b0ec248$export$54c3a1cc8eb1bc43);
$parcel$export(module.exports, "ALL_OPERATION", () => $9b2ad0bd1b0ec248$export$d3dc8e33b7258fc5);
$parcel$export(module.exports, "STATUS_CATEGORY_WEIGHTS", () => $9b2ad0bd1b0ec248$export$8fc40e3c53b7f30e);
$parcel$export(module.exports, "ANY_OPERATION", () => $9b2ad0bd1b0ec248$export$804f62993e553350);
$parcel$export(module.exports, "errorSeverity", () => $9b2ad0bd1b0ec248$export$927c560a42a52ce0);

var $gULOk = parcelRequire("gULOk");
const $9b2ad0bd1b0ec248$export$e117396b0784c7cc = 'START';
const $9b2ad0bd1b0ec248$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $9b2ad0bd1b0ec248$export$9bb188cec3fcc43d = 'GLOBAL';
const $9b2ad0bd1b0ec248$export$54c3a1cc8eb1bc43 = 'PROJECT';
const $9b2ad0bd1b0ec248$export$d3dc8e33b7258fc5 = 'ALL';
const $9b2ad0bd1b0ec248$export$8fc40e3c53b7f30e = {
    [(0, $gULOk.TODO)]: 1,
    [(0, $gULOk.IN_PROGRESS)]: 2,
    [(0, $gULOk.DONE)]: 3,
    [(0, $gULOk.UNDEFINED)]: 4
};
const $9b2ad0bd1b0ec248$export$804f62993e553350 = 'ANY';
const $9b2ad0bd1b0ec248$export$927c560a42a52ce0 = {
    WARNING: 'WARNING',
    ERROR: 'ERROR'
};

});
parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});



parcelRegister("4V5oU", function(module, exports) {

$parcel$export(module.exports, "NEW_EDITOR", () => $7efae616b0ea1988$export$83282786ca4b04f);
$parcel$export(module.exports, "LEGACY_EDITOR", () => $7efae616b0ea1988$export$e2f196e116d3fca2);
$parcel$export(module.exports, "WorkflowPublicationStatus", () => $7efae616b0ea1988$export$8b8b078375514ab6);
const $7efae616b0ea1988$export$83282786ca4b04f = 'NEW';
const $7efae616b0ea1988$export$e2f196e116d3fca2 = 'LEGACY';
var $7efae616b0ea1988$export$8b8b078375514ab6 = /*#__PURE__*/ function(WorkflowPublicationStatus) {
    WorkflowPublicationStatus[WorkflowPublicationStatus["None"] = 0] = "None";
    WorkflowPublicationStatus[WorkflowPublicationStatus["Dirty"] = 1] = "Dirty";
    WorkflowPublicationStatus[WorkflowPublicationStatus["Draft"] = 2] = "Draft";
    WorkflowPublicationStatus[WorkflowPublicationStatus["Live"] = 3] = "Live";
    return WorkflowPublicationStatus;
}({});

});

parcelRegister("lvRwX", function(module, exports) {

$parcel$export(module.exports, "useChangeToOldEditorSuccessFlag", () => $39b45d28dcfb29ea$export$4a8a957b814cf4be);

var $5uXOq = parcelRequire("5uXOq");

var $cnlW7 = parcelRequire("cnlW7");

var $4mIB9 = parcelRequire("4mIB9");
const $39b45d28dcfb29ea$export$4a8a957b814cf4be = ({ openDefaultEditorDialog: openDefaultEditorDialog })=>{
    const { showOldEditorSuccessFlag: showOldEditorSuccessFlag } = (0, $4mIB9.useChangePreferenceFlag)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $cnlW7.getShouldShowOldEditorSucccessFlag)()) {
            (0, $cnlW7.clearShowOldEditorSucccessFlag)();
            showOldEditorSuccessFlag(openDefaultEditorDialog);
        }
    }, [
        openDefaultEditorDialog,
        showOldEditorSuccessFlag
    ]);
    return {
        showOldEditorSuccessFlag: showOldEditorSuccessFlag
    };
};

});
parcelRegister("cnlW7", function(module, exports) {

$parcel$export(module.exports, "getShouldShowNewEditorSucccessFlag", () => $96ba05cf4b39267e$export$b33dd94e7d4068a9);
$parcel$export(module.exports, "setShowNewEditorSuccessFlag", () => $96ba05cf4b39267e$export$38de37b600fe15c7);
$parcel$export(module.exports, "clearShowNewEditorSucccessFlag", () => $96ba05cf4b39267e$export$10794e9068b437c1);
$parcel$export(module.exports, "getShouldShowOldEditorSucccessFlag", () => $96ba05cf4b39267e$export$b07da7bcc8c25b1a);
$parcel$export(module.exports, "clearShowOldEditorSucccessFlag", () => $96ba05cf4b39267e$export$385473acd3052995);
$parcel$export(module.exports, "setShowOldEditorSuccessFlag", () => $96ba05cf4b39267e$export$baea524121407210);

var $4R6GH = parcelRequire("4R6GH");

var $eNf8a = parcelRequire("eNf8a");
// TODO: JFP-2294 Add a prefix to identify each app and please update the same in test as well.
const $96ba05cf4b39267e$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('');
const $96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG = 'SHOW_NEW_EDITOR_SUCCESS_FLAG';
const $96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG = 'SHOW_OLD_EDITOR_SUCCESS_FLAG';
// New editor success flag
const $96ba05cf4b39267e$var$updateShowNewEditorSucccessFlag = (value)=>{
    (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $96ba05cf4b39267e$var$sessionStorageProvider.set($96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG, value) : sessionStorage.setItem($96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG, value.toString());
};
const $96ba05cf4b39267e$export$b33dd94e7d4068a9 = ()=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? Boolean($96ba05cf4b39267e$var$sessionStorageProvider.get($96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG)) : Boolean(sessionStorage.getItem($96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG));
const $96ba05cf4b39267e$export$38de37b600fe15c7 = ()=>{
    $96ba05cf4b39267e$var$updateShowNewEditorSucccessFlag(true);
};
const $96ba05cf4b39267e$export$10794e9068b437c1 = ()=>{
    (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $96ba05cf4b39267e$var$sessionStorageProvider.remove($96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG) : sessionStorage.removeItem($96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG);
};
// Old editor success flag
const $96ba05cf4b39267e$var$updateShowOldEditorSucccessFlag = (value)=>{
    (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $96ba05cf4b39267e$var$sessionStorageProvider.set($96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG, value) : sessionStorage.setItem($96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG, value.toString());
};
const $96ba05cf4b39267e$export$b07da7bcc8c25b1a = ()=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? Boolean($96ba05cf4b39267e$var$sessionStorageProvider.get($96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG)) : Boolean(sessionStorage.getItem($96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG));
const $96ba05cf4b39267e$export$385473acd3052995 = ()=>{
    (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $96ba05cf4b39267e$var$sessionStorageProvider.remove($96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG) : sessionStorage.removeItem($96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG);
};
const $96ba05cf4b39267e$export$baea524121407210 = ()=>{
    $96ba05cf4b39267e$var$updateShowOldEditorSucccessFlag(true);
};

});
parcelRegister("eNf8a", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $b98f887ad675a269$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $b98f887ad675a269$export$e0a2e9a062c6a695);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $j9Vq5 = parcelRequire("j9Vq5");
const $b98f887ad675a269$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, shouldSerialize = true)=>(0, $fNVZf.createStorageProvider)((0, $fNVZf.WebStorageType).SessionStorage, appPrefix, (0, $j9Vq5.makeSessionStore)(), shouldSerialize));
const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    return (0, $fNVZf.createExpirableStorageProvider)((0, $fNVZf.WebStorageType).SessionStorage, appPrefix, (0, $j9Vq5.makeSessionExpirableStore)());
});

});
parcelRegister("j9Vq5", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $93ac2abe604287b3$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $93ac2abe604287b3$export$a8f626c8ded9a06c);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $2NjNT = parcelRequire("2NjNT");

var $c74za = parcelRequire("c74za");

var $fNVZf = parcelRequire("fNVZf");
const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});



parcelRegister("4mIB9", function(module, exports) {

$parcel$export(module.exports, "useChangePreferenceFlag", () => $b701d8a31f793729$export$cb7da29550cd2317);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $pa9q9 = parcelRequire("pa9q9");

var $1kCbH = parcelRequire("1kCbH");
const $b701d8a31f793729$var$NEW_EDITOR_SUCCESS_FLAG = 'new-editor-success-flag';
const $b701d8a31f793729$var$learnMoreLinkNewEditor = 'https://support.atlassian.com/jira-service-management-cloud/docs/using-the-new-workflow-editor/';
const $b701d8a31f793729$var$learnMoreLinkOldEditor = 'https://support.atlassian.com/jira-service-management-cloud/docs/changing-your-default-workflow-editor/';
const $b701d8a31f793729$export$cb7da29550cd2317 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const onClickLearnMoreOldEditor = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open($b701d8a31f793729$var$learnMoreLinkOldEditor, '_blank');
    };
    const onClickLearnMoreNewEditor = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open($b701d8a31f793729$var$learnMoreLinkNewEditor, '_blank');
    };
    const showNewEditorSuccessFlag = (0, $5uXOq.useCallback)(()=>showFlag({
            id: $b701d8a31f793729$var$NEW_EDITOR_SUCCESS_FLAG,
            testId: 'workflow-editor-preference-settings.ui.success-flag',
            type: 'success',
            title: (0, $1kCbH.default).changeToNewEditorTitle,
            description: (0, $1kCbH.default).changeToNewEditorDescription,
            messageId: 'workflow-editor-preference-settings.controllers.change-preference-flag.show-flag.success.change-to-new-editor',
            messageType: 'transactional',
            actions: [
                {
                    content: (0, $1kCbH.default).learnMore,
                    onClick: onClickLearnMoreNewEditor
                },
                {
                    content: (0, $1kCbH.default).ok,
                    onClick: ()=>dismissFlag($b701d8a31f793729$var$NEW_EDITOR_SUCCESS_FLAG)
                }
            ]
        }), [
        dismissFlag,
        showFlag
    ]);
    const showOldEditorSuccessFlag = (0, $5uXOq.useCallback)((openDefaultEditorDialog = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))))=>showFlag({
            type: 'success',
            title: (0, $1kCbH.default).changeToOldEditorTitle,
            description: (0, $1kCbH.default).changeToOldEditorDescription,
            messageId: 'workflow-editor-preference-settings.controllers.change-preference-flag.show-flag.success.change-to-old-editor',
            messageType: 'transactional',
            actions: [
                {
                    content: (0, $1kCbH.default).learnMore,
                    onClick: onClickLearnMoreOldEditor
                },
                {
                    content: (0, $1kCbH.default).switchToNewEditor,
                    onClick: openDefaultEditorDialog
                }
            ]
        }), [
        showFlag
    ]);
    const showErrorFlag = (0, $5uXOq.useCallback)(()=>showFlag({
            type: 'error',
            title: (0, $1kCbH.default).updatePreferenceErrorFlagTitle,
            description: (0, $1kCbH.default).updatePreferenceErrorFlagDescription,
            messageId: 'workflow-editor-preference-settings.controllers.change-preference-flag.show-flag.error.update-preference-error',
            messageType: 'transactional'
        }), [
        showFlag
    ]);
    return {
        showNewEditorSuccessFlag: showNewEditorSuccessFlag,
        showOldEditorSuccessFlag: showOldEditorSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};

});
parcelRegister("1kCbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $94546695a392f955$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $94546695a392f955$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    changeToOldEditorTitle: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-old-editor-title",
        "defaultMessage": "You've changed the default editor"
    },
    changeToOldEditorDescription: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-old-editor-description",
        "defaultMessage": "You can use the old editor as needed while we continue building the new editor."
    },
    learnMore: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.learn-more",
        "defaultMessage": "Learn more"
    },
    switchToNewEditor: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.switch-to-new-editor",
        "defaultMessage": "Switch to new editor"
    },
    changeToNewEditorTitle: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-new-editor-title",
        "defaultMessage": "Welcome to the new workflow editor"
    },
    changeToNewEditorDescription: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-new-editor-description",
        "defaultMessage": "Enjoy a faster, cleaner, more intuitive experience while creating and editing your workflows."
    },
    ok: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.ok",
        "defaultMessage": "Ok"
    },
    updatePreferenceErrorFlagTitle: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.update-preference-error-flag-title",
        "defaultMessage": "We couldn't update your default editor"
    },
    updatePreferenceErrorFlagDescription: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.update-preference-error-flag-description",
        "defaultMessage": "Select Confirm to try again."
    }
});

});



parcelRegister("4K5zd", function(module, exports) {

$parcel$export(module.exports, "DefaultWorkflowEditorDialog", () => $b3e3e3cfc7953167$export$6e60a479812ee7d6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $fVnbM = parcelRequire("fVnbM");

var $bU3PY = parcelRequire("bU3PY");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $jouoW = parcelRequire("jouoW");

var $4R6GH = parcelRequire("4R6GH");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $7CMCs = parcelRequire("7CMCs");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $gz6NJ = parcelRequire("gz6NJ");

var $doZTA = parcelRequire("doZTA");

var $4V5oU = parcelRequire("4V5oU");

var $4mIB9 = parcelRequire("4mIB9");

var $f2tXr = parcelRequire("f2tXr");

var $aw33P = parcelRequire("aw33P");

var $e6zF8 = parcelRequire("e6zF8");

var $cnlW7 = parcelRequire("cnlW7");

var $ltuRg = parcelRequire("ltuRg");

var $aNzpN = parcelRequire("aNzpN");

var $2ogCC = parcelRequire("2ogCC");
var $b3e3e3cfc7953167$export$759a75979ec109e2 = /*#__PURE__*/ function(WarningType) {
    WarningType[WarningType["None"] = 0] = "None";
    WarningType[WarningType["Dirty"] = 1] = "Dirty";
    WarningType[WarningType["Draft"] = 2] = "Draft";
    return WarningType;
}({});
const $b3e3e3cfc7953167$var$DefaultWorkflowEditorDialogInner = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, workflowPublicationStatus: workflowPublicationStatus = (0, $4V5oU.WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
    (0, $gKZoD.di)(window);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [selectedWorkflowEditor, setSelectedWorkflowEditor] = (0, $5uXOq.useState)(null);
    const [{ route: route }] = (0, $doZTA.useRouter)();
    const { userPreference: userPreference } = (0, $f2tXr.useNewWorkflowEditorPreference)();
    const { showNewEditorSuccessFlag: showNewEditorSuccessFlag, showOldEditorSuccessFlag: showOldEditorSuccessFlag, showErrorFlag: showErrorFlag } = (0, $4mIB9.useChangePreferenceFlag)();
    (0, $5uXOq.useEffect)(()=>{
        setSelectedWorkflowEditor(userPreference);
    }, [
        userPreference,
        setSelectedWorkflowEditor
    ]);
    const redirectToLegacyEditorAndShowSuccessFlag = (0, $5uXOq.useCallback)(()=>{
        if (route?.name === 'global-settings-issues-workflows-pages') showOldEditorSuccessFlag(onOpenDefaultEditorDialog);
        else {
            // set flag to show success flag in session storage when user is redirected to legacy editor
            (0, $cnlW7.setShowOldEditorSuccessFlag)(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(shouldRedirectToDraftMode ? (0, $gz6NJ.buildEditWorkflowJSPUrl)(workflowName) : (0, $gz6NJ.getLegacyEditorLink)(workflowName));
        }
    }, [
        route?.name,
        shouldRedirectToDraftMode,
        showOldEditorSuccessFlag,
        workflowName,
        onOpenDefaultEditorDialog
    ]);
    const redirectToNewEditorAndShowSuccessFlag = (0, $5uXOq.useCallback)(()=>{
        if (route?.name === 'global-settings-issues-workflow-edit') showNewEditorSuccessFlag();
        else {
            // set flag to show success flag in session storage when user is redirected to new editor
            (0, $cnlW7.setShowNewEditorSuccessFlag)();
            workflowId && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign((0, $gz6NJ.getNewEditorLink)(workflowId));
        }
    }, [
        route?.name,
        showNewEditorSuccessFlag,
        workflowId
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $aw33P.useOptOutFeedbackDialog)({
        projectType: projectType,
        onClose: redirectToLegacyEditorAndShowSuccessFlag
    });
    const onSelectNew = ()=>setSelectedWorkflowEditor((0, $4V5oU.NEW_EDITOR));
    const onSelectOld = ()=>setSelectedWorkflowEditor((0, $4V5oU.LEGACY_EDITOR));
    const onConfirmButtonClicked = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (_, analyticsEvent)=>{
        try {
            if (selectedWorkflowEditor === (0, $4V5oU.LEGACY_EDITOR)) {
                await (0, $e6zF8.changeDefaultWorkflowEditorToLegacy)(analyticsEvent, workflowPublicationStatus);
                renderFeedbackDialog();
            }
            if (selectedWorkflowEditor === (0, $4V5oU.NEW_EDITOR)) {
                await (0, $e6zF8.changeDefaultWorkflowEditorToNew)(analyticsEvent, workflowPublicationStatus);
                redirectToNewEditorAndShowSuccessFlag();
            }
            onClose();
        } catch (error) {
            showErrorFlag();
        }
    }, [
        selectedWorkflowEditor,
        onClose,
        renderFeedbackDialog,
        redirectToNewEditorAndShowSuccessFlag,
        showErrorFlag,
        workflowPublicationStatus
    ]);
    const link = 'https://support.atlassian.com/jira-service-management-cloud/docs/using-the-new-workflow-editor/';
    const learnMoreLink = formatMessage((0, $2ogCC.default).learnMoreLink, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: link,
                target: "_blank"
            }, chunks)
    });
    const shouldShowWarningMessage = workflowPublicationStatus === (0, $4V5oU.WorkflowPublicationStatus).Draft || workflowPublicationStatus === (0, $4V5oU.WorkflowPublicationStatus).Dirty;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.modal-dialog",
        messageType: "transactional",
        onClose: onClose,
        width: "medium",
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.title"
    }, formatMessage((0, $2ogCC.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2ogCC.default).body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$Info, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, learnMoreLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$Instruction, null, formatMessage((0, $2ogCC.default).instruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100"
    }, (0, $4R6GH.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $b3e3e3cfc7953167$var$boxStyles,
        onClick: onSelectNew,
        backgroundColor: selectedWorkflowEditor === (0, $4V5oU.NEW_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.new-editor-radio"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
        isChecked: selectedWorkflowEditor === (0, $4V5oU.NEW_EDITOR),
        ariaLabel: "New editor radio"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ltuRg))),
        alt: "new editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2ogCC.default).newWorkflowEditor))) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b3e3e3cfc7953167$var$boxStyles,
        onClick: onSelectNew,
        backgroundColor: selectedWorkflowEditor === (0, $4V5oU.NEW_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.new-editor-radio"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
        isChecked: selectedWorkflowEditor === (0, $4V5oU.NEW_EDITOR),
        ariaLabel: "New editor radio"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ltuRg))),
        alt: "new editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2ogCC.default).newWorkflowEditor))), (0, $4R6GH.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $b3e3e3cfc7953167$var$boxStyles,
        onClick: onSelectOld,
        padding: "space.200",
        backgroundColor: selectedWorkflowEditor === (0, $4V5oU.LEGACY_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
        isChecked: selectedWorkflowEditor === (0, $4V5oU.LEGACY_EDITOR),
        ariaLabel: "Old editor radio"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aNzpN))),
        alt: "old editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2ogCC.default).oldWorkflowEditor))) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b3e3e3cfc7953167$var$boxStyles,
        onClick: onSelectOld,
        padding: "space.200",
        backgroundColor: selectedWorkflowEditor === (0, $4V5oU.LEGACY_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
        isChecked: selectedWorkflowEditor === (0, $4V5oU.LEGACY_EDITOR),
        ariaLabel: "Old editor radio"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aNzpN))),
        alt: "old editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2ogCC.default).oldWorkflowEditor)))), shouldShowWarningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$WarningContainer, {
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: "Warning",
        color: "var(--ds-text-warning, #A54800)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$WarningText, null, workflowPublicationStatus === (0, $4V5oU.WorkflowPublicationStatus).Draft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2ogCC.default).draftUnpublishedWarning), workflowPublicationStatus === (0, $4V5oU.WorkflowPublicationStatus).Dirty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $2ogCC.default).dirtyLossWarning,
        values: {
            workflowName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, workflowName),
            update: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("i", null, formatMessage((0, $2ogCC.default).updateButton)),
            cancel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("i", null, formatMessage((0, $2ogCC.default).cancelButton))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClose,
        appearance: "subtle"
    }, formatMessage((0, $2ogCC.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onConfirmButtonClicked,
        isDisabled: userPreference === selectedWorkflowEditor,
        appearance: "primary",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.confirm-button"
    }, formatMessage((0, $2ogCC.default).confirmButton)))));
};
const $b3e3e3cfc7953167$export$6e60a479812ee7d6 = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, workflowPublicationStatus: workflowPublicationStatus = (0, $4V5oU.WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jsm-error-boundary-default-workflow-editor-dialog",
        packageName: "workflow-editor-preference-settings",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$DefaultWorkflowEditorDialogInner, {
        workflowName: workflowName,
        projectType: projectType,
        onClose: onClose,
        onOpenDefaultEditorDialog: onOpenDefaultEditorDialog,
        workflowId: workflowId,
        workflowPublicationStatus: workflowPublicationStatus,
        shouldRedirectToDraftMode: shouldRedirectToDraftMode
    }));
};
const $b3e3e3cfc7953167$var$boxStyles = (0, $8CUq3.xcss)({
    borderStyle: 'solid',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    paddingLeft: 'space.050',
    paddingRight: 'space.500',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3e3e3cfc7953167$var$Info = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3e3e3cfc7953167$var$RadioIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1epz _u5f3pxbi _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3e3e3cfc7953167$var$Instruction = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _ca0qpxbi _n3tdu2gc _syaz131l _k48p1wq8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3e3e3cfc7953167$var$WarningContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3e3e3cfc7953167$var$WarningText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _16jlkb7n _syazwx40",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});

parcelRegister("7NYq5", function(module, exports) {

$parcel$export(module.exports, "JiraModal", () => $d308ab9275c4cac7$export$3782fcca1f68992e);

var $5uXOq = parcelRequire("5uXOq");

var $1R1Ge = parcelRequire("1R1Ge");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $1WAOl = parcelRequire("1WAOl");
const $d308ab9275c4cac7$export$3782fcca1f68992e = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1WAOl.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), rest);
};
$d308ab9275c4cac7$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("10xFf", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $36201c75b4df20a7$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $36201c75b4df20a7$export$e2cf19200849be9e);

var $iZhen = parcelRequire("iZhen");

var $t6tX9 = parcelRequire("t6tX9");
function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
    return !!props?.messageType && (0, $t6tX9.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType);
}
function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $iZhen.envType).DEV;
        case 'staging':
            return (0, $iZhen.envType).STAGING;
        case 'prod':
            return (0, $iZhen.envType).PROD;
        default:
            return (0, $iZhen.envType).LOCAL;
    }
}

});
parcelRegister("t6tX9", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $b5642a17fa90b00d$export$dbe9e38c9d6f26d0);
const $b5642a17fa90b00d$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $b5642a17fa90b00d$export$dbe9e38c9d6f26d0 = [
    $b5642a17fa90b00d$export$94e85cf3348f045a.ENGAGEMENT,
    $b5642a17fa90b00d$export$94e85cf3348f045a.MARKETING
];

});


parcelRegister("1WAOl", function(module, exports) {

$parcel$export(module.exports, "ChoreographerModal", () => $ae3d8c3c4e97b978$export$3f5d627caa6fc630);
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $1R1Ge = parcelRequire("1R1Ge");

var $cSWNW = parcelRequire("cSWNW");
const $ae3d8c3c4e97b978$export$3f5d627caa6fc630 = (0, $cSWNW.withChoreographedRender)((0, $1R1Ge.default));

});
parcelRegister("cSWNW", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $620c1a9f3fec1a68$export$c1160fdac17030e);

var $5uXOq = parcelRequire("5uXOq");

var $ioD1B = parcelRequire("ioD1B");

var $fG5AJ = parcelRequire("fG5AJ");
function $620c1a9f3fec1a68$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $fG5AJ.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});
parcelRegister("ioD1B", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $c141e5ba3428702a$export$c3226151caaf2fbf);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $c141e5ba3428702a$export$2eb1efa814fe4a);

var $5uXOq = parcelRequire("5uXOq");
const $c141e5ba3428702a$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $c141e5ba3428702a$export$2eb1efa814fe4a();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c141e5ba3428702a$export$3ff96dbefca6b00d.Provider, {
        value: $c141e5ba3428702a$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $c141e5ba3428702a$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $c141e5ba3428702a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($c141e5ba3428702a$export$3ff96dbefca6b00d);

});

parcelRegister("fG5AJ", function(module, exports) {

$parcel$export(module.exports, "getPendoPlugin", () => $596f0fde3f3a2d5a$export$3d3a86b2d636214b);
$parcel$export(module.exports, "withChoreographedToggle", () => $596f0fde3f3a2d5a$export$a646002207b915ac);
$parcel$export(module.exports, "useChoreographedRender", () => $596f0fde3f3a2d5a$export$2cfd68294be82811);

var $5uXOq = parcelRequire("5uXOq");

var $4zICj = parcelRequire("4zICj");
var $TTRxY = parcelRequire("TTRxY");
var $8r6xd = parcelRequire("8r6xd");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $7qPn9 = parcelRequire("7qPn9");

var $ioD1B = parcelRequire("ioD1B");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $596f0fde3f3a2d5a$var$environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment')) ?? 'prod';
const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                startMessage: ()=>Promise.resolve((0, $TTRxY.MessageDeliveryStatus).STARTED),
                stopMessage: ()=>Promise.resolve((0, $TTRxY.MessageDeliveryStatus).STOPPED),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                toggleMessage: ()=>Promise.resolve('')
            }),
        withChoreographedToggle: (Component)=>Component
    };
    return (0, $4zICj.choreographerFactory)((0, $TTRxY.ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
};
let $596f0fde3f3a2d5a$var$pendoPlugin;
function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
    if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, $8r6xd.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $TTRxY.ProductIds).JIRA
    });
    return $596f0fde3f3a2d5a$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11, withChoreographedToggle: $596f0fde3f3a2d5a$var$withChoreographedToggleFromFactory } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
const $596f0fde3f3a2d5a$export$a646002207b915ac = (Component, toggleableProp, toggleableContentProp)=>{
    const WithChoreographedToggleComponent = (props)=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
        const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>$596f0fde3f3a2d5a$var$withChoreographedToggleFromFactory(Component, toggleableProp), []);
        if (isAlreadyChoreographedAtAncestor || !(0, $4R6GH.fg)('jira_with_choreographed_toggle_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props);
        const propsWithContextProviderWrapper = {
            ...props
        };
        if (toggleableContentProp) {
            const { [toggleableContentProp]: toggleableContentPropValue } = propsWithContextProviderWrapper;
            if (typeof toggleableContentPropValue === 'function') // @ts-expect-error TS doesn't know this is a callback with variable params that returns ReactNode, but we do
            propsWithContextProviderWrapper[toggleableContentProp] = (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
                    isChoreographed: true
                }, toggleableContentPropValue(...args));
            else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const content = toggleableContentPropValue;
                // @ts-expect-error TS doesn't know this is a ReactNode, but we do
                propsWithContextProviderWrapper[toggleableContentProp] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
                    isChoreographed: true
                }, content);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, propsWithContextProviderWrapper);
    };
    WithChoreographedToggleComponent.displayName = `WithChoreographedToggle(${Component.displayName ?? Component.name ?? 'Component'})`;
    return WithChoreographedToggleComponent;
};
const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
    const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};

});




parcelRegister("9fuVs", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $1dd87679d9ca363b$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $1dd87679d9ca363b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k4r7E = parcelRequire("k4r7E");
const $1dd87679d9ca363b$export$ebbb59327adb551a = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $k4r7E.rootRegistry));
const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $5uXOq.useMemo)(()=>new (0, $k4r7E.ShortcutRegistry)(), []);
    const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, $k4r7E.rootRegistry);
    (0, $5uXOq.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;

});
parcelRegister("k4r7E", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $a65fecdbaed23de2$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $lbWm4 = parcelRequire("lbWm4");

var $561FV = parcelRequire("561FV");

var $hGgHi = parcelRequire("hGgHi");

var $FISJv = parcelRequire("FISJv");

var $lIZQG = parcelRequire("lIZQG");
const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $lIZQG.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $lIZQG.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $lIZQG.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();

});
parcelRegister("lIZQG", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $ca3344250c7b7406$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $ca3344250c7b7406$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $ca3344250c7b7406$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $ca3344250c7b7406$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $ca3344250c7b7406$var$toKey = (e)=>{
    if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("f2tXr", function(module, exports) {

$parcel$export(module.exports, "useNewWorkflowEditorPreference", () => $14d2db1156738fef$export$b59c27df71e5edcf);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4V5oU = parcelRequire("4V5oU");

var $6C0Kc = parcelRequire("6C0Kc");
const $14d2db1156738fef$export$b59c27df71e5edcf = ()=>{
    const [editorType, setEditorType] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $6C0Kc.getUserWorkflowEditorPreference)().then((pref)=>{
            setEditorType(pref);
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'getDefaultWorkflowEditorPreferance success');
        }).catch((error)=>{
            setEditorType(null);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('workflow-Editor.preference', 'Unable to fetch workflow editor user preference', error);
            (0, $jcw0u.default)({
                meta: {
                    id: 'getDefaultWorkflowEditorPreference',
                    packageName: 'jiraWorkflowEditorPreferenceSettings'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                attributes: {
                    isClientFetchError: (0, $fZneA.isClientFetchError)(error)
                }
            });
        });
    }, [
        createAnalyticsEvent
    ]);
    const shouldUseNewWorkFlowEditor = (0, $5uXOq.useMemo)(()=>editorType === (0, $4V5oU.NEW_EDITOR), [
        editorType
    ]);
    return {
        shouldUseNewWorkFlowEditor: shouldUseNewWorkFlowEditor,
        userPreference: editorType
    };
};

});
parcelRegister("6C0Kc", function(module, exports) {

$parcel$export(module.exports, "getUserWorkflowEditorPreference", () => $7fe92009d53491ea$export$d9664e16e2fb1f27);

var $eusud = parcelRequire("eusud");
const $7fe92009d53491ea$var$workflowEditorPreferenceKey = 'jira.user.workflow.editor.global.scope.enrolment';
const $7fe92009d53491ea$var$WORKFLOW_EDITOR_PREFERENCE_QUERY = `
query WorkflowEditorPreferenceQuery {
    myPreferences(keys: [
        "${$7fe92009d53491ea$var$workflowEditorPreferenceKey}"
    ])
}
`;
const $7fe92009d53491ea$export$d9664e16e2fb1f27 = async ()=>{
    const apiResult = await (0, $eusud.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $7fe92009d53491ea$var$WORKFLOW_EDITOR_PREFERENCE_QUERY
        })
    });
    const preferences = apiResult?.data?.myPreferences;
    if (preferences) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return preferences[`${$7fe92009d53491ea$var$workflowEditorPreferenceKey}`];
    const errorResponse = apiResult?.errors;
    if (errorResponse) throw new Error(`Error getting user preference: ${$7fe92009d53491ea$var$workflowEditorPreferenceKey}`, {
        cause: apiResult?.errors?.[0] ?? 'unknown'
    });
    return null;
};

});


parcelRegister("aw33P", function(module, exports) {

$parcel$export(module.exports, "useOptOutFeedbackDialog", () => $681aba6226e00cfc$export$f692fac382bec058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $bw7Gm = parcelRequire("bw7Gm");

var $9OXo1 = parcelRequire("9OXo1");

var $fC6Gn = parcelRequire("fC6Gn");
const $681aba6226e00cfc$var$unknownAttributeValue = 'unknown';
const $681aba6226e00cfc$var$FEEDBACK_GROUP_ID = 'workflow-editor-opt-out'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $681aba6226e00cfc$export$e4c3d9ebed5d4509 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $681aba6226e00cfc$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, projectType: projectType, cloudId: cloudId })=>[
        {
            id: (0, $7iULw.EntryKeys).LOCATION,
            value: (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? (0, $bw7Gm.default)(globalThis.window?.location.href) : (0, $bw7Gm.default)(window.location.href) // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
        },
        {
            id: (0, $7iULw.EntryKeys).REFERER,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: document.referrer ? (0, $bw7Gm.default)(document.referrer) : ''
        },
        {
            id: (0, $7iULw.EntryKeys).USER_AGENT,
            value: (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? globalThis.navigator?.userAgent : navigator.userAgent // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
        },
        {
            id: (0, $7iULw.EntryKeys).SCREEN_RESOLUTION,
            value: (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? `${globalThis.window?.screen?.width} x ${globalThis.window?.screen?.height}` : `${window.screen.width} x ${window.screen.height}` // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
        },
        {
            id: (0, $7iULw.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        }
    ];
const $681aba6226e00cfc$export$f692fac382bec058 = ({ onClose: onClose = ()=>undefined, projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const routeName = route.name ?? $681aba6226e00cfc$var$unknownAttributeValue;
    const renderFeedbackDialog = (0, $5uXOq.useCallback)(()=>{
        openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: $681aba6226e00cfc$var$FEEDBACK_GROUP_ID,
            onClose: onClose,
            feedbackContext: $681aba6226e00cfc$export$b028e515f8f652e0({
                isSiteAdmin: isSiteAdmin,
                cloudId: cloudId,
                routeName: routeName,
                projectType: projectType || $681aba6226e00cfc$var$unknownAttributeValue
            }),
            feedbackGroupLabels: {
                empty: {
                    selectOptionLabel: formatMessage((0, $fC6Gn.default).reasonPlaceholder)
                },
                bug: {
                    fieldLabel: formatMessage((0, $fC6Gn.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $fC6Gn.default).reasonBug)
                },
                comment: {
                    fieldLabel: formatMessage((0, $fC6Gn.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $fC6Gn.default).reasonComment)
                },
                suggestion: {
                    fieldLabel: formatMessage((0, $fC6Gn.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $fC6Gn.default).reasonOthers)
                },
                question: {
                    fieldLabel: formatMessage((0, $fC6Gn.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $fC6Gn.default).reasonQuestion)
                }
            },
            feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($681aba6226e00cfc$export$e4c3d9ebed5d4509, null, formatMessage((0, $fC6Gn.default).feedbackTitleDetails)),
            selectLabel: formatMessage((0, $fC6Gn.default).feedbackTitleDetailsQuestion),
            cancelButtonLabel: formatMessage((0, $fC6Gn.default).feedbackCancelButton)
        });
    }, [
        formatMessage,
        openFeedbackCollector,
        onClose,
        isSiteAdmin,
        cloudId,
        routeName,
        projectType
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};

});
parcelRegister("7iULw", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $384a8a865c8f714d$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $384a8a865c8f714d$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $384a8a865c8f714d$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $384a8a865c8f714d$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $384a8a865c8f714d$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $384a8a865c8f714d$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $384a8a865c8f714d$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $384a8a865c8f714d$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $384a8a865c8f714d$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $384a8a865c8f714d$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $384a8a865c8f714d$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $384a8a865c8f714d$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $384a8a865c8f714d$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", () => $384a8a865c8f714d$export$1b65c2053cba0686);
$parcel$export(module.exports, "ENTRY_POINT_ID_REQUEST_TYPES_PAGE", () => $384a8a865c8f714d$export$86e0eeb08f5b7ea6);
$parcel$export(module.exports, "EntryKeys", () => $384a8a865c8f714d$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $384a8a865c8f714d$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $384a8a865c8f714d$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $384a8a865c8f714d$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $384a8a865c8f714d$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $384a8a865c8f714d$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $384a8a865c8f714d$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $384a8a865c8f714d$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $384a8a865c8f714d$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $384a8a865c8f714d$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $384a8a865c8f714d$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $384a8a865c8f714d$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $384a8a865c8f714d$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $384a8a865c8f714d$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $384a8a865c8f714d$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
const $384a8a865c8f714d$export$86e0eeb08f5b7ea6 = 'ee8a71e7-85aa-4121-b455-e6316922e894';
const $384a8a865c8f714d$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies',
    COLLABORATIVE_SPRINTS: 'collaborative-sprints',
    PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap'
});

});

parcelRegister("dseDh", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $c996142feb877ddb$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $c996142feb877ddb$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $c996142feb877ddb$export$c35dbf16ebe9df04);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $c996142feb877ddb$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $c996142feb877ddb$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($c996142feb877ddb$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$c996142feb877ddb$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $c996142feb877ddb$var$Store = (0, $iXqE5.createStore)({
    name: 'feedback-collector',
    initialState: $c996142feb877ddb$export$d4c72bab9d6cc13a,
    actions: $c996142feb877ddb$export$e324594224ef24da
});
const $c996142feb877ddb$export$4be696be8a3bff13 = (0, $3sQ5x.createHook)($c996142feb877ddb$var$Store);
const $c996142feb877ddb$export$dfb2ee2d9e73fa48 = (0, $3sQ5x.createActionsHook)($c996142feb877ddb$var$Store);
const $c996142feb877ddb$export$c35dbf16ebe9df04 = (0, $51nlc.createSubscriber)($c996142feb877ddb$var$Store, {
    selector: null
});

});

parcelRegister("fC6Gn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b35f74eb43d3eeed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b35f74eb43d3eeed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reasonPlaceholder: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-placeholder",
        "defaultMessage": "Select an option"
    },
    reasonQuestion: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-question",
        "defaultMessage": "Missing features"
    },
    reasonBug: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-bug",
        "defaultMessage": "Bugs"
    },
    reasonComment: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-comment",
        "defaultMessage": "Prefer old editor"
    },
    reasonOthers: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-others",
        "defaultMessage": "Other"
    },
    fieldLabel: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.field-label",
        "defaultMessage": "Add details to help us improve the workflow editor for everyone."
    },
    feedbackTitleDetails: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-title-details",
        "defaultMessage": "Help us improve your experience with the new workflow editor."
    },
    feedbackTitleDetailsQuestion: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-title-details-question",
        "defaultMessage": "Let us know why you\u2019re moving to the old editor"
    },
    feedbackCancelButton: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-cancel-button",
        "defaultMessage": "Skip step"
    }
});

});


parcelRegister("e6zF8", function(module, exports) {

$parcel$export(module.exports, "changeDefaultWorkflowEditorToLegacy", () => $45335b456a778f97$export$f16799cd8f24c0e2);
$parcel$export(module.exports, "changeDefaultWorkflowEditorToNew", () => $45335b456a778f97$export$e03a9424d4619803);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $4V5oU = parcelRequire("4V5oU");
const $45335b456a778f97$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $45335b456a778f97$var$setGlobalScopeUserPreference = async (input)=>{
    const result = await (0, $eusud.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $45335b456a778f97$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
            variables: {
                input: input
            }
        })
    });
    if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
        cause: result.errors?.[0] ?? 'unknown'
    });
};
const $45335b456a778f97$export$f16799cd8f24c0e2 = async (analyticsEvent, workflowPublicationStatus)=>{
    try {
        await $45335b456a778f97$var$setGlobalScopeUserPreference({
            key: 'jira.user.workflow.editor.global.scope.enrolment',
            value: (0, $4V5oU.LEGACY_EDITOR)
        });
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'legacyWorkflowEditorUserPreference set', {
            workflowPublicationStatus: workflowPublicationStatus === (0, $4V5oU.WorkflowPublicationStatus).Dirty ? 'Unsaved' // user-friendly term to use instead of Dirty
             : (0, $4V5oU.WorkflowPublicationStatus)[workflowPublicationStatus]
        });
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'changeDefaultWorkflowEditorToLegacy',
                packageName: 'jiraWorkflowEditorPreferenceSettings'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        });
        throw error;
    }
};
const $45335b456a778f97$export$e03a9424d4619803 = async (analyticsEvent, workflowPublicationStatus)=>{
    try {
        await $45335b456a778f97$var$setGlobalScopeUserPreference({
            key: 'jira.user.workflow.editor.global.scope.enrolment',
            value: (0, $4V5oU.NEW_EDITOR)
        });
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'newWorkflowEditorUserPreference set', {
            workflowPublicationStatus: workflowPublicationStatus === (0, $4V5oU.WorkflowPublicationStatus).Dirty ? 'Unsaved' // user-friendly term to use instead of Dirty
             : (0, $4V5oU.WorkflowPublicationStatus)[workflowPublicationStatus]
        });
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'changeDefaultWorkflowEditorToNew',
                packageName: 'jiraWorkflowEditorPreferenceSettings'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        });
        throw error;
    }
};

});

parcelRegister("ltuRg", function(module, exports) {
module.exports = new URL("newEditorImage.very-specific-illu.5e606ca1.png", import.meta.url).toString();

});

parcelRegister("aNzpN", function(module, exports) {
module.exports = new URL("oldEditorImage.very-specific-illu.51f0890e.png", import.meta.url).toString();

});

parcelRegister("2ogCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a84b03951893833$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0a84b03951893833$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.title",
        "defaultMessage": "Select a default workflow editor"
    },
    body: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.body",
        "defaultMessage": "While we continue building the new workflow editor, you can switch between editors as needed. When you select a default, we\u2019ll always open your workflows in that editor."
    },
    instruction: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.instruction",
        "defaultMessage": "Select a default workflow editor"
    },
    link: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.link",
        "defaultMessage": "Learn more about editing workflows."
    },
    learnMoreLink: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.learn-more-link",
        "defaultMessage": "<a>Learn more about editing workflows</a>."
    },
    newWorkflowEditor: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.new-workflow-editor",
        "defaultMessage": "New editor"
    },
    oldWorkflowEditor: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.old-workflow-editor",
        "defaultMessage": "Old editor"
    },
    cancelButton: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.cancel-button",
        "defaultMessage": "Cancel"
    },
    confirmButton: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.confirm-button",
        "defaultMessage": "Confirm"
    },
    updateButton: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.update-button",
        "defaultMessage": "Update"
    },
    draftLossWarning: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.draft-loss-warning",
        "defaultMessage": "You\u2019ve made changes to {workflowName}. To save those changes select {cancel}, then publish your draft workflow before continuing."
    },
    draftUnpublishedWarning: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.draft-unpublished-warning",
        "defaultMessage": "Publish your draft workflow before continuing so that your edits will be visible in the new workflow editor."
    },
    dirtyLossWarning: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.dirty-loss-warning",
        "defaultMessage": "You\u2019ve made changes to {workflowName}. To save those changes select {cancel}, then {update} workflow before continuing."
    }
});

});


parcelRegister("8iMd2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cff5443ae1882d3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5cff5443ae1882d3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openInNewEditor: {
        "id": "workflow-editor-preference-settings.open-in-new-editor",
        "defaultMessage": "Open workflow in new editor"
    },
    changeDefaultEditor: {
        "id": "workflow-editor-preference-settings.change-default-editor",
        "defaultMessage": "Change default editor"
    },
    switchEditorButton: {
        "id": "workflow-editor-preference-settings.switch-editor-button",
        "defaultMessage": "Switch editor"
    }
});

});




parcelRegister("anXSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $286d76c503aa7d78$export$2e2bcd8739ae039);
const $286d76c503aa7d78$var$applyLazyOpts = (route)=>{
    if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
        const hydratedRoute = {
            ...route,
            ...route.lazyOpts()
        };
        delete hydratedRoute.lazyOpts;
        return hydratedRoute;
    }
    return route;
};
var $286d76c503aa7d78$export$2e2bcd8739ae039 = $286d76c503aa7d78$var$applyLazyOpts;

});


parcelRegister("5HG6S", function(module, exports) {

$parcel$export(module.exports, "getSpaRouterContext", () => $804f5602998bd8a4$export$1f61c5e3f6410afa);
const $804f5602998bd8a4$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("3qHVS", function(module, exports) {

$parcel$export(module.exports, "visualRefreshResolverOverride", () => $56907fa85239d7b0$export$73a94df81a7c0f2c);

var $dCm1o = parcelRequire("dCm1o");
const $56907fa85239d7b0$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh',
    'platform-visual-refresh-icons-legacy-facade',
    'platform-visual-refresh-icons'
];
const $56907fa85239d7b0$export$73a94df81a7c0f2c = [
    (flagKey)=>$56907fa85239d7b0$var$visualRefreshPlatformFlags.includes(flagKey),
    (0, $dCm1o.isVisualRefreshEnabled)
];

});
parcelRegister("dCm1o", function(module, exports) {

$parcel$export(module.exports, "isVisualRefreshEnabled", () => $322f7f27e3ad3058$export$48345cb467db19b6);

var $3HwlS = parcelRequire("3HwlS");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $322f7f27e3ad3058$export$48345cb467db19b6 = ()=>{
    if ((0, $4R6GH.fg)('nav4_visual_refresh_merger')) return (0, $3HwlS.getWillShowNav4)();
    return (0, $4R6GH.fg)('visual-refresh') && // Kill switch for the entire rollout of the visual refresh
    ($322f7f27e3ad3058$var$isVisualRefreshInDogfooding() || $322f7f27e3ad3058$var$isVisualRefreshInEAP() || $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta());
};
// Used for the dogfooding of the visual refresh
const $322f7f27e3ad3058$var$isVisualRefreshInDogfooding = ()=>(0, $4R6GH.fg)('visual-refresh-dogfood') && !(0, $1i1R1.getIsNav4UserOptOut)();
// Used for the EAP of the visual refresh
const $322f7f27e3ad3058$var$isVisualRefreshInEAP = ()=>(0, $4R6GH.fg)('visual-refresh-eap') && !(0, $1i1R1.getIsNav4UserOptOut)();
// Used for the OpenBeta of the visual refresh
const $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('visual-refresh-beta-existing-customers') && !(0, $1i1R1.getIsNav4UserOptOut)() || (0, $4R6GH.fg)('visual-refresh-beta-sandboxes') || (0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'isVisualRefreshEnabled', false) || (0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'isVisualRefreshEnabled', false) || (0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'isVisualRefreshEnabled', false);

});


parcelRegister("g9ZQ1", function(module, exports) {

let $bc3d74609ae0784c$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("f9F7z"), 4)),
    $bc3d74609ae0784c$var$load("kfXhT"),
    $bc3d74609ae0784c$var$load("2Lfdl"),
    $bc3d74609ae0784c$var$load("eNmuD"),
    $bc3d74609ae0784c$var$load("hPzOn"),
    $bc3d74609ae0784c$var$load("h2MrD"),
    $bc3d74609ae0784c$var$load("bYT2S"),
    $bc3d74609ae0784c$var$load("cM9em"),
    $bc3d74609ae0784c$var$load("fr9NE"),
    $bc3d74609ae0784c$var$load("2YViK")
]).then(()=>parcelRequire('gkwRL'));

});
parcelRegister("aMHR6", function(module, exports) {
"use strict";

var $g1Pp8 = parcelRequire("g1Pp8");
module.exports = $g1Pp8(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("g1Pp8", function(module, exports) {
"use strict";
let $bab49d2fea43af49$var$cachedBundles = {};
let $bab49d2fea43af49$var$cachedPreloads = {};
let $bab49d2fea43af49$var$cachedPrefetches = {};
function $bab49d2fea43af49$var$getCache(type) {
    switch(type){
        case 'preload':
            return $bab49d2fea43af49$var$cachedPreloads;
        case 'prefetch':
            return $bab49d2fea43af49$var$cachedPrefetches;
        default:
            return $bab49d2fea43af49$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $bab49d2fea43af49$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





$parcel$global.rwr("2BmTd", () => { parcelRequire("lRSO6");
parcelRequire("8oLfs");

var $2cigx = parcelRequire("2cigx");

var $8aaWz = parcelRequire("8aaWz");
(0, $8aaWz.default).install();
(0, $2cigx.provideHealthcheck)();
 }, ["eNmuD","dsiAd","hPzOn","2Lfdl","kfXhT","4ogRW","9vNc4","i5RRW","92sUi","kWrFZ","bYT2S","h2MrD","fr9NE","cM9em","e97YG"]);

$parcel$global.rlb("2BmTd")
//# sourceMappingURL=global-single-fragment.a16d261d.js.map
